
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireea44"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireea44"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("caV3w", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4Xr8A"));

});
parcelRegister("4Xr8A", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $39c1b90c41ffc6ad$export$ffb0004e005737fa; }, function (v) { return $39c1b90c41ffc6ad$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $39c1b90c41ffc6ad$export$34b9dba7ce09269b; }, function (v) { return $39c1b90c41ffc6ad$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $39c1b90c41ffc6ad$export$25062201e9e25d76; }, function (v) { return $39c1b90c41ffc6ad$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $39c1b90c41ffc6ad$export$ffb0004e005737fa;
var $39c1b90c41ffc6ad$export$34b9dba7ce09269b;
var $39c1b90c41ffc6ad$export$25062201e9e25d76;
"use strict";
var $39c1b90c41ffc6ad$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $39c1b90c41ffc6ad$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $39c1b90c41ffc6ad$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $39c1b90c41ffc6ad$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$39c1b90c41ffc6ad$export$ffb0004e005737fa = $39c1b90c41ffc6ad$var$REACT_FRAGMENT_TYPE;
$39c1b90c41ffc6ad$export$34b9dba7ce09269b = $39c1b90c41ffc6ad$var$jsxProd;
$39c1b90c41ffc6ad$export$25062201e9e25d76 = $39c1b90c41ffc6ad$var$jsxProd;

});


parcelRegister("gHMOm", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $c2968667ab46cac6$export$882461b6382ed46c; }, function (v) { return $c2968667ab46cac6$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $c2968667ab46cac6$export$757ceba2d55c277e; }, function (v) { return $c2968667ab46cac6$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $c2968667ab46cac6$export$83d89fbfd8236492; }, function (v) { return $c2968667ab46cac6$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $c2968667ab46cac6$export$882461b6382ed46c;
var $c2968667ab46cac6$export$757ceba2d55c277e;
var $c2968667ab46cac6$export$83d89fbfd8236492;
"use strict";

var $f04nL = parcelRequire("f04nL");

var $8XEkF = parcelRequire("8XEkF");

var $fdu5P = parcelRequire("fdu5P");
function $c2968667ab46cac6$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $c2968667ab46cac6$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $c2968667ab46cac6$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $c2968667ab46cac6$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $c2968667ab46cac6$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $c2968667ab46cac6$var$assertIsMounted(fiber) {
    if ($c2968667ab46cac6$var$getNearestMountedFiber(fiber) !== fiber) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(188));
}
function $c2968667ab46cac6$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $c2968667ab46cac6$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $c2968667ab46cac6$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $c2968667ab46cac6$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($c2968667ab46cac6$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $c2968667ab46cac6$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $c2968667ab46cac6$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $c2968667ab46cac6$var$assign = Object.assign, $c2968667ab46cac6$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $c2968667ab46cac6$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $c2968667ab46cac6$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $c2968667ab46cac6$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $c2968667ab46cac6$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $c2968667ab46cac6$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $c2968667ab46cac6$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $c2968667ab46cac6$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $c2968667ab46cac6$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $c2968667ab46cac6$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $c2968667ab46cac6$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $c2968667ab46cac6$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $c2968667ab46cac6$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $c2968667ab46cac6$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $c2968667ab46cac6$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $c2968667ab46cac6$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $c2968667ab46cac6$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $c2968667ab46cac6$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$c2968667ab46cac6$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $c2968667ab46cac6$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $c2968667ab46cac6$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $c2968667ab46cac6$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $c2968667ab46cac6$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $c2968667ab46cac6$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $c2968667ab46cac6$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $c2968667ab46cac6$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $c2968667ab46cac6$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $c2968667ab46cac6$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $c2968667ab46cac6$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $c2968667ab46cac6$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $c2968667ab46cac6$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $c2968667ab46cac6$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $c2968667ab46cac6$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $c2968667ab46cac6$var$getComponentNameFromType(type.type) || "Memo";
        case $c2968667ab46cac6$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $c2968667ab46cac6$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $c2968667ab46cac6$var$isArrayImpl = Array.isArray, $c2968667ab46cac6$var$ReactSharedInternals = $8XEkF.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c2968667ab46cac6$var$ReactDOMSharedInternals = $fdu5P.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $c2968667ab46cac6$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $c2968667ab46cac6$var$valueStack = [], $c2968667ab46cac6$var$index = -1;
function $c2968667ab46cac6$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $c2968667ab46cac6$var$pop(cursor) {
    0 > $c2968667ab46cac6$var$index || (cursor.current = $c2968667ab46cac6$var$valueStack[$c2968667ab46cac6$var$index], $c2968667ab46cac6$var$valueStack[$c2968667ab46cac6$var$index] = null, $c2968667ab46cac6$var$index--);
}
function $c2968667ab46cac6$var$push(cursor, value) {
    $c2968667ab46cac6$var$index++;
    $c2968667ab46cac6$var$valueStack[$c2968667ab46cac6$var$index] = cursor.current;
    cursor.current = value;
}
var $c2968667ab46cac6$var$contextStackCursor = $c2968667ab46cac6$var$createCursor(null), $c2968667ab46cac6$var$contextFiberStackCursor = $c2968667ab46cac6$var$createCursor(null), $c2968667ab46cac6$var$rootInstanceStackCursor = $c2968667ab46cac6$var$createCursor(null), $c2968667ab46cac6$var$hostTransitionProviderCursor = $c2968667ab46cac6$var$createCursor(null);
function $c2968667ab46cac6$var$pushHostContainer(fiber, nextRootInstance) {
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$rootInstanceStackCursor, nextRootInstance);
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$contextFiberStackCursor, fiber);
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $c2968667ab46cac6$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $c2968667ab46cac6$var$getOwnHostContext(nextRootInstance), fiber = $c2968667ab46cac6$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$contextStackCursor);
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$contextStackCursor, fiber);
}
function $c2968667ab46cac6$var$popHostContainer() {
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$contextStackCursor);
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$contextFiberStackCursor);
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$rootInstanceStackCursor);
}
function $c2968667ab46cac6$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $c2968667ab46cac6$var$push($c2968667ab46cac6$var$hostTransitionProviderCursor, fiber);
    var context = $c2968667ab46cac6$var$contextStackCursor.current;
    var JSCompiler_inline_result = $c2968667ab46cac6$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($c2968667ab46cac6$var$push($c2968667ab46cac6$var$contextFiberStackCursor, fiber), $c2968667ab46cac6$var$push($c2968667ab46cac6$var$contextStackCursor, JSCompiler_inline_result));
}
function $c2968667ab46cac6$var$popHostContext(fiber) {
    $c2968667ab46cac6$var$contextFiberStackCursor.current === fiber && ($c2968667ab46cac6$var$pop($c2968667ab46cac6$var$contextStackCursor), $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$contextFiberStackCursor));
    $c2968667ab46cac6$var$hostTransitionProviderCursor.current === fiber && ($c2968667ab46cac6$var$pop($c2968667ab46cac6$var$hostTransitionProviderCursor), $c2968667ab46cac6$var$HostTransitionContext._currentValue = $c2968667ab46cac6$var$sharedNotPendingObject);
}
var $c2968667ab46cac6$var$prefix, $c2968667ab46cac6$var$suffix;
function $c2968667ab46cac6$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $c2968667ab46cac6$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $c2968667ab46cac6$var$prefix = match && match[1] || "";
        $c2968667ab46cac6$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $c2968667ab46cac6$var$prefix + name + $c2968667ab46cac6$var$suffix;
}
var $c2968667ab46cac6$var$reentry = !1;
function $c2968667ab46cac6$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $c2968667ab46cac6$var$reentry) return "";
    $c2968667ab46cac6$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $c2968667ab46cac6$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $c2968667ab46cac6$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $c2968667ab46cac6$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $c2968667ab46cac6$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $c2968667ab46cac6$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $c2968667ab46cac6$var$describeBuiltInComponentFrame("Suspense Fallback") : $c2968667ab46cac6$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $c2968667ab46cac6$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $c2968667ab46cac6$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $c2968667ab46cac6$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $c2968667ab46cac6$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $c2968667ab46cac6$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $c2968667ab46cac6$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $c2968667ab46cac6$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $c2968667ab46cac6$var$hasOwnProperty = Object.prototype.hasOwnProperty, $c2968667ab46cac6$var$scheduleCallback$3 = $f04nL.unstable_scheduleCallback, $c2968667ab46cac6$var$cancelCallback$1 = $f04nL.unstable_cancelCallback, $c2968667ab46cac6$var$shouldYield = $f04nL.unstable_shouldYield, $c2968667ab46cac6$var$requestPaint = $f04nL.unstable_requestPaint, $c2968667ab46cac6$var$now = $f04nL.unstable_now, $c2968667ab46cac6$var$getCurrentPriorityLevel = $f04nL.unstable_getCurrentPriorityLevel, $c2968667ab46cac6$var$ImmediatePriority = $f04nL.unstable_ImmediatePriority, $c2968667ab46cac6$var$UserBlockingPriority = $f04nL.unstable_UserBlockingPriority, $c2968667ab46cac6$var$NormalPriority$1 = $f04nL.unstable_NormalPriority, $c2968667ab46cac6$var$LowPriority = $f04nL.unstable_LowPriority, $c2968667ab46cac6$var$IdlePriority = $f04nL.unstable_IdlePriority, $c2968667ab46cac6$var$log$1 = $f04nL.log, $c2968667ab46cac6$var$unstable_setDisableYieldValue = $f04nL.unstable_setDisableYieldValue, $c2968667ab46cac6$var$rendererID = null, $c2968667ab46cac6$var$injectedHook = null;
function $c2968667ab46cac6$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $c2968667ab46cac6$var$log$1 && $c2968667ab46cac6$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($c2968667ab46cac6$var$injectedHook && "function" === typeof $c2968667ab46cac6$var$injectedHook.setStrictMode) try {
        $c2968667ab46cac6$var$injectedHook.setStrictMode($c2968667ab46cac6$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $c2968667ab46cac6$var$clz32 = Math.clz32 ? Math.clz32 : $c2968667ab46cac6$var$clz32Fallback, $c2968667ab46cac6$var$log = Math.log, $c2968667ab46cac6$var$LN2 = Math.LN2;
function $c2968667ab46cac6$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($c2968667ab46cac6$var$log(x) / $c2968667ab46cac6$var$LN2 | 0) | 0;
}
var $c2968667ab46cac6$var$nextTransitionUpdateLane = 256, $c2968667ab46cac6$var$nextTransitionDeferredLane = 262144, $c2968667ab46cac6$var$nextRetryLane = 4194304;
function $c2968667ab46cac6$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $c2968667ab46cac6$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $c2968667ab46cac6$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $c2968667ab46cac6$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $c2968667ab46cac6$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $c2968667ab46cac6$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $c2968667ab46cac6$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $c2968667ab46cac6$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $c2968667ab46cac6$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $c2968667ab46cac6$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c2968667ab46cac6$var$claimNextRetryLane() {
    var lane = $c2968667ab46cac6$var$nextRetryLane;
    $c2968667ab46cac6$var$nextRetryLane <<= 1;
    0 === ($c2968667ab46cac6$var$nextRetryLane & 62914560) && ($c2968667ab46cac6$var$nextRetryLane = 4194304);
    return lane;
}
function $c2968667ab46cac6$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $c2968667ab46cac6$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $c2968667ab46cac6$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $c2968667ab46cac6$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $c2968667ab46cac6$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $c2968667ab46cac6$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $c2968667ab46cac6$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $c2968667ab46cac6$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $c2968667ab46cac6$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $c2968667ab46cac6$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $c2968667ab46cac6$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $c2968667ab46cac6$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $c2968667ab46cac6$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $c2968667ab46cac6$var$resolveUpdatePriority() {
    var updatePriority = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $c2968667ab46cac6$var$getEventPriority(updatePriority.type);
}
function $c2968667ab46cac6$var$runWithPriority(priority, fn) {
    var previousPriority = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
    try {
        return $c2968667ab46cac6$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $c2968667ab46cac6$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $c2968667ab46cac6$var$randomKey = Math.random().toString(36).slice(2), $c2968667ab46cac6$var$internalInstanceKey = "__reactFiber$" + $c2968667ab46cac6$var$randomKey, $c2968667ab46cac6$var$internalPropsKey = "__reactProps$" + $c2968667ab46cac6$var$randomKey, $c2968667ab46cac6$var$internalContainerInstanceKey = "__reactContainer$" + $c2968667ab46cac6$var$randomKey, $c2968667ab46cac6$var$internalEventHandlersKey = "__reactEvents$" + $c2968667ab46cac6$var$randomKey, $c2968667ab46cac6$var$internalEventHandlerListenersKey = "__reactListeners$" + $c2968667ab46cac6$var$randomKey, $c2968667ab46cac6$var$internalEventHandlesSetKey = "__reactHandles$" + $c2968667ab46cac6$var$randomKey, $c2968667ab46cac6$var$internalRootNodeResourcesKey = "__reactResources$" + $c2968667ab46cac6$var$randomKey, $c2968667ab46cac6$var$internalHoistableMarker = "__reactMarker$" + $c2968667ab46cac6$var$randomKey;
function $c2968667ab46cac6$var$detachDeletedInstance(node) {
    delete node[$c2968667ab46cac6$var$internalInstanceKey];
    delete node[$c2968667ab46cac6$var$internalPropsKey];
    delete node[$c2968667ab46cac6$var$internalEventHandlersKey];
    delete node[$c2968667ab46cac6$var$internalEventHandlerListenersKey];
    delete node[$c2968667ab46cac6$var$internalEventHandlesSetKey];
}
function $c2968667ab46cac6$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$c2968667ab46cac6$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$c2968667ab46cac6$var$internalContainerInstanceKey] || parentNode[$c2968667ab46cac6$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $c2968667ab46cac6$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$c2968667ab46cac6$var$internalInstanceKey]) return parentNode;
                targetNode = $c2968667ab46cac6$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $c2968667ab46cac6$var$getInstanceFromNode(node) {
    if (node = node[$c2968667ab46cac6$var$internalInstanceKey] || node[$c2968667ab46cac6$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $c2968667ab46cac6$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(33));
}
function $c2968667ab46cac6$var$getResourcesFromRoot(root) {
    var resources = root[$c2968667ab46cac6$var$internalRootNodeResourcesKey];
    resources || (resources = root[$c2968667ab46cac6$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $c2968667ab46cac6$var$markNodeAsHoistable(node) {
    node[$c2968667ab46cac6$var$internalHoistableMarker] = !0;
}
var $c2968667ab46cac6$var$allNativeEvents = new Set(), $c2968667ab46cac6$var$registrationNameDependencies = {};
function $c2968667ab46cac6$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $c2968667ab46cac6$var$registerDirectEvent(registrationName, dependencies);
    $c2968667ab46cac6$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $c2968667ab46cac6$var$registerDirectEvent(registrationName, dependencies) {
    $c2968667ab46cac6$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$c2968667ab46cac6$var$allNativeEvents.add(dependencies[registrationName]);
}
var $c2968667ab46cac6$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $c2968667ab46cac6$var$illegalAttributeNameCache = {}, $c2968667ab46cac6$var$validatedAttributeNameCache = {};
function $c2968667ab46cac6$var$isAttributeNameSafe(attributeName) {
    if ($c2968667ab46cac6$var$hasOwnProperty.call($c2968667ab46cac6$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($c2968667ab46cac6$var$hasOwnProperty.call($c2968667ab46cac6$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($c2968667ab46cac6$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $c2968667ab46cac6$var$validatedAttributeNameCache[attributeName] = !0;
    $c2968667ab46cac6$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $c2968667ab46cac6$var$setValueForAttribute(node, name, value) {
    if ($c2968667ab46cac6$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $c2968667ab46cac6$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $c2968667ab46cac6$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $c2968667ab46cac6$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $c2968667ab46cac6$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $c2968667ab46cac6$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $c2968667ab46cac6$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $c2968667ab46cac6$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $c2968667ab46cac6$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $c2968667ab46cac6$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $c2968667ab46cac6$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $c2968667ab46cac6$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $c2968667ab46cac6$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $c2968667ab46cac6$var$getToStringValue(value);
        } else element.value !== "" + $c2968667ab46cac6$var$getToStringValue(value) && (element.value = "" + $c2968667ab46cac6$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $c2968667ab46cac6$var$setDefaultValue(element, type, $c2968667ab46cac6$var$getToStringValue(value)) : null != defaultValue ? $c2968667ab46cac6$var$setDefaultValue(element, type, $c2968667ab46cac6$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $c2968667ab46cac6$var$getToStringValue(name) : element.removeAttribute("name");
}
function $c2968667ab46cac6$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $c2968667ab46cac6$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $c2968667ab46cac6$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $c2968667ab46cac6$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $c2968667ab46cac6$var$track(element);
}
function $c2968667ab46cac6$var$setDefaultValue(node, type, value) {
    "number" === type && $c2968667ab46cac6$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $c2968667ab46cac6$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $c2968667ab46cac6$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $c2968667ab46cac6$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $c2968667ab46cac6$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $c2968667ab46cac6$var$getToStringValue(defaultValue) : "";
}
function $c2968667ab46cac6$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(92));
            if ($c2968667ab46cac6$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $c2968667ab46cac6$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $c2968667ab46cac6$var$track(element);
}
function $c2968667ab46cac6$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $c2968667ab46cac6$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $c2968667ab46cac6$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $c2968667ab46cac6$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $c2968667ab46cac6$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $c2968667ab46cac6$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $c2968667ab46cac6$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $c2968667ab46cac6$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c2968667ab46cac6$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $c2968667ab46cac6$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $c2968667ab46cac6$var$sanitizeURL(url) {
    return $c2968667ab46cac6$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $c2968667ab46cac6$var$noop$1() {}
var $c2968667ab46cac6$var$currentReplayingEvent = null;
function $c2968667ab46cac6$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $c2968667ab46cac6$var$restoreTarget = null, $c2968667ab46cac6$var$restoreQueue = null;
function $c2968667ab46cac6$var$restoreStateOfTarget(target) {
    var internalInstance = $c2968667ab46cac6$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$c2968667ab46cac6$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $c2968667ab46cac6$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$c2968667ab46cac6$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(90));
                            $c2968667ab46cac6$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $c2968667ab46cac6$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $c2968667ab46cac6$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $c2968667ab46cac6$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $c2968667ab46cac6$var$isInsideEventHandler = !1;
function $c2968667ab46cac6$var$batchedUpdates$1(fn, a, b) {
    if ($c2968667ab46cac6$var$isInsideEventHandler) return fn(a, b);
    $c2968667ab46cac6$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($c2968667ab46cac6$var$isInsideEventHandler = !1, null !== $c2968667ab46cac6$var$restoreTarget || null !== $c2968667ab46cac6$var$restoreQueue) {
            if ($c2968667ab46cac6$var$flushSyncWork$1(), $c2968667ab46cac6$var$restoreTarget && (a = $c2968667ab46cac6$var$restoreTarget, fn = $c2968667ab46cac6$var$restoreQueue, $c2968667ab46cac6$var$restoreQueue = $c2968667ab46cac6$var$restoreTarget = null, $c2968667ab46cac6$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$c2968667ab46cac6$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $c2968667ab46cac6$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$c2968667ab46cac6$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $c2968667ab46cac6$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c2968667ab46cac6$var$passiveBrowserEventsSupported = !1;
if ($c2968667ab46cac6$var$canUseDOM) try {
    var $c2968667ab46cac6$var$options = {};
    Object.defineProperty($c2968667ab46cac6$var$options, "passive", {
        get: function() {
            $c2968667ab46cac6$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $c2968667ab46cac6$var$options, $c2968667ab46cac6$var$options);
    window.removeEventListener("test", $c2968667ab46cac6$var$options, $c2968667ab46cac6$var$options);
} catch (e) {
    $c2968667ab46cac6$var$passiveBrowserEventsSupported = !1;
}
var $c2968667ab46cac6$var$root = null, $c2968667ab46cac6$var$startText = null, $c2968667ab46cac6$var$fallbackText = null;
function $c2968667ab46cac6$var$getData() {
    if ($c2968667ab46cac6$var$fallbackText) return $c2968667ab46cac6$var$fallbackText;
    var start, startValue = $c2968667ab46cac6$var$startText, startLength = startValue.length, end, endValue = "value" in $c2968667ab46cac6$var$root ? $c2968667ab46cac6$var$root.value : $c2968667ab46cac6$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $c2968667ab46cac6$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $c2968667ab46cac6$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $c2968667ab46cac6$var$functionThatReturnsTrue() {
    return !0;
}
function $c2968667ab46cac6$var$functionThatReturnsFalse() {
    return !1;
}
function $c2968667ab46cac6$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $c2968667ab46cac6$var$functionThatReturnsTrue : $c2968667ab46cac6$var$functionThatReturnsFalse;
        this.isPropagationStopped = $c2968667ab46cac6$var$functionThatReturnsFalse;
        return this;
    }
    $c2968667ab46cac6$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $c2968667ab46cac6$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $c2968667ab46cac6$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $c2968667ab46cac6$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $c2968667ab46cac6$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c2968667ab46cac6$var$SyntheticEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$EventInterface), $c2968667ab46cac6$var$UIEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$EventInterface, {
    view: 0,
    detail: 0
}), $c2968667ab46cac6$var$SyntheticUIEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$UIEventInterface), $c2968667ab46cac6$var$lastMovementX, $c2968667ab46cac6$var$lastMovementY, $c2968667ab46cac6$var$lastMouseEvent, $c2968667ab46cac6$var$MouseEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c2968667ab46cac6$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $c2968667ab46cac6$var$lastMouseEvent && ($c2968667ab46cac6$var$lastMouseEvent && "mousemove" === event.type ? ($c2968667ab46cac6$var$lastMovementX = event.screenX - $c2968667ab46cac6$var$lastMouseEvent.screenX, $c2968667ab46cac6$var$lastMovementY = event.screenY - $c2968667ab46cac6$var$lastMouseEvent.screenY) : $c2968667ab46cac6$var$lastMovementY = $c2968667ab46cac6$var$lastMovementX = 0, $c2968667ab46cac6$var$lastMouseEvent = event);
        return $c2968667ab46cac6$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $c2968667ab46cac6$var$lastMovementY;
    }
}), $c2968667ab46cac6$var$SyntheticMouseEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$MouseEventInterface), $c2968667ab46cac6$var$DragEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$MouseEventInterface, {
    dataTransfer: 0
}), $c2968667ab46cac6$var$SyntheticDragEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$DragEventInterface), $c2968667ab46cac6$var$FocusEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$UIEventInterface, {
    relatedTarget: 0
}), $c2968667ab46cac6$var$SyntheticFocusEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$FocusEventInterface), $c2968667ab46cac6$var$AnimationEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c2968667ab46cac6$var$SyntheticAnimationEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$AnimationEventInterface), $c2968667ab46cac6$var$ClipboardEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $c2968667ab46cac6$var$SyntheticClipboardEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$ClipboardEventInterface), $c2968667ab46cac6$var$CompositionEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$EventInterface, {
    data: 0
}), $c2968667ab46cac6$var$SyntheticCompositionEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$CompositionEventInterface), $c2968667ab46cac6$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c2968667ab46cac6$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c2968667ab46cac6$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c2968667ab46cac6$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $c2968667ab46cac6$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $c2968667ab46cac6$var$getEventModifierState() {
    return $c2968667ab46cac6$var$modifierStateGetter;
}
var $c2968667ab46cac6$var$KeyboardEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $c2968667ab46cac6$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $c2968667ab46cac6$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $c2968667ab46cac6$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c2968667ab46cac6$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $c2968667ab46cac6$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $c2968667ab46cac6$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $c2968667ab46cac6$var$SyntheticKeyboardEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$KeyboardEventInterface), $c2968667ab46cac6$var$PointerEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c2968667ab46cac6$var$SyntheticPointerEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$PointerEventInterface), $c2968667ab46cac6$var$TouchEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c2968667ab46cac6$var$getEventModifierState
}), $c2968667ab46cac6$var$SyntheticTouchEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$TouchEventInterface), $c2968667ab46cac6$var$TransitionEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c2968667ab46cac6$var$SyntheticTransitionEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$TransitionEventInterface), $c2968667ab46cac6$var$WheelEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c2968667ab46cac6$var$SyntheticWheelEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$WheelEventInterface), $c2968667ab46cac6$var$ToggleEventInterface = $c2968667ab46cac6$var$assign({}, $c2968667ab46cac6$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $c2968667ab46cac6$var$SyntheticToggleEvent = $c2968667ab46cac6$var$createSyntheticEvent($c2968667ab46cac6$var$ToggleEventInterface), $c2968667ab46cac6$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $c2968667ab46cac6$var$canUseCompositionEvent = $c2968667ab46cac6$var$canUseDOM && "CompositionEvent" in window, $c2968667ab46cac6$var$documentMode = null;
$c2968667ab46cac6$var$canUseDOM && "documentMode" in document && ($c2968667ab46cac6$var$documentMode = document.documentMode);
var $c2968667ab46cac6$var$canUseTextInputEvent = $c2968667ab46cac6$var$canUseDOM && "TextEvent" in window && !$c2968667ab46cac6$var$documentMode, $c2968667ab46cac6$var$useFallbackCompositionData = $c2968667ab46cac6$var$canUseDOM && (!$c2968667ab46cac6$var$canUseCompositionEvent || $c2968667ab46cac6$var$documentMode && 8 < $c2968667ab46cac6$var$documentMode && 11 >= $c2968667ab46cac6$var$documentMode), $c2968667ab46cac6$var$SPACEBAR_CHAR = String.fromCharCode(32), $c2968667ab46cac6$var$hasSpaceKeypress = !1;
function $c2968667ab46cac6$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $c2968667ab46cac6$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c2968667ab46cac6$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $c2968667ab46cac6$var$isComposing = !1;
function $c2968667ab46cac6$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $c2968667ab46cac6$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $c2968667ab46cac6$var$hasSpaceKeypress = !0;
            return $c2968667ab46cac6$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $c2968667ab46cac6$var$SPACEBAR_CHAR && $c2968667ab46cac6$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $c2968667ab46cac6$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($c2968667ab46cac6$var$isComposing) return "compositionend" === domEventName || !$c2968667ab46cac6$var$canUseCompositionEvent && $c2968667ab46cac6$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $c2968667ab46cac6$var$getData(), $c2968667ab46cac6$var$fallbackText = $c2968667ab46cac6$var$startText = $c2968667ab46cac6$var$root = null, $c2968667ab46cac6$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $c2968667ab46cac6$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $c2968667ab46cac6$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c2968667ab46cac6$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$c2968667ab46cac6$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $c2968667ab46cac6$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $c2968667ab46cac6$var$restoreTarget ? $c2968667ab46cac6$var$restoreQueue ? $c2968667ab46cac6$var$restoreQueue.push(target) : $c2968667ab46cac6$var$restoreQueue = [
        target
    ] : $c2968667ab46cac6$var$restoreTarget = target;
    inst = $c2968667ab46cac6$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $c2968667ab46cac6$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $c2968667ab46cac6$var$activeElement$1 = null, $c2968667ab46cac6$var$activeElementInst$1 = null;
function $c2968667ab46cac6$var$runEventInBatch(dispatchQueue) {
    $c2968667ab46cac6$var$processDispatchQueue(dispatchQueue, 0);
}
function $c2968667ab46cac6$var$getInstIfValueChanged(targetInst) {
    var targetNode = $c2968667ab46cac6$var$getNodeFromInstance(targetInst);
    if ($c2968667ab46cac6$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $c2968667ab46cac6$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $c2968667ab46cac6$var$isInputEventSupported = !1;
if ($c2968667ab46cac6$var$canUseDOM) {
    var $c2968667ab46cac6$var$JSCompiler_inline_result$jscomp$286;
    if ($c2968667ab46cac6$var$canUseDOM) {
        var $c2968667ab46cac6$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$c2968667ab46cac6$var$isSupported$jscomp$inline_427) {
            var $c2968667ab46cac6$var$element$jscomp$inline_428 = document.createElement("div");
            $c2968667ab46cac6$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $c2968667ab46cac6$var$isSupported$jscomp$inline_427 = "function" === typeof $c2968667ab46cac6$var$element$jscomp$inline_428.oninput;
        }
        $c2968667ab46cac6$var$JSCompiler_inline_result$jscomp$286 = $c2968667ab46cac6$var$isSupported$jscomp$inline_427;
    } else $c2968667ab46cac6$var$JSCompiler_inline_result$jscomp$286 = !1;
    $c2968667ab46cac6$var$isInputEventSupported = $c2968667ab46cac6$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $c2968667ab46cac6$var$stopWatchingForValueChange() {
    $c2968667ab46cac6$var$activeElement$1 && ($c2968667ab46cac6$var$activeElement$1.detachEvent("onpropertychange", $c2968667ab46cac6$var$handlePropertyChange), $c2968667ab46cac6$var$activeElementInst$1 = $c2968667ab46cac6$var$activeElement$1 = null);
}
function $c2968667ab46cac6$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $c2968667ab46cac6$var$getInstIfValueChanged($c2968667ab46cac6$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $c2968667ab46cac6$var$createAndAccumulateChangeEvent(dispatchQueue, $c2968667ab46cac6$var$activeElementInst$1, nativeEvent, $c2968667ab46cac6$var$getEventTarget(nativeEvent));
        $c2968667ab46cac6$var$batchedUpdates$1($c2968667ab46cac6$var$runEventInBatch, dispatchQueue);
    }
}
function $c2968667ab46cac6$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($c2968667ab46cac6$var$stopWatchingForValueChange(), $c2968667ab46cac6$var$activeElement$1 = target, $c2968667ab46cac6$var$activeElementInst$1 = targetInst, $c2968667ab46cac6$var$activeElement$1.attachEvent("onpropertychange", $c2968667ab46cac6$var$handlePropertyChange)) : "focusout" === domEventName && $c2968667ab46cac6$var$stopWatchingForValueChange();
}
function $c2968667ab46cac6$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $c2968667ab46cac6$var$getInstIfValueChanged($c2968667ab46cac6$var$activeElementInst$1);
}
function $c2968667ab46cac6$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $c2968667ab46cac6$var$getInstIfValueChanged(targetInst);
}
function $c2968667ab46cac6$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $c2968667ab46cac6$var$getInstIfValueChanged(targetInst);
}
function $c2968667ab46cac6$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $c2968667ab46cac6$var$objectIs = "function" === typeof Object.is ? Object.is : $c2968667ab46cac6$var$is;
function $c2968667ab46cac6$var$shallowEqual(objA, objB) {
    if ($c2968667ab46cac6$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$c2968667ab46cac6$var$hasOwnProperty.call(objB, currentKey) || !$c2968667ab46cac6$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $c2968667ab46cac6$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $c2968667ab46cac6$var$getNodeForCharacterOffset(root, offset) {
    var node = $c2968667ab46cac6$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $c2968667ab46cac6$var$getLeafNode(node);
    }
}
function $c2968667ab46cac6$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $c2968667ab46cac6$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $c2968667ab46cac6$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $c2968667ab46cac6$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $c2968667ab46cac6$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $c2968667ab46cac6$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $c2968667ab46cac6$var$skipSelectionChangeEvent = $c2968667ab46cac6$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $c2968667ab46cac6$var$activeElement = null, $c2968667ab46cac6$var$activeElementInst = null, $c2968667ab46cac6$var$lastSelection = null, $c2968667ab46cac6$var$mouseDown = !1;
function $c2968667ab46cac6$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $c2968667ab46cac6$var$mouseDown || null == $c2968667ab46cac6$var$activeElement || $c2968667ab46cac6$var$activeElement !== $c2968667ab46cac6$var$getActiveElement(doc) || (doc = $c2968667ab46cac6$var$activeElement, "selectionStart" in doc && $c2968667ab46cac6$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $c2968667ab46cac6$var$lastSelection && $c2968667ab46cac6$var$shallowEqual($c2968667ab46cac6$var$lastSelection, doc) || ($c2968667ab46cac6$var$lastSelection = doc, doc = $c2968667ab46cac6$var$accumulateTwoPhaseListeners($c2968667ab46cac6$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $c2968667ab46cac6$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $c2968667ab46cac6$var$activeElement)));
}
function $c2968667ab46cac6$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $c2968667ab46cac6$var$vendorPrefixes = {
    animationend: $c2968667ab46cac6$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $c2968667ab46cac6$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $c2968667ab46cac6$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $c2968667ab46cac6$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $c2968667ab46cac6$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $c2968667ab46cac6$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $c2968667ab46cac6$var$makePrefixMap("Transition", "TransitionEnd")
}, $c2968667ab46cac6$var$prefixedEventNames = {}, $c2968667ab46cac6$var$style = {};
$c2968667ab46cac6$var$canUseDOM && ($c2968667ab46cac6$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $c2968667ab46cac6$var$vendorPrefixes.animationend.animation, delete $c2968667ab46cac6$var$vendorPrefixes.animationiteration.animation, delete $c2968667ab46cac6$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $c2968667ab46cac6$var$vendorPrefixes.transitionend.transition);
function $c2968667ab46cac6$var$getVendorPrefixedEventName(eventName) {
    if ($c2968667ab46cac6$var$prefixedEventNames[eventName]) return $c2968667ab46cac6$var$prefixedEventNames[eventName];
    if (!$c2968667ab46cac6$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $c2968667ab46cac6$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $c2968667ab46cac6$var$style) return $c2968667ab46cac6$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $c2968667ab46cac6$var$ANIMATION_END = $c2968667ab46cac6$var$getVendorPrefixedEventName("animationend"), $c2968667ab46cac6$var$ANIMATION_ITERATION = $c2968667ab46cac6$var$getVendorPrefixedEventName("animationiteration"), $c2968667ab46cac6$var$ANIMATION_START = $c2968667ab46cac6$var$getVendorPrefixedEventName("animationstart"), $c2968667ab46cac6$var$TRANSITION_RUN = $c2968667ab46cac6$var$getVendorPrefixedEventName("transitionrun"), $c2968667ab46cac6$var$TRANSITION_START = $c2968667ab46cac6$var$getVendorPrefixedEventName("transitionstart"), $c2968667ab46cac6$var$TRANSITION_CANCEL = $c2968667ab46cac6$var$getVendorPrefixedEventName("transitioncancel"), $c2968667ab46cac6$var$TRANSITION_END = $c2968667ab46cac6$var$getVendorPrefixedEventName("transitionend"), $c2968667ab46cac6$var$topLevelEventsToReactNames = new Map(), $c2968667ab46cac6$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$c2968667ab46cac6$var$simpleEventPluginEvents.push("scrollEnd");
function $c2968667ab46cac6$var$registerSimpleEvent(domEventName, reactName) {
    $c2968667ab46cac6$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $c2968667ab46cac6$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $c2968667ab46cac6$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $c2968667ab46cac6$var$concurrentQueues = [], $c2968667ab46cac6$var$concurrentQueuesIndex = 0, $c2968667ab46cac6$var$concurrentlyUpdatedLanes = 0;
function $c2968667ab46cac6$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $c2968667ab46cac6$var$concurrentQueuesIndex, i = $c2968667ab46cac6$var$concurrentlyUpdatedLanes = $c2968667ab46cac6$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $c2968667ab46cac6$var$concurrentQueues[i];
        $c2968667ab46cac6$var$concurrentQueues[i++] = null;
        var queue = $c2968667ab46cac6$var$concurrentQueues[i];
        $c2968667ab46cac6$var$concurrentQueues[i++] = null;
        var update = $c2968667ab46cac6$var$concurrentQueues[i];
        $c2968667ab46cac6$var$concurrentQueues[i++] = null;
        var lane = $c2968667ab46cac6$var$concurrentQueues[i];
        $c2968667ab46cac6$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $c2968667ab46cac6$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $c2968667ab46cac6$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $c2968667ab46cac6$var$concurrentQueues[$c2968667ab46cac6$var$concurrentQueuesIndex++] = fiber;
    $c2968667ab46cac6$var$concurrentQueues[$c2968667ab46cac6$var$concurrentQueuesIndex++] = queue;
    $c2968667ab46cac6$var$concurrentQueues[$c2968667ab46cac6$var$concurrentQueuesIndex++] = update;
    $c2968667ab46cac6$var$concurrentQueues[$c2968667ab46cac6$var$concurrentQueuesIndex++] = lane;
    $c2968667ab46cac6$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $c2968667ab46cac6$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $c2968667ab46cac6$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $c2968667ab46cac6$var$getRootForUpdatedFiber(fiber);
}
function $c2968667ab46cac6$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $c2968667ab46cac6$var$enqueueUpdate$1(fiber, null, null, lane);
    return $c2968667ab46cac6$var$getRootForUpdatedFiber(fiber);
}
function $c2968667ab46cac6$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $c2968667ab46cac6$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $c2968667ab46cac6$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $c2968667ab46cac6$var$nestedUpdateCount) throw $c2968667ab46cac6$var$nestedUpdateCount = 0, $c2968667ab46cac6$var$rootWithNestedUpdates = null, Error($c2968667ab46cac6$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $c2968667ab46cac6$var$emptyContextObject = {};
function $c2968667ab46cac6$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $c2968667ab46cac6$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $c2968667ab46cac6$var$FiberNode(tag, pendingProps, key, mode);
}
function $c2968667ab46cac6$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $c2968667ab46cac6$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $c2968667ab46cac6$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $c2968667ab46cac6$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $c2968667ab46cac6$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $c2968667ab46cac6$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $c2968667ab46cac6$var$isHostHoistableType(type, pendingProps, $c2968667ab46cac6$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $c2968667ab46cac6$var$REACT_ACTIVITY_TYPE:
            return type = $c2968667ab46cac6$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $c2968667ab46cac6$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $c2968667ab46cac6$var$REACT_FRAGMENT_TYPE:
            return $c2968667ab46cac6$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $c2968667ab46cac6$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $c2968667ab46cac6$var$REACT_PROFILER_TYPE:
            return type = $c2968667ab46cac6$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $c2968667ab46cac6$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $c2968667ab46cac6$var$REACT_SUSPENSE_TYPE:
            return type = $c2968667ab46cac6$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $c2968667ab46cac6$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $c2968667ab46cac6$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $c2968667ab46cac6$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $c2968667ab46cac6$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case $c2968667ab46cac6$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $c2968667ab46cac6$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $c2968667ab46cac6$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $c2968667ab46cac6$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $c2968667ab46cac6$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($c2968667ab46cac6$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $c2968667ab46cac6$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $c2968667ab46cac6$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $c2968667ab46cac6$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $c2968667ab46cac6$var$createFiberFromText(content, mode, lanes) {
    content = $c2968667ab46cac6$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $c2968667ab46cac6$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $c2968667ab46cac6$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $c2968667ab46cac6$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $c2968667ab46cac6$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $c2968667ab46cac6$var$CapturedStacks = new WeakMap();
function $c2968667ab46cac6$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $c2968667ab46cac6$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $c2968667ab46cac6$var$getStackByFiberInDevAndProd(source)
        };
        $c2968667ab46cac6$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $c2968667ab46cac6$var$getStackByFiberInDevAndProd(source)
    };
}
var $c2968667ab46cac6$var$forkStack = [], $c2968667ab46cac6$var$forkStackIndex = 0, $c2968667ab46cac6$var$treeForkProvider = null, $c2968667ab46cac6$var$treeForkCount = 0, $c2968667ab46cac6$var$idStack = [], $c2968667ab46cac6$var$idStackIndex = 0, $c2968667ab46cac6$var$treeContextProvider = null, $c2968667ab46cac6$var$treeContextId = 1, $c2968667ab46cac6$var$treeContextOverflow = "";
function $c2968667ab46cac6$var$pushTreeFork(workInProgress, totalChildren) {
    $c2968667ab46cac6$var$forkStack[$c2968667ab46cac6$var$forkStackIndex++] = $c2968667ab46cac6$var$treeForkCount;
    $c2968667ab46cac6$var$forkStack[$c2968667ab46cac6$var$forkStackIndex++] = $c2968667ab46cac6$var$treeForkProvider;
    $c2968667ab46cac6$var$treeForkProvider = workInProgress;
    $c2968667ab46cac6$var$treeForkCount = totalChildren;
}
function $c2968667ab46cac6$var$pushTreeId(workInProgress, totalChildren, index) {
    $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex++] = $c2968667ab46cac6$var$treeContextId;
    $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex++] = $c2968667ab46cac6$var$treeContextOverflow;
    $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex++] = $c2968667ab46cac6$var$treeContextProvider;
    $c2968667ab46cac6$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $c2968667ab46cac6$var$treeContextId;
    workInProgress = $c2968667ab46cac6$var$treeContextOverflow;
    var baseLength = 32 - $c2968667ab46cac6$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $c2968667ab46cac6$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $c2968667ab46cac6$var$treeContextId = 1 << 32 - $c2968667ab46cac6$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $c2968667ab46cac6$var$treeContextOverflow = length + workInProgress;
    } else $c2968667ab46cac6$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $c2968667ab46cac6$var$treeContextOverflow = workInProgress;
}
function $c2968667ab46cac6$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($c2968667ab46cac6$var$pushTreeFork(workInProgress, 1), $c2968667ab46cac6$var$pushTreeId(workInProgress, 1, 0));
}
function $c2968667ab46cac6$var$popTreeContext(workInProgress) {
    for(; workInProgress === $c2968667ab46cac6$var$treeForkProvider;)$c2968667ab46cac6$var$treeForkProvider = $c2968667ab46cac6$var$forkStack[--$c2968667ab46cac6$var$forkStackIndex], $c2968667ab46cac6$var$forkStack[$c2968667ab46cac6$var$forkStackIndex] = null, $c2968667ab46cac6$var$treeForkCount = $c2968667ab46cac6$var$forkStack[--$c2968667ab46cac6$var$forkStackIndex], $c2968667ab46cac6$var$forkStack[$c2968667ab46cac6$var$forkStackIndex] = null;
    for(; workInProgress === $c2968667ab46cac6$var$treeContextProvider;)$c2968667ab46cac6$var$treeContextProvider = $c2968667ab46cac6$var$idStack[--$c2968667ab46cac6$var$idStackIndex], $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex] = null, $c2968667ab46cac6$var$treeContextOverflow = $c2968667ab46cac6$var$idStack[--$c2968667ab46cac6$var$idStackIndex], $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex] = null, $c2968667ab46cac6$var$treeContextId = $c2968667ab46cac6$var$idStack[--$c2968667ab46cac6$var$idStackIndex], $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex] = null;
}
function $c2968667ab46cac6$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex++] = $c2968667ab46cac6$var$treeContextId;
    $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex++] = $c2968667ab46cac6$var$treeContextOverflow;
    $c2968667ab46cac6$var$idStack[$c2968667ab46cac6$var$idStackIndex++] = $c2968667ab46cac6$var$treeContextProvider;
    $c2968667ab46cac6$var$treeContextId = suspendedContext.id;
    $c2968667ab46cac6$var$treeContextOverflow = suspendedContext.overflow;
    $c2968667ab46cac6$var$treeContextProvider = workInProgress;
}
var $c2968667ab46cac6$var$hydrationParentFiber = null, $c2968667ab46cac6$var$nextHydratableInstance = null, $c2968667ab46cac6$var$isHydrating = !1, $c2968667ab46cac6$var$hydrationErrors = null, $c2968667ab46cac6$var$rootOrSingletonContext = !1, $c2968667ab46cac6$var$HydrationMismatchException = Error($c2968667ab46cac6$var$formatProdErrorMessage(519));
function $c2968667ab46cac6$var$throwOnHydrationMismatch(fiber) {
    var error = Error($c2968667ab46cac6$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $c2968667ab46cac6$var$queueHydrationError($c2968667ab46cac6$var$createCapturedValueAtFiber(error, fiber));
    throw $c2968667ab46cac6$var$HydrationMismatchException;
}
function $c2968667ab46cac6$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$c2968667ab46cac6$var$internalInstanceKey] = fiber;
    instance[$c2968667ab46cac6$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("cancel", instance);
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $c2968667ab46cac6$var$mediaEventTypes.length; type++)$c2968667ab46cac6$var$listenToNonDelegatedEvent($c2968667ab46cac6$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("error", instance);
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("invalid", instance);
            $c2968667ab46cac6$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("invalid", instance), $c2968667ab46cac6$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $c2968667ab46cac6$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($c2968667ab46cac6$var$listenToNonDelegatedEvent("beforetoggle", instance), $c2968667ab46cac6$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $c2968667ab46cac6$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $c2968667ab46cac6$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $c2968667ab46cac6$var$noop$1), instance = !0) : instance = !1;
    instance || $c2968667ab46cac6$var$throwOnHydrationMismatch(fiber, !0);
}
function $c2968667ab46cac6$var$popToNextHostParent(fiber) {
    for($c2968667ab46cac6$var$hydrationParentFiber = fiber.return; $c2968667ab46cac6$var$hydrationParentFiber;)switch($c2968667ab46cac6$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $c2968667ab46cac6$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $c2968667ab46cac6$var$rootOrSingletonContext = !0;
            return;
        default:
            $c2968667ab46cac6$var$hydrationParentFiber = $c2968667ab46cac6$var$hydrationParentFiber.return;
    }
}
function $c2968667ab46cac6$var$popHydrationState(fiber) {
    if (fiber !== $c2968667ab46cac6$var$hydrationParentFiber) return !1;
    if (!$c2968667ab46cac6$var$isHydrating) return $c2968667ab46cac6$var$popToNextHostParent(fiber), $c2968667ab46cac6$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $c2968667ab46cac6$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $c2968667ab46cac6$var$nextHydratableInstance && $c2968667ab46cac6$var$throwOnHydrationMismatch(fiber);
    $c2968667ab46cac6$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(317));
        $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(317));
        $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $c2968667ab46cac6$var$nextHydratableInstance, $c2968667ab46cac6$var$isSingletonScope(fiber.type) ? (fiber = $c2968667ab46cac6$var$previousHydratableOnEnteringScopedSingleton, $c2968667ab46cac6$var$previousHydratableOnEnteringScopedSingleton = null, $c2968667ab46cac6$var$nextHydratableInstance = fiber) : $c2968667ab46cac6$var$nextHydratableInstance = tag) : $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$hydrationParentFiber ? $c2968667ab46cac6$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $c2968667ab46cac6$var$resetHydrationState() {
    $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$hydrationParentFiber = null;
    $c2968667ab46cac6$var$isHydrating = !1;
}
function $c2968667ab46cac6$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $c2968667ab46cac6$var$hydrationErrors;
    null !== queuedErrors && (null === $c2968667ab46cac6$var$workInProgressRootRecoverableErrors ? $c2968667ab46cac6$var$workInProgressRootRecoverableErrors = queuedErrors : $c2968667ab46cac6$var$workInProgressRootRecoverableErrors.push.apply($c2968667ab46cac6$var$workInProgressRootRecoverableErrors, queuedErrors), $c2968667ab46cac6$var$hydrationErrors = null);
    return queuedErrors;
}
function $c2968667ab46cac6$var$queueHydrationError(error) {
    null === $c2968667ab46cac6$var$hydrationErrors ? $c2968667ab46cac6$var$hydrationErrors = [
        error
    ] : $c2968667ab46cac6$var$hydrationErrors.push(error);
}
var $c2968667ab46cac6$var$valueCursor = $c2968667ab46cac6$var$createCursor(null), $c2968667ab46cac6$var$currentlyRenderingFiber$1 = null, $c2968667ab46cac6$var$lastContextDependency = null;
function $c2968667ab46cac6$var$pushProvider(providerFiber, context, nextValue) {
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $c2968667ab46cac6$var$popProvider(context) {
    context._currentValue = $c2968667ab46cac6$var$valueCursor.current;
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$valueCursor);
}
function $c2968667ab46cac6$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $c2968667ab46cac6$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $c2968667ab46cac6$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $c2968667ab46cac6$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $c2968667ab46cac6$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $c2968667ab46cac6$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $c2968667ab46cac6$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($c2968667ab46cac6$var$HostTransitionContext) : current = [
                $c2968667ab46cac6$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $c2968667ab46cac6$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $c2968667ab46cac6$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$c2968667ab46cac6$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $c2968667ab46cac6$var$prepareToReadContext(workInProgress) {
    $c2968667ab46cac6$var$currentlyRenderingFiber$1 = workInProgress;
    $c2968667ab46cac6$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $c2968667ab46cac6$var$readContext(context) {
    return $c2968667ab46cac6$var$readContextForConsumer($c2968667ab46cac6$var$currentlyRenderingFiber$1, context);
}
function $c2968667ab46cac6$var$readContextDuringReconciliation(consumer, context) {
    null === $c2968667ab46cac6$var$currentlyRenderingFiber$1 && $c2968667ab46cac6$var$prepareToReadContext(consumer);
    return $c2968667ab46cac6$var$readContextForConsumer(consumer, context);
}
function $c2968667ab46cac6$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $c2968667ab46cac6$var$lastContextDependency) {
        if (null === consumer) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(308));
        $c2968667ab46cac6$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $c2968667ab46cac6$var$lastContextDependency = $c2968667ab46cac6$var$lastContextDependency.next = context;
    return value;
}
var $c2968667ab46cac6$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $c2968667ab46cac6$var$scheduleCallback$2 = $f04nL.unstable_scheduleCallback, $c2968667ab46cac6$var$NormalPriority = $f04nL.unstable_NormalPriority, $c2968667ab46cac6$var$CacheContext = {
    $$typeof: $c2968667ab46cac6$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $c2968667ab46cac6$var$createCache() {
    return {
        controller: new $c2968667ab46cac6$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $c2968667ab46cac6$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $c2968667ab46cac6$var$scheduleCallback$2($c2968667ab46cac6$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $c2968667ab46cac6$var$currentEntangledListeners = null, $c2968667ab46cac6$var$currentEntangledPendingCount = 0, $c2968667ab46cac6$var$currentEntangledLane = 0, $c2968667ab46cac6$var$currentEntangledActionThenable = null;
function $c2968667ab46cac6$var$entangleAsyncAction(transition, thenable) {
    if (null === $c2968667ab46cac6$var$currentEntangledListeners) {
        var entangledListeners = $c2968667ab46cac6$var$currentEntangledListeners = [];
        $c2968667ab46cac6$var$currentEntangledPendingCount = 0;
        $c2968667ab46cac6$var$currentEntangledLane = $c2968667ab46cac6$var$requestTransitionLane();
        $c2968667ab46cac6$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $c2968667ab46cac6$var$currentEntangledPendingCount++;
    thenable.then($c2968667ab46cac6$var$pingEngtangledActionScope, $c2968667ab46cac6$var$pingEngtangledActionScope);
    return thenable;
}
function $c2968667ab46cac6$var$pingEngtangledActionScope() {
    if (0 === --$c2968667ab46cac6$var$currentEntangledPendingCount && null !== $c2968667ab46cac6$var$currentEntangledListeners) {
        null !== $c2968667ab46cac6$var$currentEntangledActionThenable && ($c2968667ab46cac6$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $c2968667ab46cac6$var$currentEntangledListeners;
        $c2968667ab46cac6$var$currentEntangledListeners = null;
        $c2968667ab46cac6$var$currentEntangledLane = 0;
        $c2968667ab46cac6$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $c2968667ab46cac6$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $c2968667ab46cac6$var$prevOnStartTransitionFinish = $c2968667ab46cac6$var$ReactSharedInternals.S;
$c2968667ab46cac6$var$ReactSharedInternals.S = function(transition, returnValue) {
    $c2968667ab46cac6$var$globalMostRecentTransitionTime = $c2968667ab46cac6$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $c2968667ab46cac6$var$entangleAsyncAction(transition, returnValue);
    null !== $c2968667ab46cac6$var$prevOnStartTransitionFinish && $c2968667ab46cac6$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $c2968667ab46cac6$var$resumedCache = $c2968667ab46cac6$var$createCursor(null);
function $c2968667ab46cac6$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $c2968667ab46cac6$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $c2968667ab46cac6$var$workInProgressRoot.pooledCache;
}
function $c2968667ab46cac6$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $c2968667ab46cac6$var$push($c2968667ab46cac6$var$resumedCache, $c2968667ab46cac6$var$resumedCache.current) : $c2968667ab46cac6$var$push($c2968667ab46cac6$var$resumedCache, prevCachePool.pool);
}
function $c2968667ab46cac6$var$getSuspendedCache() {
    var cacheFromPool = $c2968667ab46cac6$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $c2968667ab46cac6$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $c2968667ab46cac6$var$SuspenseException = Error($c2968667ab46cac6$var$formatProdErrorMessage(460)), $c2968667ab46cac6$var$SuspenseyCommitException = Error($c2968667ab46cac6$var$formatProdErrorMessage(474)), $c2968667ab46cac6$var$SuspenseActionException = Error($c2968667ab46cac6$var$formatProdErrorMessage(542)), $c2968667ab46cac6$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $c2968667ab46cac6$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $c2968667ab46cac6$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($c2968667ab46cac6$var$noop$1, $c2968667ab46cac6$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $c2968667ab46cac6$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($c2968667ab46cac6$var$noop$1, $c2968667ab46cac6$var$noop$1);
            else {
                thenableState = $c2968667ab46cac6$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $c2968667ab46cac6$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $c2968667ab46cac6$var$suspendedThenable = thenable;
            throw $c2968667ab46cac6$var$SuspenseException;
    }
}
function $c2968667ab46cac6$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $c2968667ab46cac6$var$suspendedThenable = x, $c2968667ab46cac6$var$SuspenseException;
        throw x;
    }
}
var $c2968667ab46cac6$var$suspendedThenable = null;
function $c2968667ab46cac6$var$getSuspendedThenable() {
    if (null === $c2968667ab46cac6$var$suspendedThenable) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(459));
    var thenable = $c2968667ab46cac6$var$suspendedThenable;
    $c2968667ab46cac6$var$suspendedThenable = null;
    return thenable;
}
function $c2968667ab46cac6$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $c2968667ab46cac6$var$SuspenseException || rejectedReason === $c2968667ab46cac6$var$SuspenseActionException) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(483));
}
var $c2968667ab46cac6$var$thenableState$1 = null, $c2968667ab46cac6$var$thenableIndexCounter$1 = 0;
function $c2968667ab46cac6$var$unwrapThenable(thenable) {
    var index = $c2968667ab46cac6$var$thenableIndexCounter$1;
    $c2968667ab46cac6$var$thenableIndexCounter$1 += 1;
    null === $c2968667ab46cac6$var$thenableState$1 && ($c2968667ab46cac6$var$thenableState$1 = []);
    return $c2968667ab46cac6$var$trackUsedThenable($c2968667ab46cac6$var$thenableState$1, thenable, index);
}
function $c2968667ab46cac6$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $c2968667ab46cac6$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $c2968667ab46cac6$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $c2968667ab46cac6$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $c2968667ab46cac6$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $c2968667ab46cac6$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $c2968667ab46cac6$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $c2968667ab46cac6$var$REACT_LAZY_TYPE && $c2968667ab46cac6$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $c2968667ab46cac6$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $c2968667ab46cac6$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $c2968667ab46cac6$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $c2968667ab46cac6$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $c2968667ab46cac6$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $c2968667ab46cac6$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c2968667ab46cac6$var$REACT_ELEMENT_TYPE:
                    return lanes = $c2968667ab46cac6$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $c2968667ab46cac6$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $c2968667ab46cac6$var$REACT_PORTAL_TYPE:
                    return newChild = $c2968667ab46cac6$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $c2968667ab46cac6$var$REACT_LAZY_TYPE:
                    return newChild = $c2968667ab46cac6$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($c2968667ab46cac6$var$isArrayImpl(newChild) || $c2968667ab46cac6$var$getIteratorFn(newChild)) return newChild = $c2968667ab46cac6$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $c2968667ab46cac6$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c2968667ab46cac6$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $c2968667ab46cac6$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c2968667ab46cac6$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c2968667ab46cac6$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $c2968667ab46cac6$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $c2968667ab46cac6$var$REACT_LAZY_TYPE:
                    return newChild = $c2968667ab46cac6$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($c2968667ab46cac6$var$isArrayImpl(newChild) || $c2968667ab46cac6$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $c2968667ab46cac6$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c2968667ab46cac6$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $c2968667ab46cac6$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c2968667ab46cac6$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c2968667ab46cac6$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $c2968667ab46cac6$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $c2968667ab46cac6$var$REACT_LAZY_TYPE:
                    return newChild = $c2968667ab46cac6$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($c2968667ab46cac6$var$isArrayImpl(newChild) || $c2968667ab46cac6$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $c2968667ab46cac6$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c2968667ab46cac6$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $c2968667ab46cac6$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c2968667ab46cac6$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $c2968667ab46cac6$var$isHydrating && $c2968667ab46cac6$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $c2968667ab46cac6$var$isHydrating && $c2968667ab46cac6$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $c2968667ab46cac6$var$isHydrating && $c2968667ab46cac6$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $c2968667ab46cac6$var$isHydrating && $c2968667ab46cac6$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $c2968667ab46cac6$var$isHydrating && $c2968667ab46cac6$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $c2968667ab46cac6$var$isHydrating && $c2968667ab46cac6$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $c2968667ab46cac6$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $c2968667ab46cac6$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $c2968667ab46cac6$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $c2968667ab46cac6$var$REACT_LAZY_TYPE && $c2968667ab46cac6$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $c2968667ab46cac6$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $c2968667ab46cac6$var$REACT_FRAGMENT_TYPE ? (lanes = $c2968667ab46cac6$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $c2968667ab46cac6$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $c2968667ab46cac6$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $c2968667ab46cac6$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $c2968667ab46cac6$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $c2968667ab46cac6$var$REACT_LAZY_TYPE:
                    return newChild = $c2968667ab46cac6$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($c2968667ab46cac6$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($c2968667ab46cac6$var$getIteratorFn(newChild)) {
                key = $c2968667ab46cac6$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $c2968667ab46cac6$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $c2968667ab46cac6$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $c2968667ab46cac6$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $c2968667ab46cac6$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $c2968667ab46cac6$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $c2968667ab46cac6$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $c2968667ab46cac6$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $c2968667ab46cac6$var$SuspenseException || x === $c2968667ab46cac6$var$SuspenseActionException) throw x;
            var fiber = $c2968667ab46cac6$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $c2968667ab46cac6$var$reconcileChildFibers = $c2968667ab46cac6$var$createChildReconciler(!0), $c2968667ab46cac6$var$mountChildFibers = $c2968667ab46cac6$var$createChildReconciler(!1), $c2968667ab46cac6$var$hasForceUpdate = !1;
function $c2968667ab46cac6$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $c2968667ab46cac6$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $c2968667ab46cac6$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c2968667ab46cac6$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($c2968667ab46cac6$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $c2968667ab46cac6$var$getRootForUpdatedFiber(fiber);
        $c2968667ab46cac6$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $c2968667ab46cac6$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $c2968667ab46cac6$var$getRootForUpdatedFiber(fiber);
}
function $c2968667ab46cac6$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $c2968667ab46cac6$var$markRootEntangled(root, lane);
    }
}
function $c2968667ab46cac6$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $c2968667ab46cac6$var$didReadFromEntangledAsyncAction = !1;
function $c2968667ab46cac6$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($c2968667ab46cac6$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $c2968667ab46cac6$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $c2968667ab46cac6$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $c2968667ab46cac6$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $c2968667ab46cac6$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($c2968667ab46cac6$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $c2968667ab46cac6$var$currentEntangledLane && ($c2968667ab46cac6$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $c2968667ab46cac6$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $c2968667ab46cac6$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $c2968667ab46cac6$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $c2968667ab46cac6$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $c2968667ab46cac6$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$c2968667ab46cac6$var$callCallback(callbacks[updateQueue], context);
}
var $c2968667ab46cac6$var$currentTreeHiddenStackCursor = $c2968667ab46cac6$var$createCursor(null), $c2968667ab46cac6$var$prevEntangledRenderLanesCursor = $c2968667ab46cac6$var$createCursor(0);
function $c2968667ab46cac6$var$pushHiddenContext(fiber, context) {
    fiber = $c2968667ab46cac6$var$entangledRenderLanes;
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$prevEntangledRenderLanesCursor, fiber);
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$currentTreeHiddenStackCursor, context);
    $c2968667ab46cac6$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $c2968667ab46cac6$var$reuseHiddenContextOnStack() {
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$prevEntangledRenderLanesCursor, $c2968667ab46cac6$var$entangledRenderLanes);
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$currentTreeHiddenStackCursor, $c2968667ab46cac6$var$currentTreeHiddenStackCursor.current);
}
function $c2968667ab46cac6$var$popHiddenContext() {
    $c2968667ab46cac6$var$entangledRenderLanes = $c2968667ab46cac6$var$prevEntangledRenderLanesCursor.current;
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$currentTreeHiddenStackCursor);
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$prevEntangledRenderLanesCursor);
}
var $c2968667ab46cac6$var$suspenseHandlerStackCursor = $c2968667ab46cac6$var$createCursor(null), $c2968667ab46cac6$var$shellBoundary = null;
function $c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseStackCursor, $c2968667ab46cac6$var$suspenseStackCursor.current & 1);
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseHandlerStackCursor, handler);
    null === $c2968667ab46cac6$var$shellBoundary && (null === current || null !== $c2968667ab46cac6$var$currentTreeHiddenStackCursor.current ? $c2968667ab46cac6$var$shellBoundary = handler : null !== current.memoizedState && ($c2968667ab46cac6$var$shellBoundary = handler));
}
function $c2968667ab46cac6$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseStackCursor, $c2968667ab46cac6$var$suspenseStackCursor.current);
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseHandlerStackCursor, fiber);
    null === $c2968667ab46cac6$var$shellBoundary && ($c2968667ab46cac6$var$shellBoundary = fiber);
}
function $c2968667ab46cac6$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseStackCursor, $c2968667ab46cac6$var$suspenseStackCursor.current), $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseHandlerStackCursor, fiber), null === $c2968667ab46cac6$var$shellBoundary && ($c2968667ab46cac6$var$shellBoundary = fiber)) : $c2968667ab46cac6$var$reuseSuspenseHandlerOnStack(fiber);
}
function $c2968667ab46cac6$var$reuseSuspenseHandlerOnStack() {
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseStackCursor, $c2968667ab46cac6$var$suspenseStackCursor.current);
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseHandlerStackCursor, $c2968667ab46cac6$var$suspenseHandlerStackCursor.current);
}
function $c2968667ab46cac6$var$popSuspenseHandler(fiber) {
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$suspenseHandlerStackCursor);
    $c2968667ab46cac6$var$shellBoundary === fiber && ($c2968667ab46cac6$var$shellBoundary = null);
    $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$suspenseStackCursor);
}
var $c2968667ab46cac6$var$suspenseStackCursor = $c2968667ab46cac6$var$createCursor(0);
function $c2968667ab46cac6$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $c2968667ab46cac6$var$isSuspenseInstancePending(state) || $c2968667ab46cac6$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $c2968667ab46cac6$var$renderLanes = 0, $c2968667ab46cac6$var$currentlyRenderingFiber = null, $c2968667ab46cac6$var$currentHook = null, $c2968667ab46cac6$var$workInProgressHook = null, $c2968667ab46cac6$var$didScheduleRenderPhaseUpdate = !1, $c2968667ab46cac6$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $c2968667ab46cac6$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $c2968667ab46cac6$var$localIdCounter = 0, $c2968667ab46cac6$var$thenableIndexCounter = 0, $c2968667ab46cac6$var$thenableState = null, $c2968667ab46cac6$var$globalClientIdCounter = 0;
function $c2968667ab46cac6$var$throwInvalidHookError() {
    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(321));
}
function $c2968667ab46cac6$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$c2968667ab46cac6$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $c2968667ab46cac6$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $c2968667ab46cac6$var$renderLanes = nextRenderLanes;
    $c2968667ab46cac6$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $c2968667ab46cac6$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $c2968667ab46cac6$var$HooksDispatcherOnMount : $c2968667ab46cac6$var$HooksDispatcherOnUpdate;
    $c2968667ab46cac6$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $c2968667ab46cac6$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $c2968667ab46cac6$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $c2968667ab46cac6$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $c2968667ab46cac6$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $c2968667ab46cac6$var$finishRenderingHooks(current) {
    $c2968667ab46cac6$var$ReactSharedInternals.H = $c2968667ab46cac6$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $c2968667ab46cac6$var$currentHook && null !== $c2968667ab46cac6$var$currentHook.next;
    $c2968667ab46cac6$var$renderLanes = 0;
    $c2968667ab46cac6$var$workInProgressHook = $c2968667ab46cac6$var$currentHook = $c2968667ab46cac6$var$currentlyRenderingFiber = null;
    $c2968667ab46cac6$var$didScheduleRenderPhaseUpdate = !1;
    $c2968667ab46cac6$var$thenableIndexCounter = 0;
    $c2968667ab46cac6$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(300));
    null === current || $c2968667ab46cac6$var$didReceiveUpdate || (current = current.dependencies, null !== current && $c2968667ab46cac6$var$checkIfContextChanged(current) && ($c2968667ab46cac6$var$didReceiveUpdate = !0));
}
function $c2968667ab46cac6$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $c2968667ab46cac6$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $c2968667ab46cac6$var$didScheduleRenderPhaseUpdateDuringThisPass && ($c2968667ab46cac6$var$thenableState = null);
        $c2968667ab46cac6$var$thenableIndexCounter = 0;
        $c2968667ab46cac6$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $c2968667ab46cac6$var$workInProgressHook = $c2968667ab46cac6$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $c2968667ab46cac6$var$ReactSharedInternals.H = $c2968667ab46cac6$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($c2968667ab46cac6$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $c2968667ab46cac6$var$TransitionAwareHostComponent() {
    var dispatcher = $c2968667ab46cac6$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $c2968667ab46cac6$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $c2968667ab46cac6$var$currentHook ? $c2968667ab46cac6$var$currentHook.memoizedState : null) !== dispatcher && ($c2968667ab46cac6$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $c2968667ab46cac6$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $c2968667ab46cac6$var$localIdCounter;
    $c2968667ab46cac6$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $c2968667ab46cac6$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $c2968667ab46cac6$var$resetHooksOnUnwind(workInProgress) {
    if ($c2968667ab46cac6$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $c2968667ab46cac6$var$didScheduleRenderPhaseUpdate = !1;
    }
    $c2968667ab46cac6$var$renderLanes = 0;
    $c2968667ab46cac6$var$workInProgressHook = $c2968667ab46cac6$var$currentHook = $c2968667ab46cac6$var$currentlyRenderingFiber = null;
    $c2968667ab46cac6$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $c2968667ab46cac6$var$thenableIndexCounter = $c2968667ab46cac6$var$localIdCounter = 0;
    $c2968667ab46cac6$var$thenableState = null;
}
function $c2968667ab46cac6$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c2968667ab46cac6$var$workInProgressHook ? $c2968667ab46cac6$var$currentlyRenderingFiber.memoizedState = $c2968667ab46cac6$var$workInProgressHook = hook : $c2968667ab46cac6$var$workInProgressHook = $c2968667ab46cac6$var$workInProgressHook.next = hook;
    return $c2968667ab46cac6$var$workInProgressHook;
}
function $c2968667ab46cac6$var$updateWorkInProgressHook() {
    if (null === $c2968667ab46cac6$var$currentHook) {
        var nextCurrentHook = $c2968667ab46cac6$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $c2968667ab46cac6$var$currentHook.next;
    var nextWorkInProgressHook = null === $c2968667ab46cac6$var$workInProgressHook ? $c2968667ab46cac6$var$currentlyRenderingFiber.memoizedState : $c2968667ab46cac6$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $c2968667ab46cac6$var$workInProgressHook = nextWorkInProgressHook, $c2968667ab46cac6$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $c2968667ab46cac6$var$currentlyRenderingFiber.alternate) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(467));
            throw Error($c2968667ab46cac6$var$formatProdErrorMessage(310));
        }
        $c2968667ab46cac6$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $c2968667ab46cac6$var$currentHook.memoizedState,
            baseState: $c2968667ab46cac6$var$currentHook.baseState,
            baseQueue: $c2968667ab46cac6$var$currentHook.baseQueue,
            queue: $c2968667ab46cac6$var$currentHook.queue,
            next: null
        };
        null === $c2968667ab46cac6$var$workInProgressHook ? $c2968667ab46cac6$var$currentlyRenderingFiber.memoizedState = $c2968667ab46cac6$var$workInProgressHook = nextCurrentHook : $c2968667ab46cac6$var$workInProgressHook = $c2968667ab46cac6$var$workInProgressHook.next = nextCurrentHook;
    }
    return $c2968667ab46cac6$var$workInProgressHook;
}
function $c2968667ab46cac6$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $c2968667ab46cac6$var$useThenable(thenable) {
    var index = $c2968667ab46cac6$var$thenableIndexCounter;
    $c2968667ab46cac6$var$thenableIndexCounter += 1;
    null === $c2968667ab46cac6$var$thenableState && ($c2968667ab46cac6$var$thenableState = []);
    thenable = $c2968667ab46cac6$var$trackUsedThenable($c2968667ab46cac6$var$thenableState, thenable, index);
    index = $c2968667ab46cac6$var$currentlyRenderingFiber;
    null === (null === $c2968667ab46cac6$var$workInProgressHook ? index.memoizedState : $c2968667ab46cac6$var$workInProgressHook.next) && (index = index.alternate, $c2968667ab46cac6$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $c2968667ab46cac6$var$HooksDispatcherOnMount : $c2968667ab46cac6$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $c2968667ab46cac6$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $c2968667ab46cac6$var$useThenable(usable);
        if (usable.$$typeof === $c2968667ab46cac6$var$REACT_CONTEXT_TYPE) return $c2968667ab46cac6$var$readContext(usable);
    }
    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(438, String(usable)));
}
function $c2968667ab46cac6$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $c2968667ab46cac6$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $c2968667ab46cac6$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $c2968667ab46cac6$var$createFunctionComponentUpdateQueue(), $c2968667ab46cac6$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $c2968667ab46cac6$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $c2968667ab46cac6$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $c2968667ab46cac6$var$updateReducer(reducer) {
    var hook = $c2968667ab46cac6$var$updateWorkInProgressHook();
    return $c2968667ab46cac6$var$updateReducerImpl(hook, $c2968667ab46cac6$var$currentHook, reducer);
}
function $c2968667ab46cac6$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($c2968667ab46cac6$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($c2968667ab46cac6$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $c2968667ab46cac6$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($c2968667ab46cac6$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $c2968667ab46cac6$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $c2968667ab46cac6$var$currentlyRenderingFiber.lanes |= revertLane, $c2968667ab46cac6$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $c2968667ab46cac6$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $c2968667ab46cac6$var$currentlyRenderingFiber.lanes |= updateLane, $c2968667ab46cac6$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$c2968667ab46cac6$var$objectIs(pendingQueue, hook.memoizedState) && ($c2968667ab46cac6$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $c2968667ab46cac6$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $c2968667ab46cac6$var$rerenderReducer(reducer) {
    var hook = $c2968667ab46cac6$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $c2968667ab46cac6$var$objectIs(newState, hook.memoizedState) || ($c2968667ab46cac6$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $c2968667ab46cac6$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $c2968667ab46cac6$var$currentlyRenderingFiber, hook = $c2968667ab46cac6$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $c2968667ab46cac6$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$c2968667ab46cac6$var$objectIs(($c2968667ab46cac6$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $c2968667ab46cac6$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $c2968667ab46cac6$var$updateEffect($c2968667ab46cac6$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $c2968667ab46cac6$var$workInProgressHook && $c2968667ab46cac6$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $c2968667ab46cac6$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $c2968667ab46cac6$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $c2968667ab46cac6$var$workInProgressRoot) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($c2968667ab46cac6$var$renderLanes & 127) || $c2968667ab46cac6$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $c2968667ab46cac6$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $c2968667ab46cac6$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $c2968667ab46cac6$var$createFunctionComponentUpdateQueue(), $c2968667ab46cac6$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $c2968667ab46cac6$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $c2968667ab46cac6$var$checkIfSnapshotChanged(inst) && $c2968667ab46cac6$var$forceStoreRerender(fiber);
}
function $c2968667ab46cac6$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $c2968667ab46cac6$var$checkIfSnapshotChanged(inst) && $c2968667ab46cac6$var$forceStoreRerender(fiber);
    });
}
function $c2968667ab46cac6$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$c2968667ab46cac6$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $c2968667ab46cac6$var$forceStoreRerender(fiber) {
    var root = $c2968667ab46cac6$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $c2968667ab46cac6$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $c2968667ab46cac6$var$mountStateImpl(initialState) {
    var hook = $c2968667ab46cac6$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($c2968667ab46cac6$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $c2968667ab46cac6$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $c2968667ab46cac6$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c2968667ab46cac6$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $c2968667ab46cac6$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $c2968667ab46cac6$var$updateReducerImpl(hook, $c2968667ab46cac6$var$currentHook, "function" === typeof reducer ? reducer : $c2968667ab46cac6$var$basicStateReducer);
}
function $c2968667ab46cac6$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($c2968667ab46cac6$var$isRenderPhaseUpdate(fiber)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $c2968667ab46cac6$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $c2968667ab46cac6$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $c2968667ab46cac6$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $c2968667ab46cac6$var$ReactSharedInternals.T, currentTransition = {};
        $c2968667ab46cac6$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $c2968667ab46cac6$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $c2968667ab46cac6$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $c2968667ab46cac6$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $c2968667ab46cac6$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $c2968667ab46cac6$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $c2968667ab46cac6$var$onActionError(actionQueue, node, error$66);
    }
}
function $c2968667ab46cac6$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $c2968667ab46cac6$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $c2968667ab46cac6$var$onActionError(actionQueue, node, error);
    }) : $c2968667ab46cac6$var$onActionSuccess(actionQueue, node, returnValue);
}
function $c2968667ab46cac6$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $c2968667ab46cac6$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $c2968667ab46cac6$var$runActionStateAction(actionQueue, nextState)));
}
function $c2968667ab46cac6$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $c2968667ab46cac6$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $c2968667ab46cac6$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $c2968667ab46cac6$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $c2968667ab46cac6$var$mountActionState(action, initialStateProp) {
    if ($c2968667ab46cac6$var$isHydrating) {
        var ssrFormState = $c2968667ab46cac6$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $c2968667ab46cac6$var$currentlyRenderingFiber;
                if ($c2968667ab46cac6$var$isHydrating) {
                    if ($c2968667ab46cac6$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $c2968667ab46cac6$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $c2968667ab46cac6$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $c2968667ab46cac6$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $c2968667ab46cac6$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $c2968667ab46cac6$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c2968667ab46cac6$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $c2968667ab46cac6$var$dispatchSetState.bind(null, $c2968667ab46cac6$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $c2968667ab46cac6$var$mountStateImpl(!1);
    inRootOrSingleton = $c2968667ab46cac6$var$dispatchOptimisticSetState.bind(null, $c2968667ab46cac6$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $c2968667ab46cac6$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $c2968667ab46cac6$var$dispatchActionState.bind(null, $c2968667ab46cac6$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $c2968667ab46cac6$var$updateActionState(action) {
    var stateHook = $c2968667ab46cac6$var$updateWorkInProgressHook();
    return $c2968667ab46cac6$var$updateActionStateImpl(stateHook, $c2968667ab46cac6$var$currentHook, action);
}
function $c2968667ab46cac6$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $c2968667ab46cac6$var$updateReducerImpl(stateHook, currentStateHook, $c2968667ab46cac6$var$actionStateReducer)[0];
    stateHook = $c2968667ab46cac6$var$updateReducer($c2968667ab46cac6$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $c2968667ab46cac6$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $c2968667ab46cac6$var$SuspenseException) throw $c2968667ab46cac6$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $c2968667ab46cac6$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($c2968667ab46cac6$var$currentlyRenderingFiber.flags |= 2048, $c2968667ab46cac6$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $c2968667ab46cac6$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $c2968667ab46cac6$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $c2968667ab46cac6$var$rerenderActionState(action) {
    var stateHook = $c2968667ab46cac6$var$updateWorkInProgressHook(), currentStateHook = $c2968667ab46cac6$var$currentHook;
    if (null !== currentStateHook) return $c2968667ab46cac6$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $c2968667ab46cac6$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $c2968667ab46cac6$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $c2968667ab46cac6$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $c2968667ab46cac6$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $c2968667ab46cac6$var$createFunctionComponentUpdateQueue(), $c2968667ab46cac6$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $c2968667ab46cac6$var$updateRef() {
    return $c2968667ab46cac6$var$updateWorkInProgressHook().memoizedState;
}
function $c2968667ab46cac6$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $c2968667ab46cac6$var$mountWorkInProgressHook();
    $c2968667ab46cac6$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $c2968667ab46cac6$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $c2968667ab46cac6$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $c2968667ab46cac6$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $c2968667ab46cac6$var$currentHook && null !== deps && $c2968667ab46cac6$var$areHookInputsEqual(deps, $c2968667ab46cac6$var$currentHook.memoizedState.deps) ? hook.memoizedState = $c2968667ab46cac6$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($c2968667ab46cac6$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $c2968667ab46cac6$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $c2968667ab46cac6$var$mountEffect(create, deps) {
    $c2968667ab46cac6$var$mountEffectImpl(8390656, 8, create, deps);
}
function $c2968667ab46cac6$var$updateEffect(create, deps) {
    $c2968667ab46cac6$var$updateEffectImpl(2048, 8, create, deps);
}
function $c2968667ab46cac6$var$useEffectEventImpl(payload) {
    $c2968667ab46cac6$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $c2968667ab46cac6$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $c2968667ab46cac6$var$createFunctionComponentUpdateQueue(), $c2968667ab46cac6$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $c2968667ab46cac6$var$updateEvent(callback) {
    var ref = $c2968667ab46cac6$var$updateWorkInProgressHook().memoizedState;
    $c2968667ab46cac6$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($c2968667ab46cac6$var$executionContext & 2)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $c2968667ab46cac6$var$updateInsertionEffect(create, deps) {
    return $c2968667ab46cac6$var$updateEffectImpl(4, 2, create, deps);
}
function $c2968667ab46cac6$var$updateLayoutEffect(create, deps) {
    return $c2968667ab46cac6$var$updateEffectImpl(4, 4, create, deps);
}
function $c2968667ab46cac6$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $c2968667ab46cac6$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $c2968667ab46cac6$var$updateEffectImpl(4, 4, $c2968667ab46cac6$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $c2968667ab46cac6$var$mountDebugValue() {}
function $c2968667ab46cac6$var$updateCallback(callback, deps) {
    var hook = $c2968667ab46cac6$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $c2968667ab46cac6$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $c2968667ab46cac6$var$updateMemo(nextCreate, deps) {
    var hook = $c2968667ab46cac6$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $c2968667ab46cac6$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($c2968667ab46cac6$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $c2968667ab46cac6$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $c2968667ab46cac6$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $c2968667ab46cac6$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($c2968667ab46cac6$var$renderLanes & 1073741824) && 0 === ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $c2968667ab46cac6$var$requestDeferredLane();
    $c2968667ab46cac6$var$currentlyRenderingFiber.lanes |= hook;
    $c2968667ab46cac6$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $c2968667ab46cac6$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($c2968667ab46cac6$var$objectIs(value, prevValue)) return value;
    if (null !== $c2968667ab46cac6$var$currentTreeHiddenStackCursor.current) return hook = $c2968667ab46cac6$var$mountDeferredValueImpl(hook, value, initialValue), $c2968667ab46cac6$var$objectIs(hook, prevValue) || ($c2968667ab46cac6$var$didReceiveUpdate = !0), hook;
    if (0 === ($c2968667ab46cac6$var$renderLanes & 42) || 0 !== ($c2968667ab46cac6$var$renderLanes & 1073741824) && 0 === ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 261930)) return $c2968667ab46cac6$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $c2968667ab46cac6$var$requestDeferredLane();
    $c2968667ab46cac6$var$currentlyRenderingFiber.lanes |= hook;
    $c2968667ab46cac6$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $c2968667ab46cac6$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
    $c2968667ab46cac6$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $c2968667ab46cac6$var$ReactSharedInternals.T, currentTransition = {};
    $c2968667ab46cac6$var$ReactSharedInternals.T = currentTransition;
    $c2968667ab46cac6$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $c2968667ab46cac6$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $c2968667ab46cac6$var$chainThenableValue(returnValue, finishedState);
            $c2968667ab46cac6$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $c2968667ab46cac6$var$requestUpdateLane(fiber));
        } else $c2968667ab46cac6$var$dispatchSetStateInternal(fiber, queue, finishedState, $c2968667ab46cac6$var$requestUpdateLane(fiber));
    } catch (error) {
        $c2968667ab46cac6$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $c2968667ab46cac6$var$requestUpdateLane());
    } finally{
        $c2968667ab46cac6$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $c2968667ab46cac6$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c2968667ab46cac6$var$noop() {}
function $c2968667ab46cac6$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(476));
    var queue = $c2968667ab46cac6$var$ensureFormComponentIsStateful(formFiber).queue;
    $c2968667ab46cac6$var$startTransition(formFiber, queue, pendingState, $c2968667ab46cac6$var$sharedNotPendingObject, null === action ? $c2968667ab46cac6$var$noop : function() {
        $c2968667ab46cac6$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $c2968667ab46cac6$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $c2968667ab46cac6$var$sharedNotPendingObject,
        baseState: $c2968667ab46cac6$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $c2968667ab46cac6$var$basicStateReducer,
            lastRenderedState: $c2968667ab46cac6$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $c2968667ab46cac6$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $c2968667ab46cac6$var$requestFormReset$1(formFiber) {
    var stateHook = $c2968667ab46cac6$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $c2968667ab46cac6$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $c2968667ab46cac6$var$requestUpdateLane());
}
function $c2968667ab46cac6$var$useHostTransitionStatus() {
    return $c2968667ab46cac6$var$readContext($c2968667ab46cac6$var$HostTransitionContext);
}
function $c2968667ab46cac6$var$updateId() {
    return $c2968667ab46cac6$var$updateWorkInProgressHook().memoizedState;
}
function $c2968667ab46cac6$var$updateRefresh() {
    return $c2968667ab46cac6$var$updateWorkInProgressHook().memoizedState;
}
function $c2968667ab46cac6$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $c2968667ab46cac6$var$requestUpdateLane();
                fiber = $c2968667ab46cac6$var$createUpdate(lane);
                var root$69 = $c2968667ab46cac6$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($c2968667ab46cac6$var$scheduleUpdateOnFiber(root$69, provider, lane), $c2968667ab46cac6$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $c2968667ab46cac6$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $c2968667ab46cac6$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $c2968667ab46cac6$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $c2968667ab46cac6$var$isRenderPhaseUpdate(fiber) ? $c2968667ab46cac6$var$enqueueRenderPhaseUpdate(queue, action) : (action = $c2968667ab46cac6$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($c2968667ab46cac6$var$scheduleUpdateOnFiber(action, fiber, lane), $c2968667ab46cac6$var$entangleTransitionUpdate(action, queue, lane)));
}
function $c2968667ab46cac6$var$dispatchSetState(fiber, queue, action) {
    var lane = $c2968667ab46cac6$var$requestUpdateLane();
    $c2968667ab46cac6$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $c2968667ab46cac6$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c2968667ab46cac6$var$isRenderPhaseUpdate(fiber)) $c2968667ab46cac6$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($c2968667ab46cac6$var$objectIs(eagerState, currentState)) return $c2968667ab46cac6$var$enqueueUpdate$1(fiber, queue, update, 0), null === $c2968667ab46cac6$var$workInProgressRoot && $c2968667ab46cac6$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $c2968667ab46cac6$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $c2968667ab46cac6$var$scheduleUpdateOnFiber(action, fiber, lane), $c2968667ab46cac6$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $c2968667ab46cac6$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $c2968667ab46cac6$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c2968667ab46cac6$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $c2968667ab46cac6$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $c2968667ab46cac6$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $c2968667ab46cac6$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $c2968667ab46cac6$var$currentlyRenderingFiber || null !== alternate && alternate === $c2968667ab46cac6$var$currentlyRenderingFiber;
}
function $c2968667ab46cac6$var$enqueueRenderPhaseUpdate(queue, update) {
    $c2968667ab46cac6$var$didScheduleRenderPhaseUpdateDuringThisPass = $c2968667ab46cac6$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $c2968667ab46cac6$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $c2968667ab46cac6$var$markRootEntangled(root, lane);
    }
}
var $c2968667ab46cac6$var$ContextOnlyDispatcher = {
    readContext: $c2968667ab46cac6$var$readContext,
    use: $c2968667ab46cac6$var$use,
    useCallback: $c2968667ab46cac6$var$throwInvalidHookError,
    useContext: $c2968667ab46cac6$var$throwInvalidHookError,
    useEffect: $c2968667ab46cac6$var$throwInvalidHookError,
    useImperativeHandle: $c2968667ab46cac6$var$throwInvalidHookError,
    useLayoutEffect: $c2968667ab46cac6$var$throwInvalidHookError,
    useInsertionEffect: $c2968667ab46cac6$var$throwInvalidHookError,
    useMemo: $c2968667ab46cac6$var$throwInvalidHookError,
    useReducer: $c2968667ab46cac6$var$throwInvalidHookError,
    useRef: $c2968667ab46cac6$var$throwInvalidHookError,
    useState: $c2968667ab46cac6$var$throwInvalidHookError,
    useDebugValue: $c2968667ab46cac6$var$throwInvalidHookError,
    useDeferredValue: $c2968667ab46cac6$var$throwInvalidHookError,
    useTransition: $c2968667ab46cac6$var$throwInvalidHookError,
    useSyncExternalStore: $c2968667ab46cac6$var$throwInvalidHookError,
    useId: $c2968667ab46cac6$var$throwInvalidHookError,
    useHostTransitionStatus: $c2968667ab46cac6$var$throwInvalidHookError,
    useFormState: $c2968667ab46cac6$var$throwInvalidHookError,
    useActionState: $c2968667ab46cac6$var$throwInvalidHookError,
    useOptimistic: $c2968667ab46cac6$var$throwInvalidHookError,
    useMemoCache: $c2968667ab46cac6$var$throwInvalidHookError,
    useCacheRefresh: $c2968667ab46cac6$var$throwInvalidHookError
};
$c2968667ab46cac6$var$ContextOnlyDispatcher.useEffectEvent = $c2968667ab46cac6$var$throwInvalidHookError;
var $c2968667ab46cac6$var$HooksDispatcherOnMount = {
    readContext: $c2968667ab46cac6$var$readContext,
    use: $c2968667ab46cac6$var$use,
    useCallback: function(callback, deps) {
        $c2968667ab46cac6$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $c2968667ab46cac6$var$readContext,
    useEffect: $c2968667ab46cac6$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $c2968667ab46cac6$var$mountEffectImpl(4194308, 4, $c2968667ab46cac6$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $c2968667ab46cac6$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $c2968667ab46cac6$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $c2968667ab46cac6$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($c2968667ab46cac6$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $c2968667ab46cac6$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $c2968667ab46cac6$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $c2968667ab46cac6$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($c2968667ab46cac6$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $c2968667ab46cac6$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $c2968667ab46cac6$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $c2968667ab46cac6$var$dispatchReducerAction.bind(null, $c2968667ab46cac6$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $c2968667ab46cac6$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $c2968667ab46cac6$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $c2968667ab46cac6$var$dispatchSetState.bind(null, $c2968667ab46cac6$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $c2968667ab46cac6$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c2968667ab46cac6$var$mountWorkInProgressHook();
        return $c2968667ab46cac6$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $c2968667ab46cac6$var$mountStateImpl(!1);
        stateHook = $c2968667ab46cac6$var$startTransition.bind(null, $c2968667ab46cac6$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $c2968667ab46cac6$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $c2968667ab46cac6$var$currentlyRenderingFiber, hook = $c2968667ab46cac6$var$mountWorkInProgressHook();
        if ($c2968667ab46cac6$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $c2968667ab46cac6$var$workInProgressRoot) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(349));
            0 !== ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 127) || $c2968667ab46cac6$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $c2968667ab46cac6$var$mountEffect($c2968667ab46cac6$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $c2968667ab46cac6$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $c2968667ab46cac6$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $c2968667ab46cac6$var$mountWorkInProgressHook(), identifierPrefix = $c2968667ab46cac6$var$workInProgressRoot.identifierPrefix;
        if ($c2968667ab46cac6$var$isHydrating) {
            var JSCompiler_inline_result = $c2968667ab46cac6$var$treeContextOverflow;
            var idWithLeadingBit = $c2968667ab46cac6$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $c2968667ab46cac6$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $c2968667ab46cac6$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $c2968667ab46cac6$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $c2968667ab46cac6$var$useHostTransitionStatus,
    useFormState: $c2968667ab46cac6$var$mountActionState,
    useActionState: $c2968667ab46cac6$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $c2968667ab46cac6$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $c2968667ab46cac6$var$dispatchOptimisticSetState.bind(null, $c2968667ab46cac6$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $c2968667ab46cac6$var$useMemoCache,
    useCacheRefresh: function() {
        return $c2968667ab46cac6$var$mountWorkInProgressHook().memoizedState = $c2968667ab46cac6$var$refreshCache.bind(null, $c2968667ab46cac6$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $c2968667ab46cac6$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($c2968667ab46cac6$var$executionContext & 2)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $c2968667ab46cac6$var$HooksDispatcherOnUpdate = {
    readContext: $c2968667ab46cac6$var$readContext,
    use: $c2968667ab46cac6$var$use,
    useCallback: $c2968667ab46cac6$var$updateCallback,
    useContext: $c2968667ab46cac6$var$readContext,
    useEffect: $c2968667ab46cac6$var$updateEffect,
    useImperativeHandle: $c2968667ab46cac6$var$updateImperativeHandle,
    useInsertionEffect: $c2968667ab46cac6$var$updateInsertionEffect,
    useLayoutEffect: $c2968667ab46cac6$var$updateLayoutEffect,
    useMemo: $c2968667ab46cac6$var$updateMemo,
    useReducer: $c2968667ab46cac6$var$updateReducer,
    useRef: $c2968667ab46cac6$var$updateRef,
    useState: function() {
        return $c2968667ab46cac6$var$updateReducer($c2968667ab46cac6$var$basicStateReducer);
    },
    useDebugValue: $c2968667ab46cac6$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c2968667ab46cac6$var$updateWorkInProgressHook();
        return $c2968667ab46cac6$var$updateDeferredValueImpl(hook, $c2968667ab46cac6$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $c2968667ab46cac6$var$updateReducer($c2968667ab46cac6$var$basicStateReducer)[0], start = $c2968667ab46cac6$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $c2968667ab46cac6$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $c2968667ab46cac6$var$updateSyncExternalStore,
    useId: $c2968667ab46cac6$var$updateId,
    useHostTransitionStatus: $c2968667ab46cac6$var$useHostTransitionStatus,
    useFormState: $c2968667ab46cac6$var$updateActionState,
    useActionState: $c2968667ab46cac6$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $c2968667ab46cac6$var$updateWorkInProgressHook();
        return $c2968667ab46cac6$var$updateOptimisticImpl(hook, $c2968667ab46cac6$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $c2968667ab46cac6$var$useMemoCache,
    useCacheRefresh: $c2968667ab46cac6$var$updateRefresh
};
$c2968667ab46cac6$var$HooksDispatcherOnUpdate.useEffectEvent = $c2968667ab46cac6$var$updateEvent;
var $c2968667ab46cac6$var$HooksDispatcherOnRerender = {
    readContext: $c2968667ab46cac6$var$readContext,
    use: $c2968667ab46cac6$var$use,
    useCallback: $c2968667ab46cac6$var$updateCallback,
    useContext: $c2968667ab46cac6$var$readContext,
    useEffect: $c2968667ab46cac6$var$updateEffect,
    useImperativeHandle: $c2968667ab46cac6$var$updateImperativeHandle,
    useInsertionEffect: $c2968667ab46cac6$var$updateInsertionEffect,
    useLayoutEffect: $c2968667ab46cac6$var$updateLayoutEffect,
    useMemo: $c2968667ab46cac6$var$updateMemo,
    useReducer: $c2968667ab46cac6$var$rerenderReducer,
    useRef: $c2968667ab46cac6$var$updateRef,
    useState: function() {
        return $c2968667ab46cac6$var$rerenderReducer($c2968667ab46cac6$var$basicStateReducer);
    },
    useDebugValue: $c2968667ab46cac6$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $c2968667ab46cac6$var$updateWorkInProgressHook();
        return null === $c2968667ab46cac6$var$currentHook ? $c2968667ab46cac6$var$mountDeferredValueImpl(hook, value, initialValue) : $c2968667ab46cac6$var$updateDeferredValueImpl(hook, $c2968667ab46cac6$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $c2968667ab46cac6$var$rerenderReducer($c2968667ab46cac6$var$basicStateReducer)[0], start = $c2968667ab46cac6$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $c2968667ab46cac6$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $c2968667ab46cac6$var$updateSyncExternalStore,
    useId: $c2968667ab46cac6$var$updateId,
    useHostTransitionStatus: $c2968667ab46cac6$var$useHostTransitionStatus,
    useFormState: $c2968667ab46cac6$var$rerenderActionState,
    useActionState: $c2968667ab46cac6$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $c2968667ab46cac6$var$updateWorkInProgressHook();
        if (null !== $c2968667ab46cac6$var$currentHook) return $c2968667ab46cac6$var$updateOptimisticImpl(hook, $c2968667ab46cac6$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $c2968667ab46cac6$var$useMemoCache,
    useCacheRefresh: $c2968667ab46cac6$var$updateRefresh
};
$c2968667ab46cac6$var$HooksDispatcherOnRerender.useEffectEvent = $c2968667ab46cac6$var$updateEvent;
function $c2968667ab46cac6$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $c2968667ab46cac6$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $c2968667ab46cac6$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $c2968667ab46cac6$var$requestUpdateLane(), update = $c2968667ab46cac6$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $c2968667ab46cac6$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($c2968667ab46cac6$var$scheduleUpdateOnFiber(payload, inst, lane), $c2968667ab46cac6$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $c2968667ab46cac6$var$requestUpdateLane(), update = $c2968667ab46cac6$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $c2968667ab46cac6$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($c2968667ab46cac6$var$scheduleUpdateOnFiber(payload, inst, lane), $c2968667ab46cac6$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $c2968667ab46cac6$var$requestUpdateLane(), update = $c2968667ab46cac6$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $c2968667ab46cac6$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($c2968667ab46cac6$var$scheduleUpdateOnFiber(callback, inst, lane), $c2968667ab46cac6$var$entangleTransitions(callback, inst, lane));
    }
};
function $c2968667ab46cac6$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$c2968667ab46cac6$var$shallowEqual(oldProps, newProps) || !$c2968667ab46cac6$var$shallowEqual(oldState, newState) : !0;
}
function $c2968667ab46cac6$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $c2968667ab46cac6$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $c2968667ab46cac6$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $c2968667ab46cac6$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $c2968667ab46cac6$var$defaultOnUncaughtError(error) {
    $c2968667ab46cac6$var$reportGlobalError(error);
}
function $c2968667ab46cac6$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $c2968667ab46cac6$var$defaultOnRecoverableError(error) {
    $c2968667ab46cac6$var$reportGlobalError(error);
}
function $c2968667ab46cac6$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $c2968667ab46cac6$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $c2968667ab46cac6$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $c2968667ab46cac6$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $c2968667ab46cac6$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $c2968667ab46cac6$var$createClassErrorUpdate(lane) {
    lane = $c2968667ab46cac6$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $c2968667ab46cac6$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $c2968667ab46cac6$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $c2968667ab46cac6$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed ? $c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $c2968667ab46cac6$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $c2968667ab46cac6$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $c2968667ab46cac6$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $c2968667ab46cac6$var$shellBoundary ? $c2968667ab46cac6$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $c2968667ab46cac6$var$workInProgressRootExitStatus && ($c2968667ab46cac6$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $c2968667ab46cac6$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $c2968667ab46cac6$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $c2968667ab46cac6$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $c2968667ab46cac6$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($c2968667ab46cac6$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $c2968667ab46cac6$var$attachPingListener(root, value, rootRenderLanes);
        $c2968667ab46cac6$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($c2968667ab46cac6$var$isHydrating) return returnFiber = $c2968667ab46cac6$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $c2968667ab46cac6$var$HydrationMismatchException && (root = Error($c2968667ab46cac6$var$formatProdErrorMessage(422), {
        cause: value
    }), $c2968667ab46cac6$var$queueHydrationError($c2968667ab46cac6$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $c2968667ab46cac6$var$HydrationMismatchException && (returnFiber = Error($c2968667ab46cac6$var$formatProdErrorMessage(423), {
        cause: value
    }), $c2968667ab46cac6$var$queueHydrationError($c2968667ab46cac6$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $c2968667ab46cac6$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $c2968667ab46cac6$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $c2968667ab46cac6$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $c2968667ab46cac6$var$workInProgressRootExitStatus && ($c2968667ab46cac6$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($c2968667ab46cac6$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $c2968667ab46cac6$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $c2968667ab46cac6$var$workInProgressRootConcurrentErrors ? $c2968667ab46cac6$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $c2968667ab46cac6$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $c2968667ab46cac6$var$workInProgressRootExitStatus && ($c2968667ab46cac6$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $c2968667ab46cac6$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $c2968667ab46cac6$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $c2968667ab46cac6$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed || !$c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $c2968667ab46cac6$var$createClassErrorUpdate(rootRenderLanes), $c2968667ab46cac6$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $c2968667ab46cac6$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $c2968667ab46cac6$var$SelectiveHydrationException = Error($c2968667ab46cac6$var$formatProdErrorMessage(461)), $c2968667ab46cac6$var$didReceiveUpdate = !1;
function $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $c2968667ab46cac6$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $c2968667ab46cac6$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $c2968667ab46cac6$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $c2968667ab46cac6$var$prepareToReadContext(workInProgress);
    nextProps = $c2968667ab46cac6$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $c2968667ab46cac6$var$checkDidRenderIdHook();
    if (null !== current && !$c2968667ab46cac6$var$didReceiveUpdate) return $c2968667ab46cac6$var$bailoutHooks(current, workInProgress, renderLanes), $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c2968667ab46cac6$var$isHydrating && key && $c2968667ab46cac6$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $c2968667ab46cac6$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$c2968667ab46cac6$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $c2968667ab46cac6$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $c2968667ab46cac6$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$c2968667ab46cac6$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $c2968667ab46cac6$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $c2968667ab46cac6$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $c2968667ab46cac6$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($c2968667ab46cac6$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($c2968667ab46cac6$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $c2968667ab46cac6$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($c2968667ab46cac6$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $c2968667ab46cac6$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $c2968667ab46cac6$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $c2968667ab46cac6$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $c2968667ab46cac6$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $c2968667ab46cac6$var$pushHiddenContext(workInProgress, prevState) : $c2968667ab46cac6$var$reuseHiddenContextOnStack(), $c2968667ab46cac6$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $c2968667ab46cac6$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($c2968667ab46cac6$var$pushTransition(workInProgress, prevState.cachePool), $c2968667ab46cac6$var$pushHiddenContext(workInProgress, prevState), $c2968667ab46cac6$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $c2968667ab46cac6$var$pushTransition(workInProgress, null), $c2968667ab46cac6$var$reuseHiddenContextOnStack(), $c2968667ab46cac6$var$reuseSuspenseHandlerOnStack(workInProgress));
    $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $c2968667ab46cac6$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $c2968667ab46cac6$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $c2968667ab46cac6$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $c2968667ab46cac6$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $c2968667ab46cac6$var$pushTransition(workInProgress, null);
    $c2968667ab46cac6$var$reuseHiddenContextOnStack();
    $c2968667ab46cac6$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $c2968667ab46cac6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $c2968667ab46cac6$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $c2968667ab46cac6$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $c2968667ab46cac6$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $c2968667ab46cac6$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $c2968667ab46cac6$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $c2968667ab46cac6$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $c2968667ab46cac6$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($c2968667ab46cac6$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $c2968667ab46cac6$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $c2968667ab46cac6$var$bailoutOffscreenComponent(null, current);
            $c2968667ab46cac6$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $c2968667ab46cac6$var$nextHydratableInstance) ? (current = $c2968667ab46cac6$var$canHydrateHydrationBoundary(current, $c2968667ab46cac6$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $c2968667ab46cac6$var$treeContextProvider ? {
                    id: $c2968667ab46cac6$var$treeContextId,
                    overflow: $c2968667ab46cac6$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $c2968667ab46cac6$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $c2968667ab46cac6$var$hydrationParentFiber = workInProgress, $c2968667ab46cac6$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $c2968667ab46cac6$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $c2968667ab46cac6$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $c2968667ab46cac6$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $c2968667ab46cac6$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($c2968667ab46cac6$var$formatProdErrorMessage(558));
        } else if ($c2968667ab46cac6$var$didReceiveUpdate || $c2968667ab46cac6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $c2968667ab46cac6$var$didReceiveUpdate || didSuspend) {
            nextProps = $c2968667ab46cac6$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $c2968667ab46cac6$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $c2968667ab46cac6$var$enqueueConcurrentRenderForLane(current, dehydrated), $c2968667ab46cac6$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $c2968667ab46cac6$var$SelectiveHydrationException;
            $c2968667ab46cac6$var$renderDidSuspendDelayIfPossible();
            workInProgress = $c2968667ab46cac6$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$getNextHydratable(dehydrated.nextSibling), $c2968667ab46cac6$var$hydrationParentFiber = workInProgress, $c2968667ab46cac6$var$isHydrating = !0, $c2968667ab46cac6$var$hydrationErrors = null, $c2968667ab46cac6$var$rootOrSingletonContext = !1, null !== current && $c2968667ab46cac6$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $c2968667ab46cac6$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $c2968667ab46cac6$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $c2968667ab46cac6$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $c2968667ab46cac6$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $c2968667ab46cac6$var$prepareToReadContext(workInProgress);
    Component = $c2968667ab46cac6$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $c2968667ab46cac6$var$checkDidRenderIdHook();
    if (null !== current && !$c2968667ab46cac6$var$didReceiveUpdate) return $c2968667ab46cac6$var$bailoutHooks(current, workInProgress, renderLanes), $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c2968667ab46cac6$var$isHydrating && nextProps && $c2968667ab46cac6$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $c2968667ab46cac6$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $c2968667ab46cac6$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $c2968667ab46cac6$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $c2968667ab46cac6$var$finishRenderingHooks(current);
    Component = $c2968667ab46cac6$var$checkDidRenderIdHook();
    if (null !== current && !$c2968667ab46cac6$var$didReceiveUpdate) return $c2968667ab46cac6$var$bailoutHooks(current, workInProgress, renderLanes), $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $c2968667ab46cac6$var$isHydrating && Component && $c2968667ab46cac6$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $c2968667ab46cac6$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $c2968667ab46cac6$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $c2968667ab46cac6$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $c2968667ab46cac6$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $c2968667ab46cac6$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $c2968667ab46cac6$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $c2968667ab46cac6$var$readContext(contextType) : $c2968667ab46cac6$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($c2968667ab46cac6$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $c2968667ab46cac6$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $c2968667ab46cac6$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $c2968667ab46cac6$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $c2968667ab46cac6$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $c2968667ab46cac6$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $c2968667ab46cac6$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $c2968667ab46cac6$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $c2968667ab46cac6$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $c2968667ab46cac6$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $c2968667ab46cac6$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $c2968667ab46cac6$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($c2968667ab46cac6$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $c2968667ab46cac6$var$hasForceUpdate || $c2968667ab46cac6$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $c2968667ab46cac6$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $c2968667ab46cac6$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $c2968667ab46cac6$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $c2968667ab46cac6$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $c2968667ab46cac6$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $c2968667ab46cac6$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $c2968667ab46cac6$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $c2968667ab46cac6$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $c2968667ab46cac6$var$hasForceUpdate || null !== current && null !== current.dependencies && $c2968667ab46cac6$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($c2968667ab46cac6$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $c2968667ab46cac6$var$hasForceUpdate || $c2968667ab46cac6$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $c2968667ab46cac6$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $c2968667ab46cac6$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $c2968667ab46cac6$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $c2968667ab46cac6$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $c2968667ab46cac6$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $c2968667ab46cac6$var$resetHydrationState();
    workInProgress.flags |= 256;
    $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $c2968667ab46cac6$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $c2968667ab46cac6$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $c2968667ab46cac6$var$getSuspendedCache()
    };
}
function $c2968667ab46cac6$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $c2968667ab46cac6$var$workInProgressDeferredLane);
    return current;
}
function $c2968667ab46cac6$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($c2968667ab46cac6$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($c2968667ab46cac6$var$isHydrating) {
            showFallback ? $c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $c2968667ab46cac6$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $c2968667ab46cac6$var$nextHydratableInstance) ? (current = $c2968667ab46cac6$var$canHydrateHydrationBoundary(current, $c2968667ab46cac6$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $c2968667ab46cac6$var$treeContextProvider ? {
                    id: $c2968667ab46cac6$var$treeContextId,
                    overflow: $c2968667ab46cac6$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $c2968667ab46cac6$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $c2968667ab46cac6$var$hydrationParentFiber = workInProgress, $c2968667ab46cac6$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $c2968667ab46cac6$var$throwOnHydrationMismatch(workInProgress);
            $c2968667ab46cac6$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $c2968667ab46cac6$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $c2968667ab46cac6$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $c2968667ab46cac6$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $c2968667ab46cac6$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $c2968667ab46cac6$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c2968667ab46cac6$var$SUSPENDED_MARKER, $c2968667ab46cac6$var$bailoutOffscreenComponent(null, nextProps);
        $c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $c2968667ab46cac6$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $c2968667ab46cac6$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($c2968667ab46cac6$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($c2968667ab46cac6$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $c2968667ab46cac6$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $c2968667ab46cac6$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $c2968667ab46cac6$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $c2968667ab46cac6$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $c2968667ab46cac6$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c2968667ab46cac6$var$SUSPENDED_MARKER, workInProgress = $c2968667ab46cac6$var$bailoutOffscreenComponent(null, nextProps));
        else if ($c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(workInProgress), $c2968667ab46cac6$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($c2968667ab46cac6$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $c2968667ab46cac6$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $c2968667ab46cac6$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($c2968667ab46cac6$var$didReceiveUpdate || $c2968667ab46cac6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $c2968667ab46cac6$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $c2968667ab46cac6$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $c2968667ab46cac6$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $c2968667ab46cac6$var$enqueueConcurrentRenderForLane(current, nextProps), $c2968667ab46cac6$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $c2968667ab46cac6$var$SelectiveHydrationException;
            $c2968667ab46cac6$var$isSuspenseInstancePending(nextPrimaryChildren) || $c2968667ab46cac6$var$renderDidSuspendDelayIfPossible();
            workInProgress = $c2968667ab46cac6$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $c2968667ab46cac6$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$getNextHydratable(nextPrimaryChildren.nextSibling), $c2968667ab46cac6$var$hydrationParentFiber = workInProgress, $c2968667ab46cac6$var$isHydrating = !0, $c2968667ab46cac6$var$hydrationErrors = null, $c2968667ab46cac6$var$rootOrSingletonContext = !1, null !== current && $c2968667ab46cac6$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $c2968667ab46cac6$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $c2968667ab46cac6$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $c2968667ab46cac6$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $c2968667ab46cac6$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $c2968667ab46cac6$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $c2968667ab46cac6$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $c2968667ab46cac6$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $c2968667ab46cac6$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $c2968667ab46cac6$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $c2968667ab46cac6$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $c2968667ab46cac6$var$SUSPENDED_MARKER, $c2968667ab46cac6$var$bailoutOffscreenComponent(current.child, nextProps);
    $c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $c2968667ab46cac6$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $c2968667ab46cac6$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $c2968667ab46cac6$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $c2968667ab46cac6$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $c2968667ab46cac6$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $c2968667ab46cac6$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $c2968667ab46cac6$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $c2968667ab46cac6$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $c2968667ab46cac6$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $c2968667ab46cac6$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $c2968667ab46cac6$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $c2968667ab46cac6$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $c2968667ab46cac6$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseStackCursor, suspenseContext);
    $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $c2968667ab46cac6$var$isHydrating ? $c2968667ab46cac6$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $c2968667ab46cac6$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $c2968667ab46cac6$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $c2968667ab46cac6$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $c2968667ab46cac6$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $c2968667ab46cac6$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $c2968667ab46cac6$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $c2968667ab46cac6$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $c2968667ab46cac6$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($c2968667ab46cac6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $c2968667ab46cac6$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $c2968667ab46cac6$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $c2968667ab46cac6$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $c2968667ab46cac6$var$checkIfContextChanged(current) ? !0 : !1;
}
function $c2968667ab46cac6$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $c2968667ab46cac6$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $c2968667ab46cac6$var$pushProvider(workInProgress, $c2968667ab46cac6$var$CacheContext, current.memoizedState.cache);
            $c2968667ab46cac6$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $c2968667ab46cac6$var$pushHostContext(workInProgress);
            break;
        case 4:
            $c2968667ab46cac6$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $c2968667ab46cac6$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $c2968667ab46cac6$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $c2968667ab46cac6$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $c2968667ab46cac6$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($c2968667ab46cac6$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $c2968667ab46cac6$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseStackCursor, $c2968667ab46cac6$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $c2968667ab46cac6$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $c2968667ab46cac6$var$pushProvider(workInProgress, $c2968667ab46cac6$var$CacheContext, current.memoizedState.cache);
    }
    return $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $c2968667ab46cac6$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $c2968667ab46cac6$var$didReceiveUpdate = !0;
        else {
            if (!$c2968667ab46cac6$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $c2968667ab46cac6$var$didReceiveUpdate = !1, $c2968667ab46cac6$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $c2968667ab46cac6$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $c2968667ab46cac6$var$didReceiveUpdate = !1, $c2968667ab46cac6$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $c2968667ab46cac6$var$pushTreeId(workInProgress, $c2968667ab46cac6$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $c2968667ab46cac6$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $c2968667ab46cac6$var$shouldConstruct(current) ? (props = $c2968667ab46cac6$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $c2968667ab46cac6$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $c2968667ab46cac6$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $c2968667ab46cac6$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $c2968667ab46cac6$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $c2968667ab46cac6$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $c2968667ab46cac6$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $c2968667ab46cac6$var$getComponentNameFromType(current) || current;
                    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $c2968667ab46cac6$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $c2968667ab46cac6$var$resolveClassComponentProps(props, workInProgress.pendingProps), $c2968667ab46cac6$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $c2968667ab46cac6$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $c2968667ab46cac6$var$cloneUpdateQueue(current, workInProgress);
                $c2968667ab46cac6$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $c2968667ab46cac6$var$pushProvider(workInProgress, $c2968667ab46cac6$var$CacheContext, props);
                props !== prevState.cache && $c2968667ab46cac6$var$propagateContextChanges(workInProgress, [
                    $c2968667ab46cac6$var$CacheContext
                ], renderLanes, !0);
                $c2968667ab46cac6$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $c2968667ab46cac6$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $c2968667ab46cac6$var$createCapturedValueAtFiber(Error($c2968667ab46cac6$var$formatProdErrorMessage(424)), workInProgress);
                        $c2968667ab46cac6$var$queueHydrationError($$typeof);
                        workInProgress = $c2968667ab46cac6$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$getNextHydratable(current.firstChild);
                        $c2968667ab46cac6$var$hydrationParentFiber = workInProgress;
                        $c2968667ab46cac6$var$isHydrating = !0;
                        $c2968667ab46cac6$var$hydrationErrors = null;
                        $c2968667ab46cac6$var$rootOrSingletonContext = !0;
                        renderLanes = $c2968667ab46cac6$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $c2968667ab46cac6$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $c2968667ab46cac6$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $c2968667ab46cac6$var$markRef(current, workInProgress), null === current ? (renderLanes = $c2968667ab46cac6$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $c2968667ab46cac6$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $c2968667ab46cac6$var$getOwnerDocumentFromRootContainer($c2968667ab46cac6$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$c2968667ab46cac6$var$internalInstanceKey] = workInProgress, props[$c2968667ab46cac6$var$internalPropsKey] = current, $c2968667ab46cac6$var$setInitialProperties(props, renderLanes, current), $c2968667ab46cac6$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $c2968667ab46cac6$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $c2968667ab46cac6$var$pushHostContext(workInProgress), null === current && $c2968667ab46cac6$var$isHydrating && (props = workInProgress.stateNode = $c2968667ab46cac6$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $c2968667ab46cac6$var$rootInstanceStackCursor.current), $c2968667ab46cac6$var$hydrationParentFiber = workInProgress, $c2968667ab46cac6$var$rootOrSingletonContext = !0, $$typeof = $c2968667ab46cac6$var$nextHydratableInstance, $c2968667ab46cac6$var$isSingletonScope(workInProgress.type) ? ($c2968667ab46cac6$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$getNextHydratable(props.firstChild)) : $c2968667ab46cac6$var$nextHydratableInstance = $$typeof), $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $c2968667ab46cac6$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $c2968667ab46cac6$var$isHydrating) {
                if ($$typeof = props = $c2968667ab46cac6$var$nextHydratableInstance) props = $c2968667ab46cac6$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $c2968667ab46cac6$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $c2968667ab46cac6$var$hydrationParentFiber = workInProgress, $c2968667ab46cac6$var$nextHydratableInstance = $c2968667ab46cac6$var$getNextHydratable(props.firstChild), $c2968667ab46cac6$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $c2968667ab46cac6$var$throwOnHydrationMismatch(workInProgress);
            }
            $c2968667ab46cac6$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $c2968667ab46cac6$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $c2968667ab46cac6$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $c2968667ab46cac6$var$renderWithHooks(current, workInProgress, $c2968667ab46cac6$var$TransitionAwareHostComponent, null, null, renderLanes), $c2968667ab46cac6$var$HostTransitionContext._currentValue = $$typeof);
            $c2968667ab46cac6$var$markRef(current, workInProgress);
            $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $c2968667ab46cac6$var$isHydrating) {
                if (current = renderLanes = $c2968667ab46cac6$var$nextHydratableInstance) renderLanes = $c2968667ab46cac6$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $c2968667ab46cac6$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $c2968667ab46cac6$var$hydrationParentFiber = workInProgress, $c2968667ab46cac6$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $c2968667ab46cac6$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $c2968667ab46cac6$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $c2968667ab46cac6$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $c2968667ab46cac6$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $c2968667ab46cac6$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $c2968667ab46cac6$var$pushProvider(workInProgress, workInProgress.type, props.value), $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $c2968667ab46cac6$var$prepareToReadContext(workInProgress), $$typeof = $c2968667ab46cac6$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $c2968667ab46cac6$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $c2968667ab46cac6$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $c2968667ab46cac6$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $c2968667ab46cac6$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $c2968667ab46cac6$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $c2968667ab46cac6$var$prepareToReadContext(workInProgress), props = $c2968667ab46cac6$var$readContext($c2968667ab46cac6$var$CacheContext), null === current ? ($$typeof = $c2968667ab46cac6$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $c2968667ab46cac6$var$workInProgressRoot, prevState = $c2968667ab46cac6$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $c2968667ab46cac6$var$initializeUpdateQueue(workInProgress), $c2968667ab46cac6$var$pushProvider(workInProgress, $c2968667ab46cac6$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($c2968667ab46cac6$var$cloneUpdateQueue(current, workInProgress), $c2968667ab46cac6$var$processUpdateQueue(workInProgress, null, null, renderLanes), $c2968667ab46cac6$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $c2968667ab46cac6$var$pushProvider(workInProgress, $c2968667ab46cac6$var$CacheContext, props)) : (props = prevState.cache, $c2968667ab46cac6$var$pushProvider(workInProgress, $c2968667ab46cac6$var$CacheContext, props), props !== $$typeof.cache && $c2968667ab46cac6$var$propagateContextChanges(workInProgress, [
                $c2968667ab46cac6$var$CacheContext
            ], renderLanes, !0))), $c2968667ab46cac6$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $c2968667ab46cac6$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $c2968667ab46cac6$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($c2968667ab46cac6$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $c2968667ab46cac6$var$suspendedThenable = $c2968667ab46cac6$var$noopSuspenseyCommitThenable, $c2968667ab46cac6$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $c2968667ab46cac6$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$c2968667ab46cac6$var$preloadResource(resource)) {
        if ($c2968667ab46cac6$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $c2968667ab46cac6$var$suspendedThenable = $c2968667ab46cac6$var$noopSuspenseyCommitThenable, $c2968667ab46cac6$var$SuspenseyCommitException;
    }
}
function $c2968667ab46cac6$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $c2968667ab46cac6$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $c2968667ab46cac6$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $c2968667ab46cac6$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$c2968667ab46cac6$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $c2968667ab46cac6$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $c2968667ab46cac6$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $c2968667ab46cac6$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c2968667ab46cac6$var$bubbleProperties(workInProgress), null;
        case 1:
            return $c2968667ab46cac6$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $c2968667ab46cac6$var$popProvider($c2968667ab46cac6$var$CacheContext);
            $c2968667ab46cac6$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $c2968667ab46cac6$var$popHydrationState(workInProgress) ? $c2968667ab46cac6$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $c2968667ab46cac6$var$upgradeHydrationErrorsToRecoverable());
            $c2968667ab46cac6$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($c2968667ab46cac6$var$markUpdate(workInProgress), null !== nextResource ? ($c2968667ab46cac6$var$bubbleProperties(workInProgress), $c2968667ab46cac6$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($c2968667ab46cac6$var$bubbleProperties(workInProgress), $c2968667ab46cac6$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($c2968667ab46cac6$var$markUpdate(workInProgress), $c2968667ab46cac6$var$bubbleProperties(workInProgress), $c2968667ab46cac6$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($c2968667ab46cac6$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $c2968667ab46cac6$var$markUpdate(workInProgress), $c2968667ab46cac6$var$bubbleProperties(workInProgress), $c2968667ab46cac6$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $c2968667ab46cac6$var$popHostContext(workInProgress);
            renderLanes = $c2968667ab46cac6$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c2968667ab46cac6$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(166));
                    $c2968667ab46cac6$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $c2968667ab46cac6$var$contextStackCursor.current;
                $c2968667ab46cac6$var$popHydrationState(workInProgress) ? $c2968667ab46cac6$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $c2968667ab46cac6$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $c2968667ab46cac6$var$markUpdate(workInProgress));
            }
            $c2968667ab46cac6$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $c2968667ab46cac6$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c2968667ab46cac6$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(166));
                    $c2968667ab46cac6$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $c2968667ab46cac6$var$contextStackCursor.current;
                if ($c2968667ab46cac6$var$popHydrationState(workInProgress)) $c2968667ab46cac6$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $c2968667ab46cac6$var$getOwnerDocumentFromRootContainer($c2968667ab46cac6$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$c2968667ab46cac6$var$internalInstanceKey] = workInProgress;
                    nextResource[$c2968667ab46cac6$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($c2968667ab46cac6$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $c2968667ab46cac6$var$markUpdate(workInProgress);
                }
            }
            $c2968667ab46cac6$var$bubbleProperties(workInProgress);
            $c2968667ab46cac6$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $c2968667ab46cac6$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(166));
                current = $c2968667ab46cac6$var$rootInstanceStackCursor.current;
                if ($c2968667ab46cac6$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $c2968667ab46cac6$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$c2968667ab46cac6$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $c2968667ab46cac6$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $c2968667ab46cac6$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $c2968667ab46cac6$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$c2968667ab46cac6$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $c2968667ab46cac6$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $c2968667ab46cac6$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(557));
                        current[$c2968667ab46cac6$var$internalInstanceKey] = workInProgress;
                    } else $c2968667ab46cac6$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $c2968667ab46cac6$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $c2968667ab46cac6$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $c2968667ab46cac6$var$popSuspenseHandler(workInProgress), workInProgress;
                    $c2968667ab46cac6$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(558));
            }
            $c2968667ab46cac6$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $c2968667ab46cac6$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(317));
                        type[$c2968667ab46cac6$var$internalInstanceKey] = workInProgress;
                    } else $c2968667ab46cac6$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $c2968667ab46cac6$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $c2968667ab46cac6$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $c2968667ab46cac6$var$popSuspenseHandler(workInProgress), workInProgress;
                    $c2968667ab46cac6$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $c2968667ab46cac6$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $c2968667ab46cac6$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $c2968667ab46cac6$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $c2968667ab46cac6$var$popHostContainer(), null === current && $c2968667ab46cac6$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $c2968667ab46cac6$var$bubbleProperties(workInProgress), null;
        case 10:
            return $c2968667ab46cac6$var$popProvider(workInProgress.type), $c2968667ab46cac6$var$bubbleProperties(workInProgress), null;
        case 19:
            $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $c2968667ab46cac6$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $c2968667ab46cac6$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $c2968667ab46cac6$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $c2968667ab46cac6$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $c2968667ab46cac6$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $c2968667ab46cac6$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$c2968667ab46cac6$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseStackCursor, $c2968667ab46cac6$var$suspenseStackCursor.current & 1 | 2);
                            $c2968667ab46cac6$var$isHydrating && $c2968667ab46cac6$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $c2968667ab46cac6$var$now() > $c2968667ab46cac6$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $c2968667ab46cac6$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $c2968667ab46cac6$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $c2968667ab46cac6$var$scheduleRetryEffect(workInProgress, current), $c2968667ab46cac6$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$c2968667ab46cac6$var$isHydrating) return $c2968667ab46cac6$var$bubbleProperties(workInProgress), null;
                    } else 2 * $c2968667ab46cac6$var$now() - newProps.renderingStartTime > $c2968667ab46cac6$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $c2968667ab46cac6$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $c2968667ab46cac6$var$now(), current.sibling = null, renderLanes = $c2968667ab46cac6$var$suspenseStackCursor.current, $c2968667ab46cac6$var$push($c2968667ab46cac6$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $c2968667ab46cac6$var$isHydrating && $c2968667ab46cac6$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $c2968667ab46cac6$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $c2968667ab46cac6$var$popSuspenseHandler(workInProgress), $c2968667ab46cac6$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($c2968667ab46cac6$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $c2968667ab46cac6$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $c2968667ab46cac6$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $c2968667ab46cac6$var$popProvider($c2968667ab46cac6$var$CacheContext), $c2968667ab46cac6$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $c2968667ab46cac6$var$unwindWork(current, workInProgress) {
    $c2968667ab46cac6$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $c2968667ab46cac6$var$popProvider($c2968667ab46cac6$var$CacheContext), $c2968667ab46cac6$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $c2968667ab46cac6$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $c2968667ab46cac6$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(340));
                $c2968667ab46cac6$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $c2968667ab46cac6$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(340));
                $c2968667ab46cac6$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$suspenseStackCursor), null;
        case 4:
            return $c2968667ab46cac6$var$popHostContainer(), null;
        case 10:
            return $c2968667ab46cac6$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $c2968667ab46cac6$var$popSuspenseHandler(workInProgress), $c2968667ab46cac6$var$popHiddenContext(), null !== current && $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $c2968667ab46cac6$var$popProvider($c2968667ab46cac6$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $c2968667ab46cac6$var$unwindInterruptedWork(current, interruptedWork) {
    $c2968667ab46cac6$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $c2968667ab46cac6$var$popProvider($c2968667ab46cac6$var$CacheContext);
            $c2968667ab46cac6$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $c2968667ab46cac6$var$popHostContext(interruptedWork);
            break;
        case 4:
            $c2968667ab46cac6$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $c2968667ab46cac6$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $c2968667ab46cac6$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$suspenseStackCursor);
            break;
        case 10:
            $c2968667ab46cac6$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $c2968667ab46cac6$var$popSuspenseHandler(interruptedWork);
            $c2968667ab46cac6$var$popHiddenContext();
            null !== current && $c2968667ab46cac6$var$pop($c2968667ab46cac6$var$resumedCache);
            break;
        case 24:
            $c2968667ab46cac6$var$popProvider($c2968667ab46cac6$var$CacheContext);
    }
}
function $c2968667ab46cac6$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c2968667ab46cac6$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $c2968667ab46cac6$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c2968667ab46cac6$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $c2968667ab46cac6$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $c2968667ab46cac6$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $c2968667ab46cac6$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $c2968667ab46cac6$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $c2968667ab46cac6$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $c2968667ab46cac6$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $c2968667ab46cac6$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $c2968667ab46cac6$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $c2968667ab46cac6$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $c2968667ab46cac6$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c2968667ab46cac6$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $c2968667ab46cac6$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$c2968667ab46cac6$var$internalPropsKey] = newProps;
    } catch (error) {
        $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c2968667ab46cac6$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $c2968667ab46cac6$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $c2968667ab46cac6$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $c2968667ab46cac6$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $c2968667ab46cac6$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $c2968667ab46cac6$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $c2968667ab46cac6$var$noop$1));
    else if (4 !== tag && (27 === tag && $c2968667ab46cac6$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($c2968667ab46cac6$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$c2968667ab46cac6$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $c2968667ab46cac6$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $c2968667ab46cac6$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($c2968667ab46cac6$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$c2968667ab46cac6$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $c2968667ab46cac6$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $c2968667ab46cac6$var$setInitialProperties(singleton, type, props);
        singleton[$c2968667ab46cac6$var$internalInstanceKey] = finishedWork;
        singleton[$c2968667ab46cac6$var$internalPropsKey] = props;
    } catch (error) {
        $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $c2968667ab46cac6$var$offscreenSubtreeIsHidden = !1, $c2968667ab46cac6$var$offscreenSubtreeWasHidden = !1, $c2968667ab46cac6$var$needsFormReset = !1, $c2968667ab46cac6$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $c2968667ab46cac6$var$nextEffect = null;
function $c2968667ab46cac6$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $c2968667ab46cac6$var$eventsEnabled = $c2968667ab46cac6$var$_enabled;
    root = $c2968667ab46cac6$var$getActiveElementDeep(root);
    if ($c2968667ab46cac6$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $c2968667ab46cac6$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $c2968667ab46cac6$var$_enabled = !1;
    for($c2968667ab46cac6$var$nextEffect = firstChild; null !== $c2968667ab46cac6$var$nextEffect;)if (firstChild = $c2968667ab46cac6$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $c2968667ab46cac6$var$nextEffect = root;
    else for(; null !== $c2968667ab46cac6$var$nextEffect;){
        firstChild = $c2968667ab46cac6$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $c2968667ab46cac6$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $c2968667ab46cac6$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $c2968667ab46cac6$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $c2968667ab46cac6$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $c2968667ab46cac6$var$nextEffect = root;
            break;
        }
        $c2968667ab46cac6$var$nextEffect = firstChild.return;
    }
}
function $c2968667ab46cac6$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c2968667ab46cac6$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $c2968667ab46cac6$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $c2968667ab46cac6$var$commitClassCallbacks(finishedWork);
            flags & 512 && $c2968667ab46cac6$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $c2968667ab46cac6$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $c2968667ab46cac6$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $c2968667ab46cac6$var$commitHostMount(finishedWork);
            flags & 512 && $c2968667ab46cac6$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c2968667ab46cac6$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $c2968667ab46cac6$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $c2968667ab46cac6$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $c2968667ab46cac6$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $c2968667ab46cac6$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $c2968667ab46cac6$var$offscreenSubtreeWasHidden;
                prevProps = $c2968667ab46cac6$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $c2968667ab46cac6$var$offscreenSubtreeWasHidden;
                $c2968667ab46cac6$var$offscreenSubtreeIsHidden = flags;
                ($c2968667ab46cac6$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $c2968667ab46cac6$var$offscreenSubtreeIsHidden = prevProps;
                $c2968667ab46cac6$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $c2968667ab46cac6$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $c2968667ab46cac6$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $c2968667ab46cac6$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $c2968667ab46cac6$var$hostParent = null, $c2968667ab46cac6$var$hostParentIsContainer = !1;
function $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$c2968667ab46cac6$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $c2968667ab46cac6$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($c2968667ab46cac6$var$injectedHook && "function" === typeof $c2968667ab46cac6$var$injectedHook.onCommitFiberUnmount) try {
        $c2968667ab46cac6$var$injectedHook.onCommitFiberUnmount($c2968667ab46cac6$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden || $c2968667ab46cac6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden || $c2968667ab46cac6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $c2968667ab46cac6$var$hostParent, prevHostParentIsContainer = $c2968667ab46cac6$var$hostParentIsContainer;
            $c2968667ab46cac6$var$isSingletonScope(deletedFiber.type) && ($c2968667ab46cac6$var$hostParent = deletedFiber.stateNode, $c2968667ab46cac6$var$hostParentIsContainer = !1);
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c2968667ab46cac6$var$releaseSingletonInstance(deletedFiber.stateNode);
            $c2968667ab46cac6$var$hostParent = prevHostParent;
            $c2968667ab46cac6$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden || $c2968667ab46cac6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $c2968667ab46cac6$var$hostParent;
            prevHostParentIsContainer = $c2968667ab46cac6$var$hostParentIsContainer;
            $c2968667ab46cac6$var$hostParent = null;
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c2968667ab46cac6$var$hostParent = prevHostParent;
            $c2968667ab46cac6$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $c2968667ab46cac6$var$hostParent) {
                if ($c2968667ab46cac6$var$hostParentIsContainer) try {
                    (9 === $c2968667ab46cac6$var$hostParent.nodeType ? $c2968667ab46cac6$var$hostParent.body : "HTML" === $c2968667ab46cac6$var$hostParent.nodeName ? $c2968667ab46cac6$var$hostParent.ownerDocument.body : $c2968667ab46cac6$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $c2968667ab46cac6$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $c2968667ab46cac6$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $c2968667ab46cac6$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $c2968667ab46cac6$var$hostParent && ($c2968667ab46cac6$var$hostParentIsContainer ? (finishedRoot = $c2968667ab46cac6$var$hostParent, $c2968667ab46cac6$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $c2968667ab46cac6$var$retryIfBlockedOn(finishedRoot)) : $c2968667ab46cac6$var$clearHydrationBoundary($c2968667ab46cac6$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $c2968667ab46cac6$var$hostParent;
            prevHostParentIsContainer = $c2968667ab46cac6$var$hostParentIsContainer;
            $c2968667ab46cac6$var$hostParent = deletedFiber.stateNode.containerInfo;
            $c2968667ab46cac6$var$hostParentIsContainer = !0;
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c2968667ab46cac6$var$hostParent = prevHostParent;
            $c2968667ab46cac6$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $c2968667ab46cac6$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden || $c2968667ab46cac6$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden || ($c2968667ab46cac6$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $c2968667ab46cac6$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden = (prevHostParent = $c2968667ab46cac6$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $c2968667ab46cac6$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $c2968667ab46cac6$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $c2968667ab46cac6$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $c2968667ab46cac6$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $c2968667ab46cac6$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $c2968667ab46cac6$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $c2968667ab46cac6$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $c2968667ab46cac6$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($c2968667ab46cac6$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $c2968667ab46cac6$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $c2968667ab46cac6$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $c2968667ab46cac6$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($c2968667ab46cac6$var$isSingletonScope(parent.type)) {
                        $c2968667ab46cac6$var$hostParent = parent.stateNode;
                        $c2968667ab46cac6$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $c2968667ab46cac6$var$hostParent = parent.stateNode;
                    $c2968667ab46cac6$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $c2968667ab46cac6$var$hostParent = parent.stateNode.containerInfo;
                    $c2968667ab46cac6$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $c2968667ab46cac6$var$hostParent) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(160));
        $c2968667ab46cac6$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $c2968667ab46cac6$var$hostParent = null;
        $c2968667ab46cac6$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$c2968667ab46cac6$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $c2968667ab46cac6$var$currentHoistableRoot = null;
function $c2968667ab46cac6$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($c2968667ab46cac6$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $c2968667ab46cac6$var$commitHookEffectListMount(3, finishedWork), $c2968667ab46cac6$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c2968667ab46cac6$var$offscreenSubtreeWasHidden || null === current || $c2968667ab46cac6$var$safelyDetachRef(current, current.return));
            flags & 64 && $c2968667ab46cac6$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $c2968667ab46cac6$var$currentHoistableRoot;
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c2968667ab46cac6$var$offscreenSubtreeWasHidden || null === current || $c2968667ab46cac6$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$c2968667ab46cac6$var$internalHoistableMarker] || currentResource[$c2968667ab46cac6$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $c2968667ab46cac6$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$c2968667ab46cac6$var$internalInstanceKey] = finishedWork;
                                        $c2968667ab46cac6$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $c2968667ab46cac6$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $c2968667ab46cac6$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $c2968667ab46cac6$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $c2968667ab46cac6$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($c2968667ab46cac6$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$c2968667ab46cac6$var$internalInstanceKey] = finishedWork;
                                $c2968667ab46cac6$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $c2968667ab46cac6$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $c2968667ab46cac6$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $c2968667ab46cac6$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $c2968667ab46cac6$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $c2968667ab46cac6$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c2968667ab46cac6$var$offscreenSubtreeWasHidden || null === current || $c2968667ab46cac6$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $c2968667ab46cac6$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($c2968667ab46cac6$var$offscreenSubtreeWasHidden || null === current || $c2968667ab46cac6$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $c2968667ab46cac6$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $c2968667ab46cac6$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($c2968667ab46cac6$var$needsFormReset = !0);
            break;
        case 6:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $c2968667ab46cac6$var$tagCaches = null;
            hoistableRoot = $c2968667ab46cac6$var$currentHoistableRoot;
            $c2968667ab46cac6$var$currentHoistableRoot = $c2968667ab46cac6$var$getHoistableRoot(root.containerInfo);
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$currentHoistableRoot = hoistableRoot;
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $c2968667ab46cac6$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $c2968667ab46cac6$var$needsFormReset && ($c2968667ab46cac6$var$needsFormReset = !1, $c2968667ab46cac6$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $c2968667ab46cac6$var$currentHoistableRoot;
            $c2968667ab46cac6$var$currentHoistableRoot = $c2968667ab46cac6$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            $c2968667ab46cac6$var$currentHoistableRoot = flags;
            break;
        case 12:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c2968667ab46cac6$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($c2968667ab46cac6$var$globalMostRecentFallbackTime = $c2968667ab46cac6$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c2968667ab46cac6$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $c2968667ab46cac6$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $c2968667ab46cac6$var$offscreenSubtreeWasHidden;
            $c2968667ab46cac6$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $c2968667ab46cac6$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $c2968667ab46cac6$var$offscreenSubtreeIsHidden || $c2968667ab46cac6$var$offscreenSubtreeWasHidden || $c2968667ab46cac6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $c2968667ab46cac6$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $c2968667ab46cac6$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $c2968667ab46cac6$var$hideOrUnhideDehydratedBoundary(instance, !0) : $c2968667ab46cac6$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $c2968667ab46cac6$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $c2968667ab46cac6$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $c2968667ab46cac6$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $c2968667ab46cac6$var$recursivelyTraverseMutationEffects(root, finishedWork), $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork);
    }
}
function $c2968667ab46cac6$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($c2968667ab46cac6$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $c2968667ab46cac6$var$getHostSibling(finishedWork);
                    $c2968667ab46cac6$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($c2968667ab46cac6$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $c2968667ab46cac6$var$getHostSibling(finishedWork);
                    $c2968667ab46cac6$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $c2968667ab46cac6$var$getHostSibling(finishedWork);
                    $c2968667ab46cac6$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $c2968667ab46cac6$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $c2968667ab46cac6$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $c2968667ab46cac6$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$c2968667ab46cac6$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $c2968667ab46cac6$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $c2968667ab46cac6$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $c2968667ab46cac6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $c2968667ab46cac6$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $c2968667ab46cac6$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $c2968667ab46cac6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $c2968667ab46cac6$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $c2968667ab46cac6$var$safelyDetachRef(finishedWork, finishedWork.return);
                $c2968667ab46cac6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $c2968667ab46cac6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $c2968667ab46cac6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $c2968667ab46cac6$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $c2968667ab46cac6$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $c2968667ab46cac6$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$c2968667ab46cac6$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $c2968667ab46cac6$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $c2968667ab46cac6$var$commitClassCallbacks(finishedWork);
                $c2968667ab46cac6$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $c2968667ab46cac6$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $c2968667ab46cac6$var$commitHostMount(finishedWork);
                $c2968667ab46cac6$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $c2968667ab46cac6$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $c2968667ab46cac6$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $c2968667ab46cac6$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $c2968667ab46cac6$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c2968667ab46cac6$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $c2968667ab46cac6$var$releaseCache(previousCache));
}
function $c2968667ab46cac6$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $c2968667ab46cac6$var$releaseCache(current));
}
function $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$c2968667ab46cac6$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $c2968667ab46cac6$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $c2968667ab46cac6$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $c2968667ab46cac6$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $c2968667ab46cac6$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $c2968667ab46cac6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $c2968667ab46cac6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $c2968667ab46cac6$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $c2968667ab46cac6$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $c2968667ab46cac6$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $c2968667ab46cac6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $c2968667ab46cac6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $c2968667ab46cac6$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $c2968667ab46cac6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $c2968667ab46cac6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $c2968667ab46cac6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $c2968667ab46cac6$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $c2968667ab46cac6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $c2968667ab46cac6$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $c2968667ab46cac6$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c2968667ab46cac6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $c2968667ab46cac6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $c2968667ab46cac6$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $c2968667ab46cac6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $c2968667ab46cac6$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $c2968667ab46cac6$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $c2968667ab46cac6$var$suspenseyCommitFlag = 8192;
function $c2968667ab46cac6$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $c2968667ab46cac6$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$c2968667ab46cac6$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $c2968667ab46cac6$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $c2968667ab46cac6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $c2968667ab46cac6$var$suspenseyCommitFlag && null !== fiber.memoizedState && $c2968667ab46cac6$var$suspendResource(suspendedState, $c2968667ab46cac6$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $c2968667ab46cac6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $c2968667ab46cac6$var$currentHoistableRoot;
            $c2968667ab46cac6$var$currentHoistableRoot = $c2968667ab46cac6$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $c2968667ab46cac6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $c2968667ab46cac6$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $c2968667ab46cac6$var$suspenseyCommitFlag, $c2968667ab46cac6$var$suspenseyCommitFlag = 16777216, $c2968667ab46cac6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $c2968667ab46cac6$var$suspenseyCommitFlag = previousHoistableRoot) : $c2968667ab46cac6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $c2968667ab46cac6$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $c2968667ab46cac6$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $c2968667ab46cac6$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $c2968667ab46cac6$var$nextEffect = childToDelete;
            $c2968667ab46cac6$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $c2968667ab46cac6$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$c2968667ab46cac6$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $c2968667ab46cac6$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $c2968667ab46cac6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $c2968667ab46cac6$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $c2968667ab46cac6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $c2968667ab46cac6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $c2968667ab46cac6$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $c2968667ab46cac6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $c2968667ab46cac6$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $c2968667ab46cac6$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $c2968667ab46cac6$var$nextEffect = childToDelete;
            $c2968667ab46cac6$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $c2968667ab46cac6$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $c2968667ab46cac6$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $c2968667ab46cac6$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $c2968667ab46cac6$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $c2968667ab46cac6$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $c2968667ab46cac6$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $c2968667ab46cac6$var$nextEffect;){
        var fiber = $c2968667ab46cac6$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $c2968667ab46cac6$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $c2968667ab46cac6$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $c2968667ab46cac6$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $c2968667ab46cac6$var$nextEffect;){
            cache = $c2968667ab46cac6$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $c2968667ab46cac6$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $c2968667ab46cac6$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $c2968667ab46cac6$var$nextEffect = sibling;
                break a;
            }
            $c2968667ab46cac6$var$nextEffect = returnFiber;
        }
    }
}
var $c2968667ab46cac6$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $c2968667ab46cac6$var$readContext($c2968667ab46cac6$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $c2968667ab46cac6$var$readContext($c2968667ab46cac6$var$CacheContext).controller.signal;
    }
}, $c2968667ab46cac6$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $c2968667ab46cac6$var$executionContext = 0, $c2968667ab46cac6$var$workInProgressRoot = null, $c2968667ab46cac6$var$workInProgress = null, $c2968667ab46cac6$var$workInProgressRootRenderLanes = 0, $c2968667ab46cac6$var$workInProgressSuspendedReason = 0, $c2968667ab46cac6$var$workInProgressThrownValue = null, $c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings = !1, $c2968667ab46cac6$var$workInProgressRootIsPrerendering = !1, $c2968667ab46cac6$var$workInProgressRootDidAttachPingListener = !1, $c2968667ab46cac6$var$entangledRenderLanes = 0, $c2968667ab46cac6$var$workInProgressRootExitStatus = 0, $c2968667ab46cac6$var$workInProgressRootSkippedLanes = 0, $c2968667ab46cac6$var$workInProgressRootInterleavedUpdatedLanes = 0, $c2968667ab46cac6$var$workInProgressRootPingedLanes = 0, $c2968667ab46cac6$var$workInProgressDeferredLane = 0, $c2968667ab46cac6$var$workInProgressSuspendedRetryLanes = 0, $c2968667ab46cac6$var$workInProgressRootConcurrentErrors = null, $c2968667ab46cac6$var$workInProgressRootRecoverableErrors = null, $c2968667ab46cac6$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $c2968667ab46cac6$var$globalMostRecentFallbackTime = 0, $c2968667ab46cac6$var$globalMostRecentTransitionTime = 0, $c2968667ab46cac6$var$workInProgressRootRenderTargetTime = Infinity, $c2968667ab46cac6$var$workInProgressTransitions = null, $c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed = null, $c2968667ab46cac6$var$pendingEffectsStatus = 0, $c2968667ab46cac6$var$pendingEffectsRoot = null, $c2968667ab46cac6$var$pendingFinishedWork = null, $c2968667ab46cac6$var$pendingEffectsLanes = 0, $c2968667ab46cac6$var$pendingEffectsRemainingLanes = 0, $c2968667ab46cac6$var$pendingPassiveTransitions = null, $c2968667ab46cac6$var$pendingRecoverableErrors = null, $c2968667ab46cac6$var$nestedUpdateCount = 0, $c2968667ab46cac6$var$rootWithNestedUpdates = null;
function $c2968667ab46cac6$var$requestUpdateLane() {
    return 0 !== ($c2968667ab46cac6$var$executionContext & 2) && 0 !== $c2968667ab46cac6$var$workInProgressRootRenderLanes ? $c2968667ab46cac6$var$workInProgressRootRenderLanes & -$c2968667ab46cac6$var$workInProgressRootRenderLanes : null !== $c2968667ab46cac6$var$ReactSharedInternals.T ? $c2968667ab46cac6$var$requestTransitionLane() : $c2968667ab46cac6$var$resolveUpdatePriority();
}
function $c2968667ab46cac6$var$requestDeferredLane() {
    if (0 === $c2968667ab46cac6$var$workInProgressDeferredLane) {
        if (0 === ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 536870912) || $c2968667ab46cac6$var$isHydrating) {
            var lane = $c2968667ab46cac6$var$nextTransitionDeferredLane;
            $c2968667ab46cac6$var$nextTransitionDeferredLane <<= 1;
            0 === ($c2968667ab46cac6$var$nextTransitionDeferredLane & 3932160) && ($c2968667ab46cac6$var$nextTransitionDeferredLane = 262144);
            $c2968667ab46cac6$var$workInProgressDeferredLane = lane;
        } else $c2968667ab46cac6$var$workInProgressDeferredLane = 536870912;
    }
    lane = $c2968667ab46cac6$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $c2968667ab46cac6$var$workInProgressDeferredLane;
}
function $c2968667ab46cac6$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $c2968667ab46cac6$var$workInProgressRoot && (2 === $c2968667ab46cac6$var$workInProgressSuspendedReason || 9 === $c2968667ab46cac6$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $c2968667ab46cac6$var$prepareFreshStack(root, 0), $c2968667ab46cac6$var$markRootSuspended(root, $c2968667ab46cac6$var$workInProgressRootRenderLanes, $c2968667ab46cac6$var$workInProgressDeferredLane, !1);
    $c2968667ab46cac6$var$markRootUpdated$1(root, lane);
    if (0 === ($c2968667ab46cac6$var$executionContext & 2) || root !== $c2968667ab46cac6$var$workInProgressRoot) root === $c2968667ab46cac6$var$workInProgressRoot && (0 === ($c2968667ab46cac6$var$executionContext & 2) && ($c2968667ab46cac6$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $c2968667ab46cac6$var$workInProgressRootExitStatus && $c2968667ab46cac6$var$markRootSuspended(root, $c2968667ab46cac6$var$workInProgressRootRenderLanes, $c2968667ab46cac6$var$workInProgressDeferredLane, !1)), $c2968667ab46cac6$var$ensureRootIsScheduled(root);
}
function $c2968667ab46cac6$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($c2968667ab46cac6$var$executionContext & 6)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $c2968667ab46cac6$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $c2968667ab46cac6$var$renderRootConcurrent(root$jscomp$0, lanes) : $c2968667ab46cac6$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $c2968667ab46cac6$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $c2968667ab46cac6$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$c2968667ab46cac6$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $c2968667ab46cac6$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $c2968667ab46cac6$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($c2968667ab46cac6$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $c2968667ab46cac6$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($c2968667ab46cac6$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $c2968667ab46cac6$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $c2968667ab46cac6$var$workInProgressRootRecoverableErrors;
                            $c2968667ab46cac6$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $c2968667ab46cac6$var$workInProgressRootRecoverableErrors ? $c2968667ab46cac6$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $c2968667ab46cac6$var$workInProgressRootRecoverableErrors.push.apply($c2968667ab46cac6$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $c2968667ab46cac6$var$prepareFreshStack(root$jscomp$0, 0);
                $c2968667ab46cac6$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($c2968667ab46cac6$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $c2968667ab46cac6$var$markRootSuspended(shouldTimeSlice, lanes, $c2968667ab46cac6$var$workInProgressDeferredLane, !$c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $c2968667ab46cac6$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($c2968667ab46cac6$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $c2968667ab46cac6$var$globalMostRecentFallbackTime + 300 - $c2968667ab46cac6$var$now(), 10 < exitStatus)) {
                    $c2968667ab46cac6$var$markRootSuspended(shouldTimeSlice, lanes, $c2968667ab46cac6$var$workInProgressDeferredLane, !$c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $c2968667ab46cac6$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $c2968667ab46cac6$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $c2968667ab46cac6$var$scheduleTimeout($c2968667ab46cac6$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $c2968667ab46cac6$var$workInProgressRootRecoverableErrors, $c2968667ab46cac6$var$workInProgressTransitions, $c2968667ab46cac6$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $c2968667ab46cac6$var$workInProgressDeferredLane, $c2968667ab46cac6$var$workInProgressRootInterleavedUpdatedLanes, $c2968667ab46cac6$var$workInProgressSuspendedRetryLanes, $c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $c2968667ab46cac6$var$commitRootWhenReady(shouldTimeSlice, forceSync, $c2968667ab46cac6$var$workInProgressRootRecoverableErrors, $c2968667ab46cac6$var$workInProgressTransitions, $c2968667ab46cac6$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $c2968667ab46cac6$var$workInProgressDeferredLane, $c2968667ab46cac6$var$workInProgressRootInterleavedUpdatedLanes, $c2968667ab46cac6$var$workInProgressSuspendedRetryLanes, $c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $c2968667ab46cac6$var$ensureRootIsScheduled(root$jscomp$0);
}
function $c2968667ab46cac6$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $c2968667ab46cac6$var$noop$1
        };
        $c2968667ab46cac6$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $c2968667ab46cac6$var$globalMostRecentFallbackTime - $c2968667ab46cac6$var$now() : (lanes & 4194048) === lanes ? $c2968667ab46cac6$var$globalMostRecentTransitionTime - $c2968667ab46cac6$var$now() : 0;
        timeoutOffset = $c2968667ab46cac6$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $c2968667ab46cac6$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($c2968667ab46cac6$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $c2968667ab46cac6$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $c2968667ab46cac6$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $c2968667ab46cac6$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$c2968667ab46cac6$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $c2968667ab46cac6$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$c2968667ab46cac6$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$c2968667ab46cac6$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $c2968667ab46cac6$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $c2968667ab46cac6$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $c2968667ab46cac6$var$flushSyncWork$1() {
    return 0 === ($c2968667ab46cac6$var$executionContext & 6) ? ($c2968667ab46cac6$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $c2968667ab46cac6$var$resetWorkInProgressStack() {
    if (null !== $c2968667ab46cac6$var$workInProgress) {
        if (0 === $c2968667ab46cac6$var$workInProgressSuspendedReason) var interruptedWork = $c2968667ab46cac6$var$workInProgress.return;
        else interruptedWork = $c2968667ab46cac6$var$workInProgress, $c2968667ab46cac6$var$lastContextDependency = $c2968667ab46cac6$var$currentlyRenderingFiber$1 = null, $c2968667ab46cac6$var$resetHooksOnUnwind(interruptedWork), $c2968667ab46cac6$var$thenableState$1 = null, $c2968667ab46cac6$var$thenableIndexCounter$1 = 0, interruptedWork = $c2968667ab46cac6$var$workInProgress;
        for(; null !== interruptedWork;)$c2968667ab46cac6$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $c2968667ab46cac6$var$workInProgress = null;
    }
}
function $c2968667ab46cac6$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $c2968667ab46cac6$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $c2968667ab46cac6$var$pendingEffectsLanes = 0;
    $c2968667ab46cac6$var$resetWorkInProgressStack();
    $c2968667ab46cac6$var$workInProgressRoot = root;
    $c2968667ab46cac6$var$workInProgress = timeoutHandle = $c2968667ab46cac6$var$createWorkInProgress(root.current, null);
    $c2968667ab46cac6$var$workInProgressRootRenderLanes = lanes;
    $c2968667ab46cac6$var$workInProgressSuspendedReason = 0;
    $c2968667ab46cac6$var$workInProgressThrownValue = null;
    $c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $c2968667ab46cac6$var$workInProgressRootIsPrerendering = $c2968667ab46cac6$var$checkIfRootIsPrerendering(root, lanes);
    $c2968667ab46cac6$var$workInProgressRootDidAttachPingListener = !1;
    $c2968667ab46cac6$var$workInProgressSuspendedRetryLanes = $c2968667ab46cac6$var$workInProgressDeferredLane = $c2968667ab46cac6$var$workInProgressRootPingedLanes = $c2968667ab46cac6$var$workInProgressRootInterleavedUpdatedLanes = $c2968667ab46cac6$var$workInProgressRootSkippedLanes = $c2968667ab46cac6$var$workInProgressRootExitStatus = 0;
    $c2968667ab46cac6$var$workInProgressRootRecoverableErrors = $c2968667ab46cac6$var$workInProgressRootConcurrentErrors = null;
    $c2968667ab46cac6$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $c2968667ab46cac6$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $c2968667ab46cac6$var$entangledRenderLanes = lanes;
    $c2968667ab46cac6$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $c2968667ab46cac6$var$handleThrow(root, thrownValue) {
    $c2968667ab46cac6$var$currentlyRenderingFiber = null;
    $c2968667ab46cac6$var$ReactSharedInternals.H = $c2968667ab46cac6$var$ContextOnlyDispatcher;
    thrownValue === $c2968667ab46cac6$var$SuspenseException || thrownValue === $c2968667ab46cac6$var$SuspenseActionException ? (thrownValue = $c2968667ab46cac6$var$getSuspendedThenable(), $c2968667ab46cac6$var$workInProgressSuspendedReason = 3) : thrownValue === $c2968667ab46cac6$var$SuspenseyCommitException ? (thrownValue = $c2968667ab46cac6$var$getSuspendedThenable(), $c2968667ab46cac6$var$workInProgressSuspendedReason = 4) : $c2968667ab46cac6$var$workInProgressSuspendedReason = thrownValue === $c2968667ab46cac6$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $c2968667ab46cac6$var$workInProgressThrownValue = thrownValue;
    null === $c2968667ab46cac6$var$workInProgress && ($c2968667ab46cac6$var$workInProgressRootExitStatus = 1, $c2968667ab46cac6$var$logUncaughtError(root, $c2968667ab46cac6$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $c2968667ab46cac6$var$shouldRemainOnPreviousScreen() {
    var handler = $c2968667ab46cac6$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 4194048) === $c2968667ab46cac6$var$workInProgressRootRenderLanes ? null === $c2968667ab46cac6$var$shellBoundary ? !0 : !1 : ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 62914560) === $c2968667ab46cac6$var$workInProgressRootRenderLanes || 0 !== ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 536870912) ? handler === $c2968667ab46cac6$var$shellBoundary : !1;
}
function $c2968667ab46cac6$var$pushDispatcher() {
    var prevDispatcher = $c2968667ab46cac6$var$ReactSharedInternals.H;
    $c2968667ab46cac6$var$ReactSharedInternals.H = $c2968667ab46cac6$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $c2968667ab46cac6$var$ContextOnlyDispatcher : prevDispatcher;
}
function $c2968667ab46cac6$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $c2968667ab46cac6$var$ReactSharedInternals.A;
    $c2968667ab46cac6$var$ReactSharedInternals.A = $c2968667ab46cac6$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $c2968667ab46cac6$var$renderDidSuspendDelayIfPossible() {
    $c2968667ab46cac6$var$workInProgressRootExitStatus = 4;
    $c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings || ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 4194048) !== $c2968667ab46cac6$var$workInProgressRootRenderLanes && null !== $c2968667ab46cac6$var$suspenseHandlerStackCursor.current || ($c2968667ab46cac6$var$workInProgressRootIsPrerendering = !0);
    0 === ($c2968667ab46cac6$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($c2968667ab46cac6$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $c2968667ab46cac6$var$workInProgressRoot || $c2968667ab46cac6$var$markRootSuspended($c2968667ab46cac6$var$workInProgressRoot, $c2968667ab46cac6$var$workInProgressRootRenderLanes, $c2968667ab46cac6$var$workInProgressDeferredLane, !1);
}
function $c2968667ab46cac6$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $c2968667ab46cac6$var$executionContext;
    $c2968667ab46cac6$var$executionContext |= 2;
    var prevDispatcher = $c2968667ab46cac6$var$pushDispatcher(), prevAsyncDispatcher = $c2968667ab46cac6$var$pushAsyncDispatcher();
    if ($c2968667ab46cac6$var$workInProgressRoot !== root || $c2968667ab46cac6$var$workInProgressRootRenderLanes !== lanes) $c2968667ab46cac6$var$workInProgressTransitions = null, $c2968667ab46cac6$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $c2968667ab46cac6$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $c2968667ab46cac6$var$workInProgressSuspendedReason && null !== $c2968667ab46cac6$var$workInProgress) {
            var unitOfWork = $c2968667ab46cac6$var$workInProgress, thrownValue = $c2968667ab46cac6$var$workInProgressThrownValue;
            switch($c2968667ab46cac6$var$workInProgressSuspendedReason){
                case 8:
                    $c2968667ab46cac6$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $c2968667ab46cac6$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $c2968667ab46cac6$var$workInProgressSuspendedReason;
                    $c2968667ab46cac6$var$workInProgressSuspendedReason = 0;
                    $c2968667ab46cac6$var$workInProgressThrownValue = null;
                    $c2968667ab46cac6$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $c2968667ab46cac6$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $c2968667ab46cac6$var$workInProgressSuspendedReason, $c2968667ab46cac6$var$workInProgressSuspendedReason = 0, $c2968667ab46cac6$var$workInProgressThrownValue = null, $c2968667ab46cac6$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $c2968667ab46cac6$var$workLoopSync();
        exitStatus = $c2968667ab46cac6$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $c2968667ab46cac6$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $c2968667ab46cac6$var$lastContextDependency = $c2968667ab46cac6$var$currentlyRenderingFiber$1 = null;
    $c2968667ab46cac6$var$executionContext = prevExecutionContext;
    $c2968667ab46cac6$var$ReactSharedInternals.H = prevDispatcher;
    $c2968667ab46cac6$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $c2968667ab46cac6$var$workInProgress && ($c2968667ab46cac6$var$workInProgressRoot = null, $c2968667ab46cac6$var$workInProgressRootRenderLanes = 0, $c2968667ab46cac6$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $c2968667ab46cac6$var$workLoopSync() {
    for(; null !== $c2968667ab46cac6$var$workInProgress;)$c2968667ab46cac6$var$performUnitOfWork($c2968667ab46cac6$var$workInProgress);
}
function $c2968667ab46cac6$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $c2968667ab46cac6$var$executionContext;
    $c2968667ab46cac6$var$executionContext |= 2;
    var prevDispatcher = $c2968667ab46cac6$var$pushDispatcher(), prevAsyncDispatcher = $c2968667ab46cac6$var$pushAsyncDispatcher();
    $c2968667ab46cac6$var$workInProgressRoot !== root || $c2968667ab46cac6$var$workInProgressRootRenderLanes !== lanes ? ($c2968667ab46cac6$var$workInProgressTransitions = null, $c2968667ab46cac6$var$workInProgressRootRenderTargetTime = $c2968667ab46cac6$var$now() + 500, $c2968667ab46cac6$var$prepareFreshStack(root, lanes)) : $c2968667ab46cac6$var$workInProgressRootIsPrerendering = $c2968667ab46cac6$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $c2968667ab46cac6$var$workInProgressSuspendedReason && null !== $c2968667ab46cac6$var$workInProgress) {
            lanes = $c2968667ab46cac6$var$workInProgress;
            var thrownValue = $c2968667ab46cac6$var$workInProgressThrownValue;
            b: switch($c2968667ab46cac6$var$workInProgressSuspendedReason){
                case 1:
                    $c2968667ab46cac6$var$workInProgressSuspendedReason = 0;
                    $c2968667ab46cac6$var$workInProgressThrownValue = null;
                    $c2968667ab46cac6$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($c2968667ab46cac6$var$isThenableResolved(thrownValue)) {
                        $c2968667ab46cac6$var$workInProgressSuspendedReason = 0;
                        $c2968667ab46cac6$var$workInProgressThrownValue = null;
                        $c2968667ab46cac6$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $c2968667ab46cac6$var$workInProgressSuspendedReason && 9 !== $c2968667ab46cac6$var$workInProgressSuspendedReason || $c2968667ab46cac6$var$workInProgressRoot !== root || ($c2968667ab46cac6$var$workInProgressSuspendedReason = 7);
                        $c2968667ab46cac6$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $c2968667ab46cac6$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $c2968667ab46cac6$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $c2968667ab46cac6$var$isThenableResolved(thrownValue) ? ($c2968667ab46cac6$var$workInProgressSuspendedReason = 0, $c2968667ab46cac6$var$workInProgressThrownValue = null, $c2968667ab46cac6$var$replaySuspendedUnitOfWork(lanes)) : ($c2968667ab46cac6$var$workInProgressSuspendedReason = 0, $c2968667ab46cac6$var$workInProgressThrownValue = null, $c2968667ab46cac6$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($c2968667ab46cac6$var$workInProgress.tag){
                        case 26:
                            resource = $c2968667ab46cac6$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $c2968667ab46cac6$var$workInProgress;
                            if (resource ? $c2968667ab46cac6$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $c2968667ab46cac6$var$workInProgressSuspendedReason = 0;
                                $c2968667ab46cac6$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $c2968667ab46cac6$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($c2968667ab46cac6$var$workInProgress = returnFiber, $c2968667ab46cac6$var$completeUnitOfWork(returnFiber)) : $c2968667ab46cac6$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $c2968667ab46cac6$var$workInProgressSuspendedReason = 0;
                    $c2968667ab46cac6$var$workInProgressThrownValue = null;
                    $c2968667ab46cac6$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $c2968667ab46cac6$var$workInProgressSuspendedReason = 0;
                    $c2968667ab46cac6$var$workInProgressThrownValue = null;
                    $c2968667ab46cac6$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $c2968667ab46cac6$var$resetWorkInProgressStack();
                    $c2968667ab46cac6$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(462));
            }
        }
        $c2968667ab46cac6$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $c2968667ab46cac6$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $c2968667ab46cac6$var$lastContextDependency = $c2968667ab46cac6$var$currentlyRenderingFiber$1 = null;
    $c2968667ab46cac6$var$ReactSharedInternals.H = prevDispatcher;
    $c2968667ab46cac6$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $c2968667ab46cac6$var$executionContext = prevExecutionContext;
    if (null !== $c2968667ab46cac6$var$workInProgress) return 0;
    $c2968667ab46cac6$var$workInProgressRoot = null;
    $c2968667ab46cac6$var$workInProgressRootRenderLanes = 0;
    $c2968667ab46cac6$var$finishQueueingConcurrentUpdates();
    return $c2968667ab46cac6$var$workInProgressRootExitStatus;
}
function $c2968667ab46cac6$var$workLoopConcurrentByScheduler() {
    for(; null !== $c2968667ab46cac6$var$workInProgress && !$c2968667ab46cac6$var$shouldYield();)$c2968667ab46cac6$var$performUnitOfWork($c2968667ab46cac6$var$workInProgress);
}
function $c2968667ab46cac6$var$performUnitOfWork(unitOfWork) {
    var next = $c2968667ab46cac6$var$beginWork(unitOfWork.alternate, unitOfWork, $c2968667ab46cac6$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $c2968667ab46cac6$var$completeUnitOfWork(unitOfWork) : $c2968667ab46cac6$var$workInProgress = next;
}
function $c2968667ab46cac6$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $c2968667ab46cac6$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $c2968667ab46cac6$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $c2968667ab46cac6$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $c2968667ab46cac6$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $c2968667ab46cac6$var$resetHooksOnUnwind(next);
        default:
            $c2968667ab46cac6$var$unwindInterruptedWork(current, next), next = $c2968667ab46cac6$var$workInProgress = $c2968667ab46cac6$var$resetWorkInProgress(next, $c2968667ab46cac6$var$entangledRenderLanes), next = $c2968667ab46cac6$var$beginWork(current, next, $c2968667ab46cac6$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $c2968667ab46cac6$var$completeUnitOfWork(unitOfWork) : $c2968667ab46cac6$var$workInProgress = next;
}
function $c2968667ab46cac6$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $c2968667ab46cac6$var$lastContextDependency = $c2968667ab46cac6$var$currentlyRenderingFiber$1 = null;
    $c2968667ab46cac6$var$resetHooksOnUnwind(unitOfWork);
    $c2968667ab46cac6$var$thenableState$1 = null;
    $c2968667ab46cac6$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($c2968667ab46cac6$var$throwException(root, returnFiber, unitOfWork, thrownValue, $c2968667ab46cac6$var$workInProgressRootRenderLanes)) {
            $c2968667ab46cac6$var$workInProgressRootExitStatus = 1;
            $c2968667ab46cac6$var$logUncaughtError(root, $c2968667ab46cac6$var$createCapturedValueAtFiber(thrownValue, root.current));
            $c2968667ab46cac6$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $c2968667ab46cac6$var$workInProgress = returnFiber, error;
        $c2968667ab46cac6$var$workInProgressRootExitStatus = 1;
        $c2968667ab46cac6$var$logUncaughtError(root, $c2968667ab46cac6$var$createCapturedValueAtFiber(thrownValue, root.current));
        $c2968667ab46cac6$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($c2968667ab46cac6$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($c2968667ab46cac6$var$workInProgressRootIsPrerendering || 0 !== ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $c2968667ab46cac6$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $c2968667ab46cac6$var$unwindUnitOfWork(unitOfWork, root);
    } else $c2968667ab46cac6$var$completeUnitOfWork(unitOfWork);
}
function $c2968667ab46cac6$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $c2968667ab46cac6$var$unwindUnitOfWork(completedWork, $c2968667ab46cac6$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $c2968667ab46cac6$var$completeWork(completedWork.alternate, completedWork, $c2968667ab46cac6$var$entangledRenderLanes);
        if (null !== next) {
            $c2968667ab46cac6$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $c2968667ab46cac6$var$workInProgress = completedWork;
            return;
        }
        $c2968667ab46cac6$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $c2968667ab46cac6$var$workInProgressRootExitStatus && ($c2968667ab46cac6$var$workInProgressRootExitStatus = 5);
}
function $c2968667ab46cac6$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $c2968667ab46cac6$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $c2968667ab46cac6$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $c2968667ab46cac6$var$workInProgress = unitOfWork;
            return;
        }
        $c2968667ab46cac6$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $c2968667ab46cac6$var$workInProgressRootExitStatus = 6;
    $c2968667ab46cac6$var$workInProgress = null;
}
function $c2968667ab46cac6$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $c2968667ab46cac6$var$flushPendingEffects();
    while (0 !== $c2968667ab46cac6$var$pendingEffectsStatus);
    if (0 !== ($c2968667ab46cac6$var$executionContext & 6)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $c2968667ab46cac6$var$concurrentlyUpdatedLanes;
        $c2968667ab46cac6$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $c2968667ab46cac6$var$workInProgressRoot && ($c2968667ab46cac6$var$workInProgress = $c2968667ab46cac6$var$workInProgressRoot = null, $c2968667ab46cac6$var$workInProgressRootRenderLanes = 0);
        $c2968667ab46cac6$var$pendingFinishedWork = finishedWork;
        $c2968667ab46cac6$var$pendingEffectsRoot = root;
        $c2968667ab46cac6$var$pendingEffectsLanes = lanes;
        $c2968667ab46cac6$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $c2968667ab46cac6$var$pendingPassiveTransitions = transitions;
        $c2968667ab46cac6$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $c2968667ab46cac6$var$scheduleCallback$1($c2968667ab46cac6$var$NormalPriority$1, function() {
            $c2968667ab46cac6$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $c2968667ab46cac6$var$ReactSharedInternals.T;
            $c2968667ab46cac6$var$ReactSharedInternals.T = null;
            transitions = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
            $c2968667ab46cac6$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $c2968667ab46cac6$var$executionContext;
            $c2968667ab46cac6$var$executionContext |= 4;
            try {
                $c2968667ab46cac6$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $c2968667ab46cac6$var$executionContext = spawnedLane, $c2968667ab46cac6$var$ReactDOMSharedInternals.p = transitions, $c2968667ab46cac6$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $c2968667ab46cac6$var$pendingEffectsStatus = 1;
        $c2968667ab46cac6$var$flushMutationEffects();
        $c2968667ab46cac6$var$flushLayoutEffects();
        $c2968667ab46cac6$var$flushSpawnedWork();
    }
}
function $c2968667ab46cac6$var$flushMutationEffects() {
    if (1 === $c2968667ab46cac6$var$pendingEffectsStatus) {
        $c2968667ab46cac6$var$pendingEffectsStatus = 0;
        var root = $c2968667ab46cac6$var$pendingEffectsRoot, finishedWork = $c2968667ab46cac6$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $c2968667ab46cac6$var$ReactSharedInternals.T;
            $c2968667ab46cac6$var$ReactSharedInternals.T = null;
            var previousPriority = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
            $c2968667ab46cac6$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $c2968667ab46cac6$var$executionContext;
            $c2968667ab46cac6$var$executionContext |= 4;
            try {
                $c2968667ab46cac6$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $c2968667ab46cac6$var$selectionInformation, curFocusedElem = $c2968667ab46cac6$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $c2968667ab46cac6$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $c2968667ab46cac6$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $c2968667ab46cac6$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $c2968667ab46cac6$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $c2968667ab46cac6$var$_enabled = !!$c2968667ab46cac6$var$eventsEnabled;
                $c2968667ab46cac6$var$selectionInformation = $c2968667ab46cac6$var$eventsEnabled = null;
            } finally{
                $c2968667ab46cac6$var$executionContext = prevExecutionContext, $c2968667ab46cac6$var$ReactDOMSharedInternals.p = previousPriority, $c2968667ab46cac6$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $c2968667ab46cac6$var$pendingEffectsStatus = 2;
    }
}
function $c2968667ab46cac6$var$flushLayoutEffects() {
    if (2 === $c2968667ab46cac6$var$pendingEffectsStatus) {
        $c2968667ab46cac6$var$pendingEffectsStatus = 0;
        var root = $c2968667ab46cac6$var$pendingEffectsRoot, finishedWork = $c2968667ab46cac6$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $c2968667ab46cac6$var$ReactSharedInternals.T;
            $c2968667ab46cac6$var$ReactSharedInternals.T = null;
            var previousPriority = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
            $c2968667ab46cac6$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $c2968667ab46cac6$var$executionContext;
            $c2968667ab46cac6$var$executionContext |= 4;
            try {
                $c2968667ab46cac6$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $c2968667ab46cac6$var$executionContext = prevExecutionContext, $c2968667ab46cac6$var$ReactDOMSharedInternals.p = previousPriority, $c2968667ab46cac6$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $c2968667ab46cac6$var$pendingEffectsStatus = 3;
    }
}
function $c2968667ab46cac6$var$flushSpawnedWork() {
    if (4 === $c2968667ab46cac6$var$pendingEffectsStatus || 3 === $c2968667ab46cac6$var$pendingEffectsStatus) {
        $c2968667ab46cac6$var$pendingEffectsStatus = 0;
        $c2968667ab46cac6$var$requestPaint();
        var root = $c2968667ab46cac6$var$pendingEffectsRoot, finishedWork = $c2968667ab46cac6$var$pendingFinishedWork, lanes = $c2968667ab46cac6$var$pendingEffectsLanes, recoverableErrors = $c2968667ab46cac6$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $c2968667ab46cac6$var$pendingEffectsStatus = 5 : ($c2968667ab46cac6$var$pendingEffectsStatus = 0, $c2968667ab46cac6$var$pendingFinishedWork = $c2968667ab46cac6$var$pendingEffectsRoot = null, $c2968667ab46cac6$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $c2968667ab46cac6$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($c2968667ab46cac6$var$injectedHook && "function" === typeof $c2968667ab46cac6$var$injectedHook.onCommitFiberRoot) try {
            $c2968667ab46cac6$var$injectedHook.onCommitFiberRoot($c2968667ab46cac6$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $c2968667ab46cac6$var$ReactSharedInternals.T;
            remainingLanes = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
            $c2968667ab46cac6$var$ReactDOMSharedInternals.p = 2;
            $c2968667ab46cac6$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $c2968667ab46cac6$var$ReactSharedInternals.T = finishedWork, $c2968667ab46cac6$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($c2968667ab46cac6$var$pendingEffectsLanes & 3) && $c2968667ab46cac6$var$flushPendingEffects();
        $c2968667ab46cac6$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $c2968667ab46cac6$var$rootWithNestedUpdates ? $c2968667ab46cac6$var$nestedUpdateCount++ : ($c2968667ab46cac6$var$nestedUpdateCount = 0, $c2968667ab46cac6$var$rootWithNestedUpdates = root) : $c2968667ab46cac6$var$nestedUpdateCount = 0;
        $c2968667ab46cac6$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $c2968667ab46cac6$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $c2968667ab46cac6$var$releaseCache(remainingLanes)));
}
function $c2968667ab46cac6$var$flushPendingEffects() {
    $c2968667ab46cac6$var$flushMutationEffects();
    $c2968667ab46cac6$var$flushLayoutEffects();
    $c2968667ab46cac6$var$flushSpawnedWork();
    return $c2968667ab46cac6$var$flushPassiveEffects();
}
function $c2968667ab46cac6$var$flushPassiveEffects() {
    if (5 !== $c2968667ab46cac6$var$pendingEffectsStatus) return !1;
    var root = $c2968667ab46cac6$var$pendingEffectsRoot, remainingLanes = $c2968667ab46cac6$var$pendingEffectsRemainingLanes;
    $c2968667ab46cac6$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $c2968667ab46cac6$var$lanesToEventPriority($c2968667ab46cac6$var$pendingEffectsLanes), prevTransition = $c2968667ab46cac6$var$ReactSharedInternals.T, previousPriority = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
    try {
        $c2968667ab46cac6$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $c2968667ab46cac6$var$ReactSharedInternals.T = null;
        renderPriority = $c2968667ab46cac6$var$pendingPassiveTransitions;
        $c2968667ab46cac6$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $c2968667ab46cac6$var$pendingEffectsRoot, lanes = $c2968667ab46cac6$var$pendingEffectsLanes;
        $c2968667ab46cac6$var$pendingEffectsStatus = 0;
        $c2968667ab46cac6$var$pendingFinishedWork = $c2968667ab46cac6$var$pendingEffectsRoot = null;
        $c2968667ab46cac6$var$pendingEffectsLanes = 0;
        if (0 !== ($c2968667ab46cac6$var$executionContext & 6)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(331));
        var prevExecutionContext = $c2968667ab46cac6$var$executionContext;
        $c2968667ab46cac6$var$executionContext |= 4;
        $c2968667ab46cac6$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $c2968667ab46cac6$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $c2968667ab46cac6$var$executionContext = prevExecutionContext;
        $c2968667ab46cac6$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($c2968667ab46cac6$var$injectedHook && "function" === typeof $c2968667ab46cac6$var$injectedHook.onPostCommitFiberRoot) try {
            $c2968667ab46cac6$var$injectedHook.onPostCommitFiberRoot($c2968667ab46cac6$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $c2968667ab46cac6$var$ReactDOMSharedInternals.p = previousPriority, $c2968667ab46cac6$var$ReactSharedInternals.T = prevTransition, $c2968667ab46cac6$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $c2968667ab46cac6$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $c2968667ab46cac6$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $c2968667ab46cac6$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $c2968667ab46cac6$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($c2968667ab46cac6$var$markRootUpdated$1(rootFiber, 2), $c2968667ab46cac6$var$ensureRootIsScheduled(rootFiber));
}
function $c2968667ab46cac6$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $c2968667ab46cac6$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $c2968667ab46cac6$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed || !$c2968667ab46cac6$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $c2968667ab46cac6$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $c2968667ab46cac6$var$createClassErrorUpdate(2);
                instance = $c2968667ab46cac6$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($c2968667ab46cac6$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $c2968667ab46cac6$var$markRootUpdated$1(instance, 2), $c2968667ab46cac6$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $c2968667ab46cac6$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $c2968667ab46cac6$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($c2968667ab46cac6$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $c2968667ab46cac6$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $c2968667ab46cac6$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $c2968667ab46cac6$var$workInProgressRoot === root && ($c2968667ab46cac6$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $c2968667ab46cac6$var$workInProgressRootExitStatus || 3 === $c2968667ab46cac6$var$workInProgressRootExitStatus && ($c2968667ab46cac6$var$workInProgressRootRenderLanes & 62914560) === $c2968667ab46cac6$var$workInProgressRootRenderLanes && 300 > $c2968667ab46cac6$var$now() - $c2968667ab46cac6$var$globalMostRecentFallbackTime ? 0 === ($c2968667ab46cac6$var$executionContext & 2) && $c2968667ab46cac6$var$prepareFreshStack(root, 0) : $c2968667ab46cac6$var$workInProgressRootPingedLanes |= pingedLanes, $c2968667ab46cac6$var$workInProgressSuspendedRetryLanes === $c2968667ab46cac6$var$workInProgressRootRenderLanes && ($c2968667ab46cac6$var$workInProgressSuspendedRetryLanes = 0));
    $c2968667ab46cac6$var$ensureRootIsScheduled(root);
}
function $c2968667ab46cac6$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $c2968667ab46cac6$var$claimNextRetryLane());
    boundaryFiber = $c2968667ab46cac6$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($c2968667ab46cac6$var$markRootUpdated$1(boundaryFiber, retryLane), $c2968667ab46cac6$var$ensureRootIsScheduled(boundaryFiber));
}
function $c2968667ab46cac6$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $c2968667ab46cac6$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $c2968667ab46cac6$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($c2968667ab46cac6$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $c2968667ab46cac6$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $c2968667ab46cac6$var$scheduleCallback$1(priorityLevel, callback) {
    return $c2968667ab46cac6$var$scheduleCallback$3(priorityLevel, callback);
}
var $c2968667ab46cac6$var$firstScheduledRoot = null, $c2968667ab46cac6$var$lastScheduledRoot = null, $c2968667ab46cac6$var$didScheduleMicrotask = !1, $c2968667ab46cac6$var$mightHavePendingSyncWork = !1, $c2968667ab46cac6$var$isFlushingWork = !1, $c2968667ab46cac6$var$currentEventTransitionLane = 0;
function $c2968667ab46cac6$var$ensureRootIsScheduled(root) {
    root !== $c2968667ab46cac6$var$lastScheduledRoot && null === root.next && (null === $c2968667ab46cac6$var$lastScheduledRoot ? $c2968667ab46cac6$var$firstScheduledRoot = $c2968667ab46cac6$var$lastScheduledRoot = root : $c2968667ab46cac6$var$lastScheduledRoot = $c2968667ab46cac6$var$lastScheduledRoot.next = root);
    $c2968667ab46cac6$var$mightHavePendingSyncWork = !0;
    $c2968667ab46cac6$var$didScheduleMicrotask || ($c2968667ab46cac6$var$didScheduleMicrotask = !0, $c2968667ab46cac6$var$scheduleImmediateRootScheduleTask());
}
function $c2968667ab46cac6$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$c2968667ab46cac6$var$isFlushingWork && $c2968667ab46cac6$var$mightHavePendingSyncWork) {
        $c2968667ab46cac6$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $c2968667ab46cac6$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $c2968667ab46cac6$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $c2968667ab46cac6$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $c2968667ab46cac6$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $c2968667ab46cac6$var$getNextLanes(root$170, root$170 === $c2968667ab46cac6$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $c2968667ab46cac6$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $c2968667ab46cac6$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $c2968667ab46cac6$var$isFlushingWork = !1;
    }
}
function $c2968667ab46cac6$var$processRootScheduleInImmediateTask() {
    $c2968667ab46cac6$var$processRootScheduleInMicrotask();
}
function $c2968667ab46cac6$var$processRootScheduleInMicrotask() {
    $c2968667ab46cac6$var$mightHavePendingSyncWork = $c2968667ab46cac6$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $c2968667ab46cac6$var$currentEventTransitionLane && $c2968667ab46cac6$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $c2968667ab46cac6$var$currentEventTransitionLane);
    for(var currentTime = $c2968667ab46cac6$var$now(), prev = null, root = $c2968667ab46cac6$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $c2968667ab46cac6$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $c2968667ab46cac6$var$firstScheduledRoot = next : prev.next = next, null === next && ($c2968667ab46cac6$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $c2968667ab46cac6$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $c2968667ab46cac6$var$pendingEffectsStatus && 5 !== $c2968667ab46cac6$var$pendingEffectsStatus || $c2968667ab46cac6$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $c2968667ab46cac6$var$currentEventTransitionLane && ($c2968667ab46cac6$var$currentEventTransitionLane = 0);
}
function $c2968667ab46cac6$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $c2968667ab46cac6$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $c2968667ab46cac6$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $c2968667ab46cac6$var$workInProgressRoot;
    suspendedLanes = $c2968667ab46cac6$var$workInProgressRootRenderLanes;
    suspendedLanes = $c2968667ab46cac6$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $c2968667ab46cac6$var$workInProgressSuspendedReason || 9 === $c2968667ab46cac6$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $c2968667ab46cac6$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $c2968667ab46cac6$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $c2968667ab46cac6$var$cancelCallback$1(pingedLanes);
        switch($c2968667ab46cac6$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $c2968667ab46cac6$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $c2968667ab46cac6$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $c2968667ab46cac6$var$IdlePriority;
                break;
            default:
                suspendedLanes = $c2968667ab46cac6$var$NormalPriority$1;
        }
        pingedLanes = $c2968667ab46cac6$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $c2968667ab46cac6$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $c2968667ab46cac6$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $c2968667ab46cac6$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $c2968667ab46cac6$var$pendingEffectsStatus && 5 !== $c2968667ab46cac6$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($c2968667ab46cac6$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $c2968667ab46cac6$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $c2968667ab46cac6$var$getNextLanes(root, root === $c2968667ab46cac6$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $c2968667ab46cac6$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $c2968667ab46cac6$var$scheduleTaskForRootDuringMicrotask(root, $c2968667ab46cac6$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $c2968667ab46cac6$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $c2968667ab46cac6$var$performSyncWorkOnRoot(root, lanes) {
    if ($c2968667ab46cac6$var$flushPendingEffects()) return null;
    $c2968667ab46cac6$var$performWorkOnRoot(root, lanes, !0);
}
function $c2968667ab46cac6$var$scheduleImmediateRootScheduleTask() {
    $c2968667ab46cac6$var$scheduleMicrotask(function() {
        0 !== ($c2968667ab46cac6$var$executionContext & 6) ? $c2968667ab46cac6$var$scheduleCallback$3($c2968667ab46cac6$var$ImmediatePriority, $c2968667ab46cac6$var$processRootScheduleInImmediateTask) : $c2968667ab46cac6$var$processRootScheduleInMicrotask();
    });
}
function $c2968667ab46cac6$var$requestTransitionLane() {
    if (0 === $c2968667ab46cac6$var$currentEventTransitionLane) {
        var actionScopeLane = $c2968667ab46cac6$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $c2968667ab46cac6$var$nextTransitionUpdateLane, $c2968667ab46cac6$var$nextTransitionUpdateLane <<= 1, 0 === ($c2968667ab46cac6$var$nextTransitionUpdateLane & 261888) && ($c2968667ab46cac6$var$nextTransitionUpdateLane = 256));
        $c2968667ab46cac6$var$currentEventTransitionLane = actionScopeLane;
    }
    return $c2968667ab46cac6$var$currentEventTransitionLane;
}
function $c2968667ab46cac6$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $c2968667ab46cac6$var$sanitizeURL("" + actionProp);
}
function $c2968667ab46cac6$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $c2968667ab46cac6$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $c2968667ab46cac6$var$coerceFormActionProp((nativeEventTarget[$c2968667ab46cac6$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$c2968667ab46cac6$var$internalPropsKey] || null) ? $c2968667ab46cac6$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $c2968667ab46cac6$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $c2968667ab46cac6$var$currentEventTransitionLane) {
                                var formData = submitter ? $c2968667ab46cac6$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $c2968667ab46cac6$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $c2968667ab46cac6$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $c2968667ab46cac6$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $c2968667ab46cac6$var$i$jscomp$inline_1577 = 0; $c2968667ab46cac6$var$i$jscomp$inline_1577 < $c2968667ab46cac6$var$simpleEventPluginEvents.length; $c2968667ab46cac6$var$i$jscomp$inline_1577++){
    var $c2968667ab46cac6$var$eventName$jscomp$inline_1578 = $c2968667ab46cac6$var$simpleEventPluginEvents[$c2968667ab46cac6$var$i$jscomp$inline_1577], $c2968667ab46cac6$var$domEventName$jscomp$inline_1579 = $c2968667ab46cac6$var$eventName$jscomp$inline_1578.toLowerCase(), $c2968667ab46cac6$var$capitalizedEvent$jscomp$inline_1580 = $c2968667ab46cac6$var$eventName$jscomp$inline_1578[0].toUpperCase() + $c2968667ab46cac6$var$eventName$jscomp$inline_1578.slice(1);
    $c2968667ab46cac6$var$registerSimpleEvent($c2968667ab46cac6$var$domEventName$jscomp$inline_1579, "on" + $c2968667ab46cac6$var$capitalizedEvent$jscomp$inline_1580);
}
$c2968667ab46cac6$var$registerSimpleEvent($c2968667ab46cac6$var$ANIMATION_END, "onAnimationEnd");
$c2968667ab46cac6$var$registerSimpleEvent($c2968667ab46cac6$var$ANIMATION_ITERATION, "onAnimationIteration");
$c2968667ab46cac6$var$registerSimpleEvent($c2968667ab46cac6$var$ANIMATION_START, "onAnimationStart");
$c2968667ab46cac6$var$registerSimpleEvent("dblclick", "onDoubleClick");
$c2968667ab46cac6$var$registerSimpleEvent("focusin", "onFocus");
$c2968667ab46cac6$var$registerSimpleEvent("focusout", "onBlur");
$c2968667ab46cac6$var$registerSimpleEvent($c2968667ab46cac6$var$TRANSITION_RUN, "onTransitionRun");
$c2968667ab46cac6$var$registerSimpleEvent($c2968667ab46cac6$var$TRANSITION_START, "onTransitionStart");
$c2968667ab46cac6$var$registerSimpleEvent($c2968667ab46cac6$var$TRANSITION_CANCEL, "onTransitionCancel");
$c2968667ab46cac6$var$registerSimpleEvent($c2968667ab46cac6$var$TRANSITION_END, "onTransitionEnd");
$c2968667ab46cac6$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c2968667ab46cac6$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c2968667ab46cac6$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c2968667ab46cac6$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c2968667ab46cac6$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c2968667ab46cac6$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c2968667ab46cac6$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c2968667ab46cac6$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c2968667ab46cac6$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c2968667ab46cac6$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c2968667ab46cac6$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c2968667ab46cac6$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($c2968667ab46cac6$var$mediaEventTypes));
function $c2968667ab46cac6$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $c2968667ab46cac6$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $c2968667ab46cac6$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $c2968667ab46cac6$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$c2968667ab46cac6$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$c2968667ab46cac6$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($c2968667ab46cac6$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $c2968667ab46cac6$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $c2968667ab46cac6$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $c2968667ab46cac6$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $c2968667ab46cac6$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$c2968667ab46cac6$var$listeningMarker]) {
        rootContainerElement[$c2968667ab46cac6$var$listeningMarker] = !0;
        $c2968667ab46cac6$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($c2968667ab46cac6$var$nonDelegatedEvents.has(domEventName) || $c2968667ab46cac6$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $c2968667ab46cac6$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$c2968667ab46cac6$var$listeningMarker] || (ownerDocument[$c2968667ab46cac6$var$listeningMarker] = !0, $c2968667ab46cac6$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $c2968667ab46cac6$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($c2968667ab46cac6$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $c2968667ab46cac6$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $c2968667ab46cac6$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $c2968667ab46cac6$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$c2968667ab46cac6$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $c2968667ab46cac6$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $c2968667ab46cac6$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $c2968667ab46cac6$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $c2968667ab46cac6$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $c2968667ab46cac6$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $c2968667ab46cac6$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticTouchEvent;
                        break;
                    case $c2968667ab46cac6$var$ANIMATION_END:
                    case $c2968667ab46cac6$var$ANIMATION_ITERATION:
                    case $c2968667ab46cac6$var$ANIMATION_START:
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticAnimationEvent;
                        break;
                    case $c2968667ab46cac6$var$TRANSITION_END:
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $c2968667ab46cac6$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $c2968667ab46cac6$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($c2968667ab46cac6$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $c2968667ab46cac6$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($c2968667ab46cac6$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$c2968667ab46cac6$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $c2968667ab46cac6$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $c2968667ab46cac6$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $c2968667ab46cac6$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $c2968667ab46cac6$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $c2968667ab46cac6$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $c2968667ab46cac6$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $c2968667ab46cac6$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $c2968667ab46cac6$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $c2968667ab46cac6$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $c2968667ab46cac6$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $c2968667ab46cac6$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $c2968667ab46cac6$var$getTargetInstForChangeEvent;
                else if ($c2968667ab46cac6$var$isTextInputElement(reactName)) {
                    if ($c2968667ab46cac6$var$isInputEventSupported) getTargetInstFunc = $c2968667ab46cac6$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $c2968667ab46cac6$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $c2968667ab46cac6$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $c2968667ab46cac6$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $c2968667ab46cac6$var$getTargetInstForChangeEvent) : getTargetInstFunc = $c2968667ab46cac6$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $c2968667ab46cac6$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $c2968667ab46cac6$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $c2968667ab46cac6$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($c2968667ab46cac6$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $c2968667ab46cac6$var$activeElement = handleEventFunc, $c2968667ab46cac6$var$activeElementInst = targetInst, $c2968667ab46cac6$var$lastSelection = null;
                    break;
                case "focusout":
                    $c2968667ab46cac6$var$lastSelection = $c2968667ab46cac6$var$activeElementInst = $c2968667ab46cac6$var$activeElement = null;
                    break;
                case "mousedown":
                    $c2968667ab46cac6$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c2968667ab46cac6$var$mouseDown = !1;
                    $c2968667ab46cac6$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($c2968667ab46cac6$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $c2968667ab46cac6$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($c2968667ab46cac6$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $c2968667ab46cac6$var$isComposing ? $c2968667ab46cac6$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($c2968667ab46cac6$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($c2968667ab46cac6$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $c2968667ab46cac6$var$isComposing && (fallbackData = $c2968667ab46cac6$var$getData()) : ($c2968667ab46cac6$var$root = nativeEventTarget, $c2968667ab46cac6$var$startText = "value" in $c2968667ab46cac6$var$root ? $c2968667ab46cac6$var$root.value : $c2968667ab46cac6$var$root.textContent, $c2968667ab46cac6$var$isComposing = !0)), handleEventFunc = $c2968667ab46cac6$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $c2968667ab46cac6$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $c2968667ab46cac6$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $c2968667ab46cac6$var$canUseTextInputEvent ? $c2968667ab46cac6$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $c2968667ab46cac6$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $c2968667ab46cac6$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $c2968667ab46cac6$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $c2968667ab46cac6$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $c2968667ab46cac6$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $c2968667ab46cac6$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $c2968667ab46cac6$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $c2968667ab46cac6$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($c2968667ab46cac6$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $c2968667ab46cac6$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($c2968667ab46cac6$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $c2968667ab46cac6$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $c2968667ab46cac6$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $c2968667ab46cac6$var$getListener(target, registrationName), null != stateNode && listeners.unshift($c2968667ab46cac6$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $c2968667ab46cac6$var$getListener(target, registrationName), null != stateNode && listeners.push($c2968667ab46cac6$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $c2968667ab46cac6$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $c2968667ab46cac6$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $c2968667ab46cac6$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($c2968667ab46cac6$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($c2968667ab46cac6$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $c2968667ab46cac6$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $c2968667ab46cac6$var$normalizeMarkupForTextOrAttribute(clientText);
    return $c2968667ab46cac6$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $c2968667ab46cac6$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $c2968667ab46cac6$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && $c2968667ab46cac6$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $c2968667ab46cac6$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $c2968667ab46cac6$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $c2968667ab46cac6$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $c2968667ab46cac6$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $c2968667ab46cac6$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $c2968667ab46cac6$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $c2968667ab46cac6$var$setProp(domElement, tag, "name", props.name, props, null), $c2968667ab46cac6$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $c2968667ab46cac6$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $c2968667ab46cac6$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($c2968667ab46cac6$var$setProp(domElement, tag, "encType", props.encType, props, null), $c2968667ab46cac6$var$setProp(domElement, tag, "method", props.method, props, null), $c2968667ab46cac6$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $c2968667ab46cac6$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $c2968667ab46cac6$var$noop$1);
            break;
        case "onScroll":
            null != value && $c2968667ab46cac6$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $c2968667ab46cac6$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $c2968667ab46cac6$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("toggle", domElement);
            $c2968667ab46cac6$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $c2968667ab46cac6$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $c2968667ab46cac6$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $c2968667ab46cac6$var$aliases.get(key) || key, $c2968667ab46cac6$var$setValueForAttribute(domElement, key, value);
    }
}
function $c2968667ab46cac6$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $c2968667ab46cac6$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $c2968667ab46cac6$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && $c2968667ab46cac6$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $c2968667ab46cac6$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $c2968667ab46cac6$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $c2968667ab46cac6$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$c2968667ab46cac6$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$c2968667ab46cac6$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $c2968667ab46cac6$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $c2968667ab46cac6$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("error", domElement);
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($c2968667ab46cac6$var$formatProdErrorMessage(137, tag));
                    default:
                        $c2968667ab46cac6$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $c2968667ab46cac6$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $c2968667ab46cac6$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $c2968667ab46cac6$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $c2968667ab46cac6$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $c2968667ab46cac6$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $c2968667ab46cac6$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $c2968667ab46cac6$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(91));
                    break;
                default:
                    $c2968667ab46cac6$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $c2968667ab46cac6$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $c2968667ab46cac6$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("toggle", domElement);
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("cancel", domElement);
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $c2968667ab46cac6$var$mediaEventTypes.length; hasSrc++)$c2968667ab46cac6$var$listenToNonDelegatedEvent($c2968667ab46cac6$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("error", domElement);
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $c2968667ab46cac6$var$listenToNonDelegatedEvent("error", domElement), $c2968667ab46cac6$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($c2968667ab46cac6$var$formatProdErrorMessage(137, tag));
                default:
                    $c2968667ab46cac6$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($c2968667ab46cac6$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $c2968667ab46cac6$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $c2968667ab46cac6$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $c2968667ab46cac6$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $c2968667ab46cac6$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $c2968667ab46cac6$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $c2968667ab46cac6$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $c2968667ab46cac6$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $c2968667ab46cac6$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $c2968667ab46cac6$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $c2968667ab46cac6$var$updateOptions(domElement, !!lastProps, tag, !0) : $c2968667ab46cac6$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $c2968667ab46cac6$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $c2968667ab46cac6$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $c2968667ab46cac6$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $c2968667ab46cac6$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    $c2968667ab46cac6$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $c2968667ab46cac6$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $c2968667ab46cac6$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($c2968667ab46cac6$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $c2968667ab46cac6$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $c2968667ab46cac6$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $c2968667ab46cac6$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $c2968667ab46cac6$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $c2968667ab46cac6$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $c2968667ab46cac6$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $c2968667ab46cac6$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $c2968667ab46cac6$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $c2968667ab46cac6$var$eventsEnabled = null, $c2968667ab46cac6$var$selectionInformation = null;
function $c2968667ab46cac6$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $c2968667ab46cac6$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $c2968667ab46cac6$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $c2968667ab46cac6$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $c2968667ab46cac6$var$currentPopstateTransitionEvent = null;
function $c2968667ab46cac6$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $c2968667ab46cac6$var$currentPopstateTransitionEvent) return !1;
        $c2968667ab46cac6$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $c2968667ab46cac6$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $c2968667ab46cac6$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $c2968667ab46cac6$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $c2968667ab46cac6$var$localPromise = "function" === typeof Promise ? Promise : void 0, $c2968667ab46cac6$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c2968667ab46cac6$var$localPromise ? function(callback) {
    return $c2968667ab46cac6$var$localPromise.resolve(null).then(callback).catch($c2968667ab46cac6$var$handleErrorInNextTick);
} : $c2968667ab46cac6$var$scheduleTimeout;
function $c2968667ab46cac6$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $c2968667ab46cac6$var$isSingletonScope(type) {
    return "head" === type;
}
function $c2968667ab46cac6$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $c2968667ab46cac6$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $c2968667ab46cac6$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $c2968667ab46cac6$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$c2968667ab46cac6$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $c2968667ab46cac6$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $c2968667ab46cac6$var$retryIfBlockedOn(hydrationInstance);
}
function $c2968667ab46cac6$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $c2968667ab46cac6$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $c2968667ab46cac6$var$clearContainerSparingly(node);
                $c2968667ab46cac6$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $c2968667ab46cac6$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$c2968667ab46cac6$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $c2968667ab46cac6$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $c2968667ab46cac6$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $c2968667ab46cac6$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $c2968667ab46cac6$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $c2968667ab46cac6$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $c2968667ab46cac6$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $c2968667ab46cac6$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $c2968667ab46cac6$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $c2968667ab46cac6$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $c2968667ab46cac6$var$previousHydratableOnEnteringScopedSingleton = null;
function $c2968667ab46cac6$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $c2968667ab46cac6$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $c2968667ab46cac6$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $c2968667ab46cac6$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $c2968667ab46cac6$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($c2968667ab46cac6$var$formatProdErrorMessage(451));
    }
}
function $c2968667ab46cac6$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $c2968667ab46cac6$var$detachDeletedInstance(instance);
}
var $c2968667ab46cac6$var$preloadPropsMap = new Map(), $c2968667ab46cac6$var$preconnectsSet = new Set();
function $c2968667ab46cac6$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $c2968667ab46cac6$var$previousDispatcher = $c2968667ab46cac6$var$ReactDOMSharedInternals.d;
$c2968667ab46cac6$var$ReactDOMSharedInternals.d = {
    f: $c2968667ab46cac6$var$flushSyncWork,
    r: $c2968667ab46cac6$var$requestFormReset,
    D: $c2968667ab46cac6$var$prefetchDNS,
    C: $c2968667ab46cac6$var$preconnect,
    L: $c2968667ab46cac6$var$preload,
    m: $c2968667ab46cac6$var$preloadModule,
    X: $c2968667ab46cac6$var$preinitScript,
    S: $c2968667ab46cac6$var$preinitStyle,
    M: $c2968667ab46cac6$var$preinitModuleScript
};
function $c2968667ab46cac6$var$flushSyncWork() {
    var previousWasRendering = $c2968667ab46cac6$var$previousDispatcher.f(), wasRendering = $c2968667ab46cac6$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $c2968667ab46cac6$var$requestFormReset(form) {
    var formInst = $c2968667ab46cac6$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $c2968667ab46cac6$var$requestFormReset$1(formInst) : $c2968667ab46cac6$var$previousDispatcher.r(form);
}
var $c2968667ab46cac6$var$globalDocument = "undefined" === typeof document ? null : document;
function $c2968667ab46cac6$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $c2968667ab46cac6$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $c2968667ab46cac6$var$preconnectsSet.has(limitedEscapedHref) || ($c2968667ab46cac6$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $c2968667ab46cac6$var$setInitialProperties(href, "link", rel), $c2968667ab46cac6$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $c2968667ab46cac6$var$prefetchDNS(href) {
    $c2968667ab46cac6$var$previousDispatcher.D(href);
    $c2968667ab46cac6$var$preconnectAs("dns-prefetch", href, null);
}
function $c2968667ab46cac6$var$preconnect(href, crossOrigin) {
    $c2968667ab46cac6$var$previousDispatcher.C(href, crossOrigin);
    $c2968667ab46cac6$var$preconnectAs("preconnect", href, crossOrigin);
}
function $c2968667ab46cac6$var$preload(href, as, options) {
    $c2968667ab46cac6$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $c2968667ab46cac6$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $c2968667ab46cac6$var$getStyleKey(href);
                break;
            case "script":
                key = $c2968667ab46cac6$var$getScriptKey(href);
        }
        $c2968667ab46cac6$var$preloadPropsMap.has(key) || (href = $c2968667ab46cac6$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $c2968667ab46cac6$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($c2968667ab46cac6$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($c2968667ab46cac6$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $c2968667ab46cac6$var$setInitialProperties(as, "link", href), $c2968667ab46cac6$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $c2968667ab46cac6$var$preloadModule(href, options) {
    $c2968667ab46cac6$var$previousDispatcher.m(href, options);
    var ownerDocument = $c2968667ab46cac6$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $c2968667ab46cac6$var$getScriptKey(href);
        }
        if (!$c2968667ab46cac6$var$preloadPropsMap.has(key) && (href = $c2968667ab46cac6$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $c2968667ab46cac6$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($c2968667ab46cac6$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $c2968667ab46cac6$var$setInitialProperties(as, "link", href);
            $c2968667ab46cac6$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $c2968667ab46cac6$var$preinitStyle(href, precedence, options) {
    $c2968667ab46cac6$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $c2968667ab46cac6$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $c2968667ab46cac6$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $c2968667ab46cac6$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($c2968667ab46cac6$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $c2968667ab46cac6$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $c2968667ab46cac6$var$preloadPropsMap.get(key)) && $c2968667ab46cac6$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $c2968667ab46cac6$var$markNodeAsHoistable(link);
                $c2968667ab46cac6$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $c2968667ab46cac6$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $c2968667ab46cac6$var$preinitScript(src, options) {
    $c2968667ab46cac6$var$previousDispatcher.X(src, options);
    var ownerDocument = $c2968667ab46cac6$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $c2968667ab46cac6$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $c2968667ab46cac6$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($c2968667ab46cac6$var$getScriptSelectorFromKey(key)), resource || (src = $c2968667ab46cac6$var$assign({
            src: src,
            async: !0
        }, options), (options = $c2968667ab46cac6$var$preloadPropsMap.get(key)) && $c2968667ab46cac6$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $c2968667ab46cac6$var$markNodeAsHoistable(resource), $c2968667ab46cac6$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $c2968667ab46cac6$var$preinitModuleScript(src, options) {
    $c2968667ab46cac6$var$previousDispatcher.M(src, options);
    var ownerDocument = $c2968667ab46cac6$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $c2968667ab46cac6$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $c2968667ab46cac6$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($c2968667ab46cac6$var$getScriptSelectorFromKey(key)), resource || (src = $c2968667ab46cac6$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $c2968667ab46cac6$var$preloadPropsMap.get(key)) && $c2968667ab46cac6$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $c2968667ab46cac6$var$markNodeAsHoistable(resource), $c2968667ab46cac6$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $c2968667ab46cac6$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $c2968667ab46cac6$var$rootInstanceStackCursor.current) ? $c2968667ab46cac6$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $c2968667ab46cac6$var$getStyleKey(pendingProps.href), pendingProps = $c2968667ab46cac6$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $c2968667ab46cac6$var$getStyleKey(pendingProps.href);
                var styles$243 = $c2968667ab46cac6$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($c2968667ab46cac6$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $c2968667ab46cac6$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $c2968667ab46cac6$var$preloadPropsMap.set(type, pendingProps), styles$243 || $c2968667ab46cac6$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = $c2968667ab46cac6$var$getScriptKey(pendingProps), pendingProps = $c2968667ab46cac6$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($c2968667ab46cac6$var$formatProdErrorMessage(444, type));
    }
}
function $c2968667ab46cac6$var$getStyleKey(href) {
    return 'href="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $c2968667ab46cac6$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $c2968667ab46cac6$var$stylesheetPropsFromRawProps(rawProps) {
    return $c2968667ab46cac6$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $c2968667ab46cac6$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $c2968667ab46cac6$var$setInitialProperties(key, "link", preloadProps), $c2968667ab46cac6$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $c2968667ab46cac6$var$getScriptKey(src) {
    return '[src="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $c2968667ab46cac6$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $c2968667ab46cac6$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $c2968667ab46cac6$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $c2968667ab46cac6$var$markNodeAsHoistable(instance), instance;
            var styleProps = $c2968667ab46cac6$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $c2968667ab46cac6$var$markNodeAsHoistable(instance);
            $c2968667ab46cac6$var$setInitialProperties(instance, "style", styleProps);
            $c2968667ab46cac6$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $c2968667ab46cac6$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($c2968667ab46cac6$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $c2968667ab46cac6$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $c2968667ab46cac6$var$stylesheetPropsFromRawProps(props);
            (styleProps = $c2968667ab46cac6$var$preloadPropsMap.get(styleProps)) && $c2968667ab46cac6$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $c2968667ab46cac6$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $c2968667ab46cac6$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $c2968667ab46cac6$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $c2968667ab46cac6$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($c2968667ab46cac6$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $c2968667ab46cac6$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $c2968667ab46cac6$var$preloadPropsMap.get(instance$249)) instance = $c2968667ab46cac6$var$assign({}, props), $c2968667ab46cac6$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $c2968667ab46cac6$var$markNodeAsHoistable(styleProps);
            $c2968667ab46cac6$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($c2968667ab46cac6$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $c2968667ab46cac6$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $c2968667ab46cac6$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $c2968667ab46cac6$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $c2968667ab46cac6$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $c2968667ab46cac6$var$tagCaches = null;
function $c2968667ab46cac6$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $c2968667ab46cac6$var$tagCaches) {
        var cache = new Map();
        var caches = $c2968667ab46cac6$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $c2968667ab46cac6$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$c2968667ab46cac6$var$internalHoistableMarker] || node[$c2968667ab46cac6$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $c2968667ab46cac6$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $c2968667ab46cac6$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $c2968667ab46cac6$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $c2968667ab46cac6$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $c2968667ab46cac6$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($c2968667ab46cac6$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $c2968667ab46cac6$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $c2968667ab46cac6$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $c2968667ab46cac6$var$stylesheetPropsFromRawProps(props);
            (key = $c2968667ab46cac6$var$preloadPropsMap.get(key)) && $c2968667ab46cac6$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $c2968667ab46cac6$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $c2968667ab46cac6$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $c2968667ab46cac6$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $c2968667ab46cac6$var$estimatedBytesWithinLimit = 0;
function $c2968667ab46cac6$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $c2968667ab46cac6$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $c2968667ab46cac6$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $c2968667ab46cac6$var$estimatedBytesWithinLimit && ($c2968667ab46cac6$var$estimatedBytesWithinLimit = 62500 * $c2968667ab46cac6$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $c2968667ab46cac6$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $c2968667ab46cac6$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $c2968667ab46cac6$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $c2968667ab46cac6$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $c2968667ab46cac6$var$precedencesByRoot = null;
function $c2968667ab46cac6$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $c2968667ab46cac6$var$precedencesByRoot = new Map(), resources.forEach($c2968667ab46cac6$var$insertStylesheetIntoRoot, state), $c2968667ab46cac6$var$precedencesByRoot = null, $c2968667ab46cac6$var$onUnsuspend.call(state));
}
function $c2968667ab46cac6$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $c2968667ab46cac6$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $c2968667ab46cac6$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $c2968667ab46cac6$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $c2968667ab46cac6$var$HostTransitionContext = {
    $$typeof: $c2968667ab46cac6$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $c2968667ab46cac6$var$sharedNotPendingObject,
    _currentValue2: $c2968667ab46cac6$var$sharedNotPendingObject,
    _threadCount: 0
};
function $c2968667ab46cac6$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $c2968667ab46cac6$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c2968667ab46cac6$var$createLaneMap(0);
    this.hiddenUpdates = $c2968667ab46cac6$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $c2968667ab46cac6$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $c2968667ab46cac6$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $c2968667ab46cac6$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $c2968667ab46cac6$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $c2968667ab46cac6$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $c2968667ab46cac6$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $c2968667ab46cac6$var$emptyContextObject;
    parentComponent = $c2968667ab46cac6$var$emptyContextObject;
    return parentComponent;
}
function $c2968667ab46cac6$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $c2968667ab46cac6$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $c2968667ab46cac6$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $c2968667ab46cac6$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($c2968667ab46cac6$var$scheduleUpdateOnFiber(element, rootFiber, lane), $c2968667ab46cac6$var$entangleTransitions(element, rootFiber, lane));
}
function $c2968667ab46cac6$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $c2968667ab46cac6$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $c2968667ab46cac6$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $c2968667ab46cac6$var$markRetryLaneImpl(fiber, retryLane);
}
function $c2968667ab46cac6$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $c2968667ab46cac6$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $c2968667ab46cac6$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $c2968667ab46cac6$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $c2968667ab46cac6$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $c2968667ab46cac6$var$requestUpdateLane();
        lane = $c2968667ab46cac6$var$getBumpedLaneForHydrationByLane(lane);
        var root = $c2968667ab46cac6$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $c2968667ab46cac6$var$scheduleUpdateOnFiber(root, fiber, lane);
        $c2968667ab46cac6$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $c2968667ab46cac6$var$_enabled = !0;
function $c2968667ab46cac6$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $c2968667ab46cac6$var$ReactSharedInternals.T;
    $c2968667ab46cac6$var$ReactSharedInternals.T = null;
    var previousPriority = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
    try {
        $c2968667ab46cac6$var$ReactDOMSharedInternals.p = 2, $c2968667ab46cac6$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $c2968667ab46cac6$var$ReactDOMSharedInternals.p = previousPriority, $c2968667ab46cac6$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c2968667ab46cac6$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $c2968667ab46cac6$var$ReactSharedInternals.T;
    $c2968667ab46cac6$var$ReactSharedInternals.T = null;
    var previousPriority = $c2968667ab46cac6$var$ReactDOMSharedInternals.p;
    try {
        $c2968667ab46cac6$var$ReactDOMSharedInternals.p = 8, $c2968667ab46cac6$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $c2968667ab46cac6$var$ReactDOMSharedInternals.p = previousPriority, $c2968667ab46cac6$var$ReactSharedInternals.T = prevTransition;
    }
}
function $c2968667ab46cac6$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($c2968667ab46cac6$var$_enabled) {
        var blockedOn = $c2968667ab46cac6$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $c2968667ab46cac6$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $c2968667ab46cac6$var$return_targetInst, targetContainer), $c2968667ab46cac6$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($c2968667ab46cac6$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($c2968667ab46cac6$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $c2968667ab46cac6$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $c2968667ab46cac6$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $c2968667ab46cac6$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $c2968667ab46cac6$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $c2968667ab46cac6$var$ensureRootIsScheduled(fiber);
                                0 === ($c2968667ab46cac6$var$executionContext & 6) && ($c2968667ab46cac6$var$workInProgressRootRenderTargetTime = $c2968667ab46cac6$var$now() + 500, $c2968667ab46cac6$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $c2968667ab46cac6$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $c2968667ab46cac6$var$scheduleUpdateOnFiber(root, fiber, 2), $c2968667ab46cac6$var$flushSyncWork$1(), $c2968667ab46cac6$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $c2968667ab46cac6$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $c2968667ab46cac6$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $c2968667ab46cac6$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $c2968667ab46cac6$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $c2968667ab46cac6$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $c2968667ab46cac6$var$getEventTarget(nativeEvent);
    return $c2968667ab46cac6$var$findInstanceBlockingTarget(nativeEvent);
}
var $c2968667ab46cac6$var$return_targetInst = null;
function $c2968667ab46cac6$var$findInstanceBlockingTarget(targetNode) {
    $c2968667ab46cac6$var$return_targetInst = null;
    targetNode = $c2968667ab46cac6$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $c2968667ab46cac6$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $c2968667ab46cac6$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $c2968667ab46cac6$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $c2968667ab46cac6$var$return_targetInst = targetNode;
    return null;
}
function $c2968667ab46cac6$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($c2968667ab46cac6$var$getCurrentPriorityLevel()){
                case $c2968667ab46cac6$var$ImmediatePriority:
                    return 2;
                case $c2968667ab46cac6$var$UserBlockingPriority:
                    return 8;
                case $c2968667ab46cac6$var$NormalPriority$1:
                case $c2968667ab46cac6$var$LowPriority:
                    return 32;
                case $c2968667ab46cac6$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $c2968667ab46cac6$var$hasScheduledReplayAttempt = !1, $c2968667ab46cac6$var$queuedFocus = null, $c2968667ab46cac6$var$queuedDrag = null, $c2968667ab46cac6$var$queuedMouse = null, $c2968667ab46cac6$var$queuedPointers = new Map(), $c2968667ab46cac6$var$queuedPointerCaptures = new Map(), $c2968667ab46cac6$var$queuedExplicitHydrationTargets = [], $c2968667ab46cac6$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $c2968667ab46cac6$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $c2968667ab46cac6$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $c2968667ab46cac6$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $c2968667ab46cac6$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $c2968667ab46cac6$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c2968667ab46cac6$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $c2968667ab46cac6$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $c2968667ab46cac6$var$getInstanceFromNode(blockedOn), null !== blockedOn && $c2968667ab46cac6$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $c2968667ab46cac6$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $c2968667ab46cac6$var$queuedFocus = $c2968667ab46cac6$var$accumulateOrCreateContinuousQueuedReplayableEvent($c2968667ab46cac6$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $c2968667ab46cac6$var$queuedDrag = $c2968667ab46cac6$var$accumulateOrCreateContinuousQueuedReplayableEvent($c2968667ab46cac6$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $c2968667ab46cac6$var$queuedMouse = $c2968667ab46cac6$var$accumulateOrCreateContinuousQueuedReplayableEvent($c2968667ab46cac6$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $c2968667ab46cac6$var$queuedPointers.set(pointerId, $c2968667ab46cac6$var$accumulateOrCreateContinuousQueuedReplayableEvent($c2968667ab46cac6$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $c2968667ab46cac6$var$queuedPointerCaptures.set(pointerId, $c2968667ab46cac6$var$accumulateOrCreateContinuousQueuedReplayableEvent($c2968667ab46cac6$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $c2968667ab46cac6$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $c2968667ab46cac6$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $c2968667ab46cac6$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $c2968667ab46cac6$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $c2968667ab46cac6$var$runWithPriority(queuedTarget.priority, function() {
                        $c2968667ab46cac6$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $c2968667ab46cac6$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $c2968667ab46cac6$var$runWithPriority(queuedTarget.priority, function() {
                        $c2968667ab46cac6$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $c2968667ab46cac6$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $c2968667ab46cac6$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $c2968667ab46cac6$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $c2968667ab46cac6$var$currentReplayingEvent = null;
        } else return targetContainers = $c2968667ab46cac6$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $c2968667ab46cac6$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $c2968667ab46cac6$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $c2968667ab46cac6$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $c2968667ab46cac6$var$replayUnblockedEvents() {
    $c2968667ab46cac6$var$hasScheduledReplayAttempt = !1;
    null !== $c2968667ab46cac6$var$queuedFocus && $c2968667ab46cac6$var$attemptReplayContinuousQueuedEvent($c2968667ab46cac6$var$queuedFocus) && ($c2968667ab46cac6$var$queuedFocus = null);
    null !== $c2968667ab46cac6$var$queuedDrag && $c2968667ab46cac6$var$attemptReplayContinuousQueuedEvent($c2968667ab46cac6$var$queuedDrag) && ($c2968667ab46cac6$var$queuedDrag = null);
    null !== $c2968667ab46cac6$var$queuedMouse && $c2968667ab46cac6$var$attemptReplayContinuousQueuedEvent($c2968667ab46cac6$var$queuedMouse) && ($c2968667ab46cac6$var$queuedMouse = null);
    $c2968667ab46cac6$var$queuedPointers.forEach($c2968667ab46cac6$var$attemptReplayContinuousQueuedEventInMap);
    $c2968667ab46cac6$var$queuedPointerCaptures.forEach($c2968667ab46cac6$var$attemptReplayContinuousQueuedEventInMap);
}
function $c2968667ab46cac6$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $c2968667ab46cac6$var$hasScheduledReplayAttempt || ($c2968667ab46cac6$var$hasScheduledReplayAttempt = !0, $f04nL.unstable_scheduleCallback($f04nL.unstable_NormalPriority, $c2968667ab46cac6$var$replayUnblockedEvents)));
}
var $c2968667ab46cac6$var$lastScheduledReplayQueue = null;
function $c2968667ab46cac6$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $c2968667ab46cac6$var$lastScheduledReplayQueue !== formReplayingQueue && ($c2968667ab46cac6$var$lastScheduledReplayQueue = formReplayingQueue, $f04nL.unstable_scheduleCallback($f04nL.unstable_NormalPriority, function() {
        $c2968667ab46cac6$var$lastScheduledReplayQueue === formReplayingQueue && ($c2968667ab46cac6$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $c2968667ab46cac6$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $c2968667ab46cac6$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $c2968667ab46cac6$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $c2968667ab46cac6$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $c2968667ab46cac6$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $c2968667ab46cac6$var$queuedFocus && $c2968667ab46cac6$var$scheduleCallbackIfUnblocked($c2968667ab46cac6$var$queuedFocus, unblocked);
    null !== $c2968667ab46cac6$var$queuedDrag && $c2968667ab46cac6$var$scheduleCallbackIfUnblocked($c2968667ab46cac6$var$queuedDrag, unblocked);
    null !== $c2968667ab46cac6$var$queuedMouse && $c2968667ab46cac6$var$scheduleCallbackIfUnblocked($c2968667ab46cac6$var$queuedMouse, unblocked);
    $c2968667ab46cac6$var$queuedPointers.forEach(unblock);
    $c2968667ab46cac6$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $c2968667ab46cac6$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $c2968667ab46cac6$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $c2968667ab46cac6$var$queuedExplicitHydrationTargets.length && (i = $c2968667ab46cac6$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$c2968667ab46cac6$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $c2968667ab46cac6$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$c2968667ab46cac6$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $c2968667ab46cac6$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$c2968667ab46cac6$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $c2968667ab46cac6$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $c2968667ab46cac6$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $c2968667ab46cac6$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $c2968667ab46cac6$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$c2968667ab46cac6$var$ReactDOMHydrationRoot.prototype.render = $c2968667ab46cac6$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(409));
    var current = root.current, lane = $c2968667ab46cac6$var$requestUpdateLane();
    $c2968667ab46cac6$var$updateContainerImpl(current, lane, children, root, null, null);
};
$c2968667ab46cac6$var$ReactDOMHydrationRoot.prototype.unmount = $c2968667ab46cac6$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $c2968667ab46cac6$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $c2968667ab46cac6$var$flushSyncWork$1();
        container[$c2968667ab46cac6$var$internalContainerInstanceKey] = null;
    }
};
function $c2968667ab46cac6$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$c2968667ab46cac6$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $c2968667ab46cac6$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $c2968667ab46cac6$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $c2968667ab46cac6$var$queuedExplicitHydrationTargets[i].priority; i++);
        $c2968667ab46cac6$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $c2968667ab46cac6$var$attemptExplicitHydrationTarget(target);
    }
};
var $c2968667ab46cac6$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $8XEkF.version;
if ("19.2.8" !== $c2968667ab46cac6$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(527, $c2968667ab46cac6$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.8"));
$c2968667ab46cac6$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($c2968667ab46cac6$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $c2968667ab46cac6$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $c2968667ab46cac6$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $c2968667ab46cac6$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $c2968667ab46cac6$var$ReactSharedInternals,
    reconcilerVersion: "19.2.8"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $c2968667ab46cac6$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$c2968667ab46cac6$var$hook$jscomp$inline_2348.isDisabled && $c2968667ab46cac6$var$hook$jscomp$inline_2348.supportsFiber) try {
        $c2968667ab46cac6$var$rendererID = $c2968667ab46cac6$var$hook$jscomp$inline_2348.inject($c2968667ab46cac6$var$internals$jscomp$inline_2347), $c2968667ab46cac6$var$injectedHook = $c2968667ab46cac6$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$c2968667ab46cac6$export$882461b6382ed46c = function(container, options) {
    if (!$c2968667ab46cac6$var$isValidContainer(container)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $c2968667ab46cac6$var$defaultOnUncaughtError, onCaughtError = $c2968667ab46cac6$var$defaultOnCaughtError, onRecoverableError = $c2968667ab46cac6$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $c2968667ab46cac6$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $c2968667ab46cac6$var$defaultOnDefaultTransitionIndicator);
    container[$c2968667ab46cac6$var$internalContainerInstanceKey] = options.current;
    $c2968667ab46cac6$var$listenToAllSupportedEvents(container);
    return new $c2968667ab46cac6$var$ReactDOMRoot(options);
};
$c2968667ab46cac6$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$c2968667ab46cac6$var$isValidContainer(container)) throw Error($c2968667ab46cac6$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $c2968667ab46cac6$var$defaultOnUncaughtError, onCaughtError = $c2968667ab46cac6$var$defaultOnCaughtError, onRecoverableError = $c2968667ab46cac6$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $c2968667ab46cac6$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $c2968667ab46cac6$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $c2968667ab46cac6$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $c2968667ab46cac6$var$requestUpdateLane();
    isStrictMode = $c2968667ab46cac6$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $c2968667ab46cac6$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $c2968667ab46cac6$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $c2968667ab46cac6$var$markRootUpdated$1(initialChildren, options);
    $c2968667ab46cac6$var$ensureRootIsScheduled(initialChildren);
    container[$c2968667ab46cac6$var$internalContainerInstanceKey] = initialChildren.current;
    $c2968667ab46cac6$var$listenToAllSupportedEvents(container);
    return new $c2968667ab46cac6$var$ReactDOMHydrationRoot(initialChildren);
};
$c2968667ab46cac6$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("f04nL", function(module, exports) {
'use strict';

module.exports = (parcelRequire("5fUmC"));

});
parcelRegister("5fUmC", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $3d3a13239daf5f92$export$c4744153514ff05d; }, function (v) { return $3d3a13239daf5f92$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $3d3a13239daf5f92$export$3e506c1ccc9cc1a7; }, function (v) { return $3d3a13239daf5f92$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $3d3a13239daf5f92$export$e26fe2ed2fa76875; }, function (v) { return $3d3a13239daf5f92$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $3d3a13239daf5f92$export$502329bbf4b505b1; }, function (v) { return $3d3a13239daf5f92$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $3d3a13239daf5f92$export$6e3807111c4874c4; }, function (v) { return $3d3a13239daf5f92$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $3d3a13239daf5f92$export$c27134553091fb3a; }, function (v) { return $3d3a13239daf5f92$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $3d3a13239daf5f92$export$33ee1acdc04fd2a2; }, function (v) { return $3d3a13239daf5f92$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $3d3a13239daf5f92$export$b00a404bbd5edef2; }, function (v) { return $3d3a13239daf5f92$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $3d3a13239daf5f92$export$d66a1c1c77bd778b; }, function (v) { return $3d3a13239daf5f92$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $3d3a13239daf5f92$export$d3dfb8e4810cb555; }, function (v) { return $3d3a13239daf5f92$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $3d3a13239daf5f92$export$72fdf0e06517287b; }, function (v) { return $3d3a13239daf5f92$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $3d3a13239daf5f92$export$816d2913ae6b83b1; }, function (v) { return $3d3a13239daf5f92$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $3d3a13239daf5f92$export$61bcfe829111a1d0; }, function (v) { return $3d3a13239daf5f92$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $3d3a13239daf5f92$export$7ee8c9beb337bc3f; }, function (v) { return $3d3a13239daf5f92$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $3d3a13239daf5f92$export$b5836b71941fa3ed; }, function (v) { return $3d3a13239daf5f92$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $3d3a13239daf5f92$export$cf845f2c119da08a; }, function (v) { return $3d3a13239daf5f92$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3d3a13239daf5f92$export$c4744153514ff05d;
var $3d3a13239daf5f92$export$3e506c1ccc9cc1a7;
var $3d3a13239daf5f92$export$e26fe2ed2fa76875;
var $3d3a13239daf5f92$export$502329bbf4b505b1;
var $3d3a13239daf5f92$export$6e3807111c4874c4;
var $3d3a13239daf5f92$export$c27134553091fb3a;
var $3d3a13239daf5f92$export$33ee1acdc04fd2a2;
var $3d3a13239daf5f92$export$b00a404bbd5edef2;
var $3d3a13239daf5f92$export$d66a1c1c77bd778b;
var $3d3a13239daf5f92$export$d3dfb8e4810cb555;
var $3d3a13239daf5f92$export$72fdf0e06517287b;
var $3d3a13239daf5f92$export$816d2913ae6b83b1;
var $3d3a13239daf5f92$export$61bcfe829111a1d0;
var $3d3a13239daf5f92$export$7ee8c9beb337bc3f;
var $3d3a13239daf5f92$export$b5836b71941fa3ed;
var $3d3a13239daf5f92$export$cf845f2c119da08a;
"use strict";
function $3d3a13239daf5f92$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $3d3a13239daf5f92$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $3d3a13239daf5f92$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $3d3a13239daf5f92$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $3d3a13239daf5f92$var$compare(left, last)) rightIndex < length && 0 > $3d3a13239daf5f92$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $3d3a13239daf5f92$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $3d3a13239daf5f92$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$3d3a13239daf5f92$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $3d3a13239daf5f92$var$localPerformance = performance;
    $3d3a13239daf5f92$export$c4744153514ff05d = function() {
        return $3d3a13239daf5f92$var$localPerformance.now();
    };
} else {
    var $3d3a13239daf5f92$var$localDate = Date, $3d3a13239daf5f92$var$initialTime = $3d3a13239daf5f92$var$localDate.now();
    $3d3a13239daf5f92$export$c4744153514ff05d = function() {
        return $3d3a13239daf5f92$var$localDate.now() - $3d3a13239daf5f92$var$initialTime;
    };
}
var $3d3a13239daf5f92$var$taskQueue = [], $3d3a13239daf5f92$var$timerQueue = [], $3d3a13239daf5f92$var$taskIdCounter = 1, $3d3a13239daf5f92$var$currentTask = null, $3d3a13239daf5f92$var$currentPriorityLevel = 3, $3d3a13239daf5f92$var$isPerformingWork = !1, $3d3a13239daf5f92$var$isHostCallbackScheduled = !1, $3d3a13239daf5f92$var$isHostTimeoutScheduled = !1, $3d3a13239daf5f92$var$needsPaint = !1, $3d3a13239daf5f92$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $3d3a13239daf5f92$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $3d3a13239daf5f92$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $3d3a13239daf5f92$var$advanceTimers(currentTime) {
    for(var timer = $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$timerQueue); null !== timer;){
        if (null === timer.callback) $3d3a13239daf5f92$var$pop($3d3a13239daf5f92$var$timerQueue);
        else if (timer.startTime <= currentTime) $3d3a13239daf5f92$var$pop($3d3a13239daf5f92$var$timerQueue), timer.sortIndex = timer.expirationTime, $3d3a13239daf5f92$var$push($3d3a13239daf5f92$var$taskQueue, timer);
        else break;
        timer = $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$timerQueue);
    }
}
function $3d3a13239daf5f92$var$handleTimeout(currentTime) {
    $3d3a13239daf5f92$var$isHostTimeoutScheduled = !1;
    $3d3a13239daf5f92$var$advanceTimers(currentTime);
    if (!$3d3a13239daf5f92$var$isHostCallbackScheduled) {
        if (null !== $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$taskQueue)) $3d3a13239daf5f92$var$isHostCallbackScheduled = !0, $3d3a13239daf5f92$var$isMessageLoopRunning || ($3d3a13239daf5f92$var$isMessageLoopRunning = !0, $3d3a13239daf5f92$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$timerQueue);
            null !== firstTimer && $3d3a13239daf5f92$var$requestHostTimeout($3d3a13239daf5f92$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $3d3a13239daf5f92$var$isMessageLoopRunning = !1, $3d3a13239daf5f92$var$taskTimeoutID = -1, $3d3a13239daf5f92$var$frameInterval = 5, $3d3a13239daf5f92$var$startTime = -1;
function $3d3a13239daf5f92$var$shouldYieldToHost() {
    return $3d3a13239daf5f92$var$needsPaint ? !0 : $3d3a13239daf5f92$export$c4744153514ff05d() - $3d3a13239daf5f92$var$startTime < $3d3a13239daf5f92$var$frameInterval ? !1 : !0;
}
function $3d3a13239daf5f92$var$performWorkUntilDeadline() {
    $3d3a13239daf5f92$var$needsPaint = !1;
    if ($3d3a13239daf5f92$var$isMessageLoopRunning) {
        var currentTime = $3d3a13239daf5f92$export$c4744153514ff05d();
        $3d3a13239daf5f92$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $3d3a13239daf5f92$var$isHostCallbackScheduled = !1;
                $3d3a13239daf5f92$var$isHostTimeoutScheduled && ($3d3a13239daf5f92$var$isHostTimeoutScheduled = !1, $3d3a13239daf5f92$var$localClearTimeout($3d3a13239daf5f92$var$taskTimeoutID), $3d3a13239daf5f92$var$taskTimeoutID = -1);
                $3d3a13239daf5f92$var$isPerformingWork = !0;
                var previousPriorityLevel = $3d3a13239daf5f92$var$currentPriorityLevel;
                try {
                    b: {
                        $3d3a13239daf5f92$var$advanceTimers(currentTime);
                        for($3d3a13239daf5f92$var$currentTask = $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$taskQueue); null !== $3d3a13239daf5f92$var$currentTask && !($3d3a13239daf5f92$var$currentTask.expirationTime > currentTime && $3d3a13239daf5f92$var$shouldYieldToHost());){
                            var callback = $3d3a13239daf5f92$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $3d3a13239daf5f92$var$currentTask.callback = null;
                                $3d3a13239daf5f92$var$currentPriorityLevel = $3d3a13239daf5f92$var$currentTask.priorityLevel;
                                var continuationCallback = callback($3d3a13239daf5f92$var$currentTask.expirationTime <= currentTime);
                                currentTime = $3d3a13239daf5f92$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $3d3a13239daf5f92$var$currentTask.callback = continuationCallback;
                                    $3d3a13239daf5f92$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $3d3a13239daf5f92$var$currentTask === $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$taskQueue) && $3d3a13239daf5f92$var$pop($3d3a13239daf5f92$var$taskQueue);
                                $3d3a13239daf5f92$var$advanceTimers(currentTime);
                            } else $3d3a13239daf5f92$var$pop($3d3a13239daf5f92$var$taskQueue);
                            $3d3a13239daf5f92$var$currentTask = $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$taskQueue);
                        }
                        if (null !== $3d3a13239daf5f92$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$timerQueue);
                            null !== firstTimer && $3d3a13239daf5f92$var$requestHostTimeout($3d3a13239daf5f92$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $3d3a13239daf5f92$var$currentTask = null, $3d3a13239daf5f92$var$currentPriorityLevel = previousPriorityLevel, $3d3a13239daf5f92$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $3d3a13239daf5f92$var$schedulePerformWorkUntilDeadline() : $3d3a13239daf5f92$var$isMessageLoopRunning = !1;
        }
    }
}
var $3d3a13239daf5f92$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $3d3a13239daf5f92$var$localSetImmediate) $3d3a13239daf5f92$var$schedulePerformWorkUntilDeadline = function() {
    $3d3a13239daf5f92$var$localSetImmediate($3d3a13239daf5f92$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $3d3a13239daf5f92$var$channel = new MessageChannel(), $3d3a13239daf5f92$var$port = $3d3a13239daf5f92$var$channel.port2;
    $3d3a13239daf5f92$var$channel.port1.onmessage = $3d3a13239daf5f92$var$performWorkUntilDeadline;
    $3d3a13239daf5f92$var$schedulePerformWorkUntilDeadline = function() {
        $3d3a13239daf5f92$var$port.postMessage(null);
    };
} else $3d3a13239daf5f92$var$schedulePerformWorkUntilDeadline = function() {
    $3d3a13239daf5f92$var$localSetTimeout($3d3a13239daf5f92$var$performWorkUntilDeadline, 0);
};
function $3d3a13239daf5f92$var$requestHostTimeout(callback, ms) {
    $3d3a13239daf5f92$var$taskTimeoutID = $3d3a13239daf5f92$var$localSetTimeout(function() {
        callback($3d3a13239daf5f92$export$c4744153514ff05d());
    }, ms);
}
$3d3a13239daf5f92$export$3e506c1ccc9cc1a7 = 5;
$3d3a13239daf5f92$export$e26fe2ed2fa76875 = 1;
$3d3a13239daf5f92$export$502329bbf4b505b1 = 4;
$3d3a13239daf5f92$export$6e3807111c4874c4 = 3;
$3d3a13239daf5f92$export$c27134553091fb3a = null;
$3d3a13239daf5f92$export$33ee1acdc04fd2a2 = 2;
$3d3a13239daf5f92$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$3d3a13239daf5f92$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $3d3a13239daf5f92$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$3d3a13239daf5f92$export$d3dfb8e4810cb555 = function() {
    return $3d3a13239daf5f92$var$currentPriorityLevel;
};
$3d3a13239daf5f92$export$72fdf0e06517287b = function(eventHandler) {
    switch($3d3a13239daf5f92$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $3d3a13239daf5f92$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $3d3a13239daf5f92$var$currentPriorityLevel;
    $3d3a13239daf5f92$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $3d3a13239daf5f92$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$3d3a13239daf5f92$export$816d2913ae6b83b1 = function() {
    $3d3a13239daf5f92$var$needsPaint = !0;
};
$3d3a13239daf5f92$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $3d3a13239daf5f92$var$currentPriorityLevel;
    $3d3a13239daf5f92$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $3d3a13239daf5f92$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$3d3a13239daf5f92$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $3d3a13239daf5f92$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $3d3a13239daf5f92$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $3d3a13239daf5f92$var$push($3d3a13239daf5f92$var$timerQueue, priorityLevel), null === $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$taskQueue) && priorityLevel === $3d3a13239daf5f92$var$peek($3d3a13239daf5f92$var$timerQueue) && ($3d3a13239daf5f92$var$isHostTimeoutScheduled ? ($3d3a13239daf5f92$var$localClearTimeout($3d3a13239daf5f92$var$taskTimeoutID), $3d3a13239daf5f92$var$taskTimeoutID = -1) : $3d3a13239daf5f92$var$isHostTimeoutScheduled = !0, $3d3a13239daf5f92$var$requestHostTimeout($3d3a13239daf5f92$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $3d3a13239daf5f92$var$push($3d3a13239daf5f92$var$taskQueue, priorityLevel), $3d3a13239daf5f92$var$isHostCallbackScheduled || $3d3a13239daf5f92$var$isPerformingWork || ($3d3a13239daf5f92$var$isHostCallbackScheduled = !0, $3d3a13239daf5f92$var$isMessageLoopRunning || ($3d3a13239daf5f92$var$isMessageLoopRunning = !0, $3d3a13239daf5f92$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$3d3a13239daf5f92$export$b5836b71941fa3ed = $3d3a13239daf5f92$var$shouldYieldToHost;
$3d3a13239daf5f92$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $3d3a13239daf5f92$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $3d3a13239daf5f92$var$currentPriorityLevel;
        $3d3a13239daf5f92$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $3d3a13239daf5f92$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("8XEkF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("flJa4"));

});
parcelRegister("flJa4", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $b2cbd94ccd281a1e$export$9c16c1426311996d; }, function (v) { return $b2cbd94ccd281a1e$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $b2cbd94ccd281a1e$export$dca3b0875bd9a954; }, function (v) { return $b2cbd94ccd281a1e$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b2cbd94ccd281a1e$export$16fa2f45be04daa8; }, function (v) { return $b2cbd94ccd281a1e$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b2cbd94ccd281a1e$export$ffb0004e005737fa; }, function (v) { return $b2cbd94ccd281a1e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b2cbd94ccd281a1e$export$e2c29f18771995cb; }, function (v) { return $b2cbd94ccd281a1e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b2cbd94ccd281a1e$export$221d75b3f55bb0bd; }, function (v) { return $b2cbd94ccd281a1e$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b2cbd94ccd281a1e$export$5f8d39834fd61797; }, function (v) { return $b2cbd94ccd281a1e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b2cbd94ccd281a1e$export$74bf444e3cd11ea5; }, function (v) { return $b2cbd94ccd281a1e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $b2cbd94ccd281a1e$export$1ced07cd6b1985ce; }, function (v) { return $b2cbd94ccd281a1e$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $b2cbd94ccd281a1e$export$abd8e32b826d7ea7; }, function (v) { return $b2cbd94ccd281a1e$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $b2cbd94ccd281a1e$export$69a3209f1a06c04d; }, function (v) { return $b2cbd94ccd281a1e$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $b2cbd94ccd281a1e$export$8c538325882c7eec; }, function (v) { return $b2cbd94ccd281a1e$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b2cbd94ccd281a1e$export$e530037191fcd5d7; }, function (v) { return $b2cbd94ccd281a1e$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b2cbd94ccd281a1e$export$fd42f52fd3ae1109; }, function (v) { return $b2cbd94ccd281a1e$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b2cbd94ccd281a1e$export$c8a8987d4410bf2d; }, function (v) { return $b2cbd94ccd281a1e$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $b2cbd94ccd281a1e$export$7d1e3a5e95ceca43; }, function (v) { return $b2cbd94ccd281a1e$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b2cbd94ccd281a1e$export$257a8862b851cb5b; }, function (v) { return $b2cbd94ccd281a1e$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b2cbd94ccd281a1e$export$a8257692ac88316c; }, function (v) { return $b2cbd94ccd281a1e$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b2cbd94ccd281a1e$export$488013bae63b21da; }, function (v) { return $b2cbd94ccd281a1e$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b2cbd94ccd281a1e$export$7c73462e0d25e514; }, function (v) { return $b2cbd94ccd281a1e$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b2cbd94ccd281a1e$export$7568632d0d33d16d; }, function (v) { return $b2cbd94ccd281a1e$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $b2cbd94ccd281a1e$export$f93f40ac0ca7e3a8; }, function (v) { return $b2cbd94ccd281a1e$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $b2cbd94ccd281a1e$export$1f96ae73734a86cc; }, function (v) { return $b2cbd94ccd281a1e$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $b2cbd94ccd281a1e$export$9a47ced3238df325; }, function (v) { return $b2cbd94ccd281a1e$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b2cbd94ccd281a1e$export$35808ee640e87ca7; }, function (v) { return $b2cbd94ccd281a1e$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b2cbd94ccd281a1e$export$fae74005e78b1a27; }, function (v) { return $b2cbd94ccd281a1e$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b2cbd94ccd281a1e$export$dc8fbce3eb94dc1e; }, function (v) { return $b2cbd94ccd281a1e$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b2cbd94ccd281a1e$export$6a7bc4e911dc01cf; }, function (v) { return $b2cbd94ccd281a1e$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b2cbd94ccd281a1e$export$6d9c69b0de29b591; }, function (v) { return $b2cbd94ccd281a1e$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $b2cbd94ccd281a1e$export$7f54fc3180508a52; }, function (v) { return $b2cbd94ccd281a1e$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $b2cbd94ccd281a1e$export$f680877a34711e37; }, function (v) { return $b2cbd94ccd281a1e$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b2cbd94ccd281a1e$export$d5a552a76deda3c2; }, function (v) { return $b2cbd94ccd281a1e$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b2cbd94ccd281a1e$export$aaabe4eda9ed9969; }, function (v) { return $b2cbd94ccd281a1e$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b2cbd94ccd281a1e$export$e5c5a5f917a5871c; }, function (v) { return $b2cbd94ccd281a1e$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b2cbd94ccd281a1e$export$1538c33de8887b59; }, function (v) { return $b2cbd94ccd281a1e$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $b2cbd94ccd281a1e$export$fca7f784ae7a249a; }, function (v) { return $b2cbd94ccd281a1e$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $b2cbd94ccd281a1e$export$13e3392192263954; }, function (v) { return $b2cbd94ccd281a1e$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b2cbd94ccd281a1e$export$b8f5890fc79d6aca; }, function (v) { return $b2cbd94ccd281a1e$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b2cbd94ccd281a1e$export$60241385465d0a34; }, function (v) { return $b2cbd94ccd281a1e$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b2cbd94ccd281a1e$export$306c0aa65ff9ec16; }, function (v) { return $b2cbd94ccd281a1e$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b2cbd94ccd281a1e$export$7b286972b8d8ccbf; }, function (v) { return $b2cbd94ccd281a1e$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b2cbd94ccd281a1e$export$83d89fbfd8236492; }, function (v) { return $b2cbd94ccd281a1e$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b2cbd94ccd281a1e$export$9c16c1426311996d;
var $b2cbd94ccd281a1e$export$dca3b0875bd9a954;
var $b2cbd94ccd281a1e$export$16fa2f45be04daa8;
var $b2cbd94ccd281a1e$export$ffb0004e005737fa;
var $b2cbd94ccd281a1e$export$e2c29f18771995cb;
var $b2cbd94ccd281a1e$export$221d75b3f55bb0bd;
var $b2cbd94ccd281a1e$export$5f8d39834fd61797;
var $b2cbd94ccd281a1e$export$74bf444e3cd11ea5;
var $b2cbd94ccd281a1e$export$1ced07cd6b1985ce;
var $b2cbd94ccd281a1e$export$abd8e32b826d7ea7;
var $b2cbd94ccd281a1e$export$69a3209f1a06c04d;
var $b2cbd94ccd281a1e$export$8c538325882c7eec;
var $b2cbd94ccd281a1e$export$e530037191fcd5d7;
var $b2cbd94ccd281a1e$export$fd42f52fd3ae1109;
var $b2cbd94ccd281a1e$export$c8a8987d4410bf2d;
var $b2cbd94ccd281a1e$export$7d1e3a5e95ceca43;
var $b2cbd94ccd281a1e$export$257a8862b851cb5b;
var $b2cbd94ccd281a1e$export$a8257692ac88316c;
var $b2cbd94ccd281a1e$export$488013bae63b21da;
var $b2cbd94ccd281a1e$export$7c73462e0d25e514;
var $b2cbd94ccd281a1e$export$7568632d0d33d16d;
var $b2cbd94ccd281a1e$export$f93f40ac0ca7e3a8;
var $b2cbd94ccd281a1e$export$1f96ae73734a86cc;
var $b2cbd94ccd281a1e$export$9a47ced3238df325;
var $b2cbd94ccd281a1e$export$35808ee640e87ca7;
var $b2cbd94ccd281a1e$export$fae74005e78b1a27;
var $b2cbd94ccd281a1e$export$dc8fbce3eb94dc1e;
var $b2cbd94ccd281a1e$export$6a7bc4e911dc01cf;
var $b2cbd94ccd281a1e$export$6d9c69b0de29b591;
var $b2cbd94ccd281a1e$export$7f54fc3180508a52;
var $b2cbd94ccd281a1e$export$f680877a34711e37;
var $b2cbd94ccd281a1e$export$d5a552a76deda3c2;
var $b2cbd94ccd281a1e$export$aaabe4eda9ed9969;
var $b2cbd94ccd281a1e$export$e5c5a5f917a5871c;
var $b2cbd94ccd281a1e$export$1538c33de8887b59;
var $b2cbd94ccd281a1e$export$fca7f784ae7a249a;
var $b2cbd94ccd281a1e$export$13e3392192263954;
var $b2cbd94ccd281a1e$export$b8f5890fc79d6aca;
var $b2cbd94ccd281a1e$export$60241385465d0a34;
var $b2cbd94ccd281a1e$export$306c0aa65ff9ec16;
var $b2cbd94ccd281a1e$export$7b286972b8d8ccbf;
var $b2cbd94ccd281a1e$export$83d89fbfd8236492;
"use strict";
var $b2cbd94ccd281a1e$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $b2cbd94ccd281a1e$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $b2cbd94ccd281a1e$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $b2cbd94ccd281a1e$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $b2cbd94ccd281a1e$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $b2cbd94ccd281a1e$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $b2cbd94ccd281a1e$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $b2cbd94ccd281a1e$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $b2cbd94ccd281a1e$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $b2cbd94ccd281a1e$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $b2cbd94ccd281a1e$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $b2cbd94ccd281a1e$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $b2cbd94ccd281a1e$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $b2cbd94ccd281a1e$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $b2cbd94ccd281a1e$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$b2cbd94ccd281a1e$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $b2cbd94ccd281a1e$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b2cbd94ccd281a1e$var$assign = Object.assign, $b2cbd94ccd281a1e$var$emptyObject = {};
function $b2cbd94ccd281a1e$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $b2cbd94ccd281a1e$var$emptyObject;
    this.updater = updater || $b2cbd94ccd281a1e$var$ReactNoopUpdateQueue;
}
$b2cbd94ccd281a1e$var$Component.prototype.isReactComponent = {};
$b2cbd94ccd281a1e$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$b2cbd94ccd281a1e$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $b2cbd94ccd281a1e$var$ComponentDummy() {}
$b2cbd94ccd281a1e$var$ComponentDummy.prototype = $b2cbd94ccd281a1e$var$Component.prototype;
function $b2cbd94ccd281a1e$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $b2cbd94ccd281a1e$var$emptyObject;
    this.updater = updater || $b2cbd94ccd281a1e$var$ReactNoopUpdateQueue;
}
var $b2cbd94ccd281a1e$var$pureComponentPrototype = $b2cbd94ccd281a1e$var$PureComponent.prototype = new $b2cbd94ccd281a1e$var$ComponentDummy();
$b2cbd94ccd281a1e$var$pureComponentPrototype.constructor = $b2cbd94ccd281a1e$var$PureComponent;
$b2cbd94ccd281a1e$var$assign($b2cbd94ccd281a1e$var$pureComponentPrototype, $b2cbd94ccd281a1e$var$Component.prototype);
$b2cbd94ccd281a1e$var$pureComponentPrototype.isPureReactComponent = !0;
var $b2cbd94ccd281a1e$var$isArrayImpl = Array.isArray;
function $b2cbd94ccd281a1e$var$noop() {}
var $b2cbd94ccd281a1e$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $b2cbd94ccd281a1e$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $b2cbd94ccd281a1e$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $b2cbd94ccd281a1e$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $b2cbd94ccd281a1e$var$cloneAndReplaceKey(oldElement, newKey) {
    return $b2cbd94ccd281a1e$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $b2cbd94ccd281a1e$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $b2cbd94ccd281a1e$var$REACT_ELEMENT_TYPE;
}
function $b2cbd94ccd281a1e$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $b2cbd94ccd281a1e$var$userProvidedKeyEscapeRegex = /\/+/g;
function $b2cbd94ccd281a1e$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $b2cbd94ccd281a1e$var$escape("" + element.key) : index.toString(36);
}
function $b2cbd94ccd281a1e$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($b2cbd94ccd281a1e$var$noop, $b2cbd94ccd281a1e$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $b2cbd94ccd281a1e$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $b2cbd94ccd281a1e$var$REACT_ELEMENT_TYPE:
                case $b2cbd94ccd281a1e$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $b2cbd94ccd281a1e$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $b2cbd94ccd281a1e$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $b2cbd94ccd281a1e$var$getElementKey(children, 0) : nameSoFar, $b2cbd94ccd281a1e$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($b2cbd94ccd281a1e$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $b2cbd94ccd281a1e$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($b2cbd94ccd281a1e$var$isValidElement(callback) && (callback = $b2cbd94ccd281a1e$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($b2cbd94ccd281a1e$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($b2cbd94ccd281a1e$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $b2cbd94ccd281a1e$var$getElementKey(nameSoFar, i), invokeCallback += $b2cbd94ccd281a1e$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $b2cbd94ccd281a1e$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $b2cbd94ccd281a1e$var$getElementKey(nameSoFar, i++), invokeCallback += $b2cbd94ccd281a1e$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $b2cbd94ccd281a1e$var$mapIntoArray($b2cbd94ccd281a1e$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $b2cbd94ccd281a1e$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $b2cbd94ccd281a1e$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $b2cbd94ccd281a1e$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $b2cbd94ccd281a1e$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $b2cbd94ccd281a1e$var$Children = {
    map: $b2cbd94ccd281a1e$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $b2cbd94ccd281a1e$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $b2cbd94ccd281a1e$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $b2cbd94ccd281a1e$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$b2cbd94ccd281a1e$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$b2cbd94ccd281a1e$export$9c16c1426311996d = $b2cbd94ccd281a1e$var$REACT_ACTIVITY_TYPE;
$b2cbd94ccd281a1e$export$dca3b0875bd9a954 = $b2cbd94ccd281a1e$var$Children;
$b2cbd94ccd281a1e$export$16fa2f45be04daa8 = $b2cbd94ccd281a1e$var$Component;
$b2cbd94ccd281a1e$export$ffb0004e005737fa = $b2cbd94ccd281a1e$var$REACT_FRAGMENT_TYPE;
$b2cbd94ccd281a1e$export$e2c29f18771995cb = $b2cbd94ccd281a1e$var$REACT_PROFILER_TYPE;
$b2cbd94ccd281a1e$export$221d75b3f55bb0bd = $b2cbd94ccd281a1e$var$PureComponent;
$b2cbd94ccd281a1e$export$5f8d39834fd61797 = $b2cbd94ccd281a1e$var$REACT_STRICT_MODE_TYPE;
$b2cbd94ccd281a1e$export$74bf444e3cd11ea5 = $b2cbd94ccd281a1e$var$REACT_SUSPENSE_TYPE;
$b2cbd94ccd281a1e$export$1ced07cd6b1985ce = $b2cbd94ccd281a1e$var$ReactSharedInternals;
$b2cbd94ccd281a1e$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$b2cbd94ccd281a1e$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$b2cbd94ccd281a1e$export$8c538325882c7eec = function() {
    return null;
};
$b2cbd94ccd281a1e$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $b2cbd94ccd281a1e$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$b2cbd94ccd281a1e$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $b2cbd94ccd281a1e$var$ReactElement(element.type, key, props);
};
$b2cbd94ccd281a1e$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $b2cbd94ccd281a1e$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $b2cbd94ccd281a1e$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$b2cbd94ccd281a1e$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$b2cbd94ccd281a1e$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $b2cbd94ccd281a1e$var$ReactElement(type, key, props);
};
$b2cbd94ccd281a1e$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b2cbd94ccd281a1e$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $b2cbd94ccd281a1e$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$b2cbd94ccd281a1e$export$a8257692ac88316c = $b2cbd94ccd281a1e$var$isValidElement;
$b2cbd94ccd281a1e$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $b2cbd94ccd281a1e$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $b2cbd94ccd281a1e$var$lazyInitializer
    };
};
$b2cbd94ccd281a1e$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $b2cbd94ccd281a1e$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$b2cbd94ccd281a1e$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $b2cbd94ccd281a1e$var$ReactSharedInternals.T, currentTransition = {};
    $b2cbd94ccd281a1e$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $b2cbd94ccd281a1e$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($b2cbd94ccd281a1e$var$noop, $b2cbd94ccd281a1e$var$reportGlobalError);
    } catch (error) {
        $b2cbd94ccd281a1e$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $b2cbd94ccd281a1e$var$ReactSharedInternals.T = prevTransition;
    }
};
$b2cbd94ccd281a1e$export$f93f40ac0ca7e3a8 = function() {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useCacheRefresh();
};
$b2cbd94ccd281a1e$export$1f96ae73734a86cc = function(usable) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.use(usable);
};
$b2cbd94ccd281a1e$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$b2cbd94ccd281a1e$export$35808ee640e87ca7 = function(callback, deps) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$b2cbd94ccd281a1e$export$fae74005e78b1a27 = function(Context) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useContext(Context);
};
$b2cbd94ccd281a1e$export$dc8fbce3eb94dc1e = function() {};
$b2cbd94ccd281a1e$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$b2cbd94ccd281a1e$export$6d9c69b0de29b591 = function(create, deps) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useEffect(create, deps);
};
$b2cbd94ccd281a1e$export$7f54fc3180508a52 = function(callback) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$b2cbd94ccd281a1e$export$f680877a34711e37 = function() {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useId();
};
$b2cbd94ccd281a1e$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$b2cbd94ccd281a1e$export$aaabe4eda9ed9969 = function(create, deps) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$b2cbd94ccd281a1e$export$e5c5a5f917a5871c = function(create, deps) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$b2cbd94ccd281a1e$export$1538c33de8887b59 = function(create, deps) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useMemo(create, deps);
};
$b2cbd94ccd281a1e$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$b2cbd94ccd281a1e$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$b2cbd94ccd281a1e$export$b8f5890fc79d6aca = function(initialValue) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useRef(initialValue);
};
$b2cbd94ccd281a1e$export$60241385465d0a34 = function(initialState) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useState(initialState);
};
$b2cbd94ccd281a1e$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$b2cbd94ccd281a1e$export$7b286972b8d8ccbf = function() {
    return $b2cbd94ccd281a1e$var$ReactSharedInternals.H.useTransition();
};
$b2cbd94ccd281a1e$export$83d89fbfd8236492 = "19.2.8";

});


parcelRegister("fdu5P", function(module, exports) {
'use strict';
function $b13f69bcf1ce8446$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b13f69bcf1ce8446$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b13f69bcf1ce8446$var$checkDCE();

module.exports = (parcelRequire("gShnY"));

});
parcelRegister("gShnY", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $c48f2ceb33338744$export$69ce8ef3fe5cead0; }, function (v) { return $c48f2ceb33338744$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $c48f2ceb33338744$export$d39a5bbd09211389; }, function (v) { return $c48f2ceb33338744$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $c48f2ceb33338744$export$cd75ccfd720a3cd4; }, function (v) { return $c48f2ceb33338744$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $c48f2ceb33338744$export$a0816fa17a9e79be; }, function (v) { return $c48f2ceb33338744$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $c48f2ceb33338744$export$7292efcadded39f3; }, function (v) { return $c48f2ceb33338744$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $c48f2ceb33338744$export$da407abadb9b8f86; }, function (v) { return $c48f2ceb33338744$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $c48f2ceb33338744$export$314cfea32580671c; }, function (v) { return $c48f2ceb33338744$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $c48f2ceb33338744$export$513ccb98c53b8039; }, function (v) { return $c48f2ceb33338744$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $c48f2ceb33338744$export$dbca993bc2d264a; }, function (v) { return $c48f2ceb33338744$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $c48f2ceb33338744$export$4797a8006f0655d0; }, function (v) { return $c48f2ceb33338744$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $c48f2ceb33338744$export$c78a37762a8d58e1; }, function (v) { return $c48f2ceb33338744$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $c48f2ceb33338744$export$606f11b2eb45ecc6; }, function (v) { return $c48f2ceb33338744$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $c48f2ceb33338744$export$f7e8a0bf92324b1e; }, function (v) { return $c48f2ceb33338744$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $c48f2ceb33338744$export$83d89fbfd8236492; }, function (v) { return $c48f2ceb33338744$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c48f2ceb33338744$export$69ce8ef3fe5cead0;
var $c48f2ceb33338744$export$d39a5bbd09211389;
var $c48f2ceb33338744$export$cd75ccfd720a3cd4;
var $c48f2ceb33338744$export$a0816fa17a9e79be;
var $c48f2ceb33338744$export$7292efcadded39f3;
var $c48f2ceb33338744$export$da407abadb9b8f86;
var $c48f2ceb33338744$export$314cfea32580671c;
var $c48f2ceb33338744$export$513ccb98c53b8039;
var $c48f2ceb33338744$export$dbca993bc2d264a;
var $c48f2ceb33338744$export$4797a8006f0655d0;
var $c48f2ceb33338744$export$c78a37762a8d58e1;
var $c48f2ceb33338744$export$606f11b2eb45ecc6;
var $c48f2ceb33338744$export$f7e8a0bf92324b1e;
var $c48f2ceb33338744$export$83d89fbfd8236492;
"use strict";

var $8XEkF = parcelRequire("8XEkF");
function $c48f2ceb33338744$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $c48f2ceb33338744$var$noop() {}
var $c48f2ceb33338744$var$Internals = {
    d: {
        f: $c48f2ceb33338744$var$noop,
        r: function() {
            throw Error($c48f2ceb33338744$var$formatProdErrorMessage(522));
        },
        D: $c48f2ceb33338744$var$noop,
        C: $c48f2ceb33338744$var$noop,
        L: $c48f2ceb33338744$var$noop,
        m: $c48f2ceb33338744$var$noop,
        X: $c48f2ceb33338744$var$noop,
        S: $c48f2ceb33338744$var$noop,
        M: $c48f2ceb33338744$var$noop
    },
    p: 0,
    findDOMNode: null
}, $c48f2ceb33338744$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $c48f2ceb33338744$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c48f2ceb33338744$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $c48f2ceb33338744$var$ReactSharedInternals = $8XEkF.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $c48f2ceb33338744$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$c48f2ceb33338744$export$69ce8ef3fe5cead0 = $c48f2ceb33338744$var$Internals;
$c48f2ceb33338744$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($c48f2ceb33338744$var$formatProdErrorMessage(299));
    return $c48f2ceb33338744$var$createPortal$1(children, container, null, key);
};
$c48f2ceb33338744$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $c48f2ceb33338744$var$ReactSharedInternals.T, previousUpdatePriority = $c48f2ceb33338744$var$Internals.p;
    try {
        if ($c48f2ceb33338744$var$ReactSharedInternals.T = null, $c48f2ceb33338744$var$Internals.p = 2, fn) return fn();
    } finally{
        $c48f2ceb33338744$var$ReactSharedInternals.T = previousTransition, $c48f2ceb33338744$var$Internals.p = previousUpdatePriority, $c48f2ceb33338744$var$Internals.d.f();
    }
};
$c48f2ceb33338744$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $c48f2ceb33338744$var$Internals.d.C(href, options));
};
$c48f2ceb33338744$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $c48f2ceb33338744$var$Internals.d.D(href);
};
$c48f2ceb33338744$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $c48f2ceb33338744$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $c48f2ceb33338744$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $c48f2ceb33338744$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$c48f2ceb33338744$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $c48f2ceb33338744$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $c48f2ceb33338744$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $c48f2ceb33338744$var$Internals.d.M(href);
    }
};
$c48f2ceb33338744$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $c48f2ceb33338744$var$getCrossOriginStringAs(as, options.crossOrigin);
        $c48f2ceb33338744$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$c48f2ceb33338744$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $c48f2ceb33338744$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $c48f2ceb33338744$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $c48f2ceb33338744$var$Internals.d.m(href);
    }
};
$c48f2ceb33338744$export$4797a8006f0655d0 = function(form) {
    $c48f2ceb33338744$var$Internals.d.r(form);
};
$c48f2ceb33338744$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$c48f2ceb33338744$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $c48f2ceb33338744$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$c48f2ceb33338744$export$f7e8a0bf92324b1e = function() {
    return $c48f2ceb33338744$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$c48f2ceb33338744$export$83d89fbfd8236492 = "19.2.8";

});



parcelRegister("e8uqK", function(module, exports) {

$parcel$export(module.exports, "initAuth", function () { return $a4a96ae49d73347e$export$6d3c879d7a79980d; });
$parcel$export(module.exports, "openLogin", function () { return $a4a96ae49d73347e$export$7db5d06ba62cef30; });
$parcel$export(module.exports, "storageScope", function () { return $a4a96ae49d73347e$export$96468de0ab257186; });
$parcel$export(module.exports, "userLabel", function () { return $a4a96ae49d73347e$export$7048ecca6c089cb; });
$parcel$export(module.exports, "canSignOut", function () { return $a4a96ae49d73347e$export$dbb833a5d000428b; });
$parcel$export(module.exports, "doSignOut", function () { return $a4a96ae49d73347e$export$3ebfd0406116c6c7; });
$parcel$export(module.exports, "authHeader", function () { return $a4a96ae49d73347e$export$a3b7721557df7601; });
// ─────────────────────────────────────────────────────────────────────────
// Client-side auth: one place that answers "who is using the editor?".
//
// Netlify Identity is the only account system. Two states:
//   identity  Identity is enabled → open self-registration, password resets
//             and as many users as needed, all handled by the widget. API
//             calls carry the user's JWT; local storage is scoped by the
//             stable Identity user id.
//   open      Identity is not enabled. Storage is unscoped and the cloud API
//             refuses every call, so decks stay device-local. The edge
//             function (netlify/edge-functions/editor-auth.js) normally stops
//             a deploy from reaching this state at all.
//
// The EDITOR_USERS / EDITOR_PASSWORD cookie gate that used to sit alongside
// Identity is gone — see that edge function for what replaced it.
//
// initAuth() must resolve before any studio module is imported (model.js
// reads storageScope() at module-init time); studio-entry.jsx guarantees
// this by importing the app dynamically.
// ─────────────────────────────────────────────────────────────────────────

var $1tvw4 = parcelRequire("1tvw4");
let $a4a96ae49d73347e$var$mode = "open"; // "identity" | "open"
let $a4a96ae49d73347e$var$identityUser = null; // netlify-identity-widget user object
// ── Email-link flows ─────────────────────────────────────────────────────
// A page opened from an Identity email carries its token in the URL hash:
// #invite_token=… when someone accepts an invitation, #recovery_token=… when
// they reset a password. The widget reads that hash exactly once, at init,
// keeps the token only in memory, and then erases the hash — so from the
// moment the page loads, a reload throws the token away for good. The
// invitee lands back on the sign-in gate instead of the password form, and
// submitting later posts no token at all, which GoTrue answers with
// "User not found".
//
// The reload that does this is ours, and it is not a deliberate sign-out.
// The widget fires "logout" on any change of its user from set to unset —
// including the background check in its own store.init(), which loads a
// session from localStorage and clears it when the server will not validate
// it. A browser holding a stale session is exactly the state someone is in
// when they accept an invitation on a machine that was signed in before.
//
// So: read the hash before init() erases it, and hold the reload off until
// the flow has finished one way or the other.
const $a4a96ae49d73347e$var$EMAIL_TOKEN = /(confirmation|invite|recovery|email_change)_token=/;
let $a4a96ae49d73347e$var$emailFlow = false;
// Detect Identity by probing GoTrue's public settings endpoint — it only
// exists (as JSON) when Identity is enabled for the site.
async function $a4a96ae49d73347e$var$identityEnabled() {
    try {
        const r = await fetch("/.netlify/identity/settings", {
            headers: {
                accept: "application/json"
            }
        });
        return r.ok && (r.headers.get("content-type") || "").includes("json");
    } catch  {
        return false;
    }
}
async function $a4a96ae49d73347e$export$6d3c879d7a79980d() {
    if (await $a4a96ae49d73347e$var$identityEnabled()) {
        $a4a96ae49d73347e$var$mode = "identity";
        $a4a96ae49d73347e$var$emailFlow = $a4a96ae49d73347e$var$EMAIL_TOKEN.test(window.location.hash || "");
        // init() must stay AHEAD of the handlers below, and this is load-bearing
        // rather than tidy: it calls the widget's store.init() synchronously,
        // which reads any stored session and so fires "login" before we are
        // listening. Registering first would reload every page load for an
        // already-signed-in user, and that loop has no exit.
        (0, (/*@__PURE__*/$parcel$interopDefault($1tvw4))).init();
        // Reloading after login/logout re-derives the storage scope and cloud
        // session from scratch — much simpler than hot-swapping libraries.
        (0, (/*@__PURE__*/$parcel$interopDefault($1tvw4))).on("login", ()=>{
            (0, (/*@__PURE__*/$parcel$interopDefault($1tvw4))).close();
            window.location.reload();
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($1tvw4))).on("logout", ()=>{
            if (!$a4a96ae49d73347e$var$emailFlow) window.location.reload();
        });
        // Closing the widget ends the email flow: whatever the token was for is
        // either done — in which case "login" has already reloaded us — or
        // abandoned, and a later sign-out should reload as it always did.
        (0, (/*@__PURE__*/$parcel$interopDefault($1tvw4))).on("close", ()=>{
            $a4a96ae49d73347e$var$emailFlow = false;
        });
        // The widget renders its errors inside its own iframe, where nothing
        // else can see them and no reload survives them. A failed invitation is
        // the one worth a trace in the console: GoTrue answers 404 "User not
        // found" when the token matches no account, which means the link was
        // superseded by a later invitation, has been used once already, or the
        // account it was issued for is gone.
        // The widget clears its error at the start of every action, so this
        // fires with nothing to report as often as it fires with something.
        (0, (/*@__PURE__*/$parcel$interopDefault($1tvw4))).on("error", (err)=>{
            if (err) console.error("Netlify Identity:", err);
        });
        $a4a96ae49d73347e$var$identityUser = (0, (/*@__PURE__*/$parcel$interopDefault($1tvw4))).currentUser();
        return {
            mode: $a4a96ae49d73347e$var$mode,
            user: $a4a96ae49d73347e$var$identityUser
        };
    }
    $a4a96ae49d73347e$var$mode = "open";
    return {
        mode: $a4a96ae49d73347e$var$mode,
        user: null
    };
}
function $a4a96ae49d73347e$export$7db5d06ba62cef30() {
    (0, (/*@__PURE__*/$parcel$interopDefault($1tvw4))).open();
}
function $a4a96ae49d73347e$export$96468de0ab257186() {
    return $a4a96ae49d73347e$var$mode === "identity" && $a4a96ae49d73347e$var$identityUser ? "id-" + $a4a96ae49d73347e$var$identityUser.id : "";
}
function $a4a96ae49d73347e$export$7048ecca6c089cb() {
    if ($a4a96ae49d73347e$var$mode === "identity" && $a4a96ae49d73347e$var$identityUser) return $a4a96ae49d73347e$var$identityUser.user_metadata?.full_name || $a4a96ae49d73347e$var$identityUser.email || "signed in";
    return "";
}
function $a4a96ae49d73347e$export$dbb833a5d000428b() {
    return $a4a96ae49d73347e$var$mode === "identity" && !!$a4a96ae49d73347e$var$identityUser;
}
function $a4a96ae49d73347e$export$3ebfd0406116c6c7() {
    if ($a4a96ae49d73347e$var$mode !== "identity") return;
    $a4a96ae49d73347e$var$emailFlow = false; // asked for by hand, so it always reloads
    (0, (/*@__PURE__*/$parcel$interopDefault($1tvw4))).logout();
}
async function $a4a96ae49d73347e$export$a3b7721557df7601() {
    const u = $a4a96ae49d73347e$var$mode === "identity" ? (0, (/*@__PURE__*/$parcel$interopDefault($1tvw4))).currentUser() : null;
    if (!u) return {};
    for(let attempt = 0; attempt < 2; attempt++)try {
        return {
            Authorization: "Bearer " + await u.jwt()
        };
    } catch  {
        if (attempt === 0) await new Promise((r)=>setTimeout(r, 500));
    }
    return {};
}

});
parcelRegister("1tvw4", function(module, exports) {

var $5Ue0n = parcelRequire("5Ue0n");
var $1130f25edc25b2ab$require$Buffer = $5Ue0n.Buffer;
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    "use strict";
    var e, t, n, i, r, o, a, s, l, u, _, c, d = {}, g = [], p = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i, M = Array.isArray;
    function m(e, t) {
        for(var n in t)e[n] = t[n];
        return e;
    }
    function f(e) {
        e && e.parentNode && e.parentNode.removeChild(e);
    }
    function h(e, i, r, o, a) {
        var s = {
            type: e,
            props: i,
            key: r,
            ref: o,
            __k: null,
            __: null,
            __b: 0,
            __e: null,
            __c: null,
            constructor: void 0,
            __v: null == a ? ++n : a,
            __i: -1,
            __u: 0
        };
        return null == a && null != t.vnode && t.vnode(s), s;
    }
    function v(e) {
        return e.children;
    }
    function y(e, t) {
        this.props = e, this.context = t;
    }
    function N(e, t) {
        if (null == t) return e.__ ? N(e.__, e.__i + 1) : null;
        for(var n; t < e.__k.length; t++)if (null != (n = e.__k[t]) && null != n.__e) return n.__e;
        return "function" == typeof e.type ? N(e) : null;
    }
    function w(e) {
        if (e.__P && e.__d) {
            var n = e.__v, i = n.__e, r = [], o = [], a = m({}, n);
            a.__v = n.__v + 1, t.vnode && t.vnode(a), O(e.__P, a, n, e.__n, e.__P.namespaceURI, 32 & n.__u ? [
                i
            ] : null, r, null == i ? N(n) : i, !!(32 & n.__u), o), a.__v = n.__v, a.__.__k[a.__i] = a, S(r, a, o), n.__e = n.__ = null, a.__e != i && b(a);
        }
    }
    function b(e) {
        if (null != (e = e.__) && null != e.__c) return e.__e = e.__c.base = null, e.__k.some(function(t) {
            if (null != t && null != t.__e) return e.__e = e.__c.base = t.__e;
        }), b(e);
    }
    function j(e) {
        (!e.__d && (e.__d = !0) && i.push(e) && !D.__r++ || r != t.debounceRendering) && ((r = t.debounceRendering) || o)(D);
    }
    function D() {
        for(var e, t = 1; i.length;)i.length > t && i.sort(a), e = i.shift(), t = i.length, w(e);
        D.__r = 0;
    }
    function z(e, t, n, i, r, o, a, s, l, u, _) {
        var c, p, m, f, y, w, b, j = i && i.__k || g, D = t.length;
        for(l = function(e, t, n, i, r) {
            var o, a, s, l, u, _ = n.length, c = _, d = 0;
            for(e.__k = new Array(r), o = 0; o < r; o++)null != (a = t[o]) && "boolean" != typeof a && "function" != typeof a ? ("string" == typeof a || "number" == typeof a || "bigint" == typeof a || a.constructor == String ? a = e.__k[o] = h(null, a, null, null, null) : M(a) ? a = e.__k[o] = h(v, {
                children: a
            }, null, null, null) : void 0 === a.constructor && a.__b > 0 ? a = e.__k[o] = h(a.type, a.props, a.key, a.ref ? a.ref : null, a.__v) : e.__k[o] = a, l = o + d, a.__ = e, a.__b = e.__b + 1, s = null, -1 != (u = a.__i = k(a, n, l, c)) && (c--, (s = n[u]) && (s.__u |= 2)), null == s || null == s.__v ? (-1 == u && (r > _ ? d-- : r < _ && d++), "function" != typeof a.type && (a.__u |= 4)) : u != l && (u == l - 1 ? d-- : u == l + 1 ? d++ : (u > l ? d-- : d++, a.__u |= 4))) : e.__k[o] = null;
            if (c) for(o = 0; o < _; o++)null != (s = n[o]) && !(2 & s.__u) && (s.__e == i && (i = N(s)), C(s, s));
            return i;
        }(n, t, j, l, D), c = 0; c < D; c++)null != (m = n.__k[c]) && (p = -1 != m.__i && j[m.__i] || d, m.__i = c, w = O(e, m, p, r, o, a, s, l, u, _), f = m.__e, m.ref && p.ref != m.ref && (p.ref && U(p.ref, null, m), _.push(m.ref, m.__c || f, m)), null == y && null != f && (y = f), (b = !!(4 & m.__u)) || p.__k === m.__k ? l = T(m, l, e, b) : "function" == typeof m.type && void 0 !== w ? l = w : f && (l = f.nextSibling), m.__u &= -7);
        return n.__e = y, l;
    }
    function T(e, t, n, i) {
        var r, o;
        if ("function" == typeof e.type) {
            for(r = e.__k, o = 0; r && o < r.length; o++)r[o] && (r[o].__ = e, t = T(r[o], t, n, i));
            return t;
        }
        e.__e != t && (i && (t && e.type && !t.parentNode && (t = N(e)), n.insertBefore(e.__e, t || null)), t = e.__e);
        do t = t && t.nextSibling;
        while (null != t && 8 == t.nodeType);
        return t;
    }
    function k(e, t, n, i) {
        var r, o, a, s = e.key, l = e.type, u = t[n], _ = null != u && !(2 & u.__u);
        if (null === u && null == s || _ && s == u.key && l == u.type) return n;
        if (i > (_ ? 1 : 0)) {
            for(r = n - 1, o = n + 1; r >= 0 || o < t.length;)if (null != (u = t[a = r >= 0 ? r-- : o++]) && !(2 & u.__u) && s == u.key && l == u.type) return a;
        }
        return -1;
    }
    function x(e, t, n) {
        "-" == t[0] ? e.setProperty(t, null == n ? "" : n) : e[t] = null == n ? "" : "number" != typeof n || p.test(t) ? n : n + "px";
    }
    function I(e, t, n, i, r) {
        var o, a;
        e: if ("style" == t) {
            if ("string" == typeof n) e.style.cssText = n;
            else {
                if ("string" == typeof i && (e.style.cssText = i = ""), i) for(t in i)n && t in n || x(e.style, t, "");
                if (n) for(t in n)i && n[t] == i[t] || x(e.style, t, n[t]);
            }
        } else if ("o" == t[0] && "n" == t[1]) o = t != (t = t.replace(s, "$1")), a = t.toLowerCase(), t = a in e || "onFocusOut" == t || "onFocusIn" == t ? a.slice(2) : t.slice(2), e.l || (e.l = {}), e.l[t + o] = n, n ? i ? n.u = i.u : (n.u = l, e.addEventListener(t, o ? _ : u, o)) : e.removeEventListener(t, o ? _ : u, o);
        else {
            if ("http://www.w3.org/2000/svg" == r) t = t.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
            else if ("width" != t && "height" != t && "href" != t && "list" != t && "form" != t && "tabIndex" != t && "download" != t && "rowSpan" != t && "colSpan" != t && "role" != t && "popover" != t && t in e) try {
                e[t] = null == n ? "" : n;
                break e;
            } catch (c) {}
            "function" == typeof n || (null == n || !1 === n && "-" != t[4] ? e.removeAttribute(t) : e.setAttribute(t, "popover" == t && 1 == n ? "" : n));
        }
    }
    function L(e) {
        return function(n) {
            if (this.l) {
                var i = this.l[n.type + e];
                if (null == n.t) n.t = l++;
                else if (n.t < i.u) return;
                return i(t.event ? t.event(n) : n);
            }
        };
    }
    function O(n, i, r, o, a, s, l, u, _, c) {
        var p, h, w, b, j, D, T, k, x, L, O, S, U, C, P, Y = i.type;
        if (void 0 !== i.constructor) return null;
        128 & r.__u && (_ = !!(32 & r.__u), s = [
            u = i.__e = r.__e
        ]), (p = t.__b) && p(i);
        e: if ("function" == typeof Y) try {
            if (k = i.props, x = "prototype" in Y && Y.prototype.render, L = (p = Y.contextType) && o[p.__c], O = p ? L ? L.props.value : p.__ : o, r.__c ? T = (h = i.__c = r.__c).__ = h.__E : (x ? i.__c = h = new Y(k, O) : (i.__c = h = new y(k, O), h.constructor = Y, h.render = Q), L && L.sub(h), h.state || (h.state = {}), h.__n = o, w = h.__d = !0, h.__h = [], h._sb = []), x && null == h.__s && (h.__s = h.state), x && null != Y.getDerivedStateFromProps && (h.__s == h.state && (h.__s = m({}, h.__s)), m(h.__s, Y.getDerivedStateFromProps(k, h.__s))), b = h.props, j = h.state, h.__v = i, w) x && null == Y.getDerivedStateFromProps && null != h.componentWillMount && h.componentWillMount(), x && null != h.componentDidMount && h.__h.push(h.componentDidMount);
            else {
                if (x && null == Y.getDerivedStateFromProps && k !== b && null != h.componentWillReceiveProps && h.componentWillReceiveProps(k, O), i.__v == r.__v || !h.__e && null != h.shouldComponentUpdate && !1 === h.shouldComponentUpdate(k, h.__s, O)) {
                    i.__v != r.__v && (h.props = k, h.state = h.__s, h.__d = !1), i.__e = r.__e, i.__k = r.__k, i.__k.some(function(e) {
                        e && (e.__ = i);
                    }), g.push.apply(h.__h, h._sb), h._sb = [], h.__h.length && l.push(h);
                    break e;
                }
                null != h.componentWillUpdate && h.componentWillUpdate(k, h.__s, O), x && null != h.componentDidUpdate && h.__h.push(function() {
                    h.componentDidUpdate(b, j, D);
                });
            }
            if (h.context = O, h.props = k, h.__P = n, h.__e = !1, S = t.__r, U = 0, x) h.state = h.__s, h.__d = !1, S && S(i), p = h.render(h.props, h.state, h.context), g.push.apply(h.__h, h._sb), h._sb = [];
            else do h.__d = !1, S && S(i), p = h.render(h.props, h.state, h.context), h.state = h.__s;
            while (h.__d && ++U < 25);
            h.state = h.__s, null != h.getChildContext && (o = m(m({}, o), h.getChildContext())), x && !w && null != h.getSnapshotBeforeUpdate && (D = h.getSnapshotBeforeUpdate(b, j)), C = null != p && p.type === v && null == p.key ? A(p.props.children) : p, u = z(n, M(C) ? C : [
                C
            ], i, r, o, a, s, l, u, _, c), h.base = i.__e, i.__u &= -161, h.__h.length && l.push(h), T && (h.__E = h.__ = null);
        } catch (R) {
            if (i.__v = null, _ || null != s) {
                if (R.then) {
                    for(i.__u |= _ ? 160 : 128; u && 8 == u.nodeType && u.nextSibling;)u = u.nextSibling;
                    s[s.indexOf(u)] = null, i.__e = u;
                } else {
                    for(P = s.length; P--;)f(s[P]);
                    E(i);
                }
            } else i.__e = r.__e, i.__k = r.__k, R.then || E(i);
            t.__e(R, i, r);
        }
        else null == s && i.__v == r.__v ? (i.__k = r.__k, i.__e = r.__e) : u = i.__e = function(n, i, r, o, a, s, l, u, _) {
            var c, g, p, m, h, v, y, w = r.props || d, b = i.props, j = i.type;
            if ("svg" == j ? a = "http://www.w3.org/2000/svg" : "math" == j ? a = "http://www.w3.org/1998/Math/MathML" : a || (a = "http://www.w3.org/1999/xhtml"), null != s) {
                for(c = 0; c < s.length; c++)if ((h = s[c]) && "setAttribute" in h == !!j && (j ? h.localName == j : 3 == h.nodeType)) {
                    n = h, s[c] = null;
                    break;
                }
            }
            if (null == n) {
                if (null == j) return document.createTextNode(b);
                n = document.createElementNS(a, j, b.is && b), u && (t.__m && t.__m(i, s), u = !1), s = null;
            }
            if (null == j) w === b || u && n.data == b || (n.data = b);
            else {
                if (s = s && e.call(n.childNodes), !u && null != s) for(w = {}, c = 0; c < n.attributes.length; c++)w[(h = n.attributes[c]).name] = h.value;
                for(c in w)h = w[c], "dangerouslySetInnerHTML" == c ? p = h : "children" == c || c in b || "value" == c && "defaultValue" in b || "checked" == c && "defaultChecked" in b || I(n, c, null, h, a);
                for(c in b)h = b[c], "children" == c ? m = h : "dangerouslySetInnerHTML" == c ? g = h : "value" == c ? v = h : "checked" == c ? y = h : u && "function" != typeof h || w[c] === h || I(n, c, h, w[c], a);
                if (g) u || p && (g.__html == p.__html || g.__html == n.innerHTML) || (n.innerHTML = g.__html), i.__k = [];
                else if (p && (n.innerHTML = ""), z("template" == i.type ? n.content : n, M(m) ? m : [
                    m
                ], i, r, o, "foreignObject" == j ? "http://www.w3.org/1999/xhtml" : a, s, l, s ? s[0] : r.__k && N(r, 0), u, _), null != s) for(c = s.length; c--;)f(s[c]);
                u || (c = "value", "progress" == j && null == v ? n.removeAttribute("value") : null != v && (v !== n[c] || "progress" == j && !v || "option" == j && v != w[c]) && I(n, c, v, w[c], a), c = "checked", null != y && y != n[c] && I(n, c, y, w[c], a));
            }
            return n;
        }(r.__e, i, r, o, a, s, l, _, c);
        return (p = t.diffed) && p(i), 128 & i.__u ? void 0 : u;
    }
    function E(e) {
        e && (e.__c && (e.__c.__e = !0), e.__k && e.__k.some(E));
    }
    function S(e, n, i) {
        for(var r = 0; r < i.length; r++)U(i[r], i[++r], i[++r]);
        t.__c && t.__c(n, e), e.some(function(n) {
            try {
                e = n.__h, n.__h = [], e.some(function(e) {
                    e.call(n);
                });
            } catch (i) {
                t.__e(i, n.__v);
            }
        });
    }
    function A(e) {
        return "object" != typeof e || null == e || e.__b > 0 ? e : M(e) ? e.map(A) : m({}, e);
    }
    function U(e, n, i) {
        try {
            if ("function" == typeof e) {
                var r = "function" == typeof e.__u;
                r && e.__u(), r && null == n || (e.__u = e(n));
            } else e.current = n;
        } catch (o) {
            t.__e(o, i);
        }
    }
    function C(e, n, i) {
        var r, o;
        if (t.unmount && t.unmount(e), (r = e.ref) && (r.current && r.current != e.__e || U(r, null, n)), null != (r = e.__c)) {
            if (r.componentWillUnmount) try {
                r.componentWillUnmount();
            } catch (a) {
                t.__e(a, n);
            }
            r.base = r.__P = null;
        }
        if (r = e.__k) for(o = 0; o < r.length; o++)r[o] && C(r[o], n, i || "function" != typeof e.type);
        i || f(e.__e), e.__c = e.__ = e.__e = void 0;
    }
    function Q(e, t, n) {
        return this.constructor(e, n);
    }
    function P(n, i, r) {
        var o, a, s;
        i == document && (i = document.documentElement), t.__ && t.__(n, i), o = (0, i.__k), a = [], s = [], O(i, n = i.__k = function(t, n, i) {
            var r, o, a, s = {};
            for(a in n)"key" == a ? r = n[a] : "ref" == a ? o = n[a] : s[a] = n[a];
            if (arguments.length > 2 && (s.children = arguments.length > 3 ? e.call(arguments, 2) : i), "function" == typeof t && null != t.defaultProps) for(a in t.defaultProps)void 0 === s[a] && (s[a] = t.defaultProps[a]);
            return h(t, s, r, o, null);
        }(v, null, [
            n
        ]), o || d, d, i.namespaceURI, o ? null : i.firstChild ? e.call(i.childNodes) : null, a, o ? o.__e : i.firstChild, false, s), S(a, n, s);
    }
    e = g.slice, t = {
        __e: function(e, t, n, i) {
            for(var r, o, a; t = t.__;)if ((r = t.__c) && !r.__) try {
                if ((o = r.constructor) && null != o.getDerivedStateFromError && (r.setState(o.getDerivedStateFromError(e)), a = r.__d), null != r.componentDidCatch && (r.componentDidCatch(e, i || {}), a = r.__d), a) return r.__E = r;
            } catch (s) {
                e = s;
            }
            throw e;
        }
    }, n = 0, y.prototype.setState = function(e, t) {
        var n;
        n = null != this.__s && this.__s != this.state ? this.__s : this.__s = m({}, this.state), "function" == typeof e && (e = e(m({}, n), this.props)), e && m(n, e), null != e && this.__v && (t && this._sb.push(t), j(this));
    }, y.prototype.forceUpdate = function(e) {
        this.__v && (this.__e = !0, e && this.__h.push(e), j(this));
    }, y.prototype.render = v, i = [], o = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, a = function(e, t) {
        return e.__v.__b - t.__v.__b;
    }, D.__r = 0, s = /(PointerCapture)$|Capture$/i, l = 0, u = L(!1), _ = L(!0), c = 0;
    var Y = 0;
    function R(e, n, i, r, o, a) {
        n || (n = {});
        var s, l, u = n;
        if ("ref" in u) for(l in u = {}, n)"ref" == l ? s = n[l] : u[l] = n[l];
        var _ = {
            type: e,
            props: u,
            key: i,
            ref: s,
            __k: null,
            __: null,
            __b: 0,
            __e: null,
            __c: null,
            constructor: void 0,
            __v: --Y,
            __i: -1,
            __u: 0,
            __source: o,
            __self: a
        };
        if ("function" == typeof e && (s = e.defaultProps)) for(l in s)void 0 === u[l] && (u[l] = s[l]);
        return t.vnode && t.vnode(_), _;
    }
    function B(e) {
        for(var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), i = 1; i < t; i++)n[i - 1] = arguments[i];
        throw new Error("number" == typeof e ? "[MobX] minified error nr: " + e + (n.length ? " " + n.map(String).join(",") : "") + ". Find the full error at: https://github.com/mobxjs/mobx/blob/main/packages/mobx/src/errors.ts" : "[MobX] " + e);
    }
    var G = {};
    function V() {
        return "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof $parcel$global ? $parcel$global : "undefined" != typeof self ? self : G;
    }
    var H = Object.assign, Z = Object.getOwnPropertyDescriptor, W = Object.defineProperty, F = Object.prototype, J = [];
    Object.freeze(J);
    var q = {};
    Object.freeze(q);
    var K = "undefined" != typeof Proxy, X = Object.toString();
    function $() {
        K || B("Proxy not available");
    }
    function ee(e) {
        var t = !1;
        return function() {
            if (!t) return t = !0, e.apply(this, arguments);
        };
    }
    var te = function() {};
    function ne(e) {
        return "function" == typeof e;
    }
    function ie(e) {
        switch(typeof e){
            case "string":
            case "symbol":
            case "number":
                return !0;
        }
        return !1;
    }
    function re(e) {
        return null !== e && "object" == typeof e;
    }
    function oe(e) {
        if (!re(e)) return !1;
        var t = Object.getPrototypeOf(e);
        if (null == t) return !0;
        var n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
        return "function" == typeof n && n.toString() === X;
    }
    function ae(e) {
        var t = null == e ? void 0 : e.constructor;
        return !!t && ("GeneratorFunction" === t.name || "GeneratorFunction" === t.displayName);
    }
    function se(e, t, n) {
        W(e, t, {
            enumerable: !1,
            writable: !0,
            configurable: !0,
            value: n
        });
    }
    function le(e, t, n) {
        W(e, t, {
            enumerable: !1,
            writable: !1,
            configurable: !0,
            value: n
        });
    }
    function ue(e, t) {
        var n = "isMobX" + e;
        return t.prototype[n] = !0, function(e) {
            return re(e) && !0 === e[n];
        };
    }
    function _e(e) {
        return null != e && "[object Map]" === Object.prototype.toString.call(e);
    }
    function ce(e) {
        return null != e && "[object Set]" === Object.prototype.toString.call(e);
    }
    var de = void 0 !== Object.getOwnPropertySymbols;
    var ge = "undefined" != typeof Reflect && Reflect.ownKeys ? Reflect.ownKeys : de ? function(e) {
        return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
    } : Object.getOwnPropertyNames;
    function pe(e) {
        return null === e ? null : "object" == typeof e ? "" + e : e;
    }
    function Me(e, t) {
        return F.hasOwnProperty.call(e, t);
    }
    var me = Object.getOwnPropertyDescriptors || function(e) {
        var t = {};
        return ge(e).forEach(function(n) {
            t[n] = Z(e, n);
        }), t;
    };
    function fe(e, t) {
        return !!(e & t);
    }
    function he(e, t, n) {
        return n ? e |= t : e &= ~t, e;
    }
    function ve(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for(var n = 0, i = Array(t); n < t; n++)i[n] = e[n];
        return i;
    }
    function ye(e, t, n) {
        return t && function(e, t) {
            for(var n = 0; n < t.length; n++){
                var i = t[n];
                i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(e, De(i.key), i);
            }
        }(e.prototype, t), Object.defineProperty(e, "prototype", {
            writable: !1
        }), e;
    }
    function Ne(e, t) {
        var n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (n) return (n = n.call(e)).next.bind(n);
        if (Array.isArray(e) || (n = function(e, t) {
            if (e) {
                if ("string" == typeof e) return ve(e, t);
                var n = ({}).toString.call(e).slice(8, -1);
                return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? ve(e, t) : void 0;
            }
        }(e)) || t) {
            n && (e = n);
            var i = 0;
            return function() {
                return i >= e.length ? {
                    done: !0
                } : {
                    done: !1,
                    value: e[i++]
                };
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function we() {
        return we = Object.assign ? Object.assign.bind() : function(e) {
            for(var t = 1; t < arguments.length; t++){
                var n = arguments[t];
                for(var i in n)({}).hasOwnProperty.call(n, i) && (e[i] = n[i]);
            }
            return e;
        }, we.apply(null, arguments);
    }
    function be(e, t) {
        e.prototype = Object.create(t.prototype), e.prototype.constructor = e, je(e, t);
    }
    function je(e, t) {
        return (je = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
            return e.__proto__ = t, e;
        })(e, t);
    }
    function De(e) {
        var t = function(e, t) {
            if ("object" != typeof e || !e) return e;
            var n = e[Symbol.toPrimitive];
            if (void 0 !== n) {
                var i = n.call(e, t);
                if ("object" != typeof i) return i;
                throw new TypeError("@@toPrimitive must return a primitive value.");
            }
            return String(e);
        }(e, "string");
        return "symbol" == typeof t ? t : t + "";
    }
    var ze = Symbol("mobx-stored-annotations");
    function Te(e) {
        return Object.assign(function(t, n) {
            if (xe(n)) return e.decorate_20223_(t, n);
            ke(t, n, e);
        }, e);
    }
    function ke(e, t, n) {
        Me(e, ze) || se(e, ze, we({}, e[ze])), function(e) {
            return e.annotationType_ === Ce;
        }(n) || (e[ze][t] = n);
    }
    function xe(e) {
        return "object" == typeof e && "string" == typeof e.kind;
    }
    var Ie = Symbol("mobx administration"), Le = function() {
        function e(e) {
            void 0 === e && (e = "Atom"), this.name_ = void 0, this.flags_ = 0, this.observers_ = new Set, this.lastAccessedBy_ = 0, this.lowestObserverState_ = Et.NOT_TRACKING_, this.onBOL = void 0, this.onBUOL = void 0, this.name_ = e;
        }
        var t = e.prototype;
        return t.onBO = function() {
            this.onBOL && this.onBOL.forEach(function(e) {
                return e();
            });
        }, t.onBUO = function() {
            this.onBUOL && this.onBUOL.forEach(function(e) {
                return e();
            });
        }, t.reportObserved = function() {
            return on(this);
        }, t.reportChanged = function() {
            nn(), an(this), rn();
        }, t.toString = function() {
            return this.name_;
        }, ye(e, [
            {
                key: "isBeingObserved",
                get: function() {
                    return fe(this.flags_, e.isBeingObservedMask_);
                },
                set: function(t) {
                    this.flags_ = he(this.flags_, e.isBeingObservedMask_, t);
                }
            },
            {
                key: "isPendingUnobservation",
                get: function() {
                    return fe(this.flags_, e.isPendingUnobservationMask_);
                },
                set: function(t) {
                    this.flags_ = he(this.flags_, e.isPendingUnobservationMask_, t);
                }
            },
            {
                key: "diffValue",
                get: function() {
                    return fe(this.flags_, e.diffValueMask_) ? 1 : 0;
                },
                set: function(t) {
                    this.flags_ = he(this.flags_, e.diffValueMask_, 1 === t);
                }
            }
        ]);
    }();
    Le.isBeingObservedMask_ = 1, Le.isPendingUnobservationMask_ = 2, Le.diffValueMask_ = 4;
    var Oe = ue("Atom", Le);
    function Ee(e, t, n) {
        void 0 === t && (t = te), void 0 === n && (n = te);
        var i, r = new Le(e);
        return t !== te && xn(zn, r, t, i), n !== te && kn(r, n), r;
    }
    var Se = {
        structural: function(e, t) {
            return Yi(e, t);
        },
        default: function(e, t) {
            return Object.is ? Object.is(e, t) : e === t ? 0 !== e || 1 / e == 1 / t : e != e && t != t;
        }
    };
    function Ae(e, t, n) {
        return Qn(e) ? e : Array.isArray(e) ? vt.array(e, {
            name: n
        }) : oe(e) ? vt.object(e, void 0, {
            name: n
        }) : _e(e) ? vt.map(e, {
            name: n
        }) : ce(e) ? vt.set(e, {
            name: n
        }) : "function" != typeof e || wn(e) || Cn(e) ? e : ae(e) ? An(e) : Nn(n, e);
    }
    function Ue(e) {
        return e;
    }
    var Ce = "override";
    function Qe(e, t) {
        return {
            annotationType_: e,
            options_: t,
            make_: Pe,
            extend_: Ye,
            decorate_20223_: Re
        };
    }
    function Pe(e, t, n, i) {
        var r;
        if (null != (r = this.options_) && r.bound) return null === this.extend_(e, t, n, !1) ? 0 : 1;
        if (i === e.target_) return null === this.extend_(e, t, n, !1) ? 0 : 2;
        if (wn(n.value)) return 1;
        var o = Be(e, this, t, n, !1);
        return W(i, t, o), 2;
    }
    function Ye(e, t, n, i) {
        var r = Be(e, this, t, n);
        return e.defineProperty_(t, r, i);
    }
    function Re(e, t) {
        var n, i = t.kind, r = t.name, o = t.addInitializer, a = this, s = function(e) {
            var t, n, i, o;
            return kt(null != (t = null == (n = a.options_) ? void 0 : n.name) ? t : r.toString(), e, null != (i = null == (o = a.options_) ? void 0 : o.autoAction) && i);
        };
        return "field" == i ? function(e) {
            var t, n = e;
            return wn(n) || (n = s(n)), null != (t = a.options_) && t.bound && ((n = n.bind(this)).isMobxAction = !0), n;
        } : "method" == i ? (wn(e) || (e = s(e)), null != (n = this.options_) && n.bound && o(function() {
            var e = this, t = e[r].bind(e);
            t.isMobxAction = !0, e[r] = t;
        }), e) : void B("Cannot apply '" + a.annotationType_ + "' to '" + String(r) + "' (kind: " + i + "):\n'" + a.annotationType_ + "' can only be used on properties with a function value.");
    }
    function Be(e, t, n, i, r) {
        var o, a, s, l, u, _, c, d;
        void 0 === r && (r = Xt.safeDescriptors), d = i, t.annotationType_, d.value;
        var g, p = i.value;
        null != (o = t.options_) && o.bound && (p = p.bind(null != (g = e.proxy_) ? g : e.target_));
        return {
            value: kt(null != (a = null == (s = t.options_) ? void 0 : s.name) ? a : n.toString(), p, null != (l = null == (u = t.options_) ? void 0 : u.autoAction) && l, null != (_ = t.options_) && _.bound ? null != (c = e.proxy_) ? c : e.target_ : void 0),
            configurable: !r || e.isPlainObject_,
            enumerable: !1,
            writable: !r
        };
    }
    function Ge(e, t) {
        return {
            annotationType_: e,
            options_: t,
            make_: Ve,
            extend_: He,
            decorate_20223_: Ze
        };
    }
    function Ve(e, t, n, i) {
        var r;
        if (i === e.target_) return null === this.extend_(e, t, n, !1) ? 0 : 2;
        if (null != (r = this.options_) && r.bound && (!Me(e.target_, t) || !Cn(e.target_[t])) && null === this.extend_(e, t, n, !1)) return 0;
        if (Cn(n.value)) return 1;
        var o = We(e, this, t, n, !1, !1);
        return W(i, t, o), 2;
    }
    function He(e, t, n, i) {
        var r, o = We(e, this, t, n, null == (r = this.options_) ? void 0 : r.bound);
        return e.defineProperty_(t, o, i);
    }
    function Ze(e, t) {
        var n, i = t.name, r = t.addInitializer;
        return Cn(e) || (e = An(e)), null != (n = this.options_) && n.bound && r(function() {
            var e = this, t = e[i].bind(e);
            t.isMobXFlow = !0, e[i] = t;
        }), e;
    }
    function We(e, t, n, i, r, o) {
        var a;
        void 0 === o && (o = Xt.safeDescriptors), a = i, t.annotationType_, a.value;
        var s, l = i.value;
        (Cn(l) || (l = An(l)), r) && ((l = l.bind(null != (s = e.proxy_) ? s : e.target_)).isMobXFlow = !0);
        return {
            value: l,
            configurable: !o || e.isPlainObject_,
            enumerable: !1,
            writable: !o
        };
    }
    function Fe(e, t) {
        return {
            annotationType_: e,
            options_: t,
            make_: Je,
            extend_: qe,
            decorate_20223_: Ke
        };
    }
    function Je(e, t, n) {
        return null === this.extend_(e, t, n, !1) ? 0 : 1;
    }
    function qe(e, t, n, i) {
        var r;
        return r = n, this.annotationType_, r.get, e.defineComputedProperty_(t, we({}, this.options_, {
            get: n.get,
            set: n.set
        }), i);
    }
    function Ke(e, t) {
        var n = this, i = t.name;
        return (0, t.addInitializer)(function() {
            var t = vi(this)[Ie], r = we({}, n.options_, {
                get: e,
                context: this
            });
            r.name || (r.name = "ObservableObject." + i.toString()), t.values_.set(i, new Ot(r));
        }), function() {
            return this[Ie].getObservablePropValue_(i);
        };
    }
    function Xe(e, t) {
        return {
            annotationType_: e,
            options_: t,
            make_: $e,
            extend_: et,
            decorate_20223_: tt
        };
    }
    function $e(e, t, n) {
        return null === this.extend_(e, t, n, !1) ? 0 : 1;
    }
    function et(e, t, n, i) {
        var r, o;
        return this.annotationType_, e.defineObservableProperty_(t, n.value, null != (r = null == (o = this.options_) ? void 0 : o.enhancer) ? r : Ae, i);
    }
    function tt(e, t) {
        var n = this, i = t.kind, r = t.name, o = new WeakSet;
        function a(e, t) {
            var i, a, s = vi(e)[Ie], l = new Lt(t, null != (i = null == (a = n.options_) ? void 0 : a.enhancer) ? i : Ae, "ObservableObject." + r.toString(), !1);
            s.values_.set(r, l), o.add(e);
        }
        if ("accessor" == i) return {
            get: function() {
                return o.has(this) || a(this, e.get.call(this)), this[Ie].getObservablePropValue_(r);
            },
            set: function(e) {
                return o.has(this) || a(this, e), this[Ie].setObservablePropValue_(r, e);
            },
            init: function(e) {
                return o.has(this) || a(this, e), e;
            }
        };
    }
    var nt = "true", it = rt();
    function rt(e) {
        return {
            annotationType_: nt,
            options_: e,
            make_: ot,
            extend_: at,
            decorate_20223_: st
        };
    }
    function ot(e, t, n, i) {
        var r, o, a, s;
        if (n.get) return bt.make_(e, t, n, i);
        if (n.set) {
            var l = wn(n.set) ? n.set : kt(t.toString(), n.set);
            return i === e.target_ ? null === e.defineProperty_(t, {
                configurable: !Xt.safeDescriptors || e.isPlainObject_,
                set: l
            }) ? 0 : 2 : (W(i, t, {
                configurable: !0,
                set: l
            }), 2);
        }
        if (i !== e.target_ && "function" == typeof n.value) return ae(n.value) ? (null != (s = this.options_) && s.autoBind ? An.bound : An).make_(e, t, n, i) : (null != (a = this.options_) && a.autoBind ? Nn.bound : Nn).make_(e, t, n, i);
        var u, _ = !1 === (null == (r = this.options_) ? void 0 : r.deep) ? vt.ref : vt;
        "function" == typeof n.value && null != (o = this.options_) && o.autoBind && (n.value = n.value.bind(null != (u = e.proxy_) ? u : e.target_));
        return _.make_(e, t, n, i);
    }
    function at(e, t, n, i) {
        var r, o, a;
        if (n.get) return bt.extend_(e, t, n, i);
        if (n.set) return e.defineProperty_(t, {
            configurable: !Xt.safeDescriptors || e.isPlainObject_,
            set: kt(t.toString(), n.set)
        }, i);
        "function" == typeof n.value && null != (r = this.options_) && r.autoBind && (n.value = n.value.bind(null != (a = e.proxy_) ? a : e.target_));
        return (!1 === (null == (o = this.options_) ? void 0 : o.deep) ? vt.ref : vt).extend_(e, t, n, i);
    }
    function st(e, t) {
        B("'" + this.annotationType_ + "' cannot be used as a decorator");
    }
    var lt = {
        deep: !0,
        name: void 0,
        defaultDecorator: void 0,
        proxy: !0
    };
    function ut(e) {
        return e || lt;
    }
    Object.freeze(lt);
    var _t = Xe("observable"), ct = Xe("observable.ref", {
        enhancer: Ue
    }), dt = Xe("observable.shallow", {
        enhancer: function(e, t, n) {
            return null == e || wi(e) || oi(e) || _i(e) || pi(e) ? e : Array.isArray(e) ? vt.array(e, {
                name: n,
                deep: !1
            }) : oe(e) ? vt.object(e, void 0, {
                name: n,
                deep: !1
            }) : _e(e) ? vt.map(e, {
                name: n,
                deep: !1
            }) : ce(e) ? vt.set(e, {
                name: n,
                deep: !1
            }) : void 0;
        }
    }), gt = Xe("observable.struct", {
        enhancer: function(e, t) {
            return Yi(e, t) ? t : e;
        }
    }), pt = Te(_t);
    function Mt(e) {
        var t, n, i;
        return !0 === e.deep ? Ae : !1 === e.deep ? Ue : (t = e.defaultDecorator) && null != (n = null == (i = t.options_) ? void 0 : i.enhancer) ? n : Ae;
    }
    function mt(e, t, n) {
        return xe(t) ? _t.decorate_20223_(e, t) : ie(t) ? void ke(e, t, _t) : Qn(e) ? e : oe(e) ? vt.object(e, t, n) : Array.isArray(e) ? vt.array(e, t) : _e(e) ? vt.map(e, t) : ce(e) ? vt.set(e, t) : "object" == typeof e && null !== e ? e : vt.box(e, t);
    }
    H(mt, pt);
    var ft, ht, vt = H(mt, {
        box: function(e, t) {
            var n = ut(t);
            return new Lt(e, Mt(n), n.name, !0, n.equals);
        },
        array: function(e, t) {
            var n = ut(t);
            return (!1 === Xt.useProxies || !1 === n.proxy ? Si : Xn)(e, Mt(n), n.name);
        },
        map: function(e, t) {
            var n = ut(t);
            return new ui(e, Mt(n), n.name);
        },
        set: function(e, t) {
            var n = ut(t);
            return new gi(e, Mt(n), n.name);
        },
        object: function(e, t, n) {
            return Ci(function() {
                return function(e, t, n, i) {
                    var r = me(t);
                    return Ci(function() {
                        var t = vi(e, i)[Ie];
                        ge(r).forEach(function(e) {
                            t.extend_(e, r[e], !n || !(e in n) || n[e]);
                        });
                    }), e;
                }(!1 === Xt.useProxies || !1 === (null == n ? void 0 : n.proxy) ? vi({}, n) : function(e, t) {
                    var n, i;
                    return $(), e = vi(e, t), null != (i = (n = e[Ie]).proxy_) ? i : n.proxy_ = new Proxy(e, Rn);
                }({}, n), e, t);
            });
        },
        ref: Te(ct),
        shallow: Te(dt),
        deep: pt,
        struct: Te(gt)
    }), yt = "computed", Nt = Fe(yt), wt = Fe("computed.struct", {
        equals: Se.structural
    }), bt = function(e, t) {
        if (xe(t)) return Nt.decorate_20223_(e, t);
        if (ie(t)) return ke(e, t, Nt);
        if (oe(e)) return Te(Fe(yt, e));
        var n = oe(t) ? t : {};
        return n.get = e, n.name || (n.name = e.name || ""), new Ot(n);
    };
    Object.assign(bt, Nt), bt.struct = Te(wt);
    var jt = 0, Dt = 1, zt = null != (ft = null == (ht = Z(function() {}, "name")) ? void 0 : ht.configurable) && ft, Tt = {
        value: "action",
        configurable: !0,
        writable: !1,
        enumerable: !1
    };
    function kt(e, t, n, i) {
        function r() {
            return function(e, t, n, i, r) {
                var o = function(e, t) {
                    var n = !1, i = 0, r = Xt.trackingDerivation, o = !t || !r;
                    nn();
                    var a = Xt.allowStateChanges;
                    o && (Vt(), a = xt(!0));
                    var s = Zt(!0), l = {
                        runAsAction_: o,
                        prevDerivation_: r,
                        prevAllowStateChanges_: a,
                        prevAllowStateReads_: s,
                        notifySpy_: n,
                        startTime_: i,
                        actionId_: Dt++,
                        parentActionId_: jt
                    };
                    return jt = l.actionId_, l;
                }(0, t);
                try {
                    return n.apply(i, r);
                } catch (a) {
                    throw o.error_ = a, a;
                } finally{
                    !function(e) {
                        jt !== e.actionId_ && B(30);
                        jt = e.parentActionId_, void 0 !== e.error_ && (Xt.suppressReactionErrors = !0);
                        It(e.prevAllowStateChanges_), Wt(e.prevAllowStateReads_), rn(), e.runAsAction_ && Ht(e.prevDerivation_);
                        Xt.suppressReactionErrors = !1;
                    }(o);
                }
            }(0, n, t, i || this, arguments);
        }
        return void 0 === n && (n = !1), r.isMobxAction = !0, r.toString = function() {
            return t.toString();
        }, zt && (Tt.value = e, W(r, "name", Tt)), r;
    }
    function xt(e) {
        var t = Xt.allowStateChanges;
        return Xt.allowStateChanges = e, t;
    }
    function It(e) {
        Xt.allowStateChanges = e;
    }
    var Lt = function(e) {
        function t(t, n, i, r, o) {
            var a;
            return void 0 === i && (i = "ObservableValue"), void 0 === o && (o = Se.default), (a = e.call(this, i) || this).enhancer = void 0, a.name_ = void 0, a.equals = void 0, a.hasUnreportedChange_ = !1, a.interceptors_ = void 0, a.changeListeners_ = void 0, a.value_ = void 0, a.dehancer = void 0, a.enhancer = n, a.name_ = i, a.equals = o, a.value_ = n(t, void 0, i), a;
        }
        be(t, e);
        var n = t.prototype;
        return n.dehanceValue = function(e) {
            return void 0 !== this.dehancer ? this.dehancer(e) : e;
        }, n.set = function(e) {
            this.value_, (e = this.prepareNewValue_(e)) !== Xt.UNCHANGED && this.setNewValue_(e);
        }, n.prepareNewValue_ = function(e) {
            if (Bn(this)) {
                var t = Vn(this, {
                    object: this,
                    type: Jn,
                    newValue: e
                });
                if (!t) return Xt.UNCHANGED;
                e = t.newValue;
            }
            return e = this.enhancer(e, this.value_, this.name_), this.equals(this.value_, e) ? Xt.UNCHANGED : e;
        }, n.setNewValue_ = function(e) {
            var t = this.value_;
            this.value_ = e, this.reportChanged(), Hn(this) && Wn(this, {
                type: Jn,
                object: this,
                newValue: e,
                oldValue: t
            });
        }, n.get = function() {
            return this.reportObserved(), this.dehanceValue(this.value_);
        }, n.intercept_ = function(e) {
            return Gn(this, e);
        }, n.observe_ = function(e, t) {
            return t && e({
                observableKind: "value",
                debugObjectName: this.name_,
                object: this,
                type: Jn,
                newValue: this.value_,
                oldValue: void 0
            }), Zn(this, e);
        }, n.raw = function() {
            return this.value_;
        }, n.toJSON = function() {
            return this.get();
        }, n.toString = function() {
            return this.name_ + "[" + this.value_ + "]";
        }, n.valueOf = function() {
            return pe(this.get());
        }, n[Symbol.toPrimitive] = function() {
            return this.valueOf();
        }, t;
    }(Le), Ot = function() {
        function e(e) {
            this.dependenciesState_ = Et.NOT_TRACKING_, this.observing_ = [], this.newObserving_ = null, this.observers_ = new Set, this.runId_ = 0, this.lastAccessedBy_ = 0, this.lowestObserverState_ = Et.UP_TO_DATE_, this.unboundDepsCount_ = 0, this.value_ = new Qt(null), this.name_ = void 0, this.triggeredBy_ = void 0, this.flags_ = 0, this.derivation = void 0, this.setter_ = void 0, this.isTracing_ = At.NONE, this.scope_ = void 0, this.equals_ = void 0, this.requiresReaction_ = void 0, this.keepAlive_ = void 0, this.onBOL = void 0, this.onBUOL = void 0, e.get || B(31), this.derivation = e.get, this.name_ = e.name || "ComputedValue", e.set && (this.setter_ = kt("ComputedValue-setter", e.set)), this.equals_ = e.equals || (e.compareStructural || e.struct ? Se.structural : Se.default), this.scope_ = e.context, this.requiresReaction_ = e.requiresReaction, this.keepAlive_ = !!e.keepAlive;
        }
        var t = e.prototype;
        return t.onBecomeStale_ = function() {
            !function(e) {
                if (e.lowestObserverState_ !== Et.UP_TO_DATE_) return;
                e.lowestObserverState_ = Et.POSSIBLY_STALE_, e.observers_.forEach(function(e) {
                    e.dependenciesState_ === Et.UP_TO_DATE_ && (e.dependenciesState_ = Et.POSSIBLY_STALE_, e.onBecomeStale_());
                });
            }(this);
        }, t.onBO = function() {
            this.onBOL && this.onBOL.forEach(function(e) {
                return e();
            });
        }, t.onBUO = function() {
            this.onBUOL && this.onBUOL.forEach(function(e) {
                return e();
            });
        }, t.get = function() {
            if (this.isComputing && B(32, this.name_, this.derivation), 0 !== Xt.inBatch || 0 !== this.observers_.size || this.keepAlive_) {
                if (on(this), Yt(this)) {
                    var e = Xt.trackingContext;
                    this.keepAlive_ && !e && (Xt.trackingContext = this), this.trackAndCompute() && function(e) {
                        if (e.lowestObserverState_ === Et.STALE_) return;
                        e.lowestObserverState_ = Et.STALE_, e.observers_.forEach(function(t) {
                            t.dependenciesState_ === Et.POSSIBLY_STALE_ ? t.dependenciesState_ = Et.STALE_ : t.dependenciesState_ === Et.UP_TO_DATE_ && (e.lowestObserverState_ = Et.UP_TO_DATE_);
                        });
                    }(this), Xt.trackingContext = e;
                }
            } else Yt(this) && (this.warnAboutUntrackedRead_(), nn(), this.value_ = this.computeValue_(!1), rn());
            var t = this.value_;
            if (Pt(t)) throw t.cause;
            return t;
        }, t.set = function(e) {
            if (this.setter_) {
                this.isRunningSetter && B(33, this.name_), this.isRunningSetter = !0;
                try {
                    this.setter_.call(this.scope_, e);
                } finally{
                    this.isRunningSetter = !1;
                }
            } else B(34, this.name_);
        }, t.trackAndCompute = function() {
            var e = this.value_, t = this.dependenciesState_ === Et.NOT_TRACKING_, n = this.computeValue_(!0), i = t || Pt(e) || Pt(n) || !this.equals_(e, n);
            return i && (this.value_ = n), i;
        }, t.computeValue_ = function(e) {
            this.isComputing = !0;
            var t, n = xt(!1);
            if (e) t = Rt(this, this.derivation, this.scope_);
            else if (!0 === Xt.disableErrorBoundaries) t = this.derivation.call(this.scope_);
            else try {
                t = this.derivation.call(this.scope_);
            } catch (i) {
                t = new Qt(i);
            }
            return It(n), this.isComputing = !1, t;
        }, t.suspend_ = function() {
            this.keepAlive_ || (Bt(this), this.value_ = void 0);
        }, t.observe_ = function(e, t) {
            var n = this, i = !0, r = void 0;
            return function(e, t) {
                var n, i, r, o;
                void 0 === t && (t = q);
                var a, s = null != (n = null == (i = t) ? void 0 : i.name) ? n : "Autorun";
                if (t.scheduler || t.delay) {
                    var l = jn(t), u = !1;
                    a = new sn(s, function() {
                        u || (u = !0, l(function() {
                            u = !1, a.isDisposed || a.track(_);
                        }));
                    }, t.onError, t.requiresObservable);
                } else a = new sn(s, function() {
                    this.track(_);
                }, t.onError, t.requiresObservable);
                function _() {
                    e(a);
                }
                null != (r = t) && null != (r = r.signal) && r.aborted || a.schedule_();
                return a.getDisposer_(null == (o = t) ? void 0 : o.signal);
            }(function() {
                var o = n.get();
                if (!i || t) {
                    var a = Vt();
                    e({
                        observableKind: "computed",
                        debugObjectName: n.name_,
                        type: Jn,
                        object: n,
                        newValue: o,
                        oldValue: r
                    }), Ht(a);
                }
                i = !1, r = o;
            });
        }, t.warnAboutUntrackedRead_ = function() {}, t.toString = function() {
            return this.name_ + "[" + this.derivation.toString() + "]";
        }, t.valueOf = function() {
            return pe(this.get());
        }, t[Symbol.toPrimitive] = function() {
            return this.valueOf();
        }, ye(e, [
            {
                key: "isComputing",
                get: function() {
                    return fe(this.flags_, e.isComputingMask_);
                },
                set: function(t) {
                    this.flags_ = he(this.flags_, e.isComputingMask_, t);
                }
            },
            {
                key: "isRunningSetter",
                get: function() {
                    return fe(this.flags_, e.isRunningSetterMask_);
                },
                set: function(t) {
                    this.flags_ = he(this.flags_, e.isRunningSetterMask_, t);
                }
            },
            {
                key: "isBeingObserved",
                get: function() {
                    return fe(this.flags_, e.isBeingObservedMask_);
                },
                set: function(t) {
                    this.flags_ = he(this.flags_, e.isBeingObservedMask_, t);
                }
            },
            {
                key: "isPendingUnobservation",
                get: function() {
                    return fe(this.flags_, e.isPendingUnobservationMask_);
                },
                set: function(t) {
                    this.flags_ = he(this.flags_, e.isPendingUnobservationMask_, t);
                }
            },
            {
                key: "diffValue",
                get: function() {
                    return fe(this.flags_, e.diffValueMask_) ? 1 : 0;
                },
                set: function(t) {
                    this.flags_ = he(this.flags_, e.diffValueMask_, 1 === t);
                }
            }
        ]);
    }();
    Ot.isComputingMask_ = 1, Ot.isRunningSetterMask_ = 2, Ot.isBeingObservedMask_ = 4, Ot.isPendingUnobservationMask_ = 8, Ot.diffValueMask_ = 16;
    var Et, St, At, Ut, Ct = ue("ComputedValue", Ot);
    (St = Et || (Et = {}))[St.NOT_TRACKING_ = -1] = "NOT_TRACKING_", St[St.UP_TO_DATE_ = 0] = "UP_TO_DATE_", St[St.POSSIBLY_STALE_ = 1] = "POSSIBLY_STALE_", St[St.STALE_ = 2] = "STALE_", (Ut = At || (At = {}))[Ut.NONE = 0] = "NONE", Ut[Ut.LOG = 1] = "LOG", Ut[Ut.BREAK = 2] = "BREAK";
    var Qt = function(e) {
        this.cause = void 0, this.cause = e;
    };
    function Pt(e) {
        return e instanceof Qt;
    }
    function Yt(e) {
        switch(e.dependenciesState_){
            case Et.UP_TO_DATE_:
                return !1;
            case Et.NOT_TRACKING_:
            case Et.STALE_:
                return !0;
            case Et.POSSIBLY_STALE_:
                for(var t = Zt(!0), n = Vt(), i = e.observing_, r = i.length, o = 0; o < r; o++){
                    var a = i[o];
                    if (Ct(a)) {
                        if (Xt.disableErrorBoundaries) a.get();
                        else try {
                            a.get();
                        } catch (s) {
                            return Ht(n), Wt(t), !0;
                        }
                        if (e.dependenciesState_ === Et.STALE_) return Ht(n), Wt(t), !0;
                    }
                }
                return Ft(e), Ht(n), Wt(t), !1;
        }
    }
    function Rt(e, t, n) {
        var i = Zt(!0);
        Ft(e), e.newObserving_ = new Array(0 === e.runId_ ? 100 : e.observing_.length), e.unboundDepsCount_ = 0, e.runId_ = ++Xt.runId;
        var r, o = Xt.trackingDerivation;
        if (Xt.trackingDerivation = e, Xt.inBatch++, !0 === Xt.disableErrorBoundaries) r = t.call(n);
        else try {
            r = t.call(n);
        } catch (a) {
            r = new Qt(a);
        }
        return Xt.inBatch--, Xt.trackingDerivation = o, function(e) {
            for(var t = e.observing_, n = e.observing_ = e.newObserving_, i = Et.UP_TO_DATE_, r = 0, o = e.unboundDepsCount_, a = 0; a < o; a++){
                var s = n[a];
                0 === s.diffValue && (s.diffValue = 1, r !== a && (n[r] = s), r++), s.dependenciesState_ > i && (i = s.dependenciesState_);
            }
            n.length = r, e.newObserving_ = null, o = t.length;
            for(; o--;){
                var l = t[o];
                0 === l.diffValue && en(l, e), l.diffValue = 0;
            }
            for(; r--;){
                var u = n[r];
                1 === u.diffValue && (u.diffValue = 0, $t(u, e));
            }
            i !== Et.UP_TO_DATE_ && (e.dependenciesState_ = i, e.onBecomeStale_());
        }(e), Wt(i), r;
    }
    function Bt(e) {
        var t = e.observing_;
        e.observing_ = [];
        for(var n = t.length; n--;)en(t[n], e);
        e.dependenciesState_ = Et.NOT_TRACKING_;
    }
    function Gt(e) {
        var t = Vt();
        try {
            return e();
        } finally{
            Ht(t);
        }
    }
    function Vt() {
        var e = Xt.trackingDerivation;
        return Xt.trackingDerivation = null, e;
    }
    function Ht(e) {
        Xt.trackingDerivation = e;
    }
    function Zt(e) {
        var t = Xt.allowStateReads;
        return Xt.allowStateReads = e, t;
    }
    function Wt(e) {
        Xt.allowStateReads = e;
    }
    function Ft(e) {
        if (e.dependenciesState_ !== Et.UP_TO_DATE_) {
            e.dependenciesState_ = Et.UP_TO_DATE_;
            for(var t = e.observing_, n = t.length; n--;)t[n].lowestObserverState_ = Et.UP_TO_DATE_;
        }
    }
    var Jt = function() {
        this.version = 6, this.UNCHANGED = {}, this.trackingDerivation = null, this.trackingContext = null, this.runId = 0, this.mobxGuid = 0, this.inBatch = 0, this.pendingUnobservations = [], this.pendingReactions = [], this.isRunningReactions = !1, this.allowStateChanges = !1, this.allowStateReads = !0, this.enforceActions = !0, this.spyListeners = [], this.globalReactionErrorHandlers = [], this.computedRequiresReaction = !1, this.reactionRequiresObservable = !1, this.observableRequiresReaction = !1, this.disableErrorBoundaries = !1, this.suppressReactionErrors = !1, this.useProxies = !0, this.verifyProxies = !1, this.safeDescriptors = !0;
    }, qt = !0, Kt = !1, Xt = function() {
        var e = V();
        return e.__mobxInstanceCount > 0 && !e.__mobxGlobals && (qt = !1), e.__mobxGlobals && e.__mobxGlobals.version !== (new Jt).version && (qt = !1), qt ? e.__mobxGlobals ? (e.__mobxInstanceCount += 1, e.__mobxGlobals.UNCHANGED || (e.__mobxGlobals.UNCHANGED = {}), e.__mobxGlobals) : (e.__mobxInstanceCount = 1, e.__mobxGlobals = new Jt) : (setTimeout(function() {
            Kt || B(35);
        }, 1), new Jt);
    }();
    function $t(e, t) {
        e.observers_.add(t), e.lowestObserverState_ > t.dependenciesState_ && (e.lowestObserverState_ = t.dependenciesState_);
    }
    function en(e, t) {
        e.observers_.delete(t), 0 === e.observers_.size && tn(e);
    }
    function tn(e) {
        !1 === e.isPendingUnobservation && (e.isPendingUnobservation = !0, Xt.pendingUnobservations.push(e));
    }
    function nn() {
        Xt.inBatch++;
    }
    function rn() {
        if (0 === --Xt.inBatch) {
            _n();
            for(var e = Xt.pendingUnobservations, t = 0; t < e.length; t++){
                var n = e[t];
                n.isPendingUnobservation = !1, 0 === n.observers_.size && (n.isBeingObserved && (n.isBeingObserved = !1, n.onBUO()), n instanceof Ot && n.suspend_());
            }
            Xt.pendingUnobservations = [];
        }
    }
    function on(e) {
        var t = Xt.trackingDerivation;
        return null !== t ? (t.runId_ !== e.lastAccessedBy_ && (e.lastAccessedBy_ = t.runId_, t.newObserving_[t.unboundDepsCount_++] = e, !e.isBeingObserved && Xt.trackingContext && (e.isBeingObserved = !0, e.onBO())), e.isBeingObserved) : (0 === e.observers_.size && Xt.inBatch > 0 && tn(e), !1);
    }
    function an(e) {
        e.lowestObserverState_ !== Et.STALE_ && (e.lowestObserverState_ = Et.STALE_, e.observers_.forEach(function(e) {
            e.dependenciesState_ === Et.UP_TO_DATE_ && e.onBecomeStale_(), e.dependenciesState_ = Et.STALE_;
        }));
    }
    var sn = function() {
        function e(e, t, n, i) {
            void 0 === e && (e = "Reaction"), this.name_ = void 0, this.onInvalidate_ = void 0, this.errorHandler_ = void 0, this.requiresObservable_ = void 0, this.observing_ = [], this.newObserving_ = [], this.dependenciesState_ = Et.NOT_TRACKING_, this.runId_ = 0, this.unboundDepsCount_ = 0, this.flags_ = 0, this.isTracing_ = At.NONE, this.name_ = e, this.onInvalidate_ = t, this.errorHandler_ = n, this.requiresObservable_ = i;
        }
        var t = e.prototype;
        return t.onBecomeStale_ = function() {
            this.schedule_();
        }, t.schedule_ = function() {
            this.isScheduled || (this.isScheduled = !0, Xt.pendingReactions.push(this), _n());
        }, t.runReaction_ = function() {
            if (!this.isDisposed) {
                nn(), this.isScheduled = !1;
                var e = Xt.trackingContext;
                if (Xt.trackingContext = this, Yt(this)) {
                    this.isTrackPending = !0;
                    try {
                        this.onInvalidate_();
                    } catch (t) {
                        this.reportExceptionInDerivation_(t);
                    }
                }
                Xt.trackingContext = e, rn();
            }
        }, t.track = function(e) {
            if (!this.isDisposed) {
                nn(), this.isRunning = !0;
                var t = Xt.trackingContext;
                Xt.trackingContext = this;
                var n = Rt(this, e, void 0);
                Xt.trackingContext = t, this.isRunning = !1, this.isTrackPending = !1, this.isDisposed && Bt(this), Pt(n) && this.reportExceptionInDerivation_(n.cause), rn();
            }
        }, t.reportExceptionInDerivation_ = function(e) {
            var t = this;
            if (this.errorHandler_) this.errorHandler_(e, this);
            else {
                if (Xt.disableErrorBoundaries) throw e;
                var n = "[mobx] uncaught error in '" + this + "'";
                Xt.suppressReactionErrors || console.error(n, e), Xt.globalReactionErrorHandlers.forEach(function(n) {
                    return n(e, t);
                });
            }
        }, t.dispose = function() {
            this.isDisposed || (this.isDisposed = !0, this.isRunning || (nn(), Bt(this), rn()));
        }, t.getDisposer_ = function(e) {
            var t = this, n = function n() {
                t.dispose(), null == e || null == e.removeEventListener || e.removeEventListener("abort", n);
            };
            return null == e || null == e.addEventListener || e.addEventListener("abort", n), n[Ie] = this, "dispose" in Symbol && "symbol" == typeof Symbol.dispose && (n[Symbol.dispose] = n), n;
        }, t.toString = function() {
            return "Reaction[" + this.name_ + "]";
        }, t.trace = function(e) {}, ye(e, [
            {
                key: "isDisposed",
                get: function() {
                    return fe(this.flags_, e.isDisposedMask_);
                },
                set: function(t) {
                    this.flags_ = he(this.flags_, e.isDisposedMask_, t);
                }
            },
            {
                key: "isScheduled",
                get: function() {
                    return fe(this.flags_, e.isScheduledMask_);
                },
                set: function(t) {
                    this.flags_ = he(this.flags_, e.isScheduledMask_, t);
                }
            },
            {
                key: "isTrackPending",
                get: function() {
                    return fe(this.flags_, e.isTrackPendingMask_);
                },
                set: function(t) {
                    this.flags_ = he(this.flags_, e.isTrackPendingMask_, t);
                }
            },
            {
                key: "isRunning",
                get: function() {
                    return fe(this.flags_, e.isRunningMask_);
                },
                set: function(t) {
                    this.flags_ = he(this.flags_, e.isRunningMask_, t);
                }
            },
            {
                key: "diffValue",
                get: function() {
                    return fe(this.flags_, e.diffValueMask_) ? 1 : 0;
                },
                set: function(t) {
                    this.flags_ = he(this.flags_, e.diffValueMask_, 1 === t);
                }
            }
        ]);
    }();
    sn.isDisposedMask_ = 1, sn.isScheduledMask_ = 2, sn.isTrackPendingMask_ = 4, sn.isRunningMask_ = 8, sn.diffValueMask_ = 16;
    var ln = 100, un = function(e) {
        return e();
    };
    function _n() {
        Xt.inBatch > 0 || Xt.isRunningReactions || un(cn);
    }
    function cn() {
        Xt.isRunningReactions = !0;
        for(var e = Xt.pendingReactions, t = 0; e.length > 0;){
            ++t === ln && (console.error("[mobx] cycle in reaction: " + e[0]), e.splice(0));
            for(var n = e.splice(0), i = 0, r = n.length; i < r; i++)n[i].runReaction_();
        }
        Xt.isRunningReactions = !1;
    }
    var dn = ue("Reaction", sn);
    var gn = "action", pn = "autoAction", Mn = Qe(gn), mn = Qe("action.bound", {
        bound: !0
    }), fn = Qe(pn, {
        autoAction: !0
    }), hn = Qe("autoAction.bound", {
        autoAction: !0,
        bound: !0
    });
    function vn(e) {
        return function(t, n) {
            return ne(t) ? kt(t.name || "<unnamed action>", t, e) : ne(n) ? kt(t, n, e) : xe(n) ? (e ? fn : Mn).decorate_20223_(t, n) : ie(n) ? ke(t, n, e ? fn : Mn) : ie(t) ? Te(Qe(e ? pn : gn, {
                name: t,
                autoAction: e
            })) : void 0;
        };
    }
    var yn = vn(!1);
    Object.assign(yn, Mn);
    var Nn = vn(!0);
    function wn(e) {
        return ne(e) && !0 === e.isMobxAction;
    }
    Object.assign(Nn, fn), yn.bound = Te(mn), Nn.bound = Te(hn);
    var bn = function(e) {
        return e();
    };
    function jn(e) {
        return e.scheduler ? e.scheduler : e.delay ? function(t) {
            return setTimeout(t, e.delay);
        } : bn;
    }
    function Dn(e, t, n) {
        var i, r, o;
        void 0 === n && (n = q);
        var a, s, l, u = null != (i = n.name) ? i : "Reaction", _ = yn(u, n.onError ? (a = n.onError, s = t, function() {
            try {
                return s.apply(this, arguments);
            } catch (e) {
                a.call(this, e);
            }
        }) : t), c = !n.scheduler && !n.delay, d = jn(n), g = !0, p = !1, M = n.compareStructural ? Se.structural : n.equals || Se.default, m = new sn(u, function() {
            g || c ? f() : p || (p = !0, d(f));
        }, n.onError, n.requiresObservable);
        function f() {
            if (p = !1, !m.isDisposed) {
                var t = !1, i = l;
                m.track(function() {
                    var n = function(e, t) {
                        var n = xt(e);
                        try {
                            return t();
                        } finally{
                            It(n);
                        }
                    }(!1, function() {
                        return e(m);
                    });
                    t = g || !M(l, n), l = n;
                }), (g && n.fireImmediately || !g && t) && _(l, i, m), g = !1;
            }
        }
        return null != (r = n) && null != (r = r.signal) && r.aborted || m.schedule_(), m.getDisposer_(null == (o = n) ? void 0 : o.signal);
    }
    var zn = "onBO", Tn = "onBUO";
    function kn(e, t, n) {
        return xn(Tn, e, t, n);
    }
    function xn(e, t, n, i) {
        var r = Ai(t), o = ne(i) ? i : n, a = e + "L";
        return r[a] ? r[a].add(o) : r[a] = new Set([
            o
        ]), function() {
            var e = r[a];
            e && (e.delete(o), 0 === e.size && delete r[a]);
        };
    }
    var In = "always";
    var Ln = 0;
    function On() {
        this.message = "FLOW_CANCELLED";
    }
    On.prototype = Object.create(Error.prototype);
    var En = Ge("flow"), Sn = Ge("flow.bound", {
        bound: !0
    }), An = Object.assign(function(e, t) {
        if (xe(t)) return En.decorate_20223_(e, t);
        if (ie(t)) return ke(e, t, En);
        var n = e, i = n.name || "<unnamed flow>", r = function() {
            var e, t = arguments, r = ++Ln, o = yn(i + " - runid: " + r + " - init", n).apply(this, t), a = void 0, s = new Promise(function(t, n) {
                var s = 0;
                function l(e) {
                    var t;
                    a = void 0;
                    try {
                        t = yn(i + " - runid: " + r + " - yield " + s++, o.next).call(o, e);
                    } catch (l) {
                        return n(l);
                    }
                    _(t);
                }
                function u(e) {
                    var t;
                    a = void 0;
                    try {
                        t = yn(i + " - runid: " + r + " - yield " + s++, o.throw).call(o, e);
                    } catch (l) {
                        return n(l);
                    }
                    _(t);
                }
                function _(e) {
                    if (!ne(null == e ? void 0 : e.then)) return e.done ? t(e.value) : (a = Promise.resolve(e.value)).then(l, u);
                    e.then(_, n);
                }
                e = n, l(void 0);
            });
            return s.cancel = yn(i + " - runid: " + r + " - cancel", function() {
                try {
                    a && Un(a);
                    var t = o.return(void 0), n = Promise.resolve(t.value);
                    n.then(te, te), Un(n), e(new On);
                } catch (i) {
                    e(i);
                }
            }), s;
        };
        return r.isMobXFlow = !0, r;
    }, En);
    function Un(e) {
        ne(e.cancel) && e.cancel();
    }
    function Cn(e) {
        return !0 === (null == e ? void 0 : e.isMobXFlow);
    }
    function Qn(e) {
        return function(e) {
            return !!e && (wi(e) || !!e[Ie] || Oe(e) || dn(e) || Ct(e));
        }(e);
    }
    function Pn(e, t) {
        void 0 === t && (t = void 0), nn();
        try {
            return e.apply(t);
        } finally{
            rn();
        }
    }
    function Yn(e) {
        return e[Ie];
    }
    An.bound = Te(Sn);
    var Rn = {
        has: function(e, t) {
            return Yn(e).has_(t);
        },
        get: function(e, t) {
            return Yn(e).get_(t);
        },
        set: function(e, t, n) {
            var i;
            return !!ie(t) && (null == (i = Yn(e).set_(t, n, !0)) || i);
        },
        deleteProperty: function(e, t) {
            var n;
            return !!ie(t) && (null == (n = Yn(e).delete_(t, !0)) || n);
        },
        defineProperty: function(e, t, n) {
            var i;
            return null == (i = Yn(e).defineProperty_(t, n)) || i;
        },
        ownKeys: function(e) {
            return Yn(e).ownKeys_();
        },
        preventExtensions: function(e) {
            B(13);
        }
    };
    function Bn(e) {
        return void 0 !== e.interceptors_ && e.interceptors_.length > 0;
    }
    function Gn(e, t) {
        var n = e.interceptors_ || (e.interceptors_ = []);
        return n.push(t), ee(function() {
            var e = n.indexOf(t);
            -1 !== e && n.splice(e, 1);
        });
    }
    function Vn(e, t) {
        var n = Vt();
        try {
            for(var i = [].concat(e.interceptors_ || []), r = 0, o = i.length; r < o && ((t = i[r](t)) && !t.type && B(14), t); r++);
            return t;
        } finally{
            Ht(n);
        }
    }
    function Hn(e) {
        return void 0 !== e.changeListeners_ && e.changeListeners_.length > 0;
    }
    function Zn(e, t) {
        var n = e.changeListeners_ || (e.changeListeners_ = []);
        return n.push(t), ee(function() {
            var e = n.indexOf(t);
            -1 !== e && n.splice(e, 1);
        });
    }
    function Wn(e, t) {
        var n = Vt(), i = e.changeListeners_;
        if (i) {
            for(var r = 0, o = (i = i.slice()).length; r < o; r++)i[r](t);
            Ht(n);
        }
    }
    var Fn = "splice", Jn = "update", qn = {
        get: function(e, t) {
            var n = e[Ie];
            return t === Ie ? n : "length" === t ? n.getArrayLength_() : "string" != typeof t || isNaN(t) ? Me($n, t) ? $n[t] : e[t] : n.get_(parseInt(t));
        },
        set: function(e, t, n) {
            var i = e[Ie];
            return "length" === t && i.setArrayLength_(n), "symbol" == typeof t || isNaN(t) ? e[t] = n : i.set_(parseInt(t), n), !0;
        },
        preventExtensions: function() {
            B(15);
        }
    }, Kn = function() {
        function e(e, t, n, i) {
            void 0 === e && (e = "ObservableArray"), this.owned_ = void 0, this.legacyMode_ = void 0, this.atom_ = void 0, this.values_ = [], this.interceptors_ = void 0, this.changeListeners_ = void 0, this.enhancer_ = void 0, this.dehancer = void 0, this.proxy_ = void 0, this.lastKnownLength_ = 0, this.owned_ = n, this.legacyMode_ = i, this.atom_ = new Le(e), this.enhancer_ = function(e, n) {
                return t(e, n, "ObservableArray[..]");
            };
        }
        var t = e.prototype;
        return t.dehanceValue_ = function(e) {
            return void 0 !== this.dehancer ? this.dehancer(e) : e;
        }, t.dehanceValues_ = function(e) {
            return void 0 !== this.dehancer && e.length > 0 ? e.map(this.dehancer) : e;
        }, t.intercept_ = function(e) {
            return Gn(this, e);
        }, t.observe_ = function(e, t) {
            return void 0 === t && (t = !1), t && e({
                observableKind: "array",
                object: this.proxy_,
                debugObjectName: this.atom_.name_,
                type: "splice",
                index: 0,
                added: this.values_.slice(),
                addedCount: this.values_.length,
                removed: [],
                removedCount: 0
            }), Zn(this, e);
        }, t.getArrayLength_ = function() {
            return this.atom_.reportObserved(), this.values_.length;
        }, t.setArrayLength_ = function(e) {
            ("number" != typeof e || isNaN(e) || e < 0) && B("Out of range: " + e);
            var t = this.values_.length;
            if (e !== t) {
                if (e > t) {
                    for(var n = new Array(e - t), i = 0; i < e - t; i++)n[i] = void 0;
                    this.spliceWithArray_(t, 0, n);
                } else this.spliceWithArray_(e, t - e);
            }
        }, t.updateArrayLength_ = function(e, t) {
            e !== this.lastKnownLength_ && B(16), this.lastKnownLength_ += t, this.legacyMode_ && t > 0 && Ei(e + t + 1);
        }, t.spliceWithArray_ = function(e, t, n) {
            var i = this;
            this.atom_;
            var r = this.values_.length;
            if (void 0 === e ? e = 0 : e > r ? e = r : e < 0 && (e = Math.max(0, r + e)), t = 1 === arguments.length ? r - e : null == t ? 0 : Math.max(0, Math.min(t, r - e)), void 0 === n && (n = J), Bn(this)) {
                var o = Vn(this, {
                    object: this.proxy_,
                    type: Fn,
                    index: e,
                    removedCount: t,
                    added: n
                });
                if (!o) return J;
                t = o.removedCount, n = o.added;
            }
            if (n = 0 === n.length ? n : n.map(function(e) {
                return i.enhancer_(e, void 0);
            }), this.legacyMode_) {
                var a = n.length - t;
                this.updateArrayLength_(r, a);
            }
            var s = this.spliceItemsIntoValues_(e, t, n);
            return 0 === t && 0 === n.length || this.notifyArraySplice_(e, n, s), this.dehanceValues_(s);
        }, t.spliceItemsIntoValues_ = function(e, t, n) {
            var i;
            if (n.length < 1e4) return (i = this.values_).splice.apply(i, [
                e,
                t
            ].concat(n));
            var r = this.values_.slice(e, e + t), o = this.values_.slice(e + t);
            this.values_.length += n.length - t;
            for(var a = 0; a < n.length; a++)this.values_[e + a] = n[a];
            for(var s = 0; s < o.length; s++)this.values_[e + n.length + s] = o[s];
            return r;
        }, t.notifyArrayChildUpdate_ = function(e, t, n) {
            var i = !this.owned_ && !1, r = Hn(this), o = r || i ? {
                observableKind: "array",
                object: this.proxy_,
                type: Jn,
                debugObjectName: this.atom_.name_,
                index: e,
                newValue: t,
                oldValue: n
            } : null;
            this.atom_.reportChanged(), r && Wn(this, o);
        }, t.notifyArraySplice_ = function(e, t, n) {
            var i = !this.owned_ && !1, r = Hn(this), o = r || i ? {
                observableKind: "array",
                object: this.proxy_,
                debugObjectName: this.atom_.name_,
                type: Fn,
                index: e,
                removed: n,
                added: t,
                removedCount: n.length,
                addedCount: t.length
            } : null;
            this.atom_.reportChanged(), r && Wn(this, o);
        }, t.get_ = function(e) {
            if (!(this.legacyMode_ && e >= this.values_.length)) return this.atom_.reportObserved(), this.dehanceValue_(this.values_[e]);
            console.warn("[mobx] Out of bounds read: " + e);
        }, t.set_ = function(e, t) {
            var n = this.values_;
            if (this.legacyMode_ && e > n.length && B(17, e, n.length), e < n.length) {
                this.atom_;
                var i = n[e];
                if (Bn(this)) {
                    var r = Vn(this, {
                        type: Jn,
                        object: this.proxy_,
                        index: e,
                        newValue: t
                    });
                    if (!r) return;
                    t = r.newValue;
                }
                (t = this.enhancer_(t, i)) !== i && (n[e] = t, this.notifyArrayChildUpdate_(e, t, i));
            } else {
                for(var o = new Array(e + 1 - n.length), a = 0; a < o.length - 1; a++)o[a] = void 0;
                o[o.length - 1] = t, this.spliceWithArray_(n.length, 0, o);
            }
        }, e;
    }();
    function Xn(e, t, n, i) {
        return void 0 === n && (n = "ObservableArray"), void 0 === i && (i = !1), $(), Ci(function() {
            var r = new Kn(n, t, i, !1);
            le(r.values_, Ie, r);
            var o = new Proxy(r.values_, qn);
            return r.proxy_ = o, e && e.length && r.spliceWithArray_(0, 0, e), o;
        });
    }
    var $n = {
        clear: function() {
            return this.splice(0);
        },
        replace: function(e) {
            var t = this[Ie];
            return t.spliceWithArray_(0, t.values_.length, e);
        },
        toJSON: function() {
            return this.slice();
        },
        splice: function(e, t) {
            for(var n = arguments.length, i = new Array(n > 2 ? n - 2 : 0), r = 2; r < n; r++)i[r - 2] = arguments[r];
            var o = this[Ie];
            switch(arguments.length){
                case 0:
                    return [];
                case 1:
                    return o.spliceWithArray_(e);
                case 2:
                    return o.spliceWithArray_(e, t);
            }
            return o.spliceWithArray_(e, t, i);
        },
        spliceWithArray: function(e, t, n) {
            return this[Ie].spliceWithArray_(e, t, n);
        },
        push: function() {
            for(var e = this[Ie], t = arguments.length, n = new Array(t), i = 0; i < t; i++)n[i] = arguments[i];
            return e.spliceWithArray_(e.values_.length, 0, n), e.values_.length;
        },
        pop: function() {
            return this.splice(Math.max(this[Ie].values_.length - 1, 0), 1)[0];
        },
        shift: function() {
            return this.splice(0, 1)[0];
        },
        unshift: function() {
            for(var e = this[Ie], t = arguments.length, n = new Array(t), i = 0; i < t; i++)n[i] = arguments[i];
            return e.spliceWithArray_(0, 0, n), e.values_.length;
        },
        reverse: function() {
            return Xt.trackingDerivation && B(37, "reverse"), this.replace(this.slice().reverse()), this;
        },
        sort: function() {
            Xt.trackingDerivation && B(37, "sort");
            var e = this.slice();
            return e.sort.apply(e, arguments), this.replace(e), this;
        },
        remove: function(e) {
            var t = this[Ie], n = t.dehanceValues_(t.values_).indexOf(e);
            return n > -1 && (this.splice(n, 1), !0);
        }
    };
    function ei(e, t) {
        "function" == typeof Array.prototype[e] && ($n[e] = t(e));
    }
    function ti(e) {
        return function() {
            var t = this[Ie];
            t.atom_.reportObserved();
            var n = t.dehanceValues_(t.values_);
            return n[e].apply(n, arguments);
        };
    }
    function ni(e) {
        return function(t, n) {
            var i = this, r = this[Ie];
            return r.atom_.reportObserved(), r.dehanceValues_(r.values_)[e](function(e, r) {
                return t.call(n, e, r, i);
            });
        };
    }
    function ii(e) {
        return function() {
            var t = this, n = this[Ie];
            n.atom_.reportObserved();
            var i = n.dehanceValues_(n.values_), r = arguments[0];
            return arguments[0] = function(e, n, i) {
                return r(e, n, i, t);
            }, i[e].apply(i, arguments);
        };
    }
    ei("at", ti), ei("concat", ti), ei("flat", ti), ei("includes", ti), ei("indexOf", ti), ei("join", ti), ei("lastIndexOf", ti), ei("slice", ti), ei("toString", ti), ei("toLocaleString", ti), ei("toSorted", ti), ei("toSpliced", ti), ei("with", ti), ei("every", ni), ei("filter", ni), ei("find", ni), ei("findIndex", ni), ei("findLast", ni), ei("findLastIndex", ni), ei("flatMap", ni), ei("forEach", ni), ei("map", ni), ei("some", ni), ei("toReversed", ni), ei("reduce", ii), ei("reduceRight", ii);
    var ri = ue("ObservableArrayAdministration", Kn);
    function oi(e) {
        return re(e) && ri(e[Ie]);
    }
    var ai = {}, si = "add", li = "delete", ui = function() {
        function e(e, t, n) {
            var i = this;
            void 0 === t && (t = Ae), void 0 === n && (n = "ObservableMap"), this.enhancer_ = void 0, this.name_ = void 0, this[Ie] = ai, this.data_ = void 0, this.hasMap_ = void 0, this.keysAtom_ = void 0, this.interceptors_ = void 0, this.changeListeners_ = void 0, this.dehancer = void 0, this.enhancer_ = t, this.name_ = n, ne(Map) || B(18), Ci(function() {
                i.keysAtom_ = Ee("ObservableMap.keys()"), i.data_ = new Map, i.hasMap_ = new Map, e && i.merge(e);
            });
        }
        var t = e.prototype;
        return t.has_ = function(e) {
            return this.data_.has(e);
        }, t.has = function(e) {
            var t = this;
            if (!Xt.trackingDerivation) return this.has_(e);
            var n = this.hasMap_.get(e);
            if (!n) {
                var i = n = new Lt(this.has_(e), Ue, "ObservableMap.key?", !1);
                this.hasMap_.set(e, i), kn(i, function() {
                    return t.hasMap_.delete(e);
                });
            }
            return n.get();
        }, t.set = function(e, t) {
            var n = this.has_(e);
            if (Bn(this)) {
                var i = Vn(this, {
                    type: n ? Jn : si,
                    object: this,
                    newValue: t,
                    name: e
                });
                if (!i) return this;
                t = i.newValue;
            }
            return n ? this.updateValue_(e, t) : this.addValue_(e, t), this;
        }, t.delete = function(e) {
            var t = this;
            if ((this.keysAtom_, Bn(this)) && !Vn(this, {
                type: li,
                object: this,
                name: e
            })) return !1;
            if (this.has_(e)) {
                var n = Hn(this), i = n ? {
                    observableKind: "map",
                    debugObjectName: this.name_,
                    type: li,
                    object: this,
                    oldValue: this.data_.get(e).value_,
                    name: e
                } : null;
                return Pn(function() {
                    var n;
                    t.keysAtom_.reportChanged(), null == (n = t.hasMap_.get(e)) || n.setNewValue_(!1), t.data_.get(e).setNewValue_(void 0), t.data_.delete(e);
                }), n && Wn(this, i), !0;
            }
            return !1;
        }, t.updateValue_ = function(e, t) {
            var n = this.data_.get(e);
            if ((t = n.prepareNewValue_(t)) !== Xt.UNCHANGED) {
                var i = Hn(this), r = i ? {
                    observableKind: "map",
                    debugObjectName: this.name_,
                    type: Jn,
                    object: this,
                    oldValue: n.value_,
                    name: e,
                    newValue: t
                } : null;
                n.setNewValue_(t), i && Wn(this, r);
            }
        }, t.addValue_ = function(e, t) {
            var n = this;
            this.keysAtom_, Pn(function() {
                var i, r = new Lt(t, n.enhancer_, "ObservableMap.key", !1);
                n.data_.set(e, r), t = r.value_, null == (i = n.hasMap_.get(e)) || i.setNewValue_(!0), n.keysAtom_.reportChanged();
            });
            var i = Hn(this), r = i ? {
                observableKind: "map",
                debugObjectName: this.name_,
                type: si,
                object: this,
                name: e,
                newValue: t
            } : null;
            i && Wn(this, r);
        }, t.get = function(e) {
            return this.has(e) ? this.dehanceValue_(this.data_.get(e).get()) : this.dehanceValue_(void 0);
        }, t.dehanceValue_ = function(e) {
            return void 0 !== this.dehancer ? this.dehancer(e) : e;
        }, t.keys = function() {
            return this.keysAtom_.reportObserved(), this.data_.keys();
        }, t.values = function() {
            var e = this, t = this.keys();
            return ci({
                next: function() {
                    var n = t.next(), i = n.done, r = n.value;
                    return {
                        done: i,
                        value: i ? void 0 : e.get(r)
                    };
                }
            });
        }, t.entries = function() {
            var e = this, t = this.keys();
            return ci({
                next: function() {
                    var n = t.next(), i = n.done, r = n.value;
                    return {
                        done: i,
                        value: i ? void 0 : [
                            r,
                            e.get(r)
                        ]
                    };
                }
            });
        }, t[Symbol.iterator] = function() {
            return this.entries();
        }, t.forEach = function(e, t) {
            for(var n, i = Ne(this); !(n = i()).done;){
                var r = n.value, o = r[0], a = r[1];
                e.call(t, a, o, this);
            }
        }, t.merge = function(e) {
            var t = this;
            return _i(e) && (e = new Map(e)), Pn(function() {
                var n, i, r;
                oe(e) ? (function(e) {
                    var t = Object.keys(e);
                    if (!de) return t;
                    var n = Object.getOwnPropertySymbols(e);
                    return n.length ? [].concat(t, n.filter(function(t) {
                        return F.propertyIsEnumerable.call(e, t);
                    })) : t;
                })(e).forEach(function(n) {
                    return t.set(n, e[n]);
                }) : Array.isArray(e) ? e.forEach(function(e) {
                    var n = e[0], i = e[1];
                    return t.set(n, i);
                }) : _e(e) ? (n = e, i = Object.getPrototypeOf(n), r = Object.getPrototypeOf(i), null !== Object.getPrototypeOf(r) && B(19, e), e.forEach(function(e, n) {
                    return t.set(n, e);
                })) : null != e && B(20, e);
            }), this;
        }, t.clear = function() {
            var e = this;
            Pn(function() {
                Gt(function() {
                    for(var t, n = Ne(e.keys()); !(t = n()).done;){
                        var i = t.value;
                        e.delete(i);
                    }
                });
            });
        }, t.replace = function(e) {
            var t = this;
            return Pn(function() {
                for(var n, i = function(e) {
                    if (_e(e) || _i(e)) return e;
                    if (Array.isArray(e)) return new Map(e);
                    if (oe(e)) {
                        var t = new Map;
                        for(var n in e)t.set(n, e[n]);
                        return t;
                    }
                    return B(21, e);
                }(e), r = new Map, o = !1, a = Ne(t.data_.keys()); !(n = a()).done;){
                    var s = n.value;
                    if (!i.has(s)) {
                        if (t.delete(s)) o = !0;
                        else {
                            var l = t.data_.get(s);
                            r.set(s, l);
                        }
                    }
                }
                for(var u, _ = Ne(i.entries()); !(u = _()).done;){
                    var c = u.value, d = c[0], g = c[1], p = t.data_.has(d);
                    if (t.set(d, g), t.data_.has(d)) {
                        var M = t.data_.get(d);
                        r.set(d, M), p || (o = !0);
                    }
                }
                if (!o) {
                    if (t.data_.size !== r.size) t.keysAtom_.reportChanged();
                    else for(var m = t.data_.keys(), f = r.keys(), h = m.next(), v = f.next(); !h.done;){
                        if (h.value !== v.value) {
                            t.keysAtom_.reportChanged();
                            break;
                        }
                        h = m.next(), v = f.next();
                    }
                }
                t.data_ = r;
            }), this;
        }, t.toString = function() {
            return "[object ObservableMap]";
        }, t.toJSON = function() {
            return Array.from(this);
        }, t.observe_ = function(e, t) {
            return Zn(this, e);
        }, t.intercept_ = function(e) {
            return Gn(this, e);
        }, ye(e, [
            {
                key: "size",
                get: function() {
                    return this.keysAtom_.reportObserved(), this.data_.size;
                }
            },
            {
                key: Symbol.toStringTag,
                get: function() {
                    return "Map";
                }
            }
        ]);
    }(), _i = ue("ObservableMap", ui);
    function ci(e) {
        return e[Symbol.toStringTag] = "MapIterator", Vi(e);
    }
    var di = {}, gi = function() {
        function e(e, t, n) {
            var i = this;
            void 0 === t && (t = Ae), void 0 === n && (n = "ObservableSet"), this.name_ = void 0, this[Ie] = di, this.data_ = new Set, this.atom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.dehancer = void 0, this.enhancer_ = void 0, this.name_ = n, ne(Set) || B(22), this.enhancer_ = function(e, i) {
                return t(e, i, n);
            }, Ci(function() {
                i.atom_ = Ee(i.name_), e && i.replace(e);
            });
        }
        var t = e.prototype;
        return t.dehanceValue_ = function(e) {
            return void 0 !== this.dehancer ? this.dehancer(e) : e;
        }, t.clear = function() {
            var e = this;
            Pn(function() {
                Gt(function() {
                    for(var t, n = Ne(e.data_.values()); !(t = n()).done;){
                        var i = t.value;
                        e.delete(i);
                    }
                });
            });
        }, t.forEach = function(e, t) {
            for(var n, i = Ne(this); !(n = i()).done;){
                var r = n.value;
                e.call(t, r, r, this);
            }
        }, t.add = function(e) {
            var t = this;
            if (this.atom_, Bn(this)) {
                var n = Vn(this, {
                    type: si,
                    object: this,
                    newValue: e
                });
                if (!n) return this;
                e = n.newValue;
            }
            if (!this.has(e)) {
                Pn(function() {
                    t.data_.add(t.enhancer_(e, void 0)), t.atom_.reportChanged();
                });
                var i = Hn(this), r = i ? {
                    observableKind: "set",
                    debugObjectName: this.name_,
                    type: si,
                    object: this,
                    newValue: e
                } : null;
                i && Wn(this, r);
            }
            return this;
        }, t.delete = function(e) {
            var t = this;
            if (Bn(this) && !Vn(this, {
                type: li,
                object: this,
                oldValue: e
            })) return !1;
            if (this.has(e)) {
                var n = Hn(this), i = n ? {
                    observableKind: "set",
                    debugObjectName: this.name_,
                    type: li,
                    object: this,
                    oldValue: e
                } : null;
                return Pn(function() {
                    t.atom_.reportChanged(), t.data_.delete(e);
                }), n && Wn(this, i), !0;
            }
            return !1;
        }, t.has = function(e) {
            return this.atom_.reportObserved(), this.data_.has(this.dehanceValue_(e));
        }, t.entries = function() {
            var e = this.values();
            return Mi({
                next: function() {
                    var t = e.next(), n = t.value, i = t.done;
                    return i ? {
                        value: void 0,
                        done: i
                    } : {
                        value: [
                            n,
                            n
                        ],
                        done: i
                    };
                }
            });
        }, t.keys = function() {
            return this.values();
        }, t.values = function() {
            this.atom_.reportObserved();
            var e = this, t = this.data_.values();
            return Mi({
                next: function() {
                    var n = t.next(), i = n.value, r = n.done;
                    return r ? {
                        value: void 0,
                        done: r
                    } : {
                        value: e.dehanceValue_(i),
                        done: r
                    };
                }
            });
        }, t.intersection = function(e) {
            return ce(e) && !pi(e) ? e.intersection(this) : new Set(this).intersection(e);
        }, t.union = function(e) {
            return ce(e) && !pi(e) ? e.union(this) : new Set(this).union(e);
        }, t.difference = function(e) {
            return new Set(this).difference(e);
        }, t.symmetricDifference = function(e) {
            return ce(e) && !pi(e) ? e.symmetricDifference(this) : new Set(this).symmetricDifference(e);
        }, t.isSubsetOf = function(e) {
            return new Set(this).isSubsetOf(e);
        }, t.isSupersetOf = function(e) {
            return new Set(this).isSupersetOf(e);
        }, t.isDisjointFrom = function(e) {
            return ce(e) && !pi(e) ? e.isDisjointFrom(this) : new Set(this).isDisjointFrom(e);
        }, t.replace = function(e) {
            var t = this;
            return pi(e) && (e = new Set(e)), Pn(function() {
                Array.isArray(e) || ce(e) ? (t.clear(), e.forEach(function(e) {
                    return t.add(e);
                })) : null != e && B("Cannot initialize set from " + e);
            }), this;
        }, t.observe_ = function(e, t) {
            return Zn(this, e);
        }, t.intercept_ = function(e) {
            return Gn(this, e);
        }, t.toJSON = function() {
            return Array.from(this);
        }, t.toString = function() {
            return "[object ObservableSet]";
        }, t[Symbol.iterator] = function() {
            return this.values();
        }, ye(e, [
            {
                key: "size",
                get: function() {
                    return this.atom_.reportObserved(), this.data_.size;
                }
            },
            {
                key: Symbol.toStringTag,
                get: function() {
                    return "Set";
                }
            }
        ]);
    }(), pi = ue("ObservableSet", gi);
    function Mi(e) {
        return e[Symbol.toStringTag] = "SetIterator", Vi(e);
    }
    var mi = Object.create(null), fi = "remove", hi = function() {
        function e(e, t, n, i) {
            void 0 === t && (t = new Map), void 0 === i && (i = it), this.target_ = void 0, this.values_ = void 0, this.name_ = void 0, this.defaultAnnotation_ = void 0, this.keysAtom_ = void 0, this.changeListeners_ = void 0, this.interceptors_ = void 0, this.proxy_ = void 0, this.isPlainObject_ = void 0, this.appliedAnnotations_ = void 0, this.pendingKeys_ = void 0, this.target_ = e, this.values_ = t, this.name_ = n, this.defaultAnnotation_ = i, this.keysAtom_ = new Le("ObservableObject.keys"), this.isPlainObject_ = oe(this.target_);
        }
        var t = e.prototype;
        return t.getObservablePropValue_ = function(e) {
            return this.values_.get(e).get();
        }, t.setObservablePropValue_ = function(e, t) {
            var n = this.values_.get(e);
            if (n instanceof Ot) return n.set(t), !0;
            if (Bn(this)) {
                var i = Vn(this, {
                    type: Jn,
                    object: this.proxy_ || this.target_,
                    name: e,
                    newValue: t
                });
                if (!i) return null;
                t = i.newValue;
            }
            if ((t = n.prepareNewValue_(t)) !== Xt.UNCHANGED) {
                var r = Hn(this), o = r ? {
                    type: Jn,
                    observableKind: "object",
                    debugObjectName: this.name_,
                    object: this.proxy_ || this.target_,
                    oldValue: n.value_,
                    name: e,
                    newValue: t
                } : null;
                n.setNewValue_(t), r && Wn(this, o);
            }
            return !0;
        }, t.get_ = function(e) {
            return Xt.trackingDerivation && !Me(this.target_, e) && this.has_(e), this.target_[e];
        }, t.set_ = function(e, t, n) {
            return void 0 === n && (n = !1), Me(this.target_, e) ? this.values_.has(e) ? this.setObservablePropValue_(e, t) : n ? Reflect.set(this.target_, e, t) : (this.target_[e] = t, !0) : this.extend_(e, {
                value: t,
                enumerable: !0,
                writable: !0,
                configurable: !0
            }, this.defaultAnnotation_, n);
        }, t.has_ = function(e) {
            if (!Xt.trackingDerivation) return e in this.target_;
            this.pendingKeys_ || (this.pendingKeys_ = new Map);
            var t = this.pendingKeys_.get(e);
            return t || (t = new Lt(e in this.target_, Ue, "ObservableObject.key?", !1), this.pendingKeys_.set(e, t)), t.get();
        }, t.make_ = function(e, t) {
            if (!0 === t && (t = this.defaultAnnotation_), !1 !== t) {
                if (!(e in this.target_)) {
                    var n;
                    if (null != (n = this.target_[ze]) && n[e]) return;
                    B(1, t.annotationType_, this.name_ + "." + e.toString());
                }
                for(var i = this.target_; i && i !== F;){
                    var r = Z(i, e);
                    if (r) {
                        var o = t.make_(this, e, r, i);
                        if (0 === o) return;
                        if (1 === o) break;
                    }
                    i = Object.getPrototypeOf(i);
                }
                bi(this, t, e);
            }
        }, t.extend_ = function(e, t, n, i) {
            if (void 0 === i && (i = !1), !0 === n && (n = this.defaultAnnotation_), !1 === n) return this.defineProperty_(e, t, i);
            var r = n.extend_(this, e, t, i);
            return r && bi(this, n, e), r;
        }, t.defineProperty_ = function(e, t, n) {
            void 0 === n && (n = !1), this.keysAtom_;
            try {
                nn();
                var i = this.delete_(e);
                if (!i) return i;
                if (Bn(this)) {
                    var r = Vn(this, {
                        object: this.proxy_ || this.target_,
                        name: e,
                        type: si,
                        newValue: t.value
                    });
                    if (!r) return null;
                    var o = r.newValue;
                    t.value !== o && (t = we({}, t, {
                        value: o
                    }));
                }
                if (n) {
                    if (!Reflect.defineProperty(this.target_, e, t)) return !1;
                } else W(this.target_, e, t);
                this.notifyPropertyAddition_(e, t.value);
            } finally{
                rn();
            }
            return !0;
        }, t.defineObservableProperty_ = function(e, t, n, i) {
            void 0 === i && (i = !1), this.keysAtom_;
            try {
                nn();
                var r = this.delete_(e);
                if (!r) return r;
                if (Bn(this)) {
                    var o = Vn(this, {
                        object: this.proxy_ || this.target_,
                        name: e,
                        type: si,
                        newValue: t
                    });
                    if (!o) return null;
                    t = o.newValue;
                }
                var a = Ni(e), s = {
                    configurable: !Xt.safeDescriptors || this.isPlainObject_,
                    enumerable: !0,
                    get: a.get,
                    set: a.set
                };
                if (i) {
                    if (!Reflect.defineProperty(this.target_, e, s)) return !1;
                } else W(this.target_, e, s);
                var l = new Lt(t, n, "ObservableObject.key", !1);
                this.values_.set(e, l), this.notifyPropertyAddition_(e, l.value_);
            } finally{
                rn();
            }
            return !0;
        }, t.defineComputedProperty_ = function(e, t, n) {
            void 0 === n && (n = !1), this.keysAtom_;
            try {
                nn();
                var i = this.delete_(e);
                if (!i) return i;
                if (Bn(this)) {
                    if (!Vn(this, {
                        object: this.proxy_ || this.target_,
                        name: e,
                        type: si,
                        newValue: void 0
                    })) return null;
                }
                t.name || (t.name = "ObservableObject.key"), t.context = this.proxy_ || this.target_;
                var r = Ni(e), o = {
                    configurable: !Xt.safeDescriptors || this.isPlainObject_,
                    enumerable: !1,
                    get: r.get,
                    set: r.set
                };
                if (n) {
                    if (!Reflect.defineProperty(this.target_, e, o)) return !1;
                } else W(this.target_, e, o);
                this.values_.set(e, new Ot(t)), this.notifyPropertyAddition_(e, void 0);
            } finally{
                rn();
            }
            return !0;
        }, t.delete_ = function(e, t) {
            if (void 0 === t && (t = !1), this.keysAtom_, !Me(this.target_, e)) return !0;
            if (Bn(this) && !Vn(this, {
                object: this.proxy_ || this.target_,
                name: e,
                type: fi
            })) return null;
            try {
                var n;
                nn();
                var i, r = Hn(this), o = this.values_.get(e), a = void 0;
                if (!o && r) a = null == (i = Z(this.target_, e)) ? void 0 : i.value;
                if (t) {
                    if (!Reflect.deleteProperty(this.target_, e)) return !1;
                } else delete this.target_[e];
                if (o && (this.values_.delete(e), o instanceof Lt && (a = o.value_), an(o)), this.keysAtom_.reportChanged(), null == (n = this.pendingKeys_) || null == (n = n.get(e)) || n.set(e in this.target_), r) {
                    var s = {
                        type: fi,
                        observableKind: "object",
                        object: this.proxy_ || this.target_,
                        debugObjectName: this.name_,
                        oldValue: a,
                        name: e
                    };
                    r && Wn(this, s);
                }
            } finally{
                rn();
            }
            return !0;
        }, t.observe_ = function(e, t) {
            return Zn(this, e);
        }, t.intercept_ = function(e) {
            return Gn(this, e);
        }, t.notifyPropertyAddition_ = function(e, t) {
            var n, i = Hn(this);
            if (i) {
                var r = i ? {
                    type: si,
                    observableKind: "object",
                    debugObjectName: this.name_,
                    object: this.proxy_ || this.target_,
                    name: e,
                    newValue: t
                } : null;
                i && Wn(this, r);
            }
            null == (n = this.pendingKeys_) || null == (n = n.get(e)) || n.set(!0), this.keysAtom_.reportChanged();
        }, t.ownKeys_ = function() {
            return this.keysAtom_.reportObserved(), ge(this.target_);
        }, t.keys_ = function() {
            return this.keysAtom_.reportObserved(), Object.keys(this.target_);
        }, e;
    }();
    function vi(e, t) {
        var n;
        if (Me(e, Ie)) return e;
        var i = null != (n = null == t ? void 0 : t.name) ? n : "ObservableObject", r = new hi(e, new Map, String(i), function(e) {
            var t;
            return e ? null != (t = e.defaultDecorator) ? t : rt(e) : void 0;
        }(t));
        return se(e, Ie, r), e;
    }
    var yi = ue("ObservableObjectAdministration", hi);
    function Ni(e) {
        return mi[e] || (mi[e] = {
            get: function() {
                return this[Ie].getObservablePropValue_(e);
            },
            set: function(t) {
                return this[Ie].setObservablePropValue_(e, t);
            }
        });
    }
    function wi(e) {
        return !!re(e) && yi(e[Ie]);
    }
    function bi(e, t, n) {
        var i;
        null == (i = e.target_[ze]) || delete i[n];
    }
    var ji, Di, zi = Li(0), Ti = function() {
        var e = !1, t = {};
        return Object.defineProperty(t, "0", {
            set: function() {
                e = !0;
            }
        }), Object.create(t)[0] = 1, !1 === e;
    }(), ki = 0, xi = function() {};
    ji = xi, Di = Array.prototype, Object.setPrototypeOf ? Object.setPrototypeOf(ji.prototype, Di) : void 0 !== ji.prototype.__proto__ ? ji.prototype.__proto__ = Di : ji.prototype = Di;
    var Ii = function(e) {
        function t(t, n, i, r) {
            var o;
            return void 0 === i && (i = "ObservableArray"), void 0 === r && (r = !1), o = e.call(this) || this, Ci(function() {
                var e = new Kn(i, n, r, !0);
                e.proxy_ = o, le(o, Ie, e), t && t.length && o.spliceWithArray(0, 0, t), Ti && Object.defineProperty(o, "0", zi);
            }), o;
        }
        be(t, e);
        var n = t.prototype;
        return n.concat = function() {
            this[Ie].atom_.reportObserved();
            for(var e = arguments.length, t = new Array(e), n = 0; n < e; n++)t[n] = arguments[n];
            return Array.prototype.concat.apply(this.slice(), t.map(function(e) {
                return oi(e) ? e.slice() : e;
            }));
        }, n[Symbol.iterator] = function() {
            var e = this, t = 0;
            return Vi({
                next: function() {
                    return t < e.length ? {
                        value: e[t++],
                        done: !1
                    } : {
                        done: !0,
                        value: void 0
                    };
                }
            });
        }, ye(t, [
            {
                key: "length",
                get: function() {
                    return this[Ie].getArrayLength_();
                },
                set: function(e) {
                    this[Ie].setArrayLength_(e);
                }
            },
            {
                key: Symbol.toStringTag,
                get: function() {
                    return "Array";
                }
            }
        ]);
    }(xi);
    function Li(e) {
        return {
            enumerable: !1,
            configurable: !0,
            get: function() {
                return this[Ie].get_(e);
            },
            set: function(t) {
                this[Ie].set_(e, t);
            }
        };
    }
    function Oi(e) {
        W(Ii.prototype, "" + e, Li(e));
    }
    function Ei(e) {
        if (e > ki) {
            for(var t = ki; t < e + 100; t++)Oi(t);
            ki = e;
        }
    }
    function Si(e, t, n) {
        return new Ii(e, t, n);
    }
    function Ai(e, t) {
        if ("object" == typeof e && null !== e) {
            if (oi(e)) return void 0 !== t && B(23), e[Ie].atom_;
            if (pi(e)) return e.atom_;
            if (_i(e)) {
                if (void 0 === t) return e.keysAtom_;
                var n = e.data_.get(t) || e.hasMap_.get(t);
                return n || B(25, t, Ui(e)), n;
            }
            if (wi(e)) {
                if (!t) return B(26);
                var i = e[Ie].values_.get(t);
                return i || B(27, t, Ui(e)), i;
            }
            if (Oe(e) || Ct(e) || dn(e)) return e;
        } else if (ne(e) && dn(e[Ie])) return e[Ie];
        B(28);
    }
    function Ui(e, t) {
        var n;
        if (void 0 !== t) n = Ai(e, t);
        else {
            if (wn(e)) return e.name;
            n = wi(e) || _i(e) || pi(e) ? function(e) {
                return e || B(29), Oe(e) || Ct(e) || dn(e) || _i(e) || pi(e) ? e : e[Ie] ? e[Ie] : void B(24, e);
            }(e) : Ai(e);
        }
        return n.name_;
    }
    function Ci(e) {
        var t = Vt(), n = xt(!0);
        nn();
        try {
            return e();
        } finally{
            rn(), It(n), Ht(t);
        }
    }
    Object.entries($n).forEach(function(e) {
        var t = e[0], n = e[1];
        "concat" !== t && se(Ii.prototype, t, n);
    }), Ei(1e3);
    var Qi, Pi = F.toString;
    function Yi(e, t, n) {
        return void 0 === n && (n = -1), Ri(e, t, n);
    }
    function Ri(e, t, n, i, r) {
        if (e === t) return 0 !== e || 1 / e == 1 / t;
        if (null == e || null == t) return !1;
        if (e != e) return t != t;
        var o = typeof e;
        if ("function" !== o && "object" !== o && "object" != typeof t) return !1;
        var a = Pi.call(e);
        if (a !== Pi.call(t)) return !1;
        switch(a){
            case "[object RegExp]":
            case "[object String]":
                return "" + e == "" + t;
            case "[object Number]":
                return +e != +e ? +t != +t : 0 === +e ? 1 / +e == 1 / t : +e === +t;
            case "[object Date]":
            case "[object Boolean]":
                return +e === +t;
            case "[object Symbol]":
                return "undefined" != typeof Symbol && Symbol.valueOf.call(e) === Symbol.valueOf.call(t);
            case "[object Map]":
            case "[object Set]":
                n >= 0 && n++;
        }
        e = Bi(e), t = Bi(t);
        var s = "[object Array]" === a;
        if (!s) {
            if ("object" != typeof e || "object" != typeof t) return !1;
            var l = e.constructor, u = t.constructor;
            if (l !== u && !(ne(l) && l instanceof l && ne(u) && u instanceof u) && "constructor" in e && "constructor" in t) return !1;
        }
        if (0 === n) return !1;
        n < 0 && (n = -1), r = r || [];
        for(var _ = (i = i || []).length; _--;)if (i[_] === e) return r[_] === t;
        if (i.push(e), r.push(t), s) {
            if ((_ = e.length) !== t.length) return !1;
            for(; _--;)if (!Ri(e[_], t[_], n - 1, i, r)) return !1;
        } else {
            var c = Object.keys(e), d = c.length;
            if (Object.keys(t).length !== d) return !1;
            for(var g = 0; g < d; g++){
                var p = c[g];
                if (!Me(t, p) || !Ri(e[p], t[p], n - 1, i, r)) return !1;
            }
        }
        return i.pop(), r.pop(), !0;
    }
    function Bi(e) {
        return oi(e) ? e.slice() : _e(e) || _i(e) || ce(e) || pi(e) ? Array.from(e.entries()) : e;
    }
    var Gi = (null == (Qi = V().Iterator) ? void 0 : Qi.prototype) || {};
    function Vi(e) {
        return e[Symbol.iterator] = Hi, Object.assign(Object.create(Gi), e);
    }
    function Hi() {
        return this;
    }
    [
        "Symbol",
        "Map",
        "Set"
    ].forEach(function(e) {
        void 0 === V()[e] && B("MobX requires global '" + e + "' to be available or polyfilled");
    }), "object" == typeof __MOBX_DEVTOOLS_GLOBAL_HOOK__ && __MOBX_DEVTOOLS_GLOBAL_HOOK__.injectMobx({
        spy: function(e) {
            return console.warn("[mobx.spy] Is a no-op in production builds"), function() {};
        },
        extras: {
            getDebugName: Ui
        },
        $mobx: Ie
    });
    var Zi = class extends Error {
        constructor(e){
            super(e.statusText), this.name = "HTTPError", this.status = e.status;
        }
    }, Wi = class extends Zi {
        constructor(e, t){
            super(e), this.name = "TextHTTPError", this.data = t;
        }
    }, Fi = class extends Zi {
        constructor(e, t){
            super(e), this.name = "JSONHTTPError", this.json = t;
        }
    }, Ji = class e {
        constructor(e, t){
            this.apiURL = e || "", this._sameOrigin = /^\/(?!\/)/.test(this.apiURL), this.defaultHeaders = t?.defaultHeaders || {};
        }
        headers(e = {}) {
            return {
                ...this.defaultHeaders,
                "Content-Type": "application/json",
                ...e
            };
        }
        static async parseJsonResponse(e) {
            const t = await e.json();
            if (!e.ok) throw new Fi(e, t);
            return t;
        }
        async request(t, n = {}) {
            const i = this.headers(n.headers || {});
            n.body || delete i["Content-Type"];
            const r = {
                ...n,
                headers: i
            };
            this._sameOrigin && (r.credentials = n.credentials || "same-origin");
            const o = await fetch(this.apiURL + t, r), a = o.headers.get("Content-Type");
            if (a?.includes("json")) return e.parseJsonResponse(o);
            const s = await o.text();
            if (!o.ok) throw new Wi(o, s);
            return s;
        }
    }, qi = class {
        constructor(e){
            this.user = e;
        }
        listUsers(e) {
            return this.user._request("/admin/users", {
                method: "GET",
                audience: e
            });
        }
        getUser(e) {
            return this.user._request(`/admin/users/${e.id}`);
        }
        updateUser(e, t = {}) {
            return this.user._request(`/admin/users/${e.id}`, {
                method: "PUT",
                body: JSON.stringify(t)
            });
        }
        createUser(e, t, n = {}) {
            return n.email = e, n.password = t, this.user._request("/admin/users", {
                method: "POST",
                body: JSON.stringify(n)
            });
        }
        deleteUser(e) {
            return this.user._request(`/admin/users/${e.id}`, {
                method: "DELETE"
            });
        }
    }, Ki = "gotrue.user", Xi = {}, $i = null, er = {
        api: 1,
        token: 1,
        audience: 1,
        url: 1
    }, tr = {
        api: 1
    }, nr = ()=>"undefined" != typeof window, ir = !1;
    function rr() {
        !ir && nr() && (ir = !0, window.addEventListener("storage", (e)=>{
            e.key === Ki && ($i = null);
        }));
    }
    var or = class e {
        constructor(e, t, n){
            this.token = null, this.api = e, this.url = e.apiURL, this.audience = n, this._processTokenResponse(t), $i = this, rr();
        }
        static removeSavedSession() {
            nr() && localStorage.removeItem(Ki);
        }
        static recoverSession(t) {
            if (rr(), $i) return $i;
            const n = nr() && localStorage.getItem(Ki);
            if (n) try {
                const i = JSON.parse(n), { url: r, token: o, audience: a } = i;
                if (!r || !o) return null;
                const s = t || new Ji(r, {});
                return new e(s, o, a)._saveUserData(i, !0);
            } catch (i) {
                return console.error(new Error(`Gotrue-js: Error recovering session: ${i}`)), null;
            }
            return null;
        }
        get admin() {
            return new qi(this);
        }
        async update(e) {
            const t = await this._request("/user", {
                method: "PUT",
                body: JSON.stringify(e)
            });
            return this._saveUserData(t)._refreshSavedSession();
        }
        jwt(e) {
            const t = this.tokenDetails();
            if (null == t) return Promise.reject(new Error("Gotrue-js: failed getting jwt access token"));
            const { expires_at: n, refresh_token: i, access_token: r } = t;
            return e || n - 6e4 < Date.now() ? this._refreshToken(i) : Promise.resolve(r);
        }
        logout() {
            return this._request("/logout", {
                method: "POST"
            }).then(this.clearSession.bind(this)).catch(this.clearSession.bind(this));
        }
        _refreshToken(e) {
            const t = Xi[e];
            if (t) return t;
            const n = this.api.request("/token", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: `grant_type=refresh_token&refresh_token=${e}`
            }), i = new Promise((e, t)=>{
                setTimeout(()=>t(new Error("Token refresh timeout")), 3e4);
            }), r = Promise.race([
                n,
                i
            ]).then((t)=>{
                if (delete Xi[e], this._processTokenResponse(t), this._refreshSavedSession(), !this.token) throw new Error("Gotrue-js: Token not set after refresh");
                return this.token.access_token;
            }).catch((t)=>{
                throw delete Xi[e], this.clearSession(), t;
            });
            return Xi[e] = r, r;
        }
        async _request(e, t = {}) {
            t.headers = t.headers || {};
            const n = t.audience || this.audience;
            n && (t.headers["X-JWT-AUD"] = n);
            try {
                const n = await this.jwt();
                return await this.api.request(e, {
                    headers: Object.assign(t.headers, {
                        Authorization: `Bearer ${n}`
                    }),
                    ...t
                });
            } catch (i) {
                throw i instanceof Fi && i.json && (i.json.msg ? i.message = i.json.msg : i.json.error && (i.message = `${i.json.error}: ${i.json.error_description}`)), i;
            }
        }
        async getUserData() {
            const e = await this._request("/user");
            return this._saveUserData(e)._refreshSavedSession();
        }
        _saveUserData(t, n) {
            for(const i in t)i in e.prototype || i in er || (this[i] = t[i]);
            return n && (this._fromStorage = !0), this;
        }
        _processTokenResponse(e) {
            this.token = e;
            try {
                const t = JSON.parse(function(e) {
                    let t = e.replace(/-/g, "+").replace(/_/g, "/");
                    switch(t.length % 4){
                        case 0:
                            break;
                        case 2:
                            t += "==";
                            break;
                        case 3:
                            t += "=";
                            break;
                        default:
                            throw new Error("Illegal base64url string!");
                    }
                    const n = function(e) {
                        if ("function" == typeof atob) return atob(e);
                        return $1130f25edc25b2ab$require$Buffer.from(e, "base64").toString("binary");
                    }(t);
                    try {
                        const e = Uint8Array.from(n, (e)=>e.codePointAt(0) ?? 0);
                        return (new TextDecoder).decode(e);
                    } catch  {
                        return n;
                    }
                }(e.access_token.split(".")[1]));
                this.token.expires_at = 1e3 * t.exp;
            } catch (t) {
                console.error(new Error(`Gotrue-js: Failed to parse tokenResponse claims: ${t}`));
            }
        }
        _refreshSavedSession() {
            return nr() && localStorage.getItem(Ki) && this._saveSession(), this;
        }
        get _details() {
            const t = {};
            for(const n in this)n in e.prototype || n in tr || (t[n] = this[n]);
            return t;
        }
        _saveSession() {
            return nr() && localStorage.setItem(Ki, JSON.stringify(this._details)), this;
        }
        tokenDetails() {
            return this.token;
        }
        clearSession() {
            e.removeSavedSession(), this.token = null, $i = null;
        }
    };
    var ar = /^http:\/\//, sr = class {
        constructor({ APIUrl: e = "/.netlify/identity", audience: t = "", setCookie: n = !1, clientName: i = "gotrue-js" } = {}){
            ar.test(e) && console.warn("Warning:\n\nDO NOT USE HTTP IN PRODUCTION FOR GOTRUE EVER!\nGoTrue REQUIRES HTTPS to work securely."), t && (this.audience = t), this.setCookie = n, this.api = new Ji(e, {
                defaultHeaders: {
                    "X-Nf-Client": i
                }
            });
        }
        async _request(e, t = {}) {
            t.headers = t.headers || {};
            const n = t.audience || this.audience;
            n && (t.headers["X-JWT-AUD"] = n);
            try {
                return await this.api.request(e, t);
            } catch (i) {
                throw i instanceof Fi && i.json && (i.json.msg ? i.message = i.json.msg : i.json.error && (i.message = `${i.json.error}: ${i.json.error_description}`)), i;
            }
        }
        settings() {
            return this._request("/settings");
        }
        signup(e, t, n) {
            return this._request("/signup", {
                method: "POST",
                body: JSON.stringify({
                    email: e,
                    password: t,
                    data: n
                })
            });
        }
        login(e, t, n) {
            return this._setRememberHeaders(n), this._request("/token", {
                method: "POST",
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded"
                },
                body: `grant_type=password&username=${encodeURIComponent(e)}&password=${encodeURIComponent(t)}`
            }).then((e)=>(or.removeSavedSession(), this.createUser(e, n)));
        }
        loginExternalUrl(e) {
            return `${this.api.apiURL}/authorize?provider=${e}`;
        }
        confirm(e, t) {
            return this._setRememberHeaders(t), this.verify("signup", e, t);
        }
        requestPasswordRecovery(e) {
            return this._request("/recover", {
                method: "POST",
                body: JSON.stringify({
                    email: e
                })
            });
        }
        recover(e, t) {
            return this._setRememberHeaders(t), this.verify("recovery", e, t);
        }
        acceptInvite(e, t, n) {
            return this._setRememberHeaders(n), this._request("/verify", {
                method: "POST",
                body: JSON.stringify({
                    token: e,
                    password: t,
                    type: "signup"
                })
            }).then((e)=>this.createUser(e, n));
        }
        acceptInviteExternalUrl(e, t) {
            return `${this.api.apiURL}/authorize?provider=${e}&invite_token=${t}`;
        }
        createUser(e, t = !1) {
            this._setRememberHeaders(t);
            return new or(this.api, e, this.audience || "").getUserData().then((e)=>(t && e._saveSession(), e));
        }
        currentUser() {
            const e = or.recoverSession(this.api);
            return e && this._setRememberHeaders(e._fromStorage), e;
        }
        async validateCurrentSession() {
            const e = this.currentUser();
            if (!e) return null;
            try {
                return await e.getUserData();
            } catch  {
                return e.clearSession(), null;
            }
        }
        verify(e, t, n) {
            return this._setRememberHeaders(n), this._request("/verify", {
                method: "POST",
                body: JSON.stringify({
                    token: t,
                    type: e
                })
            }).then((e)=>this.createUser(e, n));
        }
        _setRememberHeaders(e) {
            this.setCookie && (this.api.defaultHeaders = this.api.defaultHeaders || {}, this.api.defaultHeaders["X-Use-Cookie"] = e ? "1" : "session");
        }
    };
    "undefined" != typeof window && (window.GoTrue = sr);
    var lr, ur, _r, cr, dr = 0, gr = [], pr = t, Mr = pr.__b, mr = pr.__r, fr = pr.diffed, hr = pr.__c, vr = pr.unmount, yr = pr.__;
    function Nr(e, t) {
        pr.__h && pr.__h(ur, e, dr || t), dr = 0;
        var n = ur.__H || (ur.__H = {
            __: [],
            __h: []
        });
        return e >= n.__.length && n.__.push({}), n.__[e];
    }
    function wr(e) {
        return dr = 1, br(Or, e);
    }
    function br(e, t, n) {
        var i = Nr(lr++, 2);
        if (i.t = e, !i.__c && (i.__ = [
            Or(void 0, t),
            function(e) {
                var t = i.__N ? i.__N[0] : i.__[0], n = i.t(t, e);
                t !== n && (i.__N = [
                    n,
                    i.__[1]
                ], i.__c.setState({}));
            }
        ], i.__c = ur, !ur.__f)) {
            var r = function(e, t, n) {
                if (!i.__c.__H) return !0;
                var r = i.__c.__H.__.filter(function(e) {
                    return e.__c;
                });
                if (r.every(function(e) {
                    return !e.__N;
                })) return !o || o.call(this, e, t, n);
                var a = i.__c.props !== e;
                return r.some(function(e) {
                    if (e.__N) {
                        var t = e.__[0];
                        e.__ = e.__N, e.__N = void 0, t !== e.__[0] && (a = !0);
                    }
                }), o && o.call(this, e, t, n) || a;
            };
            ur.__f = !0;
            var o = ur.shouldComponentUpdate, a = ur.componentWillUpdate;
            ur.componentWillUpdate = function(e, t, n) {
                if (this.__e) {
                    var i = o;
                    o = void 0, r(e, t, n), o = i;
                }
                a && a.call(this, e, t, n);
            }, ur.shouldComponentUpdate = r;
        }
        return i.__N || i.__;
    }
    function jr(e) {
        return dr = 5, function(e, t) {
            var n = Nr(lr++, 7);
            return Lr(n.__H, t) && (n.__ = e(), n.__H = t, n.__h = e), n.__;
        }(function() {
            return {
                current: e
            };
        }, []);
    }
    function Dr(e) {
        var t = ur.context[e.__c], n = Nr(lr++, 9);
        return n.c = e, t ? (null == n.__ && (n.__ = !0, t.sub(ur)), t.props.value) : e.__;
    }
    function zr() {
        for(var e; e = gr.shift();){
            var t = e.__H;
            if (e.__P && t) try {
                t.__h.some(xr), t.__h.some(Ir), t.__h = [];
            } catch (n) {
                t.__h = [], pr.__e(n, e.__v);
            }
        }
    }
    pr.__b = function(e) {
        ur = null, Mr && Mr(e);
    }, pr.__ = function(e, t) {
        e && t.__k && t.__k.__m && (e.__m = t.__k.__m), yr && yr(e, t);
    }, pr.__r = function(e) {
        mr && mr(e), lr = 0;
        var t = (ur = e.__c).__H;
        t && (_r === ur ? (t.__h = [], ur.__h = [], t.__.some(function(e) {
            e.__N && (e.__ = e.__N), e.u = e.__N = void 0;
        })) : (t.__h.some(xr), t.__h.some(Ir), t.__h = [], lr = 0)), _r = ur;
    }, pr.diffed = function(e) {
        fr && fr(e);
        var t = e.__c;
        t && t.__H && (t.__H.__h.length && (1 !== gr.push(t) && cr === pr.requestAnimationFrame || ((cr = pr.requestAnimationFrame) || kr)(zr)), t.__H.__.some(function(e) {
            e.u && (e.__H = e.u), e.u = void 0;
        })), _r = ur = null;
    }, pr.__c = function(e, t) {
        t.some(function(e) {
            try {
                e.__h.some(xr), e.__h = e.__h.filter(function(e) {
                    return !e.__ || Ir(e);
                });
            } catch (n) {
                t.some(function(e) {
                    e.__h && (e.__h = []);
                }), t = [], pr.__e(n, e.__v);
            }
        }), hr && hr(e, t);
    }, pr.unmount = function(e) {
        vr && vr(e);
        var t, n = e.__c;
        n && n.__H && (n.__H.__.some(function(e) {
            try {
                xr(e);
            } catch (n) {
                t = n;
            }
        }), n.__H = void 0, t && pr.__e(t, n.__v));
    };
    var Tr = "function" == typeof requestAnimationFrame;
    function kr(e) {
        var t, n = function() {
            clearTimeout(i), Tr && cancelAnimationFrame(t), setTimeout(e);
        }, i = setTimeout(n, 35);
        Tr && (t = requestAnimationFrame(n));
    }
    function xr(e) {
        var t = ur, n = e.__c;
        "function" == typeof n && (e.__c = void 0, n()), ur = t;
    }
    function Ir(e) {
        var t = ur;
        e.__c = e.__(), ur = t;
    }
    function Lr(e, t) {
        return !e || e.length !== t.length || t.some(function(t, n) {
            return t !== e[n];
        });
    }
    function Or(e, t) {
        return "function" == typeof t ? t(e) : t;
    }
    function Er(e) {
        const t = e.displayName || e.name || "Component";
        function n(n) {
            const [, i] = br((e)=>e + 1, 0), r = jr(null);
            var o, a, s;
            let l;
            return r.current || (r.current = new sn(`observer(${t})`, ()=>{
                i(0);
            })), o = ()=>()=>{
                    r.current?.dispose(), r.current = null;
                }, a = [], s = Nr(lr++, 3), !pr.__s && Lr(s.__H, a) && (s.__ = o, s.u = a, ur.__H.__h.push(s)), r.current.track(()=>{
                l = e(n);
            }), l;
        }
        return n.displayName = `observer(${t})`, n;
    }
    const Sr = function(e) {
        function t(e) {
            var n, i;
            return this.getChildContext || (n = new Set, (i = {})[t.__c] = this, this.getChildContext = function() {
                return i;
            }, this.componentWillUnmount = function() {
                n = null;
            }, this.shouldComponentUpdate = function(e) {
                this.props.value != e.value && n.forEach(function(e) {
                    e.__e = !0, j(e);
                });
            }, this.sub = function(e) {
                n.add(e);
                var t = e.componentWillUnmount;
                e.componentWillUnmount = function() {
                    n && n.delete(e), t && t.call(e);
                };
            }), e.children;
        }
        return t.__c = "__cC" + c++, t.__ = e, t.Provider = t.__l = (t.Consumer = function(e, t) {
            return e.children(t);
        }).contextType = t, t;
    }(null);
    function Ar({ page: e, error: t, loading: n, showHeader: i, showSignup: r, devSettings: o, isOpen: a, children: s, logo: l, isLocal: u, onClose: _, onPage: c, clearSiteURL: d, clearStoreError: g, t: p }) {
        const M = (e)=>{
            e.preventDefault(), _();
        }, m = (e)=>(t)=>{
                t.preventDefault(), c(e);
            }, f = n || !a, h = t ? function(e) {
            return "string" == typeof e ? e : e.json && e.json.error_description || e.message || e.toString();
        }(t) : null;
        return R("div", {
            className: "modalContainer",
            role: "dialog",
            "aria-hidden": `${f}`,
            onMouseDown: M,
            onKeyDown: (e)=>{
                "Escape" === e.key && _();
            },
            children: [
                R("div", {
                    className: "modalDialog" + (n ? " visuallyHidden" : ""),
                    onMouseDown: (e)=>{
                        e.stopPropagation();
                    },
                    children: R("div", {
                        className: "modalContent",
                        children: [
                            R("button", {
                                onClick: M,
                                className: "btn btnClose",
                                children: R("span", {
                                    className: "visuallyHidden",
                                    children: "Close"
                                })
                            }),
                            i && R("div", {
                                className: "header",
                                children: [
                                    r && R("button", {
                                        className: "btn btnHeader " + (e.signup ? "active" : ""),
                                        onClick: m("signup"),
                                        children: p("sign_up")
                                    }),
                                    !o && R("button", {
                                        className: "btn btnHeader " + (e.login ? "active" : ""),
                                        onClick: m("login"),
                                        children: p("log_in")
                                    })
                                ]
                            }),
                            e.title && R("div", {
                                className: "header",
                                children: R("button", {
                                    className: "btn btnHeader active",
                                    children: p(e.title)
                                })
                            }),
                            o && R("div", {
                                className: "header",
                                children: R("button", {
                                    className: "btn btnHeader active",
                                    children: p("site_url_title")
                                })
                            }),
                            h && R("div", {
                                className: "flashMessage error",
                                children: R("span", {
                                    children: p(h)
                                })
                            }),
                            u && h && h.includes("Failed to load settings from") && R("div", {
                                children: R("button", {
                                    onClick: (e)=>{
                                        d(e), g();
                                    },
                                    className: "btnLink forgotPasswordLink",
                                    children: p("site_url_link_text")
                                })
                            }),
                            s
                        ]
                    })
                }),
                l && R("a", {
                    href: "https://www.netlify.com",
                    className: "callOut" + (n ? " visuallyHidden" : ""),
                    children: [
                        R("span", {
                            className: "netlifyLogo"
                        }),
                        p("coded_by")
                    ]
                })
            ]
        });
    }
    function Ur({ devMode: e, onSiteURL: t, t: n }) {
        const [i, r] = wr(""), [o] = wr(e || !1);
        return R("div", {
            children: o ? R("div", {
                class: "subheader",
                children: [
                    R("h3", {
                        children: n("site_url_title")
                    }),
                    R("button", {
                        onClick: (e)=>{
                            e.preventDefault(), t();
                        },
                        className: "btnLink forgotPasswordLink",
                        children: n("site_url_link_text")
                    })
                ]
            }) : R("form", {
                onSubmit: (e)=>{
                    e.preventDefault();
                    const n = (o = "/.netlify/identity", -1 === (r = i).indexOf(o) ? r : r.substring(0, r.length - o.length));
                    var r, o;
                    t(n);
                },
                className: "form",
                children: [
                    R("div", {
                        className: "flashMessage",
                        children: n("site_url_message")
                    }),
                    R("div", {
                        className: "formGroup",
                        children: R("label", {
                            children: [
                                R("span", {
                                    className: "visuallyHidden",
                                    children: n("site_url_label")
                                }),
                                R("input", {
                                    className: "formControl",
                                    type: "url",
                                    name: "url",
                                    value: i,
                                    placeholder: n("site_url_placeholder"),
                                    autocapitalize: "off",
                                    required: !0,
                                    onInput: (e)=>{
                                        const t = e.target;
                                        r(t.value);
                                    }
                                }),
                                R("div", {
                                    className: "inputFieldIcon inputFieldUrl"
                                })
                            ]
                        })
                    }),
                    R("button", {
                        type: "submit",
                        className: "btn",
                        children: n("site_url_submit")
                    })
                ]
            })
        });
    }
    function Cr({ saving: e, text: t, saving_text: n }) {
        return R("button", {
            type: "submit",
            className: "btn" + (e ? " saving" : ""),
            children: e ? n || "Saving" : t || "Save"
        });
    }
    function Qr({ user: e, saving: t, onLogout: n, t: i }) {
        return R("form", {
            onSubmit: (e)=>{
                e.preventDefault(), n();
            },
            className: "form " + (t ? "disabled" : ""),
            children: [
                R("p", {
                    className: "infoText",
                    children: [
                        i("logged_in_as"),
                        " ",
                        R("br", {}),
                        R("span", {
                            className: "infoTextEmail",
                            children: e.user_metadata?.full_name || e.user_metadata?.name || e.email
                        })
                    ]
                }),
                R(Cr, {
                    saving: t,
                    text: i("log_out"),
                    saving_text: i("logging_out")
                })
            ]
        });
    }
    const Pr = {
        confirm: {
            type: "success",
            text: "message_confirm"
        },
        password_mail: {
            type: "success",
            text: "message_password_mail"
        },
        email_changed: {
            type: "sucess",
            text: "message_email_changed"
        },
        verfication_error: {
            type: "error",
            text: "message_verfication_error"
        },
        signup_disabled: {
            type: "error",
            text: "message_signup_disabled"
        }
    };
    function Yr({ type: e, t: t }) {
        const n = Pr[e];
        return R("div", {
            className: `flashMessage ${n.type}`,
            children: R("span", {
                children: t(n.text)
            })
        });
    }
    function Rr({ page: e, message: t, saving: n, namePlaceholder: i, onSubmit: r, t: o }) {
        const [a, s] = wr(""), [l, u] = wr(""), [_, c] = wr(""), [d, g] = wr(!1), p = (e)=>{
            const t = e.target, { name: n, value: i } = t;
            switch(n){
                case "name":
                    s(i);
                    break;
                case "email":
                    u(i);
                    break;
                case "password":
                    c(i);
            }
        };
        return R("form", {
            onSubmit: (e)=>{
                e.preventDefault(), r({
                    name: a,
                    email: l,
                    password: _
                });
            },
            className: "form " + (n ? "disabled" : ""),
            children: [
                t && R(Yr, {
                    type: t,
                    t: o
                }),
                e.name && R("div", {
                    className: "formGroup",
                    children: R("label", {
                        children: [
                            R("span", {
                                className: "visuallyHidden",
                                children: o("form_name_placeholder")
                            }),
                            R("input", {
                                className: "formControl",
                                type: "text",
                                name: "name",
                                value: a,
                                placeholder: i || o("form_name_label"),
                                autocomplete: "name",
                                autocapitalize: "off",
                                required: !0,
                                onInput: p
                            }),
                            R("div", {
                                className: "inputFieldIcon inputFieldName"
                            })
                        ]
                    })
                }),
                e.email && R("div", {
                    className: "formGroup",
                    children: R("label", {
                        children: [
                            R("span", {
                                className: "visuallyHidden",
                                children: o("form_email_label")
                            }),
                            R("input", {
                                className: "formControl",
                                type: "email",
                                name: "email",
                                value: l,
                                placeholder: o("form_email_placeholder"),
                                autocomplete: "email",
                                autocapitalize: "off",
                                required: !0,
                                onInput: p
                            }),
                            R("div", {
                                className: "inputFieldIcon inputFieldEmail"
                            })
                        ]
                    })
                }),
                e.password && R("div", {
                    className: "formGroup",
                    children: [
                        R("label", {
                            children: [
                                R("span", {
                                    className: "visuallyHidden",
                                    children: o("form_password_label")
                                }),
                                R("input", {
                                    className: "formControl",
                                    type: d ? "text" : "password",
                                    name: "password",
                                    value: _,
                                    placeholder: o("form_password_placeholder"),
                                    autocomplete: e.password,
                                    required: !0,
                                    onInput: p
                                }),
                                R("div", {
                                    className: "inputFieldIcon inputFieldPassword"
                                })
                            ]
                        }),
                        R("button", {
                            type: "button",
                            className: "btnPasswordToggle " + (d ? "passwordVisible" : ""),
                            "aria-pressed": d,
                            onClick: ()=>g(!d),
                            children: R("span", {
                                className: "visuallyHidden",
                                children: o(d ? "hide_password" : "show_password")
                            })
                        })
                    ]
                }),
                R(Cr, {
                    saving: n,
                    text: o(e.button),
                    saving_text: o(e.button_saving)
                })
            ]
        });
    }
    function Br({ provider: e, label: t, onLogin: n, t: i }) {
        return R("button", {
            onClick: (t)=>{
                t.preventDefault(), n(e.toLowerCase());
            },
            className: `provider${e} btn btnProvider`,
            children: `${i("continue_with")} ${t}`
        });
    }
    function Gr({ providers: e, labels: t, onLogin: n, t: i }) {
        const r = (e)=>{
            const n = e.toLowerCase();
            return n in t ? t[n] : e;
        };
        return R("div", {
            className: "providersGroup",
            children: [
                R("hr", {
                    className: "hr",
                    "data-text": i("or")
                }),
                e.map((e)=>R(Br, {
                        provider: e,
                        label: r(e),
                        onLogin: n,
                        t: i
                    }, e))
            ]
        });
    }
    const Vr = {
        login: !0,
        signup: !0
    }, Hr = {
        login: {
            login: !0,
            button: "log_in",
            button_saving: "logging_in",
            email: !0,
            password: "current-password",
            link: "amnesia",
            link_text: "forgot_password",
            providers: !0
        },
        signup: {
            signup: !0,
            button: "sign_up",
            button_saving: "signing_up",
            name: !0,
            email: !0,
            password: "new-password",
            providers: !0
        },
        amnesia: {
            title: "recover_password",
            button: "send_recovery_email",
            button_saving: "sending_recovery_email",
            email: !0,
            link: "login",
            link_text: "never_mind"
        },
        recovery: {
            title: "recover_password",
            button: "update_password",
            button_saving: "updating_password",
            password: "new-password",
            link: "login",
            link_text: "never_mind"
        },
        invite: {
            title: "complete_your_signup",
            button: "sign_up",
            button_saving: "signing_up",
            password: "new-password",
            providers: !0
        },
        user: {
            title: "logged_in"
        }
    };
    const Zr = Er(function() {
        const e = Dr(Sr);
        if (!e) return null;
        const t = (t)=>e.openModal(t), n = ()=>e.logout(), i = (t)=>{
            t && e.setSiteURL(t);
        }, r = ()=>e.clearSiteURL(), o = (t)=>e.externalLogin(t), a = ({ name: t, email: n, password: i })=>{
            switch(e.modal.page){
                case "login":
                    e.login(n, i);
                    break;
                case "signup":
                    e.signup(t, n, i);
                    break;
                case "amnesia":
                    e.requestPasswordRecovery(n);
                    break;
                case "invite":
                    e.acceptInvite(i);
                    break;
                case "recovery":
                    e.updatePassword(i);
            }
        }, s = Vr[e.modal.page] || !1, l = e.settings && !e.settings.disable_signup;
        return R("div", {
            children: R(Ar, {
                page: Hr[e.modal.page] || {},
                error: e.error,
                showHeader: s,
                showSignup: !!l,
                devSettings: !e.gotrue,
                loading: !e.error && !!e.gotrue && !e.settings,
                isOpen: e.modal.isOpen,
                onPage: t,
                onClose: ()=>e.closeModal(),
                logo: e.modal.logo,
                t: e.translate,
                isLocal: e.isLocal || !1,
                clearSiteURL: r,
                clearStoreError: ()=>e.setError(),
                children: [
                    (()=>{
                        const o = Hr[e.modal.page] || {};
                        return e.isLocal && null === e.siteURL ? R(Ur, {
                            devMode: null != e.siteURL,
                            onSiteURL: e.siteURL ? r : i,
                            t: e.translate
                        }) : e.settings ? e.user && "recovery" !== e.modal.page ? R(Qr, {
                            user: e.user,
                            saving: e.saving,
                            onLogout: n,
                            t: e.translate
                        }) : "signup" === e.modal.page && e.settings.disable_signup ? R(Yr, {
                            type: "signup_disabled",
                            t: e.translate
                        }) : R("div", {
                            children: [
                                R(Rr, {
                                    page: {
                                        name: o.name,
                                        email: o.email,
                                        password: o.password,
                                        button: o.button || "",
                                        button_saving: o.button_saving || ""
                                    },
                                    message: e.message,
                                    saving: e.saving,
                                    onSubmit: a,
                                    namePlaceholder: e.namePlaceholder,
                                    t: e.translate
                                }, e.modal.page),
                                !e.user && o.link && e.gotrue && R("button", {
                                    onClick: ()=>t(o.link),
                                    className: "btnLink forgotPasswordLink",
                                    children: e.translate(o.link_text)
                                }),
                                e.isLocal ? R(Ur, {
                                    devMode: null != e.siteURL,
                                    onSiteURL: e.siteURL ? r : i,
                                    t: e.translate
                                }) : R("div", {})
                            ]
                        }) : null;
                    })(),
                    (()=>{
                        if (!e.gotrue || !e.settings) return null;
                        if ("signup" === e.modal.page && e.settings.disable_signup) return null;
                        if (!(Hr[e.modal.page] || {}).providers) return null;
                        const t = [
                            "Google",
                            "GitHub",
                            "GitLab",
                            "BitBucket",
                            "Facebook",
                            "SAML"
                        ].filter((t)=>e.settings.external[t.toLowerCase()]);
                        return t.length ? R(Gr, {
                            providers: t,
                            labels: e.settings.external_labels || {},
                            onLogin: o,
                            t: e.translate
                        }) : null;
                    })()
                ]
            })
        });
    }), Wr = "Log in", Fr = "Log out", Jr = "Logged in as", qr = "Logged in", Kr = "Logging in", Xr = "Logging out", $r = "Sign up", eo = "Signing up", to = "Forgot password?", no = "Recover password", io = "Send recovery email", ro = "Sending recovery email", oo = "Never mind", ao = "Update password", so = "Updating password", lo = "Complete your signup", uo = "Development Settings", _o = "Clear localhost URL", co = "Looks like you're running a local server. Please let us know the URL of your Netlify site.", go = "Enter your Netlify Site URL", po = "URL of your Netlify site", Mo = "Set site's URL", mo = "A confirmation message was sent to your email, click the link there to continue.", fo = "We've sent a recovery email to your account, follow the link there to reset your password.", ho = "Your email address has been updated!", vo = "There was an error verifying your account. Please try again or contact an administrator.", yo = "Public signups are disabled. Contact an administrator and ask for an invite.", No = "Name", wo = "Enter your email", bo = "Enter your name", jo = "Email", Do = "Enter your password", zo = "Password", To = "Coded by Netlify", ko = "Continue with", xo = "Show password", Io = "Hide password", Lo = {
        log_in: Wr,
        log_out: Fr,
        logged_in_as: Jr,
        logged_in: qr,
        logging_in: Kr,
        logging_out: Xr,
        sign_up: $r,
        signing_up: eo,
        forgot_password: to,
        recover_password: no,
        send_recovery_email: io,
        sending_recovery_email: ro,
        never_mind: oo,
        update_password: ao,
        updating_password: so,
        complete_your_signup: lo,
        site_url_title: uo,
        site_url_link_text: _o,
        site_url_message: co,
        site_url_label: go,
        site_url_placeholder: po,
        site_url_submit: Mo,
        message_confirm: mo,
        message_password_mail: fo,
        message_email_changed: ho,
        message_verfication_error: vo,
        message_signup_disabled: yo,
        form_name_placeholder: No,
        form_email_label: wo,
        form_name_label: bo,
        form_email_placeholder: jo,
        form_password_label: Do,
        form_password_placeholder: zo,
        coded_by: To,
        continue_with: ko,
        "No user found with this email": "No user found with this email",
        "Invalid Password": "Invalid Password",
        "Email not confirmed": "Email not confirmed",
        "User not found": "User not found",
        or: "or",
        show_password: xo,
        hide_password: Io
    }, Oo = Object.freeze(Object.defineProperty({
        __proto__: null,
        coded_by: To,
        complete_your_signup: lo,
        continue_with: ko,
        default: Lo,
        forgot_password: to,
        form_email_label: wo,
        form_email_placeholder: jo,
        form_name_label: bo,
        form_name_placeholder: No,
        form_password_label: Do,
        form_password_placeholder: zo,
        hide_password: Io,
        log_in: Wr,
        log_out: Fr,
        logged_in: qr,
        logged_in_as: Jr,
        logging_in: Kr,
        logging_out: Xr,
        message_confirm: mo,
        message_email_changed: ho,
        message_password_mail: fo,
        message_signup_disabled: yo,
        message_verfication_error: vo,
        never_mind: oo,
        or: "or",
        recover_password: no,
        send_recovery_email: io,
        sending_recovery_email: ro,
        show_password: xo,
        sign_up: $r,
        signing_up: eo,
        site_url_label: go,
        site_url_link_text: _o,
        site_url_message: co,
        site_url_placeholder: po,
        site_url_submit: Mo,
        site_url_title: uo,
        update_password: ao,
        updating_password: so
    }, Symbol.toStringTag, {
        value: "Module"
    })), Eo = "Connexion", So = "D\xe9connexion", Ao = "Connect\xe9 en tant que", Uo = "Connect\xe9", Co = "Connexion", Qo = "D\xe9connexion", Po = "Inscription", Yo = "Inscription", Ro = "Mot de passe oubli\xe9 ?", Bo = "R\xe9cup\xe9rer le mot de passe", Go = "Envoyer l'e-mail de r\xe9cup\xe9ration", Vo = "Envoi de l'e-mail de r\xe9cup\xe9ration", Ho = "Annuler", Zo = "Mettre \xe0 jour le mot de passe", Wo = "Mise \xe0 jour du mot de passe", Fo = "Compl\xe9ter l'inscription", Jo = "Param\xe8tres de d\xe9veloppement", qo = "Effacer l'URL localhost", Ko = "On dirait que vous faites tourner un serveur local. Veuillez nous indiquer l'URL de votre site Netlify.", Xo = "Entrez l'URL de votre site Netlify", $o = "URL de votre site Netlify", ea = "D\xe9finir l'URL du site", ta = "Un message de confirmation a \xe9t\xe9 envoy\xe9 \xe0 votre adresse \xe9lectronique, cliquez sur le lien pour continuer.", na = "Nous avons envoy\xe9 un e-mail de r\xe9cup\xe9ration \xe0 votre compte, suivez le lien qui s'y trouve pour r\xe9initialiser votre mot de passe.", ia = "Votre adresse e-mail a \xe9t\xe9 mise \xe0 jour !", ra = "Il y a eu une erreur lors de la v\xe9rification de votre compte. Veuillez r\xe9essayer ou contacter un administrateur.", oa = "Les inscriptions publiques sont d\xe9sactiv\xe9es. Contactez un administrateur et demandez une invitation.", aa = "Entrez votre adresse e-mail", sa = "Saisissez votre nom", la = "E-mail", ua = "Saisissez votre mot de passe", _a = "Mot de passe", ca = "Cod\xe9 par Netlify", da = "Continuer avec", ga = "Afficher le mot de passe", pa = "Masquer le mot de passe", Ma = {
        log_in: Eo,
        log_out: So,
        logged_in_as: Ao,
        logged_in: Uo,
        logging_in: Co,
        logging_out: Qo,
        sign_up: Po,
        signing_up: Yo,
        forgot_password: Ro,
        recover_password: Bo,
        send_recovery_email: Go,
        sending_recovery_email: Vo,
        never_mind: Ho,
        update_password: Zo,
        updating_password: Wo,
        complete_your_signup: Fo,
        site_url_title: Jo,
        site_url_link_text: qo,
        site_url_message: Ko,
        site_url_label: Xo,
        site_url_placeholder: $o,
        site_url_submit: ea,
        message_confirm: ta,
        message_password_mail: na,
        message_email_changed: ia,
        message_verfication_error: ra,
        message_signup_disabled: oa,
        form_name_placeholder: "Nom",
        form_email_label: aa,
        form_name_label: sa,
        form_email_placeholder: la,
        form_password_label: ua,
        form_password_placeholder: _a,
        coded_by: ca,
        continue_with: da,
        "No user found with this email": "Aucun utilisateur trouv\xe9 avec cet e-mail",
        "Invalid Password": "Mot de passe incorrect",
        "Email not confirmed": "Adresse e-mail non confirm\xe9e",
        "User not found": "Aucun utilisateur trouv\xe9",
        or: "ou",
        show_password: ga,
        hide_password: pa
    }, ma = Object.freeze(Object.defineProperty({
        __proto__: null,
        coded_by: ca,
        complete_your_signup: Fo,
        continue_with: da,
        default: Ma,
        forgot_password: Ro,
        form_email_label: aa,
        form_email_placeholder: la,
        form_name_label: sa,
        form_name_placeholder: "Nom",
        form_password_label: ua,
        form_password_placeholder: _a,
        hide_password: pa,
        log_in: Eo,
        log_out: So,
        logged_in: Uo,
        logged_in_as: Ao,
        logging_in: Co,
        logging_out: Qo,
        message_confirm: ta,
        message_email_changed: ia,
        message_password_mail: na,
        message_signup_disabled: oa,
        message_verfication_error: ra,
        never_mind: Ho,
        or: "ou",
        recover_password: Bo,
        send_recovery_email: Go,
        sending_recovery_email: Vo,
        show_password: ga,
        sign_up: Po,
        signing_up: Yo,
        site_url_label: Xo,
        site_url_link_text: qo,
        site_url_message: Ko,
        site_url_placeholder: $o,
        site_url_submit: ea,
        site_url_title: Jo,
        update_password: Zo,
        updating_password: Wo
    }, Symbol.toStringTag, {
        value: "Module"
    })), fa = "Iniciar sesi\xf3n", ha = "Cerrar sesi\xf3n", va = "Conectado como", ya = "Conectado", Na = "Iniciando sesi\xf3n", wa = "Cerrando sesi\xf3n", ba = "Registrate", ja = "Registrandose", Da = "\xbfOlvidaste tu contrase\xf1a?", za = "Recuperar contrase\xf1a", Ta = "Enviar correo electr\xf3nico de recuperaci\xf3n", ka = "Enviando correo electr\xf3nico de recuperaci\xf3n", xa = "Regresar", Ia = "Actualizar contrase\xf1a", La = "Actualizando contrase\xf1a", Oa = "Completa tu registro", Ea = "Configuraci\xf3n de desarrollo", Sa = "Borrar URL del localhost", Aa = "Parece que estas corriendo un servidor local. Por favor haznos saber la URL de tu sitio en Netlify.", Ua = "Ingresa la URL de tu sitio en Netlify", Ca = "URL de tu sitio en Netlify", Qa = "Establecer la URL del sitio", Pa = "Se envi\xf3 un mensaje de confirmaci\xf3n a tu correo electr\xf3nico, haz clic en el enlace all\xed para continuar.", Ya = "Hemos enviado un correo electr\xf3nico de recuperaci\xf3n a tu correo electr\xf3nico, sigue el enlace all\xed para restablecer tu contrase\xf1a.", Ra = "\xa1Tu direcci\xf3n de correo electr\xf3nico ha sido actualizada!", Ba = "Se produjo un error al verificar tu cuenta. Por favor intenta nuevamente o contacta a un administrador.", Ga = "Los registros p\xfablicos est\xe1n deshabilitados. Contacta a un administrador y solicita una invitaci\xf3n.", Va = "Nombre", Ha = "Ingresa tu correo electr\xf3nico", Za = "Ingresa tu nombre", Wa = "Correo electr\xf3nico", Fa = "Ingresa tu contrase\xf1a", Ja = "Contrase\xf1a", qa = "Codificado por Netlify", Ka = "Contin\xfaa con", Xa = "Mostrar contrase\xf1a", $a = "Ocultar contrase\xf1a", es = {
        log_in: fa,
        log_out: ha,
        logged_in_as: va,
        logged_in: ya,
        logging_in: Na,
        logging_out: wa,
        sign_up: ba,
        signing_up: ja,
        forgot_password: Da,
        recover_password: za,
        send_recovery_email: Ta,
        sending_recovery_email: ka,
        never_mind: xa,
        update_password: Ia,
        updating_password: La,
        complete_your_signup: Oa,
        site_url_title: Ea,
        site_url_link_text: Sa,
        site_url_message: Aa,
        site_url_label: Ua,
        site_url_placeholder: Ca,
        site_url_submit: Qa,
        message_confirm: Pa,
        message_password_mail: Ya,
        message_email_changed: Ra,
        message_verfication_error: Ba,
        message_signup_disabled: Ga,
        form_name_placeholder: Va,
        form_email_label: Ha,
        form_name_label: Za,
        form_email_placeholder: Wa,
        form_password_label: Fa,
        form_password_placeholder: Ja,
        coded_by: qa,
        continue_with: Ka,
        "No user found with this email": "No existe ning\xfan usuario con este correo electr\xf3nico",
        "Invalid Password": "La contrase\xf1a es invalida",
        "Email not confirmed": "Correo electr\xf3nico no confirmado",
        "User not found": "Usuario no encontrado",
        or: "o",
        show_password: Xa,
        hide_password: $a
    }, ts = Object.freeze(Object.defineProperty({
        __proto__: null,
        coded_by: qa,
        complete_your_signup: Oa,
        continue_with: Ka,
        default: es,
        forgot_password: Da,
        form_email_label: Ha,
        form_email_placeholder: Wa,
        form_name_label: Za,
        form_name_placeholder: Va,
        form_password_label: Fa,
        form_password_placeholder: Ja,
        hide_password: $a,
        log_in: fa,
        log_out: ha,
        logged_in: ya,
        logged_in_as: va,
        logging_in: Na,
        logging_out: wa,
        message_confirm: Pa,
        message_email_changed: Ra,
        message_password_mail: Ya,
        message_signup_disabled: Ga,
        message_verfication_error: Ba,
        never_mind: xa,
        or: "o",
        recover_password: za,
        send_recovery_email: Ta,
        sending_recovery_email: ka,
        show_password: Xa,
        sign_up: ba,
        signing_up: ja,
        site_url_label: Ua,
        site_url_link_text: Sa,
        site_url_message: Aa,
        site_url_placeholder: Ca,
        site_url_submit: Qa,
        site_url_title: Ea,
        update_password: Ia,
        updating_password: La
    }, Symbol.toStringTag, {
        value: "Module"
    })), ns = "Bejelentkez\xe9s", is = "Kijelentkez\xe9s", rs = "Bejelentkezve mint", os = "Bejelentkezve", as = "Bejelentkez\xe9s", ss = "Kijelentkez\xe9s", ls = "Regisztr\xe1ci\xf3", us = "Regisztr\xe1l\xe1s", _s = "Elfelejtette a jelszav\xe1t?", cs = "Jelsz\xf3 vissza\xe1ll\xedt\xe1sa", ds = "Jelsz\xf3p\xf3tl\xf3 lev\xe9l k\xfcld\xe9se", gs = "Jelsz\xf3p\xf3tl\xf3 lev\xe9l k\xfcld\xe9se", ps = "M\xe9gsem", Ms = "\xdaj jelsz\xf3 be\xe1ll\xedt\xe1sa", ms = "\xdaj jelsz\xf3 be\xe1ll\xedt\xe1sa", fs = "Regisztr\xe1ci\xf3 befejez\xe9se", hs = "Fejleszt\u0151i Be\xe1ll\xedt\xe1sok", vs = "Localhost URL t\xf6rl\xe9se", ys = "\xdagy n\xe9z ki egy helyi szervert futtat. K\xe9rj\xfck adja meg a Netlify oldala URL-j\xe9t.", Ns = "Adja meg a Netlify oldala URL-j\xe9t", ws = "a Netlify oldala URL-je", bs = "URL be\xe1ll\xedt\xe1sa", js = "Elk\xfcldt\xfcnk egy meger\u0151s\xedt\u0151 levelet e-mailben, k\xe9rj\xfck kattintson a linkre a lev\xe9lben a folytat\xe1shoz.", Ds = "Elk\xfcldt\xfcnk egy jelsz\xf3p\xf3tl\xf3 levelet e-mailben, k\xe9rj\xfck k\xf6vesse a linket a lev\xe9lben a jelszava vissza\xe1ll\xedt\xe1s\xe1hoz.", zs = "Az e-mail c\xedm\xe9t friss\xedtett\xfck!", Ts = "Probl\xe9ma t\xf6rt\xe9nt a fi\xf3kja meger\u0151s\xedt\xe9se k\xf6zben. K\xe9rj\xfck pr\xf3b\xe1lja \xfajra, vagy vegye fel a kapcsolatot egy adminisztr\xe1torral.", ks = "A nyilv\xe1nos regisztr\xe1ci\xf3 nincs enged\xe9lyezve. Vegye fel a kapcsolatot egy adminisztr\xe1torral \xe9s k\xe9rjen megh\xedv\xf3t.", xs = "Adja meg az e-mail c\xedm\xe9t", Is = "Adja meg a nev\xe9t", Ls = "E-mail", Os = "Adja meg a jelszav\xe1t", Es = "Jelsz\xf3", Ss = "Fejlesztette a Netlify", As = "Bejelentkez\xe9s ezzel:", Us = "vagy", Cs = "Jelsz\xf3 megjelen\xedt\xe9se", Qs = "Jelsz\xf3 elrejt\xe9se", Ps = {
        log_in: ns,
        log_out: is,
        logged_in_as: rs,
        logged_in: os,
        logging_in: as,
        logging_out: ss,
        sign_up: ls,
        signing_up: us,
        forgot_password: _s,
        recover_password: cs,
        send_recovery_email: ds,
        sending_recovery_email: gs,
        never_mind: ps,
        update_password: Ms,
        updating_password: ms,
        complete_your_signup: fs,
        site_url_title: hs,
        site_url_link_text: vs,
        site_url_message: ys,
        site_url_label: Ns,
        site_url_placeholder: ws,
        site_url_submit: bs,
        message_confirm: js,
        message_password_mail: Ds,
        message_email_changed: zs,
        message_verfication_error: Ts,
        message_signup_disabled: ks,
        form_name_placeholder: "N\xe9v",
        form_email_label: xs,
        form_name_label: Is,
        form_email_placeholder: Ls,
        form_password_label: Os,
        form_password_placeholder: Es,
        coded_by: Ss,
        continue_with: As,
        "No user found with this email": "Nem tal\xe1lhat\xf3 fi\xf3k ezzel az e-mail c\xedmmel",
        "Invalid Password": "Helytelen Jelsz\xf3",
        "Email not confirmed": "Az e-mail nem er\u0151s\xfclt meg",
        "User not found": "Felhaszn\xe1l\xf3 nem tal\xe1lhat\xf3",
        or: Us,
        show_password: Cs,
        hide_password: Qs
    }, Ys = Object.freeze(Object.defineProperty({
        __proto__: null,
        coded_by: Ss,
        complete_your_signup: fs,
        continue_with: As,
        default: Ps,
        forgot_password: _s,
        form_email_label: xs,
        form_email_placeholder: Ls,
        form_name_label: Is,
        form_name_placeholder: "N\xe9v",
        form_password_label: Os,
        form_password_placeholder: Es,
        hide_password: Qs,
        log_in: ns,
        log_out: is,
        logged_in: os,
        logged_in_as: rs,
        logging_in: as,
        logging_out: ss,
        message_confirm: js,
        message_email_changed: zs,
        message_password_mail: Ds,
        message_signup_disabled: ks,
        message_verfication_error: Ts,
        never_mind: ps,
        or: Us,
        recover_password: cs,
        send_recovery_email: ds,
        sending_recovery_email: gs,
        show_password: Cs,
        sign_up: ls,
        signing_up: us,
        site_url_label: Ns,
        site_url_link_text: vs,
        site_url_message: ys,
        site_url_placeholder: ws,
        site_url_submit: bs,
        site_url_title: hs,
        update_password: Ms,
        updating_password: ms
    }, Symbol.toStringTag, {
        value: "Module"
    })), Rs = "Entrar", Bs = "Sair", Gs = "Logado como", Vs = "Logado em", Hs = "Logando em", Zs = "Saindo", Ws = "Registrar", Fs = "Registrando", Js = "Esqueceu a senha?", qs = "Recuperar senha", Ks = "Enviar email de recupera\xe7\xe3o de senha", Xs = "Enviando email de recupera\xe7\xe3o de senha", $s = "Deixa pra l\xe1", el = "Atualizar senha", tl = "Atualizando senha", nl = "Complete seu registro", il = "Configura\xe7\xf5es de desenvolvimento", rl = "Limpar URL do localhost", ol = "Parece que voc\xea est\xe1 executando um servidor local. Informe-nos o URL do seu site Netlify.", al = "Insira o URL do seu site Netlify", sl = "URL do seu site Netlify", ll = "Configure a URL do seu site", ul = "Uma mensagem de confirma\xe7\xe3o foi enviada para o seu email, clique no link para continuar.", _l = "Enviamos um e-mail de recupera\xe7\xe3o para sua conta, siga o link para redefinir sua senha.", cl = "Seu email foi atualizado!", dl = "Ocorreu um erro ao verificar sua conta. Tente novamente ou entre em contato com um administrador.", gl = "Registros p\xfablicos est\xe3o desabilitados. Contate um administrador e pe\xe7a por um convite.", pl = "Nome", Ml = "Insira seu email", ml = "Insira seu nome", fl = "Email", hl = "Insira sua senha", vl = "Senha", yl = "Desenvolvido por Netlify", Nl = "Continue com", wl = "Mostrar senha", bl = "Ocultar senha", jl = {
        log_in: Rs,
        log_out: Bs,
        logged_in_as: Gs,
        logged_in: Vs,
        logging_in: Hs,
        logging_out: Zs,
        sign_up: Ws,
        signing_up: Fs,
        forgot_password: Js,
        recover_password: qs,
        send_recovery_email: Ks,
        sending_recovery_email: Xs,
        never_mind: $s,
        update_password: el,
        updating_password: tl,
        complete_your_signup: nl,
        site_url_title: il,
        site_url_link_text: rl,
        site_url_message: ol,
        site_url_label: al,
        site_url_placeholder: sl,
        site_url_submit: ll,
        message_confirm: ul,
        message_password_mail: _l,
        message_email_changed: cl,
        message_verfication_error: dl,
        message_signup_disabled: gl,
        form_name_placeholder: pl,
        form_email_label: Ml,
        form_name_label: ml,
        form_email_placeholder: fl,
        form_password_label: hl,
        form_password_placeholder: vl,
        coded_by: yl,
        continue_with: Nl,
        "No user found with this email": "Nenhum usu\xe1rio encontrado com esse email",
        "Invalid Password": "Senha inv\xe1lida",
        "Email not confirmed": "Email n\xe3o confirmado",
        "User not found": "Usu\xe1rio n\xe3o encontrado",
        or: "ou",
        show_password: wl,
        hide_password: bl
    }, Dl = Object.freeze(Object.defineProperty({
        __proto__: null,
        coded_by: yl,
        complete_your_signup: nl,
        continue_with: Nl,
        default: jl,
        forgot_password: Js,
        form_email_label: Ml,
        form_email_placeholder: fl,
        form_name_label: ml,
        form_name_placeholder: pl,
        form_password_label: hl,
        form_password_placeholder: vl,
        hide_password: bl,
        log_in: Rs,
        log_out: Bs,
        logged_in: Vs,
        logged_in_as: Gs,
        logging_in: Hs,
        logging_out: Zs,
        message_confirm: ul,
        message_email_changed: cl,
        message_password_mail: _l,
        message_signup_disabled: gl,
        message_verfication_error: dl,
        never_mind: $s,
        or: "ou",
        recover_password: qs,
        send_recovery_email: Ks,
        sending_recovery_email: Xs,
        show_password: wl,
        sign_up: Ws,
        signing_up: Fs,
        site_url_label: al,
        site_url_link_text: rl,
        site_url_message: ol,
        site_url_placeholder: sl,
        site_url_submit: ll,
        site_url_title: il,
        update_password: el,
        updating_password: tl
    }, Symbol.toStringTag, {
        value: "Module"
    })), zl = "Zaloguj si\u0119", Tl = "Wyloguj si\u0119", kl = "Zaloguj jako", xl = "Zalogowany", Il = "Logowanie", Ll = "Wylogowywanie", Ol = "Zarejestruj si\u0119", El = "Rejestracja", Sl = "Nie pami\u0119tasz has\u0142a?", Al = "Resetuj has\u0142o", Ul = "Wy\u015Blij link do resetowania has\u0142a", Cl = "Wysy\u0142anie linku do resetowania has\u0142a", Ql = "Nieistotne", Pl = "Zaktualizuj has\u0142o", Yl = "Aktualizowanie has\u0142o", Rl = "Doko\u0144cz rejestracj\u0119", Bl = "Ustawienia strony", Gl = "Usu\u0144 adres localhost", Vl = "Wygl\u0105da na to \u017Ce zosta\u0142 uruchomiony lokalny serwer. Wprowad\u017A adres Twojej strony na Netlify.", Hl = "Wprowadz adres strony na Netlify", Zl = "Adres Twojej strony na Netlify", Wl = "Ustaw adres strony", Fl = "Potwierdzenie zosta\u0142o wys\u0142ane na Tw\xf3j adres email. Kliknij w link w wiadomo\u015Bci aby kontunuowa\u0107.", Jl = "Wys\u0142ali\u015Bmy link resetuj\u0105cy has\u0142o na Tw\xf3j adres email. Klknij w link w wiadomo\u015Bci aby zresetowa\u0107 has\u0142o.", ql = "Tw\xf3j adres email zosta\u0142 zaktualizowany!", Kl = "Wyst\u0105pi\u0142 b\u0142\u0105d podczas weryfikcacji Twoje konta. Spr\xf3buj ponownie lub skontaktuj si\u0119 z administratorem,", Xl = "Publiczna rejestracja jest wy\u0142\u0105czona. Skontaktuj si\u0119 z administratorem by uzyska\u0107 zaproszenie.", $l = "Imi\u0119", eu = "Wprowad\u017A Tw\xf3j adres email", tu = "Wprowad\u017A Twoje imi\u0119", nu = "Email", iu = "Wprowad\u017A twoje has\u0142o", ru = "Has\u0142o", ou = "Coded by Netlify", au = "Kontynuuj z", su = "Poka\u017C has\u0142o", lu = "Ukryj has\u0142o", uu = {
        log_in: zl,
        log_out: Tl,
        logged_in_as: kl,
        logged_in: xl,
        logging_in: Il,
        logging_out: Ll,
        sign_up: Ol,
        signing_up: El,
        forgot_password: Sl,
        recover_password: Al,
        send_recovery_email: Ul,
        sending_recovery_email: Cl,
        never_mind: Ql,
        update_password: Pl,
        updating_password: Yl,
        complete_your_signup: Rl,
        site_url_title: Bl,
        site_url_link_text: Gl,
        site_url_message: Vl,
        site_url_label: Hl,
        site_url_placeholder: Zl,
        site_url_submit: Wl,
        message_confirm: Fl,
        message_password_mail: Jl,
        message_email_changed: ql,
        message_verfication_error: Kl,
        message_signup_disabled: Xl,
        form_name_placeholder: $l,
        form_email_label: eu,
        form_name_label: tu,
        form_email_placeholder: nu,
        form_password_label: iu,
        form_password_placeholder: ru,
        coded_by: ou,
        continue_with: au,
        "No user found with this email": "Nie znaleziono u\u017Cytkownika o tym adresie",
        "Invalid Password": "Has\u0142o nieprawid\u0142owe",
        "Email not confirmed": "Email nie zosta\u0142 potwierdzony",
        "User not found": "Nie znaleziono u\u017Cytkownika",
        or: "lub",
        show_password: su,
        hide_password: lu
    }, _u = Object.freeze(Object.defineProperty({
        __proto__: null,
        coded_by: ou,
        complete_your_signup: Rl,
        continue_with: au,
        default: uu,
        forgot_password: Sl,
        form_email_label: eu,
        form_email_placeholder: nu,
        form_name_label: tu,
        form_name_placeholder: $l,
        form_password_label: iu,
        form_password_placeholder: ru,
        hide_password: lu,
        log_in: zl,
        log_out: Tl,
        logged_in: xl,
        logged_in_as: kl,
        logging_in: Il,
        logging_out: Ll,
        message_confirm: Fl,
        message_email_changed: ql,
        message_password_mail: Jl,
        message_signup_disabled: Xl,
        message_verfication_error: Kl,
        never_mind: Ql,
        or: "lub",
        recover_password: Al,
        send_recovery_email: Ul,
        sending_recovery_email: Cl,
        show_password: su,
        sign_up: Ol,
        signing_up: El,
        site_url_label: Hl,
        site_url_link_text: Gl,
        site_url_message: Vl,
        site_url_placeholder: Zl,
        site_url_submit: Wl,
        site_url_title: Bl,
        update_password: Pl,
        updating_password: Yl
    }, Symbol.toStringTag, {
        value: "Module"
    })), cu = "P\u0159ihl\xe1sit se", du = "Odhl\xe1sit se", gu = "P\u0159ihl\xe1\u0161en jako", pu = "P\u0159ihl\xe1\u0161en\xfd u\u017Eivatel", Mu = "Prob\xedh\xe1 p\u0159ihl\xe1\u0161en\xed", mu = "Prob\xedh\xe1 odhl\xe1\u0161en\xed", fu = "Zaregistrovat se", hu = "Registrace", vu = "Zapomn\u011Bli jste heslo?", yu = "Obnovit heslo", Nu = "Odeslat e-mail pro obnoven\xed", wu = "Odes\xedl\xe1n\xed e-mailu pro obnoven\xed", bu = "Zp\u011Bt", ju = "Aktualizovat heslo", Du = "Aktualizace hesla", zu = "Dokon\u010Dete registraci", Tu = "Nastaven\xed v\xfdvoje", ku = "Vymazat URL localhost", xu = "Zd\xe1 se, \u017Ee pou\u017E\xedv\xe1te lok\xe1ln\xed server. Sd\u011Blte n\xe1m pros\xedm adresu URL sv\xe9ho Netlify serveru.", Iu = "Zadejte adresu URL sv\xe9ho serveru Netlify", Lu = "URL va\u0161eho Netlify serveru", Ou = "Nastavit adresu URL", Eu = "Na v\xe1\u0161 e-mail byl odesl\xe1n odkaz k potvrzen\xed registrace, pokra\u010Dujte kliknut\xedm na tento odkaz.", Su = "Zaslali jsme v\xe1m e-mail pro obnoven\xed hesla, heslo obnov\xedte kliknut\xedm na odkaz v e-mailu.", Au = "Va\u0161e e-mailov\xe1 adresa byla aktualizov\xe1na!", Uu = "P\u0159i ov\u011B\u0159ov\xe1n\xed va\u0161eho \xfa\u010Dtu do\u0161lo k chyb\u011B. Zkuste to pros\xedm znovu nebo kontaktujte spr\xe1vce.", Cu = "Registrace pro ve\u0159ejnost jsou zak\xe1z\xe1ny. Kontaktujte spr\xe1vce a po\u017E\xe1dejte o pozv\xe1nku.", Qu = "Jm\xe9no", Pu = "Zadejte sv\u016Fj e-mail", Yu = "Zadejte sv\xe9 jm\xe9no", Ru = "E-mail", Bu = "Zadejte sv\xe9 heslo", Gu = "Heslo", Vu = "Vytvo\u0159eno Netlify", Hu = "Pokra\u010Dovat p\u0159es", Zu = "nebo", Wu = "Zobrazit heslo", Fu = "Skr\xfdt heslo", Ju = {
        log_in: cu,
        log_out: du,
        logged_in_as: gu,
        logged_in: pu,
        logging_in: Mu,
        logging_out: mu,
        sign_up: fu,
        signing_up: hu,
        forgot_password: vu,
        recover_password: yu,
        send_recovery_email: Nu,
        sending_recovery_email: wu,
        never_mind: bu,
        update_password: ju,
        updated_password: Du,
        complete_your_signup: zu,
        site_url_title: Tu,
        site_url_link_text: ku,
        site_url_message: xu,
        site_url_label: Iu,
        site_url_placeholder: Lu,
        site_url_submit: Ou,
        message_confirm: Eu,
        message_password_mail: Su,
        message_email_changed: Au,
        message_verfication_error: Uu,
        message_signup_disabled: Cu,
        form_name_placeholder: Qu,
        form_email_label: Pu,
        form_name_label: Yu,
        form_email_placeholder: Ru,
        form_password_label: Bu,
        form_password_placeholder: Gu,
        coded_by: Vu,
        continue_with: Hu,
        "No user found with this email": "Nebyl nalezen \u017E\xe1dn\xfd u\u017Eivatel s t\xedmto e-mailem",
        "Invalid Password": "Neplatn\xe9 heslo",
        "Email not confirmed": "E-mail nebyl potvrzen",
        "User not found": "U\u017Eivatel nebyl nalezen",
        or: Zu,
        show_password: Wu,
        hide_password: Fu
    }, qu = Object.freeze(Object.defineProperty({
        __proto__: null,
        coded_by: Vu,
        complete_your_signup: zu,
        continue_with: Hu,
        default: Ju,
        forgot_password: vu,
        form_email_label: Pu,
        form_email_placeholder: Ru,
        form_name_label: Yu,
        form_name_placeholder: Qu,
        form_password_label: Bu,
        form_password_placeholder: Gu,
        hide_password: Fu,
        log_in: cu,
        log_out: du,
        logged_in: pu,
        logged_in_as: gu,
        logging_in: Mu,
        logging_out: mu,
        message_confirm: Eu,
        message_email_changed: Au,
        message_password_mail: Su,
        message_signup_disabled: Cu,
        message_verfication_error: Uu,
        never_mind: bu,
        or: Zu,
        recover_password: yu,
        send_recovery_email: Nu,
        sending_recovery_email: wu,
        show_password: Wu,
        sign_up: fu,
        signing_up: hu,
        site_url_label: Iu,
        site_url_link_text: ku,
        site_url_message: xu,
        site_url_placeholder: Lu,
        site_url_submit: Ou,
        site_url_title: Tu,
        update_password: ju,
        updated_password: Du
    }, Symbol.toStringTag, {
        value: "Module"
    })), Ku = "Prihl\xe1si\u0165 sa", Xu = "Odhl\xe1si\u0165 sa", $u = "Prihl\xe1sen\xfd ako", e_ = "Prihl\xe1sen\xfd u\u017E\xedvate\u013E", t_ = "Prebieha prihl\xe1senie", n_ = "Prebieha odhl\xe1senie", i_ = "Zaregistrova\u0165 sa", r_ = "Registr\xe1cia", o_ = "Zabudli ste heslo?", a_ = "Obnovi\u0165 heslo", s_ = "Odosla\u0165 e-mail pre obnovenie", l_ = "Odosielanie e-mailu pre obnovenie", u_ = "Nasp\xe4\u0165", __ = "Aktualizova\u0165 heslo", c_ = "Aktualiz\xe1cia hesla", d_ = "Dokon\u010Dite registr\xe1ciu", g_ = "Nastavenie v\xfdvoja", p_ = "Vymaza\u0165 URL localhost", M_ = "Zd\xe1 sa, \u017Ee pou\u017E\xedvate lok\xe1lny server. Pros\xedm, nastavte URL adresu svojho Netlify servera.", m_ = "Zadajte URL svojho Netlify servera", f_ = "URL v\xe1\u0161ho Netlify servera", h_ = "Nastavi\u0165 URL adresu", v_ = "Potvr\u010Fte registr\xe1ciu kliknut\xedm na odkaz v spr\xe1ve, ktor\xfa sme V\xe1m pr\xe1ve zaslali na v\xe1\u0161 email.", y_ = "Poslali sme v\xe1m e-mail pre obnovenie hesla, heslo obnov\xedte kliknut\xedm na odkaz v e-maile.", N_ = "Va\u0161a e-mailov\xe1 adresa bola aktualizovan\xe1!", w_ = "Pri overovan\xed v\xe1\u0161ho \xfa\u010Dtu do\u0161lo k chybe. Pros\xedm, sk\xfaste to znova alebo kontaktujte spr\xe1vcu.", b_ = "Registr\xe1cia pre verejnos\u0165 s\xfa zak\xe1zan\xe9. Kontaktujte spr\xe1vcu a po\u017Eiadajte o pozv\xe1nku.", j_ = "Meno", D_ = "Zadajte svoj e-mail", z_ = "Zadajte svoje meno", T_ = "E-mail", k_ = "Zadajte svoje heslo", x_ = "Heslo", I_ = "Vytvoren\xe9 Netlify", L_ = "Pokra\u010Dova\u0165 cez", O_ = "alebo", E_ = "Zobrazi\u0165 heslo", S_ = "Skry\u0165 heslo", A_ = {
        log_in: Ku,
        log_out: Xu,
        logged_in_as: $u,
        logged_in: e_,
        logging_in: t_,
        logging_out: n_,
        sign_up: i_,
        signing_up: r_,
        forgot_password: o_,
        recover_password: a_,
        send_recovery_email: s_,
        sending_recovery_email: l_,
        never_mind: u_,
        update_password: __,
        updated_password: c_,
        complete_your_signup: d_,
        site_url_title: g_,
        site_url_link_text: p_,
        site_url_message: M_,
        site_url_label: m_,
        site_url_placeholder: f_,
        site_url_submit: h_,
        message_confirm: v_,
        message_password_mail: y_,
        message_email_changed: N_,
        message_verfication_error: w_,
        message_signup_disabled: b_,
        form_name_placeholder: j_,
        form_email_label: D_,
        form_name_label: z_,
        form_email_placeholder: T_,
        form_password_label: k_,
        form_password_placeholder: x_,
        coded_by: I_,
        continue_with: L_,
        "No user found with this email": "Nebol n\xe1jden\xfd \u017Eiadny u\u017E\xedvate\u013E s t\xfdmto e-mailom",
        "Invalid Password": "Neplatn\xe9 heslo",
        "Email not confirmed": "E-mail nebol potvrden\xfd",
        "User not found": "Pou\u017E\xedvate\u013E nebol n\xe1jden\xfd",
        or: O_,
        show_password: E_,
        hide_password: S_
    }, U_ = Object.freeze(Object.defineProperty({
        __proto__: null,
        coded_by: I_,
        complete_your_signup: d_,
        continue_with: L_,
        default: A_,
        forgot_password: o_,
        form_email_label: D_,
        form_email_placeholder: T_,
        form_name_label: z_,
        form_name_placeholder: j_,
        form_password_label: k_,
        form_password_placeholder: x_,
        hide_password: S_,
        log_in: Ku,
        log_out: Xu,
        logged_in: e_,
        logged_in_as: $u,
        logging_in: t_,
        logging_out: n_,
        message_confirm: v_,
        message_email_changed: N_,
        message_password_mail: y_,
        message_signup_disabled: b_,
        message_verfication_error: w_,
        never_mind: u_,
        or: O_,
        recover_password: a_,
        send_recovery_email: s_,
        sending_recovery_email: l_,
        show_password: E_,
        sign_up: i_,
        signing_up: r_,
        site_url_label: m_,
        site_url_link_text: p_,
        site_url_message: M_,
        site_url_placeholder: f_,
        site_url_submit: h_,
        site_url_title: g_,
        update_password: __,
        updated_password: c_
    }, Symbol.toStringTag, {
        value: "Module"
    })), C_ = "\u0412\u043E\u0439\u0442\u0438", Q_ = "\u0412\u044B\u0439\u0442\u0438", P_ = "\u0412\u044B \u0432\u043E\u0448\u043B\u0438 \u043A\u0430\u043A", Y_ = "\u0412\u044B \u0432\u043E\u0448\u043B\u0438", R_ = "\u0412\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442\u0441\u044F \u0432\u0445\u043E\u0434", B_ = "\u0412\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442\u0441\u044F \u0432\u044B\u0445\u043E\u0434", G_ = "\u0417\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F", V_ = "\u0412\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442\u0441\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F", H_ = "\u0417\u0430\u0431\u044B\u043B\u0438 \u043F\u0430\u0440\u043E\u043B\u044C?", Z_ = "\u0412\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C", W_ = "\u041E\u0442\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u043F\u0438\u0441\u044C\u043C\u043E \u0434\u043B\u044F \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F", F_ = "\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0438\u0441\u044C\u043C\u0430 \u0434\u043B\u044F \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F", J_ = "\u041E\u0442\u043C\u0435\u043D\u0430", q_ = "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C", K_ = "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0430\u0440\u043E\u043B\u044F", X_ = "\u0417\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E", $_ = "\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0438", ec = "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u044B\u0439 URL", tc = "\u041F\u043E\u0445\u043E\u0436\u0435, \u0432\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0435 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0435\u0440\u0432\u0435\u0440. \u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0430\u0434\u0440\u0435\u0441 \u0412\u0430\u0448\u0435\u0433\u043E \u0441\u0430\u0439\u0442\u0430, \u0440\u0430\u0437\u043C\u0435\u0449\u0451\u043D\u043D\u043E\u0433\u043E \u043D\u0430 Netlify.", nc = "\u0410\u0434\u0440\u0435\u0441 \u0441\u0430\u0439\u0442\u0430 Netlify", ic = "URL \u0441\u0430\u0439\u0442\u0430 Netlify", rc = "\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u0438\u0442\u044C URL \u0441\u0430\u0439\u0442\u0430", oc = "\u041F\u0438\u0441\u044C\u043C\u043E \u0441 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u0435\u043C \u043E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043E \u043D\u0430 \u0412\u0430\u0448 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B. \u041D\u0430\u0436\u043C\u0438\u0442\u0435 \u043D\u0430 \u0441\u0441\u044B\u043B\u043A\u0443 \u0432 \u043F\u0438\u0441\u044C\u043C\u0435 \u0434\u043B\u044F \u043F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D\u0438\u044F.", ac = "\u041C\u044B \u043E\u0442\u043F\u0440\u0430\u0432\u0438\u043B\u0438 \u0412\u0430\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0435 \u043F\u0438\u0441\u044C\u043C\u043E \u0434\u043B\u044F \u0432\u043E\u0441\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u044F. \u041F\u0435\u0440\u0435\u0439\u0434\u0438\u0442\u0435 \u043F\u043E \u0441\u0441\u044B\u043B\u043A\u0435 \u0432 \u043F\u0438\u0441\u044C\u043C\u0435 \u0434\u043B\u044F \u0441\u0431\u0440\u043E\u0441\u0430 \u043F\u0430\u0440\u043E\u043B\u044F.", sc = "\u0412\u0430\u0448\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430 \u043E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0430!", lc = "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0430\u043A\u043A\u0430\u0443\u043D\u0442\u0430. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043F\u043E\u043F\u0440\u043E\u0431\u0443\u0439\u0442\u0435 \u0441\u043D\u043E\u0432\u0430 \u0438\u043B\u0438 \u0441\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u043E\u043C.", uc = "\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0437\u0430\u043A\u0440\u044B\u0442\u0430. \u0421\u0432\u044F\u0436\u0438\u0442\u0435\u0441\u044C \u0441 \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u043E\u043C, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u043F\u0440\u043E\u0441\u0438\u0442\u044C \u043F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0435.", _c = "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0412\u0430\u0448 \u0430\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B", cc = "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u0438\u043C\u044F", dc = "\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u0430\u044F \u043F\u043E\u0447\u0442\u0430", gc = "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043F\u0430\u0440\u043E\u043B\u044C", pc = "\u041F\u0430\u0440\u043E\u043B\u044C", Mc = "\u0421\u0434\u0435\u043B\u0430\u043D\u043E Netlify", mc = "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u0441", fc = "\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C", hc = "\u0421\u043A\u0440\u044B\u0442\u044C \u043F\u0430\u0440\u043E\u043B\u044C", vc = {
        log_in: C_,
        log_out: Q_,
        logged_in_as: P_,
        logged_in: Y_,
        logging_in: R_,
        logging_out: B_,
        sign_up: G_,
        signing_up: V_,
        forgot_password: H_,
        recover_password: Z_,
        send_recovery_email: W_,
        sending_recovery_email: F_,
        never_mind: J_,
        update_password: q_,
        updating_password: K_,
        complete_your_signup: X_,
        site_url_title: $_,
        site_url_link_text: ec,
        site_url_message: tc,
        site_url_label: nc,
        site_url_placeholder: ic,
        site_url_submit: rc,
        message_confirm: oc,
        message_password_mail: ac,
        message_email_changed: sc,
        message_verfication_error: lc,
        message_signup_disabled: uc,
        form_name_placeholder: "\u0418\u043C\u044F",
        form_email_label: _c,
        form_name_label: cc,
        form_email_placeholder: dc,
        form_password_label: gc,
        form_password_placeholder: pc,
        coded_by: Mc,
        "No user found with this email": "\u041D\u0435\u0442 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F \u0441 \u0442\u0430\u043A\u043E\u0439 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u043E\u0439",
        "Invalid Password": "\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0439 \u043F\u0430\u0440\u043E\u043B\u044C",
        continue_with: mc,
        "Email not confirmed": "\u0410\u0434\u0440\u0435\u0441 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u043E\u0439 \u043F\u043E\u0447\u0442\u044B \u043D\u0435 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0451\u043D",
        "User not found": "\u041F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D",
        or: "\u0438\u043B\u0438",
        show_password: fc,
        hide_password: hc
    }, yc = Object.freeze(Object.defineProperty({
        __proto__: null,
        coded_by: Mc,
        complete_your_signup: X_,
        continue_with: mc,
        default: vc,
        forgot_password: H_,
        form_email_label: _c,
        form_email_placeholder: dc,
        form_name_label: cc,
        form_name_placeholder: "\u0418\u043C\u044F",
        form_password_label: gc,
        form_password_placeholder: pc,
        hide_password: hc,
        log_in: C_,
        log_out: Q_,
        logged_in: Y_,
        logged_in_as: P_,
        logging_in: R_,
        logging_out: B_,
        message_confirm: oc,
        message_email_changed: sc,
        message_password_mail: ac,
        message_signup_disabled: uc,
        message_verfication_error: lc,
        never_mind: J_,
        or: "\u0438\u043B\u0438",
        recover_password: Z_,
        send_recovery_email: W_,
        sending_recovery_email: F_,
        show_password: fc,
        sign_up: G_,
        signing_up: V_,
        site_url_label: nc,
        site_url_link_text: ec,
        site_url_message: tc,
        site_url_placeholder: ic,
        site_url_submit: rc,
        site_url_title: $_,
        update_password: q_,
        updating_password: K_
    }, Symbol.toStringTag, {
        value: "Module"
    })), Nc = "Anmelden", wc = "Abmelden", bc = "Angemeldet als", jc = "Angemeldet", Dc = "Anmeldung l\xe4uft", zc = "Abmeldung l\xe4uft", Tc = "Registrieren", kc = "Registrierung l\xe4uft", xc = "Passwort vergessen?", Ic = "Passwort wiederherstellen", Lc = "Wiederherstellungsmail senden", Oc = "Wiederherstellungsmail wird gesendet", Ec = "Wann anders", Sc = "Passwort aktualisieren", Ac = "Passwort wird aktualisiert", Uc = "Vervollst\xe4ndige deine Registrierung", Cc = "Entwicklungseinstellungen", Qc = "Localhost URL l\xf6schen", Pc = "Sieht so aus als benutzt du einen local server. Bitte teile uns die URL deiner Netlify-Seite mit.", Yc = "Gib die URL deiner Netlify-Seite ein", Rc = "URL deiner Netlify-Seite", Bc = "URL festlegen", Gc = "Dir wurde eine Best\xe4tigungsmail geschickt, klicke den Link um fortzufahren.", Vc = "Wir haben dir einen Wiederherstellungsmail geschickt, folge dem Link um dein Passwort zur\xfcckzusetzen.", Hc = "Deine E-Mail-Adresse wurde aktualisiert!", Zc = "Beim Best\xe4tigen deines Accounts ist ein Fehler aufgetreten. Bitte versuche es nochmal oder kontaktiere den Administrator.", Wc = "\xd6ffentliche Registrierungen sind deaktiviert. Kontaktiere den Administrator und bitte um eine Einladung.", Fc = "Name", Jc = "Gib deine E-Mail ein", qc = "Gib deinen Namen ein", Kc = "E-Mail", Xc = "Gib dein Passwort ein", $c = "Passwort", ed = "Entwickelt von Netlify", td = "Weiter mit", nd = "oder", id = "Passwort anzeigen", rd = "Passwort verbergen", od = {
        log_in: Nc,
        log_out: wc,
        logged_in_as: bc,
        logged_in: jc,
        logging_in: Dc,
        logging_out: zc,
        sign_up: Tc,
        signing_up: kc,
        forgot_password: xc,
        recover_password: Ic,
        send_recovery_email: Lc,
        sending_recovery_email: Oc,
        never_mind: Ec,
        update_password: Sc,
        updating_password: Ac,
        complete_your_signup: Uc,
        site_url_title: Cc,
        site_url_link_text: Qc,
        site_url_message: Pc,
        site_url_label: Yc,
        site_url_placeholder: Rc,
        site_url_submit: Bc,
        message_confirm: Gc,
        message_password_mail: Vc,
        message_email_changed: Hc,
        message_verfication_error: Zc,
        message_signup_disabled: Wc,
        form_name_placeholder: Fc,
        form_email_label: Jc,
        form_name_label: qc,
        form_email_placeholder: Kc,
        form_password_label: Xc,
        form_password_placeholder: $c,
        coded_by: ed,
        continue_with: td,
        "No user found with this email": "Kein Nutzer mit dieser E-Mail gefunden",
        "Invalid Password": "Ung\xfcltiges Passwort",
        "Email not confirmed": "E-Mail nicht best\xe4tigt",
        "User not found": "Nutzer nicht gefunden",
        or: nd,
        show_password: id,
        hide_password: rd
    }, ad = Object.freeze(Object.defineProperty({
        __proto__: null,
        coded_by: ed,
        complete_your_signup: Uc,
        continue_with: td,
        default: od,
        forgot_password: xc,
        form_email_label: Jc,
        form_email_placeholder: Kc,
        form_name_label: qc,
        form_name_placeholder: Fc,
        form_password_label: Xc,
        form_password_placeholder: $c,
        hide_password: rd,
        log_in: Nc,
        log_out: wc,
        logged_in: jc,
        logged_in_as: bc,
        logging_in: Dc,
        logging_out: zc,
        message_confirm: Gc,
        message_email_changed: Hc,
        message_password_mail: Vc,
        message_signup_disabled: Wc,
        message_verfication_error: Zc,
        never_mind: Ec,
        or: nd,
        recover_password: Ic,
        send_recovery_email: Lc,
        sending_recovery_email: Oc,
        show_password: id,
        sign_up: Tc,
        signing_up: kc,
        site_url_label: Yc,
        site_url_link_text: Qc,
        site_url_message: Pc,
        site_url_placeholder: Rc,
        site_url_submit: Bc,
        site_url_title: Cc,
        update_password: Sc,
        updating_password: Ac
    }, Symbol.toStringTag, {
        value: "Module"
    })), sd = "Login", ld = "Logout", ud = "Connesso come", _d = "Connesso", cd = "Connessione", dd = "Disconnessione", gd = "Registrati", pd = "Registrazione", Md = "Password dimenticata?", md = "Recupera password", fd = "Invia email di recupero", hd = "Invio email di recupero", vd = "Annulla", yd = "Aggiorna password", Nd = "Aggiornamento password", wd = "Completa la registrazione", bd = "Impostazioni di sviluppo", jd = "Elimina l'URL localhost", Dd = "Esecuzione su server locale rilevata. Inserisci l'URL del tuo sito Netlify.", zd = "Inserisci l'URL del tuo sito Netlify", Td = "URL del tuo sito Netlify", kd = "Imposta URL", xd = "Un messaggio di conferma \xe8 stato inviato alla tua email, clicca sul link al suo interno per continuare.", Id = "Abbiamo inviato un email di recupero al tuo account, clicca sul link al suo interno per reimpostare la password.", Ld = "Indirizzo email aggiornato!", Od = "Errore durante la verifica del tuo account. Riprova pi\xf9 tardi o contatta un amministratore.", Ed = "La registrazione pubblica \xe8 disabilitata. Contatta un amministratore per chiedere un invito.", Sd = "Nome", Ad = "Inserisci la tua email", Ud = "Inserisci il tuo nome", Cd = "Email", Qd = "Inserisci password", Pd = "Password", Yd = "Coded by Netlify", Rd = "Continua con", Bd = "Mostra password", Gd = "Nascondi password", Vd = {
        log_in: sd,
        log_out: ld,
        logged_in_as: ud,
        logged_in: _d,
        logging_in: cd,
        logging_out: dd,
        sign_up: gd,
        signing_up: pd,
        forgot_password: Md,
        recover_password: md,
        send_recovery_email: fd,
        sending_recovery_email: hd,
        never_mind: vd,
        update_password: yd,
        updating_password: Nd,
        complete_your_signup: wd,
        site_url_title: bd,
        site_url_link_text: jd,
        site_url_message: Dd,
        site_url_label: zd,
        site_url_placeholder: Td,
        site_url_submit: kd,
        message_confirm: xd,
        message_password_mail: Id,
        message_email_changed: Ld,
        message_verfication_error: Od,
        message_signup_disabled: Ed,
        form_name_placeholder: Sd,
        form_email_label: Ad,
        form_name_label: Ud,
        form_email_placeholder: Cd,
        form_password_label: Qd,
        form_password_placeholder: Pd,
        coded_by: Yd,
        continue_with: Rd,
        "No user found with this email": "Nessun utente trovato per questa email",
        "Invalid Password": "Password non valida",
        "Email not confirmed": "Email non confermata",
        "User not found": "Utente non trovato",
        or: "o",
        show_password: Bd,
        hide_password: Gd
    }, Hd = Object.freeze(Object.defineProperty({
        __proto__: null,
        coded_by: Yd,
        complete_your_signup: wd,
        continue_with: Rd,
        default: Vd,
        forgot_password: Md,
        form_email_label: Ad,
        form_email_placeholder: Cd,
        form_name_label: Ud,
        form_name_placeholder: Sd,
        form_password_label: Qd,
        form_password_placeholder: Pd,
        hide_password: Gd,
        log_in: sd,
        log_out: ld,
        logged_in: _d,
        logged_in_as: ud,
        logging_in: cd,
        logging_out: dd,
        message_confirm: xd,
        message_email_changed: Ld,
        message_password_mail: Id,
        message_signup_disabled: Ed,
        message_verfication_error: Od,
        never_mind: vd,
        or: "o",
        recover_password: md,
        send_recovery_email: fd,
        sending_recovery_email: hd,
        show_password: Bd,
        sign_up: gd,
        signing_up: pd,
        site_url_label: zd,
        site_url_link_text: jd,
        site_url_message: Dd,
        site_url_placeholder: Td,
        site_url_submit: kd,
        site_url_title: bd,
        update_password: yd,
        updating_password: Nd
    }, Symbol.toStringTag, {
        value: "Module"
    })), Zd = "\u0633\u062C\u0644 \u062F\u062E\u0648\u0644", Wd = "\u0633\u062C\u0644 \u062E\u0631\u0648\u062C", Fd = "\u0645\u0633\u062C\u0644 \u0643\u0640", Jd = "\u0645\u0633\u062C\u0644", qd = "\u0641\u064A \u0637\u0648\u0631 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062F\u062E\u0648\u0644", Kd = "\u0641\u064A \u0637\u0648\u0631 \u062A\u0633\u062C\u064A\u0644 \u0627\u0644\u062E\u0631\u0648\u062C", Xd = "\u0627\u0634\u062A\u0631\u0643", $d = "\u0641\u064A \u0637\u0648\u0631 \u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643", eg = "\u0646\u0633\u064A\u062A \u0643\u0644\u0645\u0629 \u0627\u0644\u0633\u0631\u061F", tg = "\u0627\u0633\u062A\u0639\u062F \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631", ng = "\u0625\u0631\u0633\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0644\u0627\u0633\u062A\u0631\u062F\u0627\u062F", ig = "\u0641\u064A \u0637\u0648\u0631 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0644\u0644\u0627\u0633\u062A\u0631\u062F\u0627\u062F", rg = "\u0627\u0644\u0639\u0648\u062F\u0629", og = "\u062A\u062D\u062F\u064A\u062B \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631", ag = "\u0641\u064A \u0637\u0648\u0631 \u062A\u062D\u062F\u064A\u062B \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631", sg = "\u0623\u0643\u0645\u0644 \u0627\u0634\u062A\u0631\u0627\u0643\u0643", lg = "\u0625\u0639\u062F\u0627\u062F\u0627\u062A \u0627\u0644\u062A\u0637\u0648\u064A\u0631", ug = "\u0627\u0645\u0633\u062D \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0627\u0628\u0637 \u0644\u0644\u0645\u0636\u064A\u0641 \u0627\u0644\u0645\u062D\u0644\u064A", _g = "\u064A\u0628\u062F\u0648 \u0623\u0646\u0643 \u062A\u0642\u0648\u0645 \u0628\u062A\u0634\u063A\u064A\u0644 \u062E\u0627\u062F\u0645 \u0645\u062D\u0644\u064A. \u064A\u0631\u062C\u0649 \u0625\u0639\u0644\u0627\u0645\u0646\u0627 \u0628\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0627\u0628\u0637 \u0644\u0645\u0648\u0642\u0639 \u0646\u062A\u0644\u064A\u0641\u0627\u064A \u0627\u0644\u062E\u0627\u0635 \u0628\u0643.", cg = "\u0623\u062F\u062E\u0644 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0627\u0628\u0637 \u0644\u0645\u0648\u0642\u0639 \u0646\u062A\u0644\u064A\u0641\u0627\u064A \u0627\u0644\u062E\u0627\u0635 \u0628\u0643", dg = "\u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0627\u0628\u0637 \u0644\u0645\u0648\u0642\u0639 \u0646\u062A\u0644\u064A\u0641\u0627\u064A \u0627\u0644\u062E\u0627\u0635 \u0628\u0643", gg = "\u0639\u064A\u0646 \u0639\u0646\u0648\u0627\u0646 \u0627\u0644\u0631\u0627\u0628\u0637 \u0644\u0644\u0645\u0648\u0642\u0639", pg = "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0631\u0633\u0627\u0644\u0629 \u062A\u0623\u0643\u064A\u062F \u0625\u0644\u0649 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u060C \u0627\u0646\u0642\u0631 \u0641\u0648\u0642 \u0627\u0644\u0631\u0627\u0628\u0637 \u0647\u0646\u0627\u0643 \u0644\u0644\u0645\u062A\u0627\u0628\u0639\u0629.", Mg = "\u0644\u0642\u062F \u0623\u0631\u0633\u0644\u0646\u0627 \u0628\u0631\u064A\u062F\u064B\u0627 \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A\u064B\u0627 \u0644\u0627\u0633\u062A\u0631\u062F\u0627\u062F \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0625\u0644\u0649 \u062D\u0633\u0627\u0628\u0643\u060C \u0627\u062A\u0628\u0639 \u0627\u0644\u0631\u0627\u0628\u0637 \u0627\u0644\u0645\u0648\u062C\u0648\u062F \u0647\u0646\u0627\u0643 \u0644\u0625\u0639\u0627\u062F\u0629 \u062A\u0639\u064A\u064A\u0646 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643.", mg = "\u0644\u0642\u062F \u062A\u0645 \u062A\u062D\u062F\u064A\u062B \u0639\u0646\u0648\u0627\u0646 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A!", fg = "\u062D\u062F\u062B \u062E\u0637\u0623 \u0641\u064A \u0627\u0644\u062A\u062D\u0642\u0642 \u0645\u0646 \u062D\u0633\u0627\u0628\u0643. \u0627\u0644\u0631\u062C\u0627\u0621 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0623\u0648 \u0627\u0644\u0627\u062A\u0635\u0627\u0644 \u0628\u0627\u0644\u0645\u0633\u0624\u0648\u0644.", hg = "\u0627\u0644\u0627\u0634\u062A\u0631\u0627\u0643\u0627\u062A \u0627\u0644\u0639\u0627\u0645\u0629 \u0645\u0639\u0637\u0644\u0629. \u0627\u062A\u0635\u0644 \u0628\u0627\u0644\u0645\u0633\u0624\u0648\u0644 \u0648\u0627\u0637\u0644\u0628 \u062F\u0639\u0648\u0629.", vg = "\u0627\u0644\u0625\u0633\u0645", yg = "\u0623\u062F\u062E\u0644 \u0628\u0631\u064A\u062F\u0643 \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A", Ng = "\u0623\u062F\u062E\u0644 \u0623\u0633\u0645\u0643", wg = "\u0627\u0644\u0628\u0631\u064A\u062F \u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A", bg = "\u0623\u062F\u062E\u0644 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u0627\u0644\u062E\u0627\u0635\u0629 \u0628\u0643", jg = "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631", Dg = "\u0645\u0628\u0631\u0645\u062C \u0628\u0648\u0627\u0633\u0637\u0629 \u0646\u062A\u0644\u064A\u0641\u0627\u064A", zg = "\u0625\u0633\u062A\u0645\u0631 \u0645\u0639", Tg = "\u0625\u0638\u0647\u0627\u0631 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631", kg = "\u0625\u062E\u0641\u0627\u0621 \u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631", xg = {
        log_in: Zd,
        log_out: Wd,
        logged_in_as: Fd,
        logged_in: Jd,
        logging_in: qd,
        logging_out: Kd,
        sign_up: Xd,
        signing_up: $d,
        forgot_password: eg,
        recover_password: tg,
        send_recovery_email: ng,
        sending_recovery_email: ig,
        never_mind: rg,
        update_password: og,
        updating_password: ag,
        complete_your_signup: sg,
        site_url_title: lg,
        site_url_link_text: ug,
        site_url_message: _g,
        site_url_label: cg,
        site_url_placeholder: dg,
        site_url_submit: gg,
        message_confirm: pg,
        message_password_mail: Mg,
        message_email_changed: mg,
        message_verfication_error: fg,
        message_signup_disabled: hg,
        form_name_placeholder: vg,
        form_email_label: yg,
        form_name_label: Ng,
        form_email_placeholder: wg,
        form_password_label: bg,
        form_password_placeholder: jg,
        coded_by: Dg,
        continue_with: zg,
        "No user found with this email": "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0645\u0633\u062A\u062E\u062F\u0645 \u0644\u062F\u064A\u0647 \u0647\u0630\u0627 \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        "Invalid Password": "\u0643\u0644\u0645\u0629 \u0627\u0644\u0645\u0631\u0648\u0631 \u063A\u064A\u0631 \u0635\u062D\u064A\u062D\u0629",
        "Email not confirmed": "\u0644\u0645 \u064A\u062A\u0645 \u062A\u0623\u0643\u064A\u062F \u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A",
        "User not found": "\u0644\u0645 \u064A\u062A\u0645 \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u0645\u0633\u062A\u062E\u062F\u0645",
        or: "\u0623\u0648",
        show_password: Tg,
        hide_password: kg
    }, Ig = Object.freeze(Object.defineProperty({
        __proto__: null,
        coded_by: Dg,
        complete_your_signup: sg,
        continue_with: zg,
        default: xg,
        forgot_password: eg,
        form_email_label: yg,
        form_email_placeholder: wg,
        form_name_label: Ng,
        form_name_placeholder: vg,
        form_password_label: bg,
        form_password_placeholder: jg,
        hide_password: kg,
        log_in: Zd,
        log_out: Wd,
        logged_in: Jd,
        logged_in_as: Fd,
        logging_in: qd,
        logging_out: Kd,
        message_confirm: pg,
        message_email_changed: mg,
        message_password_mail: Mg,
        message_signup_disabled: hg,
        message_verfication_error: fg,
        never_mind: rg,
        or: "\u0623\u0648",
        recover_password: tg,
        send_recovery_email: ng,
        sending_recovery_email: ig,
        show_password: Tg,
        sign_up: Xd,
        signing_up: $d,
        site_url_label: cg,
        site_url_link_text: ug,
        site_url_message: _g,
        site_url_placeholder: dg,
        site_url_submit: gg,
        site_url_title: lg,
        update_password: og,
        updating_password: ag
    }, Symbol.toStringTag, {
        value: "Module"
    })), Lg = "\u5DF2\u767B\u5F55\u8D26\u53F7: ", Og = "\u6B63\u5728\u767B\u5F55", Eg = "\u6B63\u5728\u6CE8\u518C", Sg = "\u5FD8\u8BB0\u5BC6\u7801?", Ag = "\u6062\u590D\u5BC6\u7801", Ug = "\u53D1\u9001\u6062\u590D\u90AE\u4EF6", Cg = "\u6B63\u5728\u53D1\u9001\u6062\u590D\u90AE\u4EF6", Qg = "\u66F4\u65B0\u5BC6\u7801", Pg = "\u6B63\u5728\u66F4\u65B0\u5BC6\u7801", Yg = "\u5B8C\u6210\u6CE8\u518C", Rg = "\u5F00\u53D1\u6A21\u5F0F\u8BBE\u7F6E", Bg = "\u6E05\u7406 localhost URL", Gg = "\u4F60\u4F3C\u4E4E\u6B63\u5728\u8FD0\u884C\u672C\u5730\u670D\u52A1. \u8BF7\u544A\u8BC9\u6211\u4EEC\u4F60\u7684 Netlify \u7F51\u7AD9\u7684 URL.", Vg = "\u8F93\u5165 Netlify \u7F51\u7AD9\u7684 URL", Hg = "Netlify \u7F51\u7AD9\u7684 URL", Zg = "\u8BBE\u7F6E\u7F51\u7AD9 URL", Wg = "\u5DF2\u5411\u60A8\u7684\u90AE\u7BB1\u53D1\u9001\u786E\u8BA4\u90AE\u4EF6\uFF0C\u8BF7\u524D\u5F80\u90AE\u7BB1\u67E5\u770B.", Fg = "\u6211\u4EEC\u5DF2\u5411\u60A8\u7684\u5E10\u6237\u53D1\u9001\u4E86\u6062\u590D\u90AE\u4EF6\uFF0C\u8BF7\u70B9\u51FB\u6B64\u5904\u7684\u94FE\u63A5\u91CD\u7F6E\u60A8\u7684\u5BC6\u7801.", Jg = "\u60A8\u7684\u7535\u5B50\u90AE\u4EF6\u5730\u5740\u5DF2\u66F4\u65B0!", qg = "\u9A8C\u8BC1\u60A8\u7684\u5E10\u6237\u65F6\u51FA\u9519\u3002\u8BF7\u91CD\u8BD5\u6216\u8054\u7CFB\u7BA1\u7406\u5458", Kg = "\u516C\u5F00\u6CE8\u518C\u5DF2\u5173\u95ED. \u8BF7\u8054\u7CFB\u7BA1\u7406\u5458\u83B7\u53D6\u9080\u8BF7\u94FE\u63A5.", Xg = "\u8F93\u5165\u90AE\u7BB1", $g = "\u8F93\u5165\u7528\u6237\u540D", ep = "\u8F93\u5165\u5BC6\u7801", tp = "\u7531 Netlify \u5F3A\u529B\u9A71\u52A8", np = "\u7EE7\u7EED\u767B\u5F55", ip = "\u663E\u793A\u5BC6\u7801", rp = "\u9690\u85CF\u5BC6\u7801", op = {
        log_in: "\u767B\u5F55",
        log_out: "\u6CE8\u9500",
        logged_in_as: Lg,
        logged_in: "\u5DF2\u767B\u5F55",
        logging_in: Og,
        logging_out: "\u5DF2\u9000\u51FA",
        sign_up: "\u6CE8\u518C",
        signing_up: Eg,
        forgot_password: Sg,
        recover_password: Ag,
        send_recovery_email: Ug,
        sending_recovery_email: Cg,
        never_mind: "\u5FFD\u7565",
        update_password: Qg,
        updating_password: Pg,
        complete_your_signup: Yg,
        site_url_title: Rg,
        site_url_link_text: Bg,
        site_url_message: Gg,
        site_url_label: Vg,
        site_url_placeholder: Hg,
        site_url_submit: Zg,
        message_confirm: Wg,
        message_password_mail: Fg,
        message_email_changed: Jg,
        message_verfication_error: qg,
        message_signup_disabled: Kg,
        form_name_placeholder: "\u7528\u6237\u540D",
        form_email_label: Xg,
        form_name_label: $g,
        form_email_placeholder: "\u90AE\u7BB1",
        form_password_label: ep,
        form_password_placeholder: "\u5BC6\u7801",
        coded_by: tp,
        continue_with: np,
        "No user found with this email": "\u672A\u627E\u5230\u8BE5\u90AE\u7BB1\u7684\u7528\u6237",
        "Invalid Password": "\u65E0\u6548\u5BC6\u7801",
        "Email not confirmed": "\u90AE\u7BB1\u672A\u786E\u8BA4",
        "User not found": "\u7528\u6237\u672A\u627E\u5230",
        or: "\u6216",
        show_password: ip,
        hide_password: rp
    }, ap = Object.freeze(Object.defineProperty({
        __proto__: null,
        coded_by: tp,
        complete_your_signup: Yg,
        continue_with: np,
        default: op,
        forgot_password: Sg,
        form_email_label: Xg,
        form_email_placeholder: "\u90AE\u7BB1",
        form_name_label: $g,
        form_name_placeholder: "\u7528\u6237\u540D",
        form_password_label: ep,
        form_password_placeholder: "\u5BC6\u7801",
        hide_password: rp,
        log_in: "\u767B\u5F55",
        log_out: "\u6CE8\u9500",
        logged_in: "\u5DF2\u767B\u5F55",
        logged_in_as: Lg,
        logging_in: Og,
        logging_out: "\u5DF2\u9000\u51FA",
        message_confirm: Wg,
        message_email_changed: Jg,
        message_password_mail: Fg,
        message_signup_disabled: Kg,
        message_verfication_error: qg,
        never_mind: "\u5FFD\u7565",
        or: "\u6216",
        recover_password: Ag,
        send_recovery_email: Ug,
        sending_recovery_email: Cg,
        show_password: ip,
        sign_up: "\u6CE8\u518C",
        signing_up: Eg,
        site_url_label: Vg,
        site_url_link_text: Bg,
        site_url_message: Gg,
        site_url_placeholder: Hg,
        site_url_submit: Zg,
        site_url_title: Rg,
        update_password: Qg,
        updating_password: Pg
    }, Symbol.toStringTag, {
        value: "Module"
    })), sp = "Inloggen", lp = "Uitloggen", up = "Ingelogd als", _p = "Ingelogd", cp = "Inloggen...", dp = "Uitloggen...", gp = "Registreren", pp = "Registreren...", Mp = "Wachtwoord vergeten?", mp = "Wachtwoord herstellen", fp = "Herstelmail verzenden", hp = "Herstelmail wordt verzonden", vp = "Laat maar", yp = "Wachtwoord wijzigen", Np = "Wachtwoord wordt gewijzigd", wp = "Inschrijving voltooien", bp = "Developer Instellingen", jp = "Wis localhost URL", Dp = "Het lijkt erop dat je een lokale server draait. Vul de URL van je Netlify Website in.", zp = "Vul je Netlify Website URL in", Tp = "URL van je Netlify Website", kp = "Stel de URL in", xp = "Er is een bevestigingsmail verzonden. Klik op de link in je mail om verder te gaan.", Ip = "We hebben een herstelmail verzonden, klik op de link in je mail om je wachtwoord te herstellen.", Lp = "Je e-mailadres is veranderd!", Op = "Er ging iets mis bij het verifi\xebren van je account. Probeer opnieuw, of neem contact op met een beheerder.", Ep = "Publieke inschrijvingen zijn uitgeschakeld. Neem contact op met een beheerder en vraag om een uitnodiging.", Sp = "Naam", Ap = "Vul je e-mailadres in", Up = "Vul je naam in", Cp = "E-mail", Qp = "Vul je wachtwoord in", Pp = "Wachtwoord", Yp = "Gemaakt door Netlify", Rp = "Verdergaan met", Bp = "Wachtwoord tonen", Gp = "Wachtwoord verbergen", Vp = {
        log_in: sp,
        log_out: lp,
        logged_in_as: up,
        logged_in: _p,
        logging_in: cp,
        logging_out: dp,
        sign_up: gp,
        signing_up: pp,
        forgot_password: Mp,
        recover_password: mp,
        send_recovery_email: fp,
        sending_recovery_email: hp,
        never_mind: vp,
        update_password: yp,
        updating_password: Np,
        complete_your_signup: wp,
        site_url_title: bp,
        site_url_link_text: jp,
        site_url_message: Dp,
        site_url_label: zp,
        site_url_placeholder: Tp,
        site_url_submit: kp,
        message_confirm: xp,
        message_password_mail: Ip,
        message_email_changed: Lp,
        message_verfication_error: Op,
        message_signup_disabled: Ep,
        form_name_placeholder: Sp,
        form_email_label: Ap,
        form_name_label: Up,
        form_email_placeholder: Cp,
        form_password_label: Qp,
        form_password_placeholder: Pp,
        coded_by: Yp,
        continue_with: Rp,
        "No user found with this email": "Er is geen gebruiker gevonden met dit e-mailadres",
        "Invalid Password": "Ongeldig Wachtwoord",
        "Email not confirmed": "E-mailadres niet bevestigd",
        "User not found": "Gebruiker niet gevonden",
        or: "of",
        show_password: Bp,
        hide_password: Gp
    }, Hp = Object.freeze(Object.defineProperty({
        __proto__: null,
        coded_by: Yp,
        complete_your_signup: wp,
        continue_with: Rp,
        default: Vp,
        forgot_password: Mp,
        form_email_label: Ap,
        form_email_placeholder: Cp,
        form_name_label: Up,
        form_name_placeholder: Sp,
        form_password_label: Qp,
        form_password_placeholder: Pp,
        hide_password: Gp,
        log_in: sp,
        log_out: lp,
        logged_in: _p,
        logged_in_as: up,
        logging_in: cp,
        logging_out: dp,
        message_confirm: xp,
        message_email_changed: Lp,
        message_password_mail: Ip,
        message_signup_disabled: Ep,
        message_verfication_error: Op,
        never_mind: vp,
        or: "of",
        recover_password: mp,
        send_recovery_email: fp,
        sending_recovery_email: hp,
        show_password: Bp,
        sign_up: gp,
        signing_up: pp,
        site_url_label: zp,
        site_url_link_text: jp,
        site_url_message: Dp,
        site_url_placeholder: Tp,
        site_url_submit: kp,
        site_url_title: bp,
        update_password: yp,
        updating_password: Np
    }, Symbol.toStringTag, {
        value: "Module"
    })), Zp = "Logga in", Wp = "Logga ut", Fp = "Inloggad som", Jp = "Inloggad", qp = "Loggar in", Kp = "Loggar ut", Xp = "Registrera", $p = "Registrerar", eM = "Gl\xf6mt l\xf6senord?", tM = "\xc5terst\xe4ll l\xf6senord", nM = "Skicka \xe5terst\xe4llningsmejl", iM = "Skickar \xe5terst\xe4llningsmejl", rM = "Gl\xf6m det", oM = "Uppdatera l\xf6senord", aM = "Uppdaterar l\xf6senord", sM = "Slutf\xf6r registrering", lM = "Inst\xe4llningar f\xf6r utvecklare", uM = "Rensa localhost URL", _M = "Det ser ut som att du k\xf6r en lokal server. V\xe4nligen ange din Netlify sajt URL.", cM = "Ange din Netlify sajt URL", dM = "URL f\xf6r din Netlify sajt", gM = "S\xe4tt sajt-URL", pM = "Ett bekr\xe4ftelsemejl har skickats till din epost, klicka p\xe5 l\xe4nken i mejlet f\xf6r att forts\xe4tta.", MM = "Vi har skickat ett \xe5terst\xe4llningsmejl till ditt konto, klicka p\xe5 l\xe4nken i mejlet f\xf6r att \xe5terst\xe4lla l\xf6senordet.", mM = "Din epostadress har uppdaterats!", fM = "Ett fel intr\xe4ffade vid verifieringen av ditt konto. V\xe4nligen f\xf6rs\xf6k igen eller kontakta en administrat\xf6r.", hM = "Registreringen \xe4r l\xe5st. Kontakta en administrat\xf6r f\xf6r att be om en inbjudan.", vM = "Namn", yM = "Ange din epost", NM = "Ange ditt namn", wM = "Epost", bM = "Ange l\xf6senord", jM = "L\xf6senord", DM = "Utvecklad av Netlify", zM = "Forts\xe4tt med", TM = "eller", kM = "Visa l\xf6senord", xM = "D\xf6lj l\xf6senord", IM = {
        log_in: Zp,
        log_out: Wp,
        logged_in_as: Fp,
        logged_in: Jp,
        logging_in: qp,
        logging_out: Kp,
        sign_up: Xp,
        signing_up: $p,
        forgot_password: eM,
        recover_password: tM,
        send_recovery_email: nM,
        sending_recovery_email: iM,
        never_mind: rM,
        update_password: oM,
        updating_password: aM,
        complete_your_signup: sM,
        site_url_title: lM,
        site_url_link_text: uM,
        site_url_message: _M,
        site_url_label: cM,
        site_url_placeholder: dM,
        site_url_submit: gM,
        message_confirm: pM,
        message_password_mail: MM,
        message_email_changed: mM,
        message_verfication_error: fM,
        message_signup_disabled: hM,
        form_name_placeholder: vM,
        form_email_label: yM,
        form_name_label: NM,
        form_email_placeholder: wM,
        form_password_label: bM,
        form_password_placeholder: jM,
        coded_by: DM,
        continue_with: zM,
        "No user found with this email": "Ingen anv\xe4ndare hittades med denna epost",
        "Invalid Password": "Felaktigt l\xf6senord",
        "Email not confirmed": "Din epost \xe4r inte verifierad",
        "User not found": "Anv\xe4ndaren hittades inte",
        or: TM,
        show_password: kM,
        hide_password: xM
    }, LM = Object.freeze(Object.defineProperty({
        __proto__: null,
        coded_by: DM,
        complete_your_signup: sM,
        continue_with: zM,
        default: IM,
        forgot_password: eM,
        form_email_label: yM,
        form_email_placeholder: wM,
        form_name_label: NM,
        form_name_placeholder: vM,
        form_password_label: bM,
        form_password_placeholder: jM,
        hide_password: xM,
        log_in: Zp,
        log_out: Wp,
        logged_in: Jp,
        logged_in_as: Fp,
        logging_in: qp,
        logging_out: Kp,
        message_confirm: pM,
        message_email_changed: mM,
        message_password_mail: MM,
        message_signup_disabled: hM,
        message_verfication_error: fM,
        never_mind: rM,
        or: TM,
        recover_password: tM,
        send_recovery_email: nM,
        sending_recovery_email: iM,
        show_password: kM,
        sign_up: Xp,
        signing_up: $p,
        site_url_label: cM,
        site_url_link_text: uM,
        site_url_message: _M,
        site_url_placeholder: dM,
        site_url_submit: gM,
        site_url_title: lM,
        update_password: oM,
        updating_password: aM
    }, Symbol.toStringTag, {
        value: "Module"
    })), OM = "Ingia", EM = "Toka", SM = "Umeingia kama", AM = "Umeingia", UM = "Unaingia", CM = "Unatoka", QM = "Jisajili", PM = "Unajisajili", YM = "Umesahau nenosiri?", RM = "Pata nenosiri", BM = "Tuma barua pepe ya kurejesha akaunti", GM = "Barua pepe ya kurejesha akaunti inatumwa", VM = "Usijali", HM = "Sasisha nenosiri", ZM = "Nenosiri inasasishwa", WM = "Kamilisha usajili wako", FM = "Mpangilio wa Usanidi", JM = "Safisha kiungo cha tovuti", qM = "Inaonekana kwamba unatumia seva ya ndani. Tafadhali tujulishe anwani ya tovuti yako ya Netlify.", KM = "Andika anwani ya tovuti yako ya Netlify", XM = "Anwani ya tovuti yako ya Netlify", $M = "Weka anwani ya tovuti", em = "Ujumbe wa uthibitisho ulitumwa kwa barua pepe yako, bonyeza kiungo hapo ili kuendelea.", tm = "Tumetuma barua pepe ya kurejesha akaunti yako, fuata kiunga hapo ili kuweka upya nenosiri yako.", nm = "Anwani yako ya barua pepe imesasishwa!", im = "Kulikuwa na hitilafu katika kuthibitisha akaunti yako. Tafadhali jaribu tena au wasiliana na msimamizi.", rm = "Usajili wa umma umezimwa. Wasiliana na msimamizi na uombe mwaliko.", om = "Jina", am = "Andika barua pepe yako", sm = "Andika jina lako", lm = "Barua pepe", um = "Andika nenosiri yako", _m = "Nenosiri", cm = "Imeandikwa na Netlify", dm = "Endelea na", gm = "Onyesha nenosiri", pm = "Ficha nenosiri", Mm = {
        log_in: OM,
        log_out: EM,
        logged_in_as: SM,
        logged_in: AM,
        logging_in: UM,
        logging_out: CM,
        sign_up: QM,
        signing_up: PM,
        forgot_password: YM,
        recover_password: RM,
        send_recovery_email: BM,
        sending_recovery_email: GM,
        never_mind: VM,
        update_password: HM,
        updating_password: ZM,
        complete_your_signup: WM,
        site_url_title: FM,
        site_url_link_text: JM,
        site_url_message: qM,
        site_url_label: KM,
        site_url_placeholder: XM,
        site_url_submit: $M,
        message_confirm: em,
        message_password_mail: tm,
        message_email_changed: nm,
        message_verfication_error: im,
        message_signup_disabled: rm,
        form_name_placeholder: om,
        form_email_label: am,
        form_name_label: sm,
        form_email_placeholder: lm,
        form_password_label: um,
        form_password_placeholder: _m,
        coded_by: cm,
        continue_with: dm,
        "No user found with this email": "Hakuna mtumiaji aliyepatikana na barua pepe hii",
        "Invalid Password": "Nenosiri batili",
        "Email not confirmed": "Barua pepe haijathibitishwa",
        "User not found": "Mtumiaji wa akaunti hapatikani",
        or: "au",
        show_password: gm,
        hide_password: pm
    }, mm = Object.freeze(Object.defineProperty({
        __proto__: null,
        coded_by: cm,
        complete_your_signup: WM,
        continue_with: dm,
        default: Mm,
        forgot_password: YM,
        form_email_label: am,
        form_email_placeholder: lm,
        form_name_label: sm,
        form_name_placeholder: om,
        form_password_label: um,
        form_password_placeholder: _m,
        hide_password: pm,
        log_in: OM,
        log_out: EM,
        logged_in: AM,
        logged_in_as: SM,
        logging_in: UM,
        logging_out: CM,
        message_confirm: em,
        message_email_changed: nm,
        message_password_mail: tm,
        message_signup_disabled: rm,
        message_verfication_error: im,
        never_mind: VM,
        or: "au",
        recover_password: RM,
        send_recovery_email: BM,
        sending_recovery_email: GM,
        show_password: gm,
        sign_up: QM,
        signing_up: PM,
        site_url_label: KM,
        site_url_link_text: JM,
        site_url_message: qM,
        site_url_placeholder: XM,
        site_url_submit: $M,
        site_url_title: FM,
        update_password: HM,
        updating_password: ZM
    }, Symbol.toStringTag, {
        value: "Module"
    })), fm = "en", hm = {
        en: Oo,
        fr: ma,
        es: ts,
        hu: Ys,
        pt: Dl,
        pl: _u,
        cs: qu,
        sk: U_,
        ru: yc,
        de: ad,
        it: Hd,
        ar: Ig,
        zhCN: ap,
        nl: Hp,
        sv: LM,
        sw: mm
    };
    !function(e) {
        !0 === e.isolateGlobalState && function() {
            if ((Xt.pendingReactions.length || Xt.inBatch || Xt.isRunningReactions) && B(36), Kt = !0, qt) {
                var e = V();
                0 === --e.__mobxInstanceCount && (e.__mobxGlobals = void 0), Xt = new Jt;
            }
        }();
        var t = e.useProxies, n = e.enforceActions;
        void 0 !== t && (Xt.useProxies = t === In || "never" !== t && "undefined" != typeof Proxy), "ifavailable" === t && (Xt.verifyProxies = !0);
        var i, r, o = "observed" === n;
        Xt.enforceActions = o, Xt.allowStateChanges = !0 !== o && o !== In, [
            "computedRequiresReaction",
            "reactionRequiresObservable",
            "observableRequiresReaction",
            "disableErrorBoundaries",
            "safeDescriptors"
        ].forEach(function(t) {
            t in e && (Xt[t] = !!e[t]);
        }), Xt.allowStateReads = !Xt.observableRequiresReaction, e.reactionScheduler && (i = e.reactionScheduler, r = un, un = function(e) {
            return i(function() {
                return r(e);
            });
        });
    }({
        enforceActions: "never"
    });
    const vm = vt({
        user: null,
        recovered_user: null,
        message: null,
        settings: null,
        gotrue: null,
        error: null,
        siteURL: null,
        remember: !0,
        saving: !1,
        invite_token: null,
        email_change_token: null,
        namePlaceholder: null,
        signupMetadata: null,
        cookieDomain: null,
        isLocal: !1,
        modal: {
            page: "login",
            isOpen: !1,
            logo: !0
        },
        locale: fm
    });
    function ym(e) {
        const t = vm.cookieDomain ? `; domain=${vm.cookieDomain}` : "", n = "https:" === window.location.protocol ? "; secure" : "";
        document.cookie = e ? `nf_jwt=${e}; path=/${t}${n}; SameSite=Lax` : `nf_jwt=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/${t}${n}; SameSite=Lax`;
    }
    vm.setNamePlaceholder = yn(function(e) {
        vm.namePlaceholder = e;
    }), vm.startAction = yn(function() {
        vm.saving = !0, vm.error = null, vm.message = null;
    }), vm.setError = yn(function(e) {
        vm.saving = !1, vm.error = e ?? null;
    }), vm.init = yn(function(e, t) {
        e && (vm.gotrue = e, vm.user = e.currentUser(), vm.user && (vm.modal.page = "user", vm.user.getUserData().catch(yn(()=>{
            vm.user = null, vm.modal.page = "login", ym(null);
        })))), t && vm.loadSettings();
    }), vm.loadSettings = yn(function() {
        vm.settings || vm.gotrue && vm.gotrue.settings().then(yn((e)=>vm.settings = e)).catch(yn(()=>{
            vm.error = new Error(`Failed to load settings from ${vm.gotrue.api.apiURL}`);
        }));
    }), vm.setIsLocal = yn(function(e) {
        vm.isLocal = e;
    }), vm.setSiteURL = yn(function(e) {
        vm.siteURL = e;
    }), vm.clearSiteURL = yn(function() {
        vm.gotrue = null, vm.siteURL = null, vm.settings = null;
    }), vm.login = yn(function(e, t) {
        return vm.startAction(), vm.gotrue.login(e, t, vm.remember).then(yn((e)=>{
            vm.user = e, vm.modal.page = "user", vm.invite_token = null, ym(e.tokenDetails()?.access_token ?? null), vm.email_change_token && vm.doEmailChange(), vm.saving = !1;
        })).catch(vm.setError);
    }), vm.externalLogin = yn(function(e) {
        vm.error = null, vm.message = null;
        const t = vm.invite_token ? vm.gotrue.acceptInviteExternalUrl(e, vm.invite_token) : vm.gotrue.loginExternalUrl(e);
        window.location.href = t;
    }), vm.completeExternalLogin = yn(function(e) {
        vm.startAction(), vm.gotrue.createUser(e, vm.remember).then((e)=>{
            vm.user = e, vm.modal.page = "user", ym(e.tokenDetails()?.access_token ?? null), vm.saving = !1;
        }).catch(vm.setError);
    }), vm.signup = yn(function(e, t, n) {
        return vm.startAction(), vm.gotrue.signup(t, n, {
            ...vm.signupMetadata,
            full_name: e
        }).then(yn(()=>{
            vm.signupMetadata = null, vm.settings?.autoconfirm ? vm.login(t, n) : vm.message = "confirm", vm.saving = !1;
        })).catch(vm.setError);
    }), vm.logout = yn(function() {
        if (vm.user) return vm.startAction(), vm.user.logout().then(yn(()=>{
            vm.user = null, vm.modal.page = "login", vm.saving = !1, ym(null);
        })).catch(vm.setError);
        vm.modal.page = "login", vm.saving = !1, ym(null);
    }), vm.updatePassword = yn(function(e) {
        vm.startAction();
        (vm.recovered_user || vm.user).update({
            password: e
        }).then((e)=>{
            vm.user = e, vm.recovered_user = null, vm.modal.page = "user", ym(e.tokenDetails()?.access_token ?? null), vm.saving = !1;
        }).catch(vm.setError);
    }), vm.acceptInvite = yn(function(e) {
        vm.startAction(), vm.gotrue.acceptInvite(vm.invite_token, e, vm.remember).then((e)=>{
            vm.saving = !1, vm.invite_token = null, vm.user = e, vm.modal.page = "user", ym(e.tokenDetails()?.access_token ?? null);
        }).catch(vm.setError);
    }), vm.doEmailChange = yn(function() {
        return vm.startAction(), vm.user.update({
            email_change_token: vm.email_change_token
        }).then(yn((e)=>{
            vm.user = e, vm.email_change_token = null, vm.message = "email_changed", vm.saving = !1;
        })).catch(vm.setError);
    }), vm.verifyToken = yn(function(e, t) {
        const n = vm.gotrue;
        switch(vm.modal.isOpen = !0, e){
            case "confirmation":
                vm.startAction(), vm.modal.page = "signup", n.confirm(t, vm.remember).then(yn((e)=>{
                    vm.user = e, ym(e.tokenDetails()?.access_token ?? null), vm.saving = !1;
                })).catch(yn((e)=>{
                    console.error(e), vm.message = "verfication_error", vm.modal.page = "signup", vm.saving = !1;
                }));
                break;
            case "email_change":
                vm.email_change_token = t, vm.modal.page = "message", vm.user ? vm.doEmailChange() : vm.modal.page = "login";
                break;
            case "invite":
                vm.modal.page = e, vm.invite_token = t;
                break;
            case "recovery":
                vm.startAction(), vm.user = null, vm.modal.page = e, vm.gotrue.recover(t, vm.remember).then((e)=>{
                    vm.saving = !1, vm.recovered_user = e;
                }).catch((e)=>{
                    vm.saving = !1, vm.error = e, vm.modal.page = "login";
                });
                break;
            default:
                vm.error = "Unknown token type";
        }
    }), vm.requestPasswordRecovery = yn(function(e) {
        vm.startAction(), vm.gotrue.requestPasswordRecovery(e).then(yn(()=>{
            vm.message = "password_mail", vm.saving = !1;
        })).catch(vm.setError);
    }), vm.openModal = yn(function(e) {
        vm.modal.page = e, vm.modal.isOpen = !0;
    }), vm.closeModal = yn(function() {
        vm.modal.isOpen = !1, vm.error = null, vm.message = null, vm.saving = !1;
    }), vm.translate = yn(function(e) {
        return ((e, t = fm)=>{
            const n = hm[t]?.[e];
            return n || hm[fm][e] || e;
        })(e, vm.locale);
    });
    const Nm = Er(function({ mode: e, text: t }) {
        const n = Dr(Sr);
        if (!n) return null;
        const { user: i, translate: r } = n, o = ()=>{
            n.openModal("user");
        };
        return "button" === e ? R("button", {
            type: "button",
            className: "netlify-identity-button",
            onClick: ()=>{
                n.openModal(i ? "user" : "login");
            },
            children: t || r(i ? "log_out" : "log_in")
        }) : R("ul", i ? {
            className: "netlify-identity-menu",
            children: [
                R("li", {
                    className: "netlify-identity-item netlify-identity-user-details",
                    children: [
                        r("logged_in_as"),
                        " ",
                        R("span", {
                            className: "netlify-identity-user",
                            children: i.user_metadata?.name || i.email
                        })
                    ]
                }),
                R("li", {
                    className: "netlify-identity-item",
                    children: R("button", {
                        type: "button",
                        className: "netlify-identity-logout",
                        onClick: o,
                        children: r("log_out")
                    })
                })
            ]
        } : {
            className: "netlify-identity-menu",
            children: [
                R("li", {
                    className: "netlify-identity-item",
                    children: R("button", {
                        type: "button",
                        className: "netlify-identity-signup",
                        onClick: ()=>{
                            n.openModal("signup");
                        },
                        children: r("sign_up")
                    })
                }),
                R("li", {
                    className: "netlify-identity-item",
                    children: R("button", {
                        type: "button",
                        className: "netlify-identity-login",
                        onClick: ()=>{
                            n.openModal("login");
                        },
                        children: r("log_in")
                    })
                })
            ]
        });
    }), wm = ":root{--baseColor: rgb(14, 30, 37);--subduedColor: #a3a9ac;--errorColor: #fa3946;--providerColorGoogle: #4285f4;--providerAltColorGoogle: #366dc7;--providerColorGitHub: #333;--providerAltColorGitHub: #000;--providerColorGitLab: #e24329;--providerAltColorGitLab: #b03320;--providerColorBitbucket: #205081;--providerAltColorBitbucket: #14314f;--providerColorFacebook: #1877F2;--providerAltColorFacebook: #166FE5;--fontFamily: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\";--basePadding: 32px}::-webkit-input-placeholder{color:#a3a9ac;color:var(--subduedColor);font-weight:500}::-moz-placeholder{color:#a3a9ac;color:var(--subduedColor);font-weight:500}:-ms-input-placeholder{color:#a3a9ac;color:var(--subduedColor);font-weight:500}:-moz-placeholder{color:#a3a9ac;color:var(--subduedColor);font-weight:500}.modalContainer{position:absolute;top:0;left:0;width:100%;min-height:100%;overflow-x:hidden;overflow-y:auto;box-sizing:border-box;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",Segoe UI Symbol;font-family:var(--fontFamily);font-size:14px;line-height:1.5;display:flex;flex-direction:column;align-items:center;z-index:99999}.modalContainer:before{content:\"\";display:block;position:fixed;inset:0;background-color:#fff;z-index:-1}.modalDialog{flex-grow:1;display:flex;flex-direction:column;width:100%}.modalContent{position:relative;padding:32px;padding:var(--basePadding);opacity:0;transform:translateY(10px) scale(1);background:#fff}[aria-hidden=false] .modalContent{animation:bouncyEntrance .2s cubic-bezier(.18,.89,.32,1.28);animation-fill-mode:forwards}@keyframes bouncyEntrance{0%{opacity:0;transform:translateY(10px) scale(.9)}to{opacity:1;transform:translateY(0) scale(1)}}@media(min-width:480px){.modalContainer:before{background-color:#0e1e25;background-color:var(--baseColor);animation:fadeIn .1s ease-in;animation-fill-mode:forwards}.modalDialog{max-width:364px;justify-content:center}.modalContent{background:#fff;box-shadow:0 4px 12px #00000012,0 12px 32px #0e1e251a;border-radius:8px;margin-top:32px;margin-top:var(--basePadding)}}@keyframes fadeIn{0%{opacity:0}to{opacity:.67}}.flashMessage{text-align:center;color:#0e1e25;color:var(--baseColor);font-weight:500;font-size:14px;background-color:#f2f3f3;padding:6px;border-radius:4px;opacity:.7;transition:opacity .2s linear}.flashMessage:hover,.flashMessage:focus{opacity:1}.error{color:#fa3946;color:var(--errorColor);background-color:#fceef0;opacity:1}.error span:before{content:\"\";display:inline-block;position:relative;top:3px;margin-right:4px;width:16px;height:16px;background:no-repeat center center;background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBmaWxsPSIjRkEzOTQ2IiBkPSJNOCwxLjMzMzMzMzMzIEMxMS42NzYsMS4zMzMzMzMzMyAxNC42NjY2NjY3LDQuMzI0IDE0LjY2NjY2NjcsOCBDMTQuNjY2NjY2NywxMS42NzYgMTEuNjc2LDE0LjY2NjY2NjcgOCwxNC42NjY2NjY3IEM0LjMyNCwxNC42NjY2NjY3IDEuMzMzMzMzMzMsMTEuNjc2IDEuMzMzMzMzMzMsOCBDMS4zMzMzMzMzMyw0LjMyNCA0LjMyNCwxLjMzMzMzMzMzIDgsMS4zMzMzMzMzMyBaIE04LDAgQzMuNTgyLDAgMCwzLjU4MiAwLDggQzAsMTIuNDE4IDMuNTgyLDE2IDgsMTYgQzEyLjQxOCwxNiAxNiwxMi40MTggMTYsOCBDMTYsMy41ODIgMTIuNDE4LDAgOCwwIFogTTcuMTI2NjY2NjcsNS4wMTczMzMzMyBDNy4wNjA2NjY2Nyw0LjQ3OTMzMzMzIDcuNDc4NjY2NjcsNCA4LjAyNTMzMzMzLDQgQzguNTM5MzMzMzMsNCA4Ljk0MzMzMzMzLDQuNDUwNjY2NjcgOC44Nzg2NjY2Nyw0Ljk2NzMzMzMzIEw4LjM3NCw5LjAwMjY2NjY3IEM4LjM1MDY2NjY3LDkuMTkxMzMzMzMgOC4xOSw5LjMzMzMzMzMzIDgsOS4zMzMzMzMzMyBDNy44MSw5LjMzMzMzMzMzIDcuNjQ5MzMzMzMsOS4xOTEzMzMzMyA3LjYyNTMzMzMzLDkuMDAyNjY2NjcgTDcuMTI2NjY2NjcsNS4wMTczMzMzMyBMNy4xMjY2NjY2Nyw1LjAxNzMzMzMzIFogTTgsMTIuMTY2NjY2NyBDNy41NCwxMi4xNjY2NjY3IDcuMTY2NjY2NjcsMTEuNzkzMzMzMyA3LjE2NjY2NjY3LDExLjMzMzMzMzMgQzcuMTY2NjY2NjcsMTAuODczMzMzMyA3LjU0LDEwLjUgOCwxMC41IEM4LjQ2LDEwLjUgOC44MzMzMzMzMywxMC44NzMzMzMzIDguODMzMzMzMzMsMTEuMzMzMzMzMyBDOC44MzMzMzMzMywxMS43OTMzMzMzIDguNDYsMTIuMTY2NjY2NyA4LDEyLjE2NjY2NjcgWiIvPgo8L3N2Zz4K)}.disabled{opacity:.38;pointer-events:none}.infoText{text-align:center;margin:32px 0}.infoTextEmail{font-size:16px;font-weight:500}.saving{background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABQCAMAAACeYYN3AAAAxlBMVEUAAAD////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////DTx3aAAAAQnRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIiMkJSYnKCkqKywtLi8wMTIzNDU2Nzg5Ojs8PT4/QEGgjKRfAAACk0lEQVR4AYXQDXP5WhAG8CUhiSQqSv4RRRMVL1Fa1VZf3PL9v9Tde9wc9M8+P8/M7s6czJiHgNIvVCJO6YiAMlAiWckASiQrm4bJMZTDrmbBIEC9qpgVjp6n4B+oyEwCzKrMQBVaQIlkpmXZln1dhQB+49gOh5dLexlV6MhsAqyazEQVugCqsOK5nsQmwPWZ53ucvyczSGb4l9T9OsdnLgFOXVZFFd4AqEKrIasR4AdBI2hw1GR6VzMwSWY2A60ZNDl6KnUC3KbMRhXeAqhCpyXzCAjarNVucdqXVEhWaRfCdsj5vQcE1EOZQ7Jy+EcUlklWi2Q3BLQ6nagTcTra2Y0qrHZirRN3OOezTUAjvq4bd7suqpDfSGJUoXcnCwiIerIqqlC96vf6HD1ZsUcE3PYH/QGnrx3uYnqoQn4l6aMK/XtZi4BuIrNIZqVJkiapkhx37Y6AcDgcpsNU44Nz3OuoQn4jSVGFNw+ykID+SGaTzM5G2YiTFVM73AMConE2zjhj7XAXs4EqHE/4d12GKgwmsoiAZCpzSObMptPZdHZVSkCc5/ksnym8cPRUmiQzpvNcmedzTl4o7qlBsuZc1iVg9ChDFdYWshEBveV/FssFZ/l7Z7eowsfl0/JJ4UXj43A/ogpbT7IeAZNnWQ1VuJJNCBi8HKxeVhw9tRaq8JkfrV/WHDULxb1CFbbX7HX9yllfck9A/ipzSea+yeYEJO+yEFX4tim8b94VXjj/zzdU4Z/NmY/NB+fkTglYfMg8knmfsiUBD1+yCFX4+X309f3FOds/UYVR8fH2e6vwovExIuB5K/NJ5v8jWxGQ/chiVOF2d+pn98M5zt3WJFm83+/2O4UXjprabkzAWn+o56k9qvBfX4hMaM+SxOMAAAAASUVORK5CYII=);background-repeat:repeat-x;background-size:contain;background-origin:border-box;background-position:0% 0%;animation:loading 20s linear infinite;pointer-events:none}.saving:after{content:\"\u2026\"}@keyframes loading{0%{background-position:0% 0%}to{background-position:700% 0%}}.btn{display:block;position:relative;width:100%;height:auto;margin:14px 0 0;padding:6px;outline:0;cursor:pointer;border:2px solid rgb(14,30,37);border:2px solid var(--baseColor);border-radius:4px;background-color:#2d3b41;color:#fff;transition:background-color .2s ease;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",Segoe UI Symbol;font-family:var(--fontFamily);font-size:14px;font-weight:500;line-height:24px;text-align:center;-webkit-text-decoration:none;text-decoration:none;white-space:nowrap}.btn:hover,.btn:focus{background-color:#0e1e25;background-color:var(--baseColor);-webkit-text-decoration:none;text-decoration:none}.btnClose{position:absolute;top:-6px;right:-6px;margin:0;padding:0;border:0;width:44px;height:44px;border-radius:50%;background:#fff;color:#a3a9ac;color:var(--subduedColor);cursor:pointer}.btnClose:before{content:\"\xd7\";font-size:25px;line-height:9px}.btnClose:hover,.btnClose:focus{background:#e9ebeb;color:#0e1e25;color:var(--baseColor)}.header{display:flex;margin-top:-8px;margin-bottom:32px;margin-bottom:var(--basePadding)}.btnHeader{font-size:16px;line-height:24px;background:#fff;color:#a3a9ac;color:var(--subduedColor);border:0;border-bottom:2px solid #e9ebeb;border-radius:4px 4px 0 0;margin:0}.btnHeader:focus,.btnHeader.active{background:#fff;color:#0e1e25;color:var(--baseColor);border-color:#0e1e25;border-color:var(--baseColor);font-weight:700}.btnHeader:not(:only-child):hover{background-color:#e9ebeb;color:#0e1e25;color:var(--baseColor)}.btnHeader:only-child{cursor:auto}.btnLink{display:block;position:relative;width:auto;height:auto;margin:14px auto 0;padding:6px 6px 0;outline:0;cursor:pointer;color:#0e1e25;color:var(--baseColor);border:none;border-bottom:2px solid #e9ebeb;border-radius:0;background-color:inherit;transition:border-color .2s ease;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica,Arial,sans-serif,\"Apple Color Emoji\",\"Segoe UI Emoji\",Segoe UI Symbol;font-family:var(--fontFamily);font-size:14px;font-weight:500;line-height:24px;text-align:center;white-space:nowrap}.btnLink:hover,.btnLink:focus{background-color:inherit;border-color:#a3a9ac;border-color:var(--subduedColor)}.formGroup{position:relative;margin-top:14px}.formControl{box-sizing:border-box;display:block;width:100%;height:40px;margin:0;padding:6px 12px 6px 36px;border:2px solid #e9ebeb;border-radius:4px;background:#fff;color:#0e1e25;color:var(--baseColor);box-shadow:none;font-size:16px;font-weight:500;line-height:24px;transition:box-shadow ease-in-out .15s;-webkit-appearance:none;-moz-appearance:none}.inputFieldIcon{position:absolute;top:12px;left:12px;display:inline-block;width:16px;height:16px;background-repeat:no-repeat;background-position:center;pointer-events:none}.inputFieldName{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4gIDxwYXRoIGZpbGw9IiNBM0E5QUMiIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTgsNyBDNi4zNDMxNDU3NSw3IDUsNS42NTY4NTQyNSA1LDQgQzUsMi4zNDMxNDU3NSA2LjM0MzE0NTc1LDEgOCwxIEM5LjY1Njg1NDI1LDEgMTEsMi4zNDMxNDU3NSAxMSw0IEMxMSw1LjY1Njg1NDI1IDkuNjU2ODU0MjUsNyA4LDcgWiBNOCwxNSBMMS41LDE1IEMxLjUsMTEuMTM0MDA2OCA0LjQxMDE0OTEzLDggOCw4IEMxMS41ODk4NTA5LDggMTQuNSwxMS4xMzQwMDY4IDE0LjUsMTUgTDgsMTUgWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEgLTEpIi8+PC9zdmc+)}.inputFieldEmail{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxMSIgdmlld0JveD0iMCAwIDE2IDExIj4gIDxwYXRoIGZpbGw9IiNBM0E5QUMiIGQ9Ik0xLjE3MDczMTcxLDMgQzAuNTIyMTQ2MzQxLDMgMy45MDI0NTk4N2UtMDgsMy41NDUxMTA4MSAzLjkwMjQ1OTg3ZS0wOCw0LjIyMjIyMTU0IEwzLjkwMjQ1OTg3ZS0wOCwxMi43Nzc3Nzg1IEMzLjkwMjQ1OTg3ZS0wOCwxMy40NTQ4ODkyIDAuNTIyMTQ2MzQxLDE0IDEuMTcwNzMxNzEsMTQgTDE0LjgyOTI2ODMsMTQgQzE1LjQ3Nzg1MzcsMTQgMTYsMTMuNDU0ODg5MiAxNiwxMi43Nzc3Nzg1IEwxNiw0LjIyMjIyMTU0IEMxNiwzLjU0NTExMDgxIDE1LjQ3Nzg1MzcsMyAxNC44MjkyNjgzLDMgTDEuMTcwNzMxNzEsMyBaIE0yLjMzNzQyMTE5LDUuMDAxODY1NjYgQzIuNDU3NTExNzUsNC45ODk1NTIxNCAyLjU2MDcxNDU3LDUuMDM5MzM5OCAyLjYzNjM1OTg1LDUuMTE3Mjg0MzcgTDcuNDgyNjA2MTcsMTAuMTEzMjU0NSBDNy43ODQ0ODgyMiwxMC40MjQ3NDU1IDguMjAzMjc4MjksMTAuNDI0NzY2IDguNTA1ODk2MTksMTAuMTEzMjU0NSBMMTMuMzYzNjQwMiw1LjExNzI4NDM3IEMxMy41MDUxMjU1LDQuOTcxMjA0OTkgMTMuNzUyOTc3OSw0Ljk4MTg5NzIzIDEzLjg4MzkyMjIsNS4xMzk3MzYwMiBDMTQuMDE0ODY2NSw1LjI5NzU3NDgxIDE0LjAwNTI4MjEsNS41NzQwNzQ4OCAxMy44NjM3OTY3LDUuNzIwMTU0MjYgTDExLjExNTg2MDYsOC41NDg0MTE1MiBMMTMuODU4MDU3MSwxMS4yNjc2NDY5IEMxNC4wMjE3ODM1LDExLjQwMzE5ODIgMTQuMDQ4OTM2MywxMS43MDE0OTMyIDEzLjkxMjk4ODIsMTEuODcwOTg4OCBDMTMuNzc3MDQwMSwxMi4wNDA1MDQ5IDEzLjUwODI4OTcsMTIuMDQzNDE5MSAxMy4zNjkzOTgyLDExLjg3Njk0MDQgTDEwLjU3NTQ3MTUsOS4xMDYzOTg2MiBMOS4wMDYwNTI3NSwxMC43MTYxMjQ0IEM4LjQzNDk0MTk1LDExLjMwNDAzMzQgNy41NTMzMDI4NiwxMS4zMDUxNjIxIDYuOTgyNDY4LDEwLjcxNjEyNDQgTDUuNDI0NTI4NSw5LjEwNjM5ODYyIEwyLjYzMDYwMTgzLDExLjg3Njk0MDQgQzIuNDkxNzEwMzMsMTIuMDQzNDM5NyAyLjIyMjk1OTg4LDEyLjA0MDUyNTUgMi4wODcwMTE3OCwxMS44NzA5ODg4IEMxLjk1MTA2MzY3LDExLjcwMTQ5MzIgMS45NzgyMTY1LDExLjQwMzE5ODIgMi4xNDE5NDI5LDExLjI2NzY0NjkgTDQuODg0MTM5MzksOC41NDg0MTE1MiBMMi4xMzYyMDMyOCw1LjcyMDE1NDI2IEMyLjAyODcxNDE0LDUuNjE2MjI4MTYgMS45ODM1NTE0MSw1LjQzODk1NDUzIDIuMDI1OTkxNSw1LjI4NzQ5ODI1IEMyLjA2ODQxMzE5LDUuMTM2MDYyNDkgMi4xOTYwMjc4MSw1LjAxOTAyMjQ5IDIuMzM3NDIxMTksNS4wMDE4NjU2NiBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIC0zKSIvPjwvc3ZnPg==)}.inputFieldPassword{background-image:url(data:image/svg+xml;base64,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)}.btnPasswordToggle{position:absolute;top:8px;right:8px;width:24px;height:24px;padding:0;border:0;background:transparent;cursor:pointer;background-repeat:no-repeat;background-position:center;background-size:16px 16px;opacity:.5;transition:opacity .15s ease;background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%230e1e25' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z'/%3E%3Ccircle cx='12' cy='12' r='3'/%3E%3C/svg%3E\")}.btnPasswordToggle:hover,.btnPasswordToggle:focus{opacity:1}.btnPasswordToggle.passwordVisible{background-image:url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%230e1e25' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24'/%3E%3Cline x1='1' y1='1' x2='23' y2='23'/%3E%3C/svg%3E\")}.inputFieldUrl{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE0IDE0Ij4gIDxwYXRoIGZpbGw9IiNBM0E5QUMiIGQ9Ik0xMCw1IEMxMCwzLjg5NTQzMDUgOS4xMDQ1Njk1LDMgOCwzIEM2Ljg5NTQzMDUsMyA2LDMuODk1NDMwNSA2LDUgTTQsMTAgTDQsMTEgTDYsMTEgTDYsMTAgQzYsOS40NDc3MTUyNSA1LjU1MjI4NDc1LDkgNSw5IEM0LjQ0NzcxNTI1LDkgNCw5LjQ0NzcxNTI1IDQsMTAgWiBNMTIsMTAgQzEyLDkuNDQ3NzE1MjUgMTEuNTUyMjg0Nyw5IDExLDkgQzEwLjQ0NzcxNTMsOSAxMCw5LjQ0NzcxNTI1IDEwLDEwIEwxMCwxMSBMMTIsMTEgTDEyLDEwIFogTTYsNiBMNiw1IEw0LDUgTDQsNiBDNCw2LjU1MjI4NDc1IDQuNDQ3NzE1MjUsNyA1LDcgQzUuNTUyMjg0NzUsNyA2LDYuNTUyMjg0NzUgNiw2IFogTTEwLDYgQzEwLDYuNTUyMjg0NzUgMTAuNDQ3NzE1Myw3IDExLDcgQzExLjU1MjI4NDcsNyAxMiw2LjU1MjI4NDc1IDEyLDYgTDEyLDUgTDEwLDUgTDEwLDYgWiBNNCw1IEM0LDIuNzkwODYxIDUuNzkwODYxLDEgOCwxIEMxMC4yMDkxMzksMSAxMiwyLjc5MDg2MSAxMiw1IEw0LDUgWiBNNCwxMSBMMTIsMTEgQzEyLDEzLjIwOTEzOSAxMC4yMDkxMzksMTUgOCwxNSBDNS43OTA4NjEsMTUgNCwxMy4yMDkxMzkgNCwxMSBaIE0xMCwxMSBMNiwxMSBDNiwxMi4xMDQ1Njk1IDYuODk1NDMwNSwxMyA4LDEzIEM5LjEwNDU2OTUsMTMgMTAsMTIuMTA0NTY5NSAxMCwxMSBaIE04LDExIEM3LjQ0NzcxNTI1LDExIDcsMTAuNTUyMjg0NyA3LDEwIEw3LDYgQzcsNS40NDc3MTUyNSA3LjQ0NzcxNTI1LDUgOCw1IEM4LjU1MjI4NDc1LDUgOSw1LjQ0NzcxNTI1IDksNiBMOSwxMCBDOSwxMC41NTIyODQ3IDguNTUyMjg0NzUsMTEgOCwxMSBaIiB0cmFuc2Zvcm09InJvdGF0ZSg0NSA4LjcwNyA2LjI5MykiLz48L3N2Zz4=)}.hr{border:0;border-top:2px solid #e9ebeb;margin:32px 0 -1px;margin:var(--basePadding) 0 -1px;text-align:center;overflow:visible}.hr:before{content:attr(data-text);position:relative;display:inline-block;font-size:12px;font-weight:800;line-height:1;text-transform:uppercase;background-color:#fff;color:#0e1e25;color:var(--baseColor);padding:4px;top:-11px}.btnProvider{padding-left:40px;padding-right:40px}.btnProvider:before{content:\"\";position:absolute;display:inline-block;vertical-align:middle;width:32px;height:40px;background-repeat:no-repeat;background-position:left center;top:-2px;left:14px}.providerGoogle{background-color:#4285f4;background-color:var(--providerColorGoogle);border-color:#366dc7;border-color:var(--providerAltColorGoogle)}.providerGoogle:hover,.providerGoogle:focus{background-color:#366dc7;background-color:var(--providerAltColorGoogle)}.providerGitHub{background-color:#333;background-color:var(--providerColorGitHub);border-color:#000;border-color:var(--providerAltColorGitHub)}.providerGitHub:hover,.providerGitHub:focus{background-color:#000;background-color:var(--providerAltColorGitHub)}.providerGitLab{background-color:#e24329;background-color:var(--providerColorGitLab);border-color:#b03320;border-color:var(--providerAltColorGitLab)}.providerGitLab:hover,.providerGitLab:focus{background-color:#b03320;background-color:var(--providerAltColorGitLab)}.providerBitbucket{background-color:#205081;background-color:var(--providerColorBitbucket);border-color:#14314f;border-color:var(--providerAltColorBitbucket)}.providerBitbucket:hover,.providerBitbucket:focus{background-color:#14314f;background-color:var(--providerAltColorBitbucket)}.providerFacebook{background-color:#1877f2;background-color:var(--providerColorFacebook);border-color:#166fe5;border-color:var(--providerAltColorFacebook)}.providerFacebook:hover,.providerFacebook:focus{background-color:#166fe5;background-color:var(--providerAltColorFacebook)}.providerGoogle:before{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMyIgaGVpZ2h0PSIxMiIgdmlld0JveD0iMCAwIDEzIDEyIj4gIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEuNDg4IC0yKSI+ICAgIDxyZWN0IHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIvPiAgICA8cGF0aCBmaWxsPSIjRkZGRkZGIiBmaWxsLXJ1bGU9Im5vbnplcm8iIGQ9Ik0wLjY1MjczNDM3NSwzLjI5NTI4MjQ0IEMwLjIzNzk4NDM3NSw0LjEwNTgzMjA2IDIuODQyMTcwOTRlLTE0LDUuMDE2MDQ1OCAyLjg0MjE3MDk0ZS0xNCw1Ljk3OTM4OTMxIEMyLjg0MjE3MDk0ZS0xNCw2Ljk0MjczMjgyIDAuMjM3OTg0Mzc1LDcuODUyOTAwNzYgMC42NTI3MzQzNzUsOC42NjM0NTAzOCBDMS42NTkwNDY4NywxMC42MTY3MDIzIDMuNzI2MDkzNzUsMTEuOTU4Nzc4NiA2LjExOTUzMTI1LDExLjk1ODc3ODYgQzcuNzcxNzgxMjUsMTEuOTU4Nzc4NiA5LjE1ODg1OTM3LDExLjQyNzI1MTkgMTAuMTcyMDE1NiwxMC41MTA0NDI3IEMxMS4zMjc5MDYyLDkuNDY3MzU4NzggMTEuOTk0MjgxMiw3LjkzMjY0MTIyIDExLjk5NDI4MTIsNi4xMTIyNTk1NCBDMTEuOTk0MjgxMiw1LjYyMDYyNTk1IDExLjk1MzQ1MzEsNS4yNjE4NjI2IDExLjg2NTA5MzcsNC44ODk4MTY3OSBMNi4xMTk1MzEyNSw0Ljg4OTgxNjc5IEw2LjExOTUzMTI1LDcuMTA4ODA5MTYgTDkuNDkyMDQ2ODcsNy4xMDg4MDkxNiBDOS40MjQwNzgxMiw3LjY2MDI1OTU0IDkuMDU2OTA2MjUsOC40OTA3MzI4MiA4LjI0MDk1MzEyLDkuMDQ4Nzc4NjMgQzcuNzI0MjAzMTIsOS40MDA5MDA3NiA3LjAzMDY0MDYyLDkuNjQ2NzE3NTYgNi4xMTk1MzEyNSw5LjY0NjcxNzU2IEM0LjUwMTI2NTYyLDkuNjQ2NzE3NTYgMy4xMjc3ODEyNSw4LjYwMzY3OTM5IDIuNjM4MTcxODcsNy4xNjE5ODQ3MyBMMi42Mjg3MTIwNSw3LjE2Mjc2OTU5IEMyLjUwNTM0MTU4LDYuNzk3Mjk0NjggMi40MzQyMTg3NSw2LjM4MTEyMjg1IDIuNDM0MjE4NzUsNS45NzkzODkzMSBDMi40MzQyMTg3NSw1LjU2NzQ1MDM4IDIuNTA4OTg0MzgsNS4xNjg4Mzk2OSAyLjYzMTM3NSw0Ljc5Njc5Mzg5IEMzLjEyNzc4MTI1LDMuMzU1MDk5MjQgNC41MDEyNjU2MiwyLjMxMjAxNTI3IDYuMTE5NTMxMjUsMi4zMTIwMTUyNyBDNy4yNjg2MjUsMi4zMTIwMTUyNyA4LjA0Mzc1LDIuNzk3MDA3NjMgOC40ODU3MzQzNywzLjIwMjMwNTM0IEwxMC4yMTI3OTY5LDEuNTU0NjQxMjIgQzkuMTUyMTA5MzcsMC41OTEyOTc3MSA3Ljc3MTc4MTI1LDguODgxNzg0MmUtMTYgNi4xMTk1MzEyNSw4Ljg4MTc4NDJlLTE2IEMzLjcyNjA5Mzc1LDguODgxNzg0MmUtMTYgMS42NTkwNDY4NywxLjM0MjAzMDUzIDAuNjUyNzM0Mzc1LDMuMjk1MjgyNDQgTDAuNjUyNzM0Mzc1LDMuMjk1MjgyNDQgWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMiAyKSIvPiAgPC9nPjwvc3ZnPg==)}.providerGitHub:before{background-image:url(data:image/svg+xml;base64,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)}.providerGitLab:before{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxMyIgdmlld0JveD0iMCAwIDE0IDEzIj4gIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEgLTIpIj4gICAgPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2Ii8+ICAgIDxwYXRoIGZpbGw9IiNGRkZGRkYiIGZpbGwtcnVsZT0ibm9uemVybyIgZD0iTTcuMDA0MDkzMzYsMTIuOTQ5MjQzMyBMNC40MjgwOTMzMyw0Ljk5NzI4MjU0IEw5LjU4MDA5MzM2LDQuOTk3MjgyNTQgTDcuMDA0MDkzMzYsMTIuOTQ5MjQzMyBaIE03LjAwNDA5MzM2LDEyLjk0OTIzIEwwLjgxNzg5MzMzMyw0Ljk5NzI2OTE3IEw0LjQyODA5MzMzLDQuOTk3MjY5MTcgTDcuMDA0MDkzMzYsMTIuOTQ5MjMgWiBNMC44MTc4OTk5OTksNC45OTcyODkyMyBMNy4wMDQwOTk5OCwxMi45NDkyNSBMMC4yMjg4MzMzMzMsOC4wMTE4ODA4IEMwLjA0MTksNy44NzU2NzE1MiAtMC4wMzYzLDcuNjM0MjEyNyAwLjAzNTEsNy40MTM4MTcxMiBMMC44MTc4OTk5OTksNC45OTcyODkyMyBaIE0wLjgxNzg5OTk5OSw0Ljk5NzI5NTkxIEwyLjM2OTM2NjY3LDAuMjA3OTA0NzE0IEMyLjQ0OTE2NjY3LC0wLjAzODUwMjM1ODggMi43OTY3NjY2NywtMC4wMzg1NjkyMjY1IDIuODc2NTY2NjcsMC4yMDc5MDQ3MTQgTDQuNDI4MSw0Ljk5NzI5NTkxIEwwLjgxNzg5OTk5OSw0Ljk5NzI5NTkxIFogTTcuMDA0MDkzMzYsMTIuOTQ5MjMgTDkuNTgwMDkzMzYsNC45OTcyNjkxNyBMMTMuMTkwMjkzMyw0Ljk5NzI2OTE3IEw3LjAwNDA5MzM2LDEyLjk0OTIzIFogTTEzLjE5MDI5MzMsNC45OTcyODkyMyBMMTMuOTczMDkzMyw3LjQxMzgxNzEyIEMxNC4wNDQ0OTMzLDcuNjM0MjEyNyAxMy45NjYyOTM0LDcuODc1NjcxNTIgMTMuNzc5MzYsOC4wMTE4ODA4IEw3LjAwNDA5MzM2LDEyLjk0OTI1IEwxMy4xOTAyOTMzLDQuOTk3Mjg5MjMgWiBNMTMuMTkwMjkzMyw0Ljk5NzI5NTkxIEw5LjU4MDA5MzM2LDQuOTk3Mjk1OTEgTDExLjEzMTYyNjcsMC4yMDc5MDQ3MTQgQzExLjIxMTQyNjcsLTAuMDM4NTY5MjI2NSAxMS41NTkwMjY3LC0wLjAzODUwMjM1ODggMTEuNjM4ODI2NywwLjIwNzkwNDcxNCBMMTMuMTkwMjkzMyw0Ljk5NzI5NTkxIFoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEgMikiLz4gIDwvZz48L3N2Zz4=)}.providerBitbucket:before{background-image:url(data:image/svg+xml;base64,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)}.providerFacebook:before{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgdmlld0JveD0iMCAwIDE2IDE2Ij4gIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSkiPiAgICA8cmVjdCB3aWR0aD0iMTYiIGhlaWdodD0iMTYiLz4gICAgPHBhdGggZmlsbD0iI0ZGRkZGRiIgZD0iTTguNjk1IDE2SDUuNjA5VjkuMDM0SDMuODg5VjYuNDA5aDEuNzJWNC45MDNDNS42MDkgMi45NDMgNi4zODUgMSA4Ljg1MSAxaDIuMTg2djIuNjEzaC0xLjI1MWMtMS4wMjMgMC0xLjA5LjM4Mi0xLjA5IDEuMDk0TDguNjkyIDYuNDA5aDIuMzYybC0uMjc5IDIuNjI1SDguNTI3VjE2aC4xNjh6Ii8+ICA8L2c+PC9zdmc+)}.callOut{display:block;padding:32px;padding:var(--basePadding);font-size:14px;font-weight:500;-webkit-text-decoration:none;text-decoration:none;color:#a3a9ac;color:var(--subduedColor);text-align:center}.callOut:after{content:\" \u2665\";transition:color 4s ease}.callOut:hover:after{color:red}.callOut .netlifyLogo{display:block;margin:auto auto 8px;width:32px;height:32px;background-image:url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIGlkPSJhIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIj48cGF0aCBkPSJNMTguMzEsLjdsMTIuOTksMTIuOTksLjQ4LC40OCwuMjIsLjUzdjIuNThsLS4yMiwuNTMtLjQ4LC40OC0xMi45OSwxMi45OS0uNDgsLjQ4LS41MywuMjJoLTIuNThsLS41My0uMjItLjQ4LS40OEwuNywxOC4zMWwtLjQ4LS40OC0uMjItLjUzdi0yLjU4bC4yMi0uNTMsLjQ4LS40OEwxMy42OSwuN2wuNDgtLjQ4TDE0LjcxLDBoMi41OGwuNTMsLjIyLC40OCwuNDhabS0zLjQ2LDIyLjA2djYuMjRsLjE3LC4xN2gxLjk5bC4xNy0uMTd2LTYuMjRsLS4xNy0uMTdoLTEuOTlsLS4xNywuMTdabTAtMTMuNTNWM2wuMTctLjE3aDEuOTlsLjE3LC4xN3Y2LjI0bC0uMTcsLjE3aC0xLjk5bC0uMTctLjE3Wm0tNS41MiwxNS4xNGguMjdsMS44Mi0xLjgydi0xLjQ0bC0uMTktLjE5aC0xLjQ0cy0xLjgyLDEuODItMS44MiwxLjgydi4yN2wxLjM2LDEuMzZabS0xLjM2LTE1LjA1di0uMjdsMS4zNi0xLjM3aC4yN2wxLjgyLDEuODJ2MS40NGwtLjE5LC4xOWgtMS40NGwtMS44Mi0xLjgyWm0xLjUyLDUuNTFIMi40NmwtLjE3LC4xN3YxLjk5bC4xNywuMTdoNy4wMmwuMTctLjE3di0xLjk5bC0uMTctLjE3Wm0xMC4yMyw1LjNoLTEuOThsLS4xNy0uMTd2LTQuNjVjMC0uODMtLjMyLTEuNDctMS4zMi0xLjQ5LS41MS0uMDEtMS4xLDAtMS43MywuMDNsLS4wOSwuMXY2LjAxcy0uMTYsLjE3LS4xNiwuMTdoLTEuOThsLS4xNy0uMTd2LTcuOTRsLjE3LS4xN2g0LjQ3YzEuNzQsMCwzLjE0LDEuNDEsMy4xNCwzLjE0djQuOTZsLS4xNywuMTdabTIuOC0yLjk3aDcuMDJsLjE3LS4xN3YtMS45OWwtLjE3LS4xN2gtNy4wMmwtLjE3LC4xN3YxLjk5bC4xNywuMTdaIiBmaWxsPSIjYTNhOWFjIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.visuallyHidden{border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;width:1px;white-space:nowrap}.subheader{margin-top:2em;border-top:1px solid rgb(14,30,37)}.subheader h3{padding-top:1em;text-align:center}", bm = {};
    function jm(e, ...t) {
        const n = bm[e] || new Set;
        Array.from(n.values()).forEach((e)=>{
            e(...t);
        });
    }
    const Dm = {
        login: !0,
        signup: !0,
        error: !0
    }, zm = {
        on: (e, t)=>{
            bm[e] = bm[e] || new Set, bm[e].add(t);
        },
        off: (e, t)=>{
            bm[e] && (t ? bm[e].delete(t) : bm[e].clear());
        },
        open: (e, t)=>{
            if (!Dm[e = e || "login"]) throw new Error(`Invalid action for open: ${e}`);
            vm.signupMetadata = t && Object.keys(t).length > 0 ? t : null, vm.openModal(vm.user ? "user" : e);
        },
        close: ()=>{
            vm.closeModal();
        },
        currentUser: ()=>vm.gotrue && vm.gotrue.currentUser(),
        logout: ()=>vm.logout(),
        get gotrue () {
            return vm.gotrue || vm.openModal("login"), vm.gotrue;
        },
        refresh: (e)=>(vm.gotrue || vm.openModal("login"), vm.gotrue.currentUser().jwt(e)),
        init: (e)=>{
            !function(e = {}) {
                if (document.getElementById("netlify-identity-widget")) return;
                const { APIUrl: t, logo: n = !0, namePlaceholder: i, locale: r } = e;
                if (e.cookieDomain) {
                    if (/[;\r\n]/.test(e.cookieDomain)) throw new Error("Invalid cookieDomain: must not contain semicolons or newlines");
                    vm.cookieDomain = e.cookieDomain;
                }
                r && (vm.locale = r);
                const o = document.querySelectorAll("[data-netlify-identity-menu],[data-netlify-identity-button]");
                Array.prototype.slice.call(o).forEach((e)=>{
                    const t = null === e.getAttribute("data-netlify-identity-menu") ? "button" : "menu";
                    P(R(Sr.Provider, {
                        value: vm,
                        children: R(Nm, {
                            mode: t,
                            text: e.innerText.trim()
                        })
                    }), e);
                }), vm.init(Im(t)), vm.modal.logo = n, vm.setNamePlaceholder(i || null), Lm = document.createElement("iframe"), Lm.id = "netlify-identity-widget", Lm.title = "Netlify identity widget", Lm.onload = ()=>{
                    const e = Lm.contentDocument.createElement("style");
                    e.innerHTML = wm.toString(), Lm.contentDocument.head.appendChild(e), P(R(Sr.Provider, {
                        value: vm,
                        children: R(Zr, {})
                    }), Lm.contentDocument.body), function() {
                        const e = (document.location.hash || "").replace(/^#\/?/, "");
                        if (!e) return;
                        const t = e.match(Em);
                        t && (vm.verifyToken(t[1], t[2]), document.location.hash = "");
                        e.match(Sm) && (vm.openModal("signup"), document.location.hash = "");
                        if (e.match(Am)) {
                            const t = {};
                            if (e.split("&").forEach((e)=>{
                                const [n, i] = e.split("=");
                                t[n] = i;
                            }), document && t.access_token && ym(t.access_token), t.state) try {
                                const e = decodeURIComponent(t.state), { auth_type: n } = JSON.parse(e);
                                if ("implicit" === n) return;
                            } catch  {}
                            document.location.hash = "", vm.openModal("login"), vm.completeExternalLogin(t);
                        }
                    }();
                }, km(Lm, Om), Lm.src = "about:blank";
                const a = e.container ? document.querySelector(e.container) : document.body;
                a.appendChild(Lm), Tm && (Lm.setAttribute("style", Tm), Tm = null);
            }(e);
        },
        setLocale: (e)=>{
            e && (vm.locale = e);
        },
        store: vm
    };
    let Tm = null;
    function km(e, t) {
        let n = "";
        for(const i in t)n += `${i}: ${t[i]}; `;
        e ? e.setAttribute("style", n) : Tm = n;
    }
    const xm = {
        localhost: !0,
        "127.0.0.1": !0,
        "0.0.0.0": !0
    };
    function Im(e) {
        const t = xm[window.location.hostname], n = !t && !vm.cookieDomain;
        if (e) return new sr({
            APIUrl: e,
            setCookie: n,
            clientName: "netlify-identity-widget"
        });
        if (t) {
            vm.setIsLocal(t);
            const e = localStorage.getItem("netlifySiteURL");
            return e && vm.setSiteURL(e), null;
        }
        return new sr({
            setCookie: n,
            clientName: "netlify-identity-widget"
        });
    }
    let Lm = null;
    const Om = {
        position: "fixed",
        top: 0,
        left: 0,
        border: "none",
        width: "100%",
        height: "100%",
        overflow: "visible",
        background: "transparent",
        display: "none",
        "z-index": 99
    };
    Dn(()=>vm.modal.isOpen, ()=>{
        vm.settings || vm.loadSettings(), km(Lm, {
            ...Om,
            display: vm.modal.isOpen ? "block !important" : "none"
        }), vm.modal.isOpen ? jm("open", vm.modal.page) : jm("close");
    }), Dn(()=>vm.siteURL, ()=>{
        let e;
        if (null === vm.siteURL || void 0 === vm.siteURL ? localStorage.removeItem("netlifySiteURL") : localStorage.setItem("netlifySiteURL", vm.siteURL), vm.siteURL) e = `${vm.siteURL.replace(/\/$/, "")}/.netlify/identity`;
        vm.init(Im(e), !0);
    }), Dn(()=>vm.user, ()=>{
        vm.user ? jm("login", vm.user) : jm("logout");
    }), Dn(()=>vm.gotrue, ()=>{
        vm.gotrue && jm("init", vm.gotrue.currentUser());
    }), Dn(()=>vm.error, ()=>{
        jm("error", vm.error);
    });
    const Em = /(confirmation|invite|recovery|email_change)_token=([^&]+)/, Sm = /error=access_denied&error_description=403/, Am = /access_token=/;
    return "undefined" != typeof window && (window.netlifyIdentity = zm), "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", ()=>{
        zm.init();
    }) : zm.init(), zm;
});

});
parcelRegister("5Ue0n", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $44cd0bd3a1192d9a$export$a143d493d941bafc; }, function (v) { return $44cd0bd3a1192d9a$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $44cd0bd3a1192d9a$export$f99ded8fe4b79145; }, function (v) { return $44cd0bd3a1192d9a$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $44cd0bd3a1192d9a$export$a143d493d941bafc;
var $44cd0bd3a1192d9a$export$e4cf37d7f6fb9e0a;
var $44cd0bd3a1192d9a$export$f99ded8fe4b79145;
var $44cd0bd3a1192d9a$export$599f31c3813fae4d;
'use strict';

var $2IpUO = parcelRequire("2IpUO");

var $7CwwS = parcelRequire("7CwwS");
const $44cd0bd3a1192d9a$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$44cd0bd3a1192d9a$export$a143d493d941bafc = $44cd0bd3a1192d9a$var$Buffer;
$44cd0bd3a1192d9a$export$e4cf37d7f6fb9e0a = $44cd0bd3a1192d9a$var$SlowBuffer;
$44cd0bd3a1192d9a$export$f99ded8fe4b79145 = 50;
const $44cd0bd3a1192d9a$var$K_MAX_LENGTH = 0x7fffffff;
$44cd0bd3a1192d9a$export$599f31c3813fae4d = $44cd0bd3a1192d9a$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $44cd0bd3a1192d9a$var$Buffer.TYPED_ARRAY_SUPPORT = $44cd0bd3a1192d9a$var$typedArraySupport();
if (!$44cd0bd3a1192d9a$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $44cd0bd3a1192d9a$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($44cd0bd3a1192d9a$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($44cd0bd3a1192d9a$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $44cd0bd3a1192d9a$var$createBuffer(length) {
    if (length > $44cd0bd3a1192d9a$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $44cd0bd3a1192d9a$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $44cd0bd3a1192d9a$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $44cd0bd3a1192d9a$var$allocUnsafe(arg);
    }
    return $44cd0bd3a1192d9a$var$from(arg, encodingOrOffset, length);
}
$44cd0bd3a1192d9a$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $44cd0bd3a1192d9a$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $44cd0bd3a1192d9a$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $44cd0bd3a1192d9a$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($44cd0bd3a1192d9a$var$isInstance(value, ArrayBuffer) || value && $44cd0bd3a1192d9a$var$isInstance(value.buffer, ArrayBuffer)) return $44cd0bd3a1192d9a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($44cd0bd3a1192d9a$var$isInstance(value, SharedArrayBuffer) || value && $44cd0bd3a1192d9a$var$isInstance(value.buffer, SharedArrayBuffer))) return $44cd0bd3a1192d9a$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $44cd0bd3a1192d9a$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $44cd0bd3a1192d9a$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $44cd0bd3a1192d9a$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $44cd0bd3a1192d9a$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $44cd0bd3a1192d9a$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($44cd0bd3a1192d9a$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($44cd0bd3a1192d9a$var$Buffer, Uint8Array);
function $44cd0bd3a1192d9a$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $44cd0bd3a1192d9a$var$alloc(size, fill, encoding) {
    $44cd0bd3a1192d9a$var$assertSize(size);
    if (size <= 0) return $44cd0bd3a1192d9a$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $44cd0bd3a1192d9a$var$createBuffer(size).fill(fill, encoding) : $44cd0bd3a1192d9a$var$createBuffer(size).fill(fill);
    return $44cd0bd3a1192d9a$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $44cd0bd3a1192d9a$var$Buffer.alloc = function(size, fill, encoding) {
    return $44cd0bd3a1192d9a$var$alloc(size, fill, encoding);
};
function $44cd0bd3a1192d9a$var$allocUnsafe(size) {
    $44cd0bd3a1192d9a$var$assertSize(size);
    return $44cd0bd3a1192d9a$var$createBuffer(size < 0 ? 0 : $44cd0bd3a1192d9a$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $44cd0bd3a1192d9a$var$Buffer.allocUnsafe = function(size) {
    return $44cd0bd3a1192d9a$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $44cd0bd3a1192d9a$var$Buffer.allocUnsafeSlow = function(size) {
    return $44cd0bd3a1192d9a$var$allocUnsafe(size);
};
function $44cd0bd3a1192d9a$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$44cd0bd3a1192d9a$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $44cd0bd3a1192d9a$var$byteLength(string, encoding) | 0;
    let buf = $44cd0bd3a1192d9a$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $44cd0bd3a1192d9a$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $44cd0bd3a1192d9a$var$checked(array.length) | 0;
    const buf = $44cd0bd3a1192d9a$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $44cd0bd3a1192d9a$var$fromArrayView(arrayView) {
    if ($44cd0bd3a1192d9a$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $44cd0bd3a1192d9a$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $44cd0bd3a1192d9a$var$fromArrayLike(arrayView);
}
function $44cd0bd3a1192d9a$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $44cd0bd3a1192d9a$var$Buffer.prototype);
    return buf;
}
function $44cd0bd3a1192d9a$var$fromObject(obj) {
    if ($44cd0bd3a1192d9a$var$Buffer.isBuffer(obj)) {
        const len = $44cd0bd3a1192d9a$var$checked(obj.length) | 0;
        const buf = $44cd0bd3a1192d9a$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $44cd0bd3a1192d9a$var$numberIsNaN(obj.length)) return $44cd0bd3a1192d9a$var$createBuffer(0);
        return $44cd0bd3a1192d9a$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $44cd0bd3a1192d9a$var$fromArrayLike(obj.data);
}
function $44cd0bd3a1192d9a$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $44cd0bd3a1192d9a$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $44cd0bd3a1192d9a$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $44cd0bd3a1192d9a$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $44cd0bd3a1192d9a$var$Buffer.alloc(+length);
}
$44cd0bd3a1192d9a$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $44cd0bd3a1192d9a$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$44cd0bd3a1192d9a$var$Buffer.compare = function compare(a, b) {
    if ($44cd0bd3a1192d9a$var$isInstance(a, Uint8Array)) a = $44cd0bd3a1192d9a$var$Buffer.from(a, a.offset, a.byteLength);
    if ($44cd0bd3a1192d9a$var$isInstance(b, Uint8Array)) b = $44cd0bd3a1192d9a$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(a) || !$44cd0bd3a1192d9a$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$44cd0bd3a1192d9a$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$44cd0bd3a1192d9a$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $44cd0bd3a1192d9a$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $44cd0bd3a1192d9a$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($44cd0bd3a1192d9a$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(buf)) buf = $44cd0bd3a1192d9a$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $44cd0bd3a1192d9a$var$byteLength(string, encoding) {
    if ($44cd0bd3a1192d9a$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $44cd0bd3a1192d9a$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $44cd0bd3a1192d9a$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $44cd0bd3a1192d9a$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $44cd0bd3a1192d9a$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$44cd0bd3a1192d9a$var$Buffer.byteLength = $44cd0bd3a1192d9a$var$byteLength;
function $44cd0bd3a1192d9a$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $44cd0bd3a1192d9a$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $44cd0bd3a1192d9a$var$utf8Slice(this, start, end);
        case 'ascii':
            return $44cd0bd3a1192d9a$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $44cd0bd3a1192d9a$var$latin1Slice(this, start, end);
        case 'base64':
            return $44cd0bd3a1192d9a$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $44cd0bd3a1192d9a$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$44cd0bd3a1192d9a$var$Buffer.prototype._isBuffer = true;
function $44cd0bd3a1192d9a$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$44cd0bd3a1192d9a$var$swap(this, i, i + 1);
    return this;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $44cd0bd3a1192d9a$var$swap(this, i, i + 3);
        $44cd0bd3a1192d9a$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $44cd0bd3a1192d9a$var$swap(this, i, i + 7);
        $44cd0bd3a1192d9a$var$swap(this, i + 1, i + 6);
        $44cd0bd3a1192d9a$var$swap(this, i + 2, i + 5);
        $44cd0bd3a1192d9a$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $44cd0bd3a1192d9a$var$utf8Slice(this, 0, length);
    return $44cd0bd3a1192d9a$var$slowToString.apply(this, arguments);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.toLocaleString = $44cd0bd3a1192d9a$var$Buffer.prototype.toString;
$44cd0bd3a1192d9a$var$Buffer.prototype.equals = function equals(b) {
    if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $44cd0bd3a1192d9a$var$Buffer.compare(this, b) === 0;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $44cd0bd3a1192d9a$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($44cd0bd3a1192d9a$var$customInspectSymbol) $44cd0bd3a1192d9a$var$Buffer.prototype[$44cd0bd3a1192d9a$var$customInspectSymbol] = $44cd0bd3a1192d9a$var$Buffer.prototype.inspect;
$44cd0bd3a1192d9a$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($44cd0bd3a1192d9a$var$isInstance(target, Uint8Array)) target = $44cd0bd3a1192d9a$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $44cd0bd3a1192d9a$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($44cd0bd3a1192d9a$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $44cd0bd3a1192d9a$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($44cd0bd3a1192d9a$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $44cd0bd3a1192d9a$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $44cd0bd3a1192d9a$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $44cd0bd3a1192d9a$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $44cd0bd3a1192d9a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $44cd0bd3a1192d9a$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $44cd0bd3a1192d9a$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($44cd0bd3a1192d9a$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $44cd0bd3a1192d9a$var$utf8Write(buf, string, offset, length) {
    return $44cd0bd3a1192d9a$var$blitBuffer($44cd0bd3a1192d9a$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $44cd0bd3a1192d9a$var$asciiWrite(buf, string, offset, length) {
    return $44cd0bd3a1192d9a$var$blitBuffer($44cd0bd3a1192d9a$var$asciiToBytes(string), buf, offset, length);
}
function $44cd0bd3a1192d9a$var$base64Write(buf, string, offset, length) {
    return $44cd0bd3a1192d9a$var$blitBuffer($44cd0bd3a1192d9a$var$base64ToBytes(string), buf, offset, length);
}
function $44cd0bd3a1192d9a$var$ucs2Write(buf, string, offset, length) {
    return $44cd0bd3a1192d9a$var$blitBuffer($44cd0bd3a1192d9a$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$44cd0bd3a1192d9a$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $44cd0bd3a1192d9a$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $44cd0bd3a1192d9a$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $44cd0bd3a1192d9a$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $44cd0bd3a1192d9a$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $44cd0bd3a1192d9a$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$44cd0bd3a1192d9a$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $44cd0bd3a1192d9a$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $2IpUO.fromByteArray(buf);
    else return $2IpUO.fromByteArray(buf.slice(start, end));
}
function $44cd0bd3a1192d9a$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $44cd0bd3a1192d9a$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $44cd0bd3a1192d9a$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $44cd0bd3a1192d9a$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $44cd0bd3a1192d9a$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $44cd0bd3a1192d9a$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $44cd0bd3a1192d9a$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $44cd0bd3a1192d9a$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $44cd0bd3a1192d9a$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $44cd0bd3a1192d9a$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $44cd0bd3a1192d9a$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $44cd0bd3a1192d9a$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $44cd0bd3a1192d9a$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$44cd0bd3a1192d9a$var$Buffer.prototype.readUintLE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUintBE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUint8 = $44cd0bd3a1192d9a$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUint16LE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUint16BE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUint32LE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readUint32BE = $44cd0bd3a1192d9a$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readBigUInt64LE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $44cd0bd3a1192d9a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $44cd0bd3a1192d9a$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$44cd0bd3a1192d9a$var$Buffer.prototype.readBigUInt64BE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $44cd0bd3a1192d9a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $44cd0bd3a1192d9a$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$44cd0bd3a1192d9a$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readBigInt64LE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $44cd0bd3a1192d9a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $44cd0bd3a1192d9a$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$44cd0bd3a1192d9a$var$Buffer.prototype.readBigInt64BE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $44cd0bd3a1192d9a$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $44cd0bd3a1192d9a$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$44cd0bd3a1192d9a$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return $7CwwS.read(this, offset, true, 23, 4);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 4, this.length);
    return $7CwwS.read(this, offset, false, 23, 4);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 8, this.length);
    return $7CwwS.read(this, offset, true, 52, 8);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkOffset(offset, 8, this.length);
    return $7CwwS.read(this, offset, false, 52, 8);
};
function $44cd0bd3a1192d9a$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUintLE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $44cd0bd3a1192d9a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUintBE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $44cd0bd3a1192d9a$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUint8 = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUint16LE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUint16BE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUint32LE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeUint32BE = $44cd0bd3a1192d9a$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $44cd0bd3a1192d9a$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $44cd0bd3a1192d9a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $44cd0bd3a1192d9a$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $44cd0bd3a1192d9a$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.writeBigUInt64LE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $44cd0bd3a1192d9a$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$44cd0bd3a1192d9a$var$Buffer.prototype.writeBigUInt64BE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $44cd0bd3a1192d9a$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$44cd0bd3a1192d9a$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $44cd0bd3a1192d9a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $44cd0bd3a1192d9a$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeBigInt64LE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $44cd0bd3a1192d9a$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$44cd0bd3a1192d9a$var$Buffer.prototype.writeBigInt64BE = $44cd0bd3a1192d9a$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $44cd0bd3a1192d9a$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $44cd0bd3a1192d9a$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $44cd0bd3a1192d9a$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $7CwwS.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $44cd0bd3a1192d9a$var$writeFloat(this, value, offset, true, noAssert);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $44cd0bd3a1192d9a$var$writeFloat(this, value, offset, false, noAssert);
};
function $44cd0bd3a1192d9a$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $44cd0bd3a1192d9a$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $7CwwS.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$44cd0bd3a1192d9a$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $44cd0bd3a1192d9a$var$writeDouble(this, value, offset, true, noAssert);
};
$44cd0bd3a1192d9a$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $44cd0bd3a1192d9a$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$44cd0bd3a1192d9a$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$44cd0bd3a1192d9a$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$44cd0bd3a1192d9a$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$44cd0bd3a1192d9a$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $44cd0bd3a1192d9a$var$Buffer.isBuffer(val) ? val : $44cd0bd3a1192d9a$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $44cd0bd3a1192d9a$var$errors = {};
function $44cd0bd3a1192d9a$var$E(sym, getMessage, Base) {
    $44cd0bd3a1192d9a$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$44cd0bd3a1192d9a$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$44cd0bd3a1192d9a$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$44cd0bd3a1192d9a$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $44cd0bd3a1192d9a$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $44cd0bd3a1192d9a$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $44cd0bd3a1192d9a$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $44cd0bd3a1192d9a$var$checkBounds(buf, offset, byteLength) {
    $44cd0bd3a1192d9a$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $44cd0bd3a1192d9a$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $44cd0bd3a1192d9a$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $44cd0bd3a1192d9a$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $44cd0bd3a1192d9a$var$checkBounds(buf, offset, byteLength);
}
function $44cd0bd3a1192d9a$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $44cd0bd3a1192d9a$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $44cd0bd3a1192d9a$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $44cd0bd3a1192d9a$var$validateNumber(value, type);
        throw new $44cd0bd3a1192d9a$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $44cd0bd3a1192d9a$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $44cd0bd3a1192d9a$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $44cd0bd3a1192d9a$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $44cd0bd3a1192d9a$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($44cd0bd3a1192d9a$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $44cd0bd3a1192d9a$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $44cd0bd3a1192d9a$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $44cd0bd3a1192d9a$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $44cd0bd3a1192d9a$var$base64ToBytes(str) {
    return $2IpUO.toByteArray($44cd0bd3a1192d9a$var$base64clean(str));
}
function $44cd0bd3a1192d9a$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $44cd0bd3a1192d9a$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $44cd0bd3a1192d9a$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $44cd0bd3a1192d9a$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $44cd0bd3a1192d9a$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $44cd0bd3a1192d9a$var$BufferBigIntNotDefined : fn;
}
function $44cd0bd3a1192d9a$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("2IpUO", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $1fa3cb0d676f4b02$export$d622b2ad8d90c771; }, function (v) { return $1fa3cb0d676f4b02$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $1fa3cb0d676f4b02$export$6100ba28696e12de; }, function (v) { return $1fa3cb0d676f4b02$export$6100ba28696e12de = v; });
var $1fa3cb0d676f4b02$export$a48f0734ac7c2329;
var $1fa3cb0d676f4b02$export$d622b2ad8d90c771;
var $1fa3cb0d676f4b02$export$6100ba28696e12de;
'use strict';
$1fa3cb0d676f4b02$export$a48f0734ac7c2329 = $1fa3cb0d676f4b02$var$byteLength;
$1fa3cb0d676f4b02$export$d622b2ad8d90c771 = $1fa3cb0d676f4b02$var$toByteArray;
$1fa3cb0d676f4b02$export$6100ba28696e12de = $1fa3cb0d676f4b02$var$fromByteArray;
var $1fa3cb0d676f4b02$var$lookup = [];
var $1fa3cb0d676f4b02$var$revLookup = [];
var $1fa3cb0d676f4b02$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $1fa3cb0d676f4b02$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $1fa3cb0d676f4b02$var$i = 0, $1fa3cb0d676f4b02$var$len = $1fa3cb0d676f4b02$var$code.length; $1fa3cb0d676f4b02$var$i < $1fa3cb0d676f4b02$var$len; ++$1fa3cb0d676f4b02$var$i){
    $1fa3cb0d676f4b02$var$lookup[$1fa3cb0d676f4b02$var$i] = $1fa3cb0d676f4b02$var$code[$1fa3cb0d676f4b02$var$i];
    $1fa3cb0d676f4b02$var$revLookup[$1fa3cb0d676f4b02$var$code.charCodeAt($1fa3cb0d676f4b02$var$i)] = $1fa3cb0d676f4b02$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$1fa3cb0d676f4b02$var$revLookup['-'.charCodeAt(0)] = 62;
$1fa3cb0d676f4b02$var$revLookup['_'.charCodeAt(0)] = 63;
function $1fa3cb0d676f4b02$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $1fa3cb0d676f4b02$var$byteLength(b64) {
    var lens = $1fa3cb0d676f4b02$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $1fa3cb0d676f4b02$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $1fa3cb0d676f4b02$var$toByteArray(b64) {
    var tmp;
    var lens = $1fa3cb0d676f4b02$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $1fa3cb0d676f4b02$var$Arr($1fa3cb0d676f4b02$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i)] << 18 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i)] << 2 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i)] << 10 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $1fa3cb0d676f4b02$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $1fa3cb0d676f4b02$var$tripletToBase64(num) {
    return $1fa3cb0d676f4b02$var$lookup[num >> 18 & 0x3F] + $1fa3cb0d676f4b02$var$lookup[num >> 12 & 0x3F] + $1fa3cb0d676f4b02$var$lookup[num >> 6 & 0x3F] + $1fa3cb0d676f4b02$var$lookup[num & 0x3F];
}
function $1fa3cb0d676f4b02$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($1fa3cb0d676f4b02$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $1fa3cb0d676f4b02$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($1fa3cb0d676f4b02$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($1fa3cb0d676f4b02$var$lookup[tmp >> 2] + $1fa3cb0d676f4b02$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($1fa3cb0d676f4b02$var$lookup[tmp >> 10] + $1fa3cb0d676f4b02$var$lookup[tmp >> 4 & 0x3F] + $1fa3cb0d676f4b02$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("7CwwS", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $58c550a140bdb182$export$aafa59e2e03f2942; }, function (v) { return $58c550a140bdb182$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $58c550a140bdb182$export$68d8715fc104d294; }, function (v) { return $58c550a140bdb182$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $58c550a140bdb182$export$aafa59e2e03f2942;
var $58c550a140bdb182$export$68d8715fc104d294;
$58c550a140bdb182$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$58c550a140bdb182$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});




parcelRegister("lfY1m", function(module, exports) {

$parcel$export(module.exports, "textSafe", function () { return $f7998e9b083de168$export$b5b041eb1b71c554; });
$parcel$export(module.exports, "MICRO", function () { return $f7998e9b083de168$export$540c5b0096dd2bee; });
$parcel$export(module.exports, "TABLE_LEADING", function () { return $f7998e9b083de168$export$7e6b61b06188ca76; });
$parcel$export(module.exports, "PLAYER_FONTS", function () { return $f7998e9b083de168$export$2cd87dc82ccd39e6; });
$parcel$export(module.exports, "MARKINGS", function () { return $f7998e9b083de168$export$9321b5a9998403cf; });
$parcel$export(module.exports, "defaultMarking", function () { return $f7998e9b083de168$export$10d208bcc38e384c; });
$parcel$export(module.exports, "markedFurniture", function () { return $f7998e9b083de168$export$ba33fa2385fa4606; });
$parcel$export(module.exports, "slideFurniture", function () { return $f7998e9b083de168$export$b9bf4c4d2c698825; });
$parcel$export(module.exports, "readableOn", function () { return $f7998e9b083de168$export$48b0a3a813850053; });
$parcel$export(module.exports, "loadExportFontCss", function () { return $f7998e9b083de168$export$69aa15096868ebb1; });
$parcel$export(module.exports, "tint", function () { return $f7998e9b083de168$export$fc176dd65a27d98b; });
$parcel$export(module.exports, "MIN_CONTRAST", function () { return $f7998e9b083de168$export$fe34ac93313c346f; });
$parcel$export(module.exports, "contrastRatio", function () { return $f7998e9b083de168$export$e73df0c08bfd3ec3; });
$parcel$export(module.exports, "brandCss", function () { return $f7998e9b083de168$export$e8cc8402a4e24ae; });
$parcel$export(module.exports, "FAVICON_DATA_URI", function () { return $f7998e9b083de168$export$f5d07afc56de0f80; });
$parcel$export(module.exports, "BRAND", function () { return (parcelRequire("7xe2g")).BRAND; });
$parcel$export(module.exports, "P", function () { return (parcelRequire("7xe2g")).P; });
$parcel$export(module.exports, "SERIES", function () { return (parcelRequire("7xe2g")).SERIES; });
$parcel$export(module.exports, "TYPE", function () { return (parcelRequire("7xe2g")).TYPE; });
$parcel$export(module.exports, "RULES", function () { return (parcelRequire("7xe2g")).RULES; });
$parcel$export(module.exports, "CHROME", function () { return (parcelRequire("7xe2g")).CHROME; });
$parcel$export(module.exports, "FONTS", function () { return (parcelRequire("7xe2g")).FONTS; });
$parcel$export(module.exports, "fonts", function () { return (parcelRequire("7xe2g")).fonts; });
$parcel$export(module.exports, "PPTX", function () { return (parcelRequire("7xe2g")).PPTX; });
$parcel$export(module.exports, "icons", function () { return (parcelRequire("7xe2g")).icons; });
$parcel$export(module.exports, "FURNITURE", function () { return (parcelRequire("7xe2g")).FURNITURE; });
$parcel$export(module.exports, "COVER", function () { return (parcelRequire("7xe2g")).COVER; });
$parcel$export(module.exports, "SPLIT", function () { return (parcelRequire("7xe2g")).SPLIT; });
$parcel$export(module.exports, "IMPORT", function () { return (parcelRequire("7xe2g")).IMPORT; });
$parcel$export(module.exports, "INFOGRAPHIC", function () { return (parcelRequire("7xe2g")).INFOGRAPHIC; });
$parcel$export(module.exports, "GROUNDS", function () { return (parcelRequire("7xe2g")).GROUNDS; });
$parcel$export(module.exports, "DIAGRAMS", function () { return (parcelRequire("7xe2g")).DIAGRAMS; });
$parcel$export(module.exports, "DOCX", function () { return (parcelRequire("7xe2g")).DOCX; });
$parcel$export(module.exports, "coverImage", function () { return (parcelRequire("fDnNf")).coverImage; });
// ─────────────────────────────────────────────────────────────────────────
// The active brand, resolved at build time.
//
// `src/generated/brand.js` is a verbatim copy of brand/$BRAND/brand.config.js
// (see scripts/apply-brand.mjs). Everything the editor needs to look like a
// given brand comes through here or through src/js/palette.js (which re-exports
// this module's P, so every existing `P.<name>` call site is brand-aware).
// ─────────────────────────────────────────────────────────────────────────

var $7xe2g = parcelRequire("7xe2g");

var $fDnNf = parcelRequire("fDnNf");
// ── text-colour guard ───────────────────────────────────────────────────────
// A brand may forbid some of its own colours as a text colour — Telia's
// guidelines are explicit that Core Purple is never one. Blocks that tint
// small type with an element's accent (a card's tag, a quote's attribution, a
// stat's caption) run the accent through this first, so an accent that is
// legitimate as a graphic cannot become text through the back door.
const $f7998e9b083de168$var$NEVER_TEXT = ((0, $7xe2g.RULES).neverText || []).map((r)=>r.color);
function $f7998e9b083de168$export$b5b041eb1b71c554(color, fallback) {
    const c = $f7998e9b083de168$var$rgbOf(color);
    const hit = c && $f7998e9b083de168$var$NEVER_TEXT.some((n)=>$f7998e9b083de168$var$rgbOf(n) === c);
    return hit ? fallback || (0, $7xe2g.P).light : color;
}
const $f7998e9b083de168$export$540c5b0096dd2bee = {
    font: (0, $7xe2g.FONTS)[(0, $7xe2g.TYPE).microFont] || (0, $7xe2g.FONTS).mono,
    transform: (0, $7xe2g.TYPE).microCase,
    tracking: (0, $7xe2g.TYPE).microTracking,
    // All-caps micro-type needs tracking to stay legible; sentence case does
    // not, and Telia's guidelines rule out the caps in the first place. Wrap a
    // hand-authored tracking value in this and it survives only where it helps.
    track: (px)=>(0, $7xe2g.TYPE).microCase === "uppercase" ? px : 0,
    // Apply the brand's case to a string, for the places that transform text
    // rather than style it (the canvas converter's flattened HTML).
    case: (s)=>(0, $7xe2g.TYPE).microCase === "uppercase" ? String(s ?? "").toUpperCase() : String(s ?? "")
};
const $f7998e9b083de168$export$7e6b61b06188ca76 = Math.min((0, $7xe2g.TYPE).bodyLineHeight || 1.5, 1.3);
const $f7998e9b083de168$export$2cd87dc82ccd39e6 = {
    ...(0, $7xe2g.FONTS),
    micro: $f7998e9b083de168$export$540c5b0096dd2bee.font,
    microCase: $f7998e9b083de168$export$540c5b0096dd2bee.transform,
    bodyLineHeight: (0, $7xe2g.TYPE).bodyLineHeight,
    listLineHeight: (0, $7xe2g.TYPE).listLineHeight,
    tableLineHeight: $f7998e9b083de168$export$7e6b61b06188ca76,
    // Colours the brand does not allow as text, for the player's own textSafe().
    neverText: $f7998e9b083de168$var$NEVER_TEXT
};
const $f7998e9b083de168$export$9321b5a9998403cf = (0, $7xe2g.FURNITURE) && (0, $7xe2g.FURNITURE).markings || null;
function $f7998e9b083de168$export$10d208bcc38e384c() {
    const label = (0, $7xe2g.FURNITURE) && (0, $7xe2g.FURNITURE).rest && (0, $7xe2g.FURNITURE).rest.label;
    if (!$f7998e9b083de168$export$9321b5a9998403cf || !label) return "";
    return Object.keys($f7998e9b083de168$export$9321b5a9998403cf).find((k)=>$f7998e9b083de168$export$9321b5a9998403cf[k] === label.text) || "";
}
// The label a half of the furniture prints for one classification. Three
// answers and the third is the one that matters:
//
//   nothing stored, or the brand declares no markings → the label as declared
//   an id the brand knows                             → that word
//   an id it does NOT know                            → no label at all
//
// The last is a deck marked on another brand and opened here. Printing the
// declared default there would put "Public" on a deck somebody classified
// internal, which is the one failure a confidentiality marking exists to
// prevent — so it prints nothing, which is visibly missing rather than quietly
// wrong.
function $f7998e9b083de168$var$markLabel(label, marking) {
    if (!label || !marking) return label;
    if (!$f7998e9b083de168$export$9321b5a9998403cf) return label;
    const text = $f7998e9b083de168$export$9321b5a9998403cf[marking];
    if (!text) return null;
    return text === label.text ? label : {
        ...label,
        text: text
    };
}
function $f7998e9b083de168$export$ba33fa2385fa4606(marking = "") {
    if (!(0, $7xe2g.FURNITURE) || !marking || !$f7998e9b083de168$export$9321b5a9998403cf) return 0, $7xe2g.FURNITURE;
    const half = (f)=>{
        if (!f || !f.label) return f;
        const label = $f7998e9b083de168$var$markLabel(f.label, marking);
        return label === f.label ? f : {
            ...f,
            ...label ? {
                label: label
            } : {},
            ...label ? {} : {
                label: null
            }
        };
    };
    return {
        ...(0, $7xe2g.FURNITURE),
        first: half((0, $7xe2g.FURNITURE).first),
        rest: half((0, $7xe2g.FURNITURE).rest)
    };
}
function $f7998e9b083de168$export$b9bf4c4d2c698825(index, backdrop = null, marking = "") {
    if (!(0, $7xe2g.FURNITURE)) return null;
    let f = index === 0 ? (0, $7xe2g.FURNITURE).first : (0, $7xe2g.FURNITURE).rest;
    if (f && f.label && marking) {
        const label = $f7998e9b083de168$var$markLabel(f.label, marking);
        if (label !== f.label) f = label ? {
            ...f,
            label: label
        } : {
            ...f,
            label: null
        };
    }
    if (!f || !(f.label || f.logo)) return null;
    // The marking is ink on the slide like any other text, and a brand that sets
    // its content pages light and its statement pages dark needs it to follow.
    // The template states one colour because the template has one ground; the
    // studio can put a slide on either, so the colour is resolved per slide.
    if (!backdrop || !f.label) return f;
    const color = $f7998e9b083de168$export$48b0a3a813850053(f.label.color, backdrop);
    return color === f.label.color ? f : {
        ...f,
        label: {
            ...f.label,
            color: color
        }
    };
}
// What exported decks and generated pages put in their <style>: the faces the
// build inlined for this brand (fonts.embedInExports), then any extra CSS the
// brand authored by hand.
//
// Fetched on demand rather than imported, because the faces are the largest
// thing this build produces — Telia's seven are 295 kB of base64 — and NOTHING
// in the editor renders with them. They exist so an exported deck and a
// generated page carry the family with them; the editor itself uses the faces
// the build put in its own stylesheet. Importing them here put a quarter of a
// megabyte of base64 into the main bundle, downloaded and parsed on every page
// load, for a file most sessions never produce.
//
// There is no synchronous reader on purpose. Every caller is an export, every
// export is already async, and a sync accessor that answers "" until something
// has warmed it is a font that silently goes missing from one deck in ten.
let $f7998e9b083de168$var$_faces = null;

async function $f7998e9b083de168$export$69aa15096868ebb1() {
    if ($f7998e9b083de168$var$_faces === null) // A brand with no faces to embed still has its hand-written CSS, and a
    // chunk that will not load is a deck in the fallback stack rather than no
    // deck at all.
    try {
        $f7998e9b083de168$var$_faces = (await (parcelRequire("dwI54"))).embeddedFontCss || "";
    } catch  {
        $f7998e9b083de168$var$_faces = "";
    }
    return $f7998e9b083de168$var$_faces + (0, $7xe2g.exportFontCss);
}
function $f7998e9b083de168$export$fc176dd65a27d98b(color, alpha) {
    const rgb = $f7998e9b083de168$var$rgbOf(color);
    return rgb ? `rgba(${rgb},${alpha})` : color;
}
function $f7998e9b083de168$var$rgbOf(c) {
    if (typeof c !== "string") return null;
    const s = c.trim();
    let m = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(s);
    if (m) {
        let h = m[1];
        if (h.length === 3) h = h.split("").map((x)=>x + x).join("");
        return `${parseInt(h.slice(0, 2), 16)},${parseInt(h.slice(2, 4), 16)},${parseInt(h.slice(4, 6), 16)}`;
    }
    m = /^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i.exec(s);
    return m ? `${m[1]},${m[2]},${m[3]}` : null;
}
const $f7998e9b083de168$export$fe34ac93313c346f = 3; // the ratio Review asks of text on a background
const $f7998e9b083de168$var$triple = (c)=>{
    if (Array.isArray(c)) return c.length >= 3 ? c : null;
    const rgb = $f7998e9b083de168$var$rgbOf(c);
    return rgb ? rgb.split(",").map(Number) : null;
};
const $f7998e9b083de168$var$relLum = (rgb)=>{
    const f = (v)=>{
        v /= 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
    };
    return 0.2126 * f(rgb[0]) + 0.7152 * f(rgb[1]) + 0.0722 * f(rgb[2]);
};
function $f7998e9b083de168$export$e73df0c08bfd3ec3(a, b) {
    const x = $f7998e9b083de168$var$triple(a), y = $f7998e9b083de168$var$triple(b);
    if (!x || !y) return 21; // not a colour we can judge — never flag it
    const la = $f7998e9b083de168$var$relLum(x), lb = $f7998e9b083de168$var$relLum(y);
    return (Math.max(la, lb) + 0.05) / (Math.min(la, lb) + 0.05);
}
function $f7998e9b083de168$export$48b0a3a813850053(color, backdrop, min = $f7998e9b083de168$export$fe34ac93313c346f) {
    if (!color || !backdrop || !$f7998e9b083de168$var$triple(color) || !$f7998e9b083de168$var$triple(backdrop)) return color;
    if ($f7998e9b083de168$export$e73df0c08bfd3ec3(color, backdrop) >= min) return color;
    const target = $f7998e9b083de168$export$e73df0c08bfd3ec3((0, $7xe2g.P).light, backdrop) >= $f7998e9b083de168$export$e73df0c08bfd3ec3((0, $7xe2g.P).deep, backdrop) ? (0, $7xe2g.P).light : (0, $7xe2g.P).deep;
    const m = /^rgba\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*([\d.]+)\s*\)$/i.exec(String(color).trim());
    const alpha = m ? Number(m[1]) : 1;
    return alpha < 1 ? $f7998e9b083de168$export$fc176dd65a27d98b(target, alpha) : target;
}
// ── brandCss ────────────────────────────────────────────────────────────────
// The Studio's static stylesheets — editor chrome, the exported deck player,
// generated interactive pages — are authored against the *generic* palette.
// Piping them through brandCss() swaps those literals for the active brand's,
// so a brand declares values only and never a substitution table.
//
// AUTHORED mirrors brand/generic/brand.config.js. Keep the two in step: a
// literal that is not listed here simply passes through unchanged.
const $f7998e9b083de168$var$AUTHORED = {
    hex: {
        "#0B1026": (0, $7xe2g.P).deep,
        "#161D38": (0, $7xe2g.P).dark,
        "#1C2547": (0, $7xe2g.P).card,
        "#6C5CE7": (0, $7xe2g.P).purple,
        "#E9ECFF": (0, $7xe2g.P).light,
        "#E15FD5": (0, $7xe2g.P).magenta,
        "#0FA396": (0, $7xe2g.P).teal,
        "#0A0F22": (0, $7xe2g.CHROME).bg,
        "#171F3A": (0, $7xe2g.CHROME).menu,
        "#7D6EF5": (0, $7xe2g.CHROME).hover,
        "#171F3C": (0, $7xe2g.CHROME).stageTop,
        "#090D1E": (0, $7xe2g.CHROME).stageBottom,
        "#141B34": (0, $7xe2g.CHROME).diagramTop,
        "#8B7BF0": (0, $7xe2g.CHROME).numAccent,
        "#7DD3FC": (0, $7xe2g.P).electric,
        "#FFD740": (0, $7xe2g.P).gold,
        "#69F0AE": (0, $7xe2g.P).green,
        "#FF5252": (0, $7xe2g.P).red,
        "#FF8A65": (0, $7xe2g.P).orange,
        // The bright accent doubles as the editor's interactive colour, and every
        // literal occurrence of it in src is chrome (focus rings, busy states),
        // so it translates to CHROME.accent rather than to the palette's P.cyan.
        "#00D4FF": (0, $7xe2g.CHROME).accent
    },
    // Bare r,g,b triples, matched only inside rgb()/rgba() so a stray number
    // sequence elsewhere in the CSS can never be rewritten. "153,10,227" is the
    // Telia purple that had leaked into a few generic rules — mapping it too
    // normalises those onto whichever brand is building.
    rgb: {
        "233,236,255": (0, $7xe2g.CHROME).lightRgb,
        "108,92,231": (0, $7xe2g.CHROME).purpleRgb,
        "153,10,227": (0, $7xe2g.CHROME).purpleRgb,
        "22,29,56": (0, $7xe2g.CHROME).darkRgb,
        "12,17,36": (0, $7xe2g.CHROME).barRgb,
        "7,10,22": (0, $7xe2g.CHROME).scrimRgb,
        "6,9,18": (0, $7xe2g.CHROME).scrim2Rgb,
        // The editor accent, written at many alphas. "56,224,255" is a slightly
        // brighter hand-mixed variant of the same accent in the converter grid.
        "0,212,255": (0, $7xe2g.CHROME).accentRgb,
        "56,224,255": (0, $7xe2g.CHROME).accentRgb
    }
};
const $f7998e9b083de168$var$HEX_RE = new RegExp(Object.keys($f7998e9b083de168$var$AUTHORED.hex).join("|"), "gi");
const $f7998e9b083de168$var$RGB_RE = new RegExp(`(rgba?\\(\\s*)(${Object.keys($f7998e9b083de168$var$AUTHORED.rgb).map((k)=>k.replace(/,/g, "\\s*,\\s*")).join("|")})`, "gi");
const $f7998e9b083de168$var$CANON = (s)=>s.replace(/\s+/g, "");
function $f7998e9b083de168$export$e8cc8402a4e24ae(css) {
    return String(css).replace($f7998e9b083de168$var$HEX_RE, (m)=>$f7998e9b083de168$var$AUTHORED.hex[m.toUpperCase()] || m).replace($f7998e9b083de168$var$RGB_RE, (m, open, triple)=>open + ($f7998e9b083de168$var$AUTHORED.rgb[$f7998e9b083de168$var$CANON(triple)] || triple));
}
const $f7998e9b083de168$export$f5d07afc56de0f80 = "data:image/svg+xml," + encodeURIComponent((0, $7xe2g.favicon).inline);

});
parcelRegister("7xe2g", function(module, exports) {

$parcel$export(module.exports, "BRAND", function () { return $57c6809da92e53c9$export$cf2deea74cde46b4; });
$parcel$export(module.exports, "P", function () { return $57c6809da92e53c9$export$56c0d5a1e737357d; });
$parcel$export(module.exports, "SERIES", function () { return $57c6809da92e53c9$export$a6677a1b5a91da63; });
$parcel$export(module.exports, "TYPE", function () { return $57c6809da92e53c9$export$b87f371cbc396fcf; });
$parcel$export(module.exports, "RULES", function () { return $57c6809da92e53c9$export$6f0adf80117cb8df; });
$parcel$export(module.exports, "CHROME", function () { return $57c6809da92e53c9$export$882c3be734f84f58; });
$parcel$export(module.exports, "FONTS", function () { return $57c6809da92e53c9$export$826128ff895ed268; });
$parcel$export(module.exports, "fonts", function () { return $57c6809da92e53c9$export$f45fbea8fe20ca8a; });
$parcel$export(module.exports, "DOCX", function () { return $57c6809da92e53c9$export$9c0218000b0ed452; });
$parcel$export(module.exports, "PPTX", function () { return $57c6809da92e53c9$export$aee92db49bdb4299; });
$parcel$export(module.exports, "FURNITURE", function () { return $57c6809da92e53c9$export$391b32669466333b; });
$parcel$export(module.exports, "IMPORT", function () { return $57c6809da92e53c9$export$a763edbf796b780a; });
$parcel$export(module.exports, "COVER", function () { return $57c6809da92e53c9$export$5f58061f1631e471; });
$parcel$export(module.exports, "SPLIT", function () { return $57c6809da92e53c9$export$3ddb346136bb0b31; });
$parcel$export(module.exports, "GROUNDS", function () { return $57c6809da92e53c9$export$9dd74e94c0aa617c; });
$parcel$export(module.exports, "INFOGRAPHIC", function () { return $57c6809da92e53c9$export$9e555ad1c87e15df; });
$parcel$export(module.exports, "icons", function () { return $57c6809da92e53c9$export$df03f54e09e486fa; });
$parcel$export(module.exports, "favicon", function () { return $57c6809da92e53c9$export$d1d228f217d37317; });
$parcel$export(module.exports, "exportFontCss", function () { return $57c6809da92e53c9$export$c8719c4bb74f57b; });
$parcel$export(module.exports, "DIAGRAMS", function () { return $57c6809da92e53c9$export$957e800db0077e0c; });
// GENERATED by scripts/apply-brand.mjs from brand/generic/brand.config.js.
// Do not edit — your changes will be overwritten on the next build.
// ─────────────────────────────────────────────────────────────────────────
// Brand: generic — the neutral, unbranded Presentation Studio.
//
// This file is ALSO the authoring baseline: the colour literals below are the
// ones written by hand throughout src/, and brandCss() (src/js/brand.js)
// translates them to whichever brand is active. Keep it dependency-free — the
// build copies it verbatim to src/generated/brand.js.
// ─────────────────────────────────────────────────────────────────────────
const $57c6809da92e53c9$export$cf2deea74cde46b4 = {
    id: "generic",
    // <title> and the sign-in gate headline.
    name: "Presentation Studio",
    // Toolbar lockup: mark + short name.
    mark: "\u25C6",
    shortName: "Studio",
    // How the ✓ Review panel refers to the approved colour set.
    paletteLabel: "theme palette",
    // Title of the built-in starter deck.
    starterTitle: "Welcome to Presentation Studio"
};
const $57c6809da92e53c9$export$56c0d5a1e737357d = {
    // Base surfaces & primary accent
    deep: "#0B1026",
    dark: "#161D38",
    card: "#1C2547",
    purple: "#6C5CE7",
    light: "#E9ECFF",
    magenta: "#E15FD5",
    teal: "#0FA396",
    // Bright accents — identical across brands
    cyan: "#00D4FF",
    electric: "#7DD3FC",
    gold: "#FFD740",
    green: "#69F0AE",
    red: "#FF5252",
    orange: "#FF8A65",
    // Text tones
    white: "#FFFFFF",
    dim: "rgba(233,236,255,0.65)",
    muted: "rgba(233,236,255,0.4)",
    faint: "rgba(233,236,255,0.15)"
};
const $57c6809da92e53c9$export$a6677a1b5a91da63 = [
    $57c6809da92e53c9$export$56c0d5a1e737357d.cyan,
    $57c6809da92e53c9$export$56c0d5a1e737357d.magenta,
    $57c6809da92e53c9$export$56c0d5a1e737357d.gold,
    $57c6809da92e53c9$export$56c0d5a1e737357d.green,
    $57c6809da92e53c9$export$56c0d5a1e737357d.orange,
    $57c6809da92e53c9$export$56c0d5a1e737357d.electric,
    $57c6809da92e53c9$export$56c0d5a1e737357d.purple,
    $57c6809da92e53c9$export$56c0d5a1e737357d.teal
];
const $57c6809da92e53c9$export$b87f371cbc396fcf = {
    microCase: "uppercase",
    microFont: "mono",
    microTracking: 5,
    align: "center",
    headLineHeight: 1.02,
    // Slide leading, not web-article leading. These were 1.6 and 1.45, which is
    // right for a column of prose somebody reads at their own pace and too loose
    // for a slide: the same outline that fitted one Telia page (1.2) ran onto a
    // second here, and the second page of each pair carried two bullets and a
    // repeated heading. Still airy — this brand's character — just not by a whole
    // slide. See TABLE_LEADING in src/js/brand.js for the same argument about a
    // grid, where a cell holding "150 ms" is not a paragraph at all.
    bodyLineHeight: 1.5,
    listLineHeight: 1.35,
    listMarker: "\u25C6"
};
const $57c6809da92e53c9$export$6f0adf80117cb8df = {
    neverText: [],
    neverBackground: [],
    clashes: [],
    noAllCaps: false
};
const $57c6809da92e53c9$export$882c3be734f84f58 = {
    bg: "#0A0F22",
    menu: "#171F3A",
    hover: "#7D6EF5",
    stageTop: "#171F3C",
    stageBottom: "#090D1E",
    diagramTop: "#141b34",
    numAccent: "#8B7BF0",
    accent: "#00D4FF",
    accentRgb: "0,212,255",
    ok: "#69F0AE",
    warn: "#FFD740",
    danger: "#FF5252",
    lightRgb: "233,236,255",
    purpleRgb: "108,92,231",
    darkRgb: "22,29,56",
    barRgb: "12,17,36",
    scrimRgb: "7,10,22",
    scrim2Rgb: "6,9,18"
};
const $57c6809da92e53c9$export$826128ff895ed268 = {
    head: "'Space Grotesk', system-ui, -apple-system, 'Segoe UI', sans-serif",
    body: "system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif",
    mono: "'JetBrains Mono', ui-monospace, 'SFMono-Regular', monospace"
};
const $57c6809da92e53c9$export$f45fbea8fe20ca8a = {
    embedInExports: true,
    faces: [
        {
            family: "Space Grotesk",
            weight: "300 700",
            style: "normal",
            file: "fonts/SpaceGrotesk-Variable.woff2"
        }
    ]
};
const $57c6809da92e53c9$export$9c0218000b0ed452 = null;
const $57c6809da92e53c9$export$aee92db49bdb4299 = {
    // The CSS family that means "theme heading". `headingFace` stays null: the
    // display face is shipped for the web, not installed on the machines that
    // open an exported .pptx, so heading runs are left to PowerPoint's own theme
    // font rather than naming a face the recipient almost certainly lacks. Name
    // it here if the font is rolled out to those machines.
    headingMarker: "Space Grotesk",
    headingFace: null,
    // `bodyMarker` + `weightFaces` name the GDI families for weights PowerPoint
    // cannot reach with the bold flag — a Medium or Light face usually installs
    // as its own family rather than as a weight of the body family. The body
    // role here is the system stack, which has no such families.
    bodyMarker: null,
    weightFaces: {},
    theme: null
};
const $57c6809da92e53c9$export$391b32669466333b = null;
const $57c6809da92e53c9$export$a763edbf796b780a = {
    rebrand: false
};
const $57c6809da92e53c9$export$5f58061f1631e471 = {
    image: null,
    title: {
        x: 90,
        y: 200,
        w: 1100,
        h: 220,
        size: 96,
        lineHeight: 1.02
    },
    sub: {
        x: 90,
        y: 440,
        w: 640,
        h: 95,
        size: 30
    },
    meta: {
        x: 90,
        y: 570,
        w: 400,
        h: 95,
        size: 18
    }
};
const $57c6809da92e53c9$export$3ddb346136bb0b31 = {
    title: {
        x: 90,
        y: 72,
        w: 620,
        h: 120,
        size: 52
    },
    // The column is a comfortable measure rather than the whole gap to the
    // picture: the layout runs it wider when a slide's copy will not fit,
    // and it needs somewhere to run to.
    copy: {
        x: 90,
        y: 232,
        w: 520,
        h: 416
    },
    picture: {
        x: 700,
        y: 0,
        w: 580,
        h: 720
    }
};
const $57c6809da92e53c9$export$9dd74e94c0aa617c = {
    content: $57c6809da92e53c9$export$56c0d5a1e737357d.deep,
    statement: $57c6809da92e53c9$export$56c0d5a1e737357d.deep
};
const $57c6809da92e53c9$export$9e555ad1c87e15df = {
    // Corner radius for a diagram node, a group container and a smart object's
    // panels. `null` leaves each block's own default alone.
    radius: null,
    // Flat fill only — solid colour, hairline border, no gradient, glow, bevel
    // or sheen sweep. Generic keeps the depth.
    flat: false,
    // The inks an arrow may be drawn in, as a list — a brand that gives arrows a
    // colour of their own usually gives them one per ground, and whichever reads
    // on the page is used. `null` means an arrow takes the colour of whatever it
    // points at, which is the studio default.
    arrow: null,
    // Stroke width for connectors, chart lines and rules.
    lineWidth: 4,
    // Radius of the round marker on each point of a line chart; 0 for none.
    marker: 0,
    // Font role for a large figure that IS the content — a counter's value, a
    // chart's data label. "head" or "body".
    dataFont: "head",
    // Weight for a sum or total, which a chart may set apart from its parts.
    totalWeight: 700
};
const $57c6809da92e53c9$export$df03f54e09e486fa = null;
const $57c6809da92e53c9$export$d1d228f217d37317 = {
    file: "assets/favicon.svg",
    inline: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><rect width="64" height="64" rx="14" fill="#00D4FF"/><rect x="12" y="16" width="40" height="28" rx="4" fill="#0B1026" opacity="0.85"/><path d="M27 23l14 7-14 7z" fill="#FFFFFF"/><rect x="22" y="48" width="20" height="3.5" rx="1.75" fill="#0B1026" opacity="0.85"/></svg>'
};
const $57c6809da92e53c9$export$c8719c4bb74f57b = "";
const $57c6809da92e53c9$export$957e800db0077e0c = [];

});

parcelRegister("fDnNf", function(module, exports) {

$parcel$export(module.exports, "coverImage", function () { return $b61cf464e8a4551f$export$f5a7adcc778cc91d; });
// GENERATED by scripts/apply-brand.mjs from brand/generic/brand.config.js.
// Do not edit — your changes will be overwritten on the next build.
const $b61cf464e8a4551f$export$f5a7adcc778cc91d = "";

});

parcelRegister("dwI54", function(module, exports) {
module.exports = $parcel$import("lynb8").then(()=>parcelRequire('aMmHm'));

});


parcelRegister("lGbE1", function(module, exports) {
module.exports = $parcel$import("eqLVX").then(()=>parcelRequire('6qRdO'));

});

var $232132153c7c1526$exports = {};
$parcel$extendImportMap({
    "lynb8": "fonts.6ee357e9.js",
    "eqLVX": "app.fd0c8767.js",
    "3c5kQ": "jszip.min.5edb19cb.js",
    "8ZHqK": "icons.7bc40b3b.js",
    "4VF16": "three-global-bundle.generated.8369d215.js",
    "liR8z": "pptxgen.es.4a5f3f85.js",
    "58GxM": "_empty.84223129.js",
    "7Nn8N": "dist.e2d006e5.js",
    "i7tqb": "raster-slides.f8d2a9ad.js",
    "ebs9H": "import-pptx.ce020436.js"
});


var $caV3w = parcelRequire("caV3w");
var $d955aa3bcb03bbc5$exports = {};
'use strict';
function $d955aa3bcb03bbc5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($d955aa3bcb03bbc5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$d955aa3bcb03bbc5$var$checkDCE();

$d955aa3bcb03bbc5$exports = (parcelRequire("gHMOm"));



var $e8uqK = parcelRequire("e8uqK");
parcelRequire("lfY1m");
var $7xe2g = parcelRequire("7xe2g");
var $lfY1m = parcelRequire("lfY1m");
// When Netlify Identity is enabled and nobody is signed in, show this landing
// gate instead of the editor. The widget handles sign-up, sign-in and
// password recovery; a successful login reloads the page into the editor.
function $74a569fcf69870ab$var$SignInGate() {
    const wrap = {
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 14,
        background: `radial-gradient(circle at 70% 20%, rgba(${(0, $7xe2g.CHROME).accentRgb},.10), transparent 55%), radial-gradient(circle at 20% 80%, rgba(${(0, $7xe2g.CHROME).purpleRgb},.18), transparent 55%), ${(0, $7xe2g.P).deep}`,
        color: (0, $7xe2g.P).light,
        textAlign: "center",
        padding: 24
    };
    return /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
        style: wrap,
        children: [
            /*#__PURE__*/ (0, $caV3w.jsxs)("div", {
                style: {
                    fontWeight: 700,
                    letterSpacing: 0.5,
                    color: (0, $7xe2g.CHROME).accent,
                    fontSize: 22
                },
                children: [
                    (0, $7xe2g.BRAND).mark,
                    " ",
                    (0, $7xe2g.BRAND).name
                ]
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("p", {
                style: {
                    margin: 0,
                    maxWidth: 420,
                    color: (0, $lfY1m.tint)((0, $7xe2g.P).light, 0.65),
                    fontSize: 14.5,
                    lineHeight: 1.6
                },
                children: "Sign in \u2014 or create a free account \u2014 to open your presentations. Your decks are private to your account and sync across your devices."
            }),
            /*#__PURE__*/ (0, $caV3w.jsx)("button", {
                onClick: (0, $e8uqK.openLogin),
                style: {
                    font: "inherit",
                    fontWeight: 600,
                    fontSize: 15,
                    padding: "11px 26px",
                    borderRadius: 10,
                    border: 0,
                    cursor: "pointer",
                    background: (0, $7xe2g.P).purple,
                    color: "#fff"
                },
                children: "Sign in / Sign up"
            })
        ]
    });
}
const $74a569fcf69870ab$var$container = document.getElementById("studio-root");

if ($74a569fcf69870ab$var$container) (0, $e8uqK.initAuth)().then(async ({ mode: mode, user: user })=>{
    const root = (0, $d955aa3bcb03bbc5$exports.createRoot)($74a569fcf69870ab$var$container);
    if (mode === "identity" && !user) {
        root.render(/*#__PURE__*/ (0, $caV3w.jsx)($74a569fcf69870ab$var$SignInGate, {}));
        return;
    }
    // Imported only now so model.js reads the resolved auth scope at init.
    const { default: StudioApp } = await (parcelRequire("lGbE1"));
    root.render(/*#__PURE__*/ (0, $caV3w.jsx)(StudioApp, {}));
});


//# sourceMappingURL=repo.635e9565.js.map
